/*
 * DO NOT EDIT THIS FILE! THIS FILE IS GENERATED AUTOMATICALLY
 * SO YOUR CHANGES WILL BE LOST ON THE NEXT UPDATE.
 * TO ADD CUSTOM CODE USE custom-theme.js FILE INSTEAD.
**/

/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/index.js":
/*!**************************************************************************************!*\
  !*** ./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/index.js ***!
  \**************************************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _types_options__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./types/options */ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/types/options.js");
/* harmony import */ var _l10n_default__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./l10n/default */ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/l10n/default.js");
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./utils */ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/utils/index.js");
/* harmony import */ var _utils_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utils/dom */ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/utils/dom.js");
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./utils/dates */ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/utils/dates.js");
/* harmony import */ var _utils_formatting__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./utils/formatting */ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/utils/formatting.js");
/* harmony import */ var _utils_polyfills__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./utils/polyfills */ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/utils/polyfills.js");
/* harmony import */ var _utils_polyfills__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_utils_polyfills__WEBPACK_IMPORTED_MODULE_6__);
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};







var DEBOUNCED_CHANGE_MS = 300;
function FlatpickrInstance(element, instanceConfig) {
    var self = {
        config: __assign(__assign({}, _types_options__WEBPACK_IMPORTED_MODULE_0__.defaults), flatpickr.defaultConfig),
        l10n: _l10n_default__WEBPACK_IMPORTED_MODULE_1__["default"],
    };
    self.parseDate = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__.createDateParser)({ config: self.config, l10n: self.l10n });
    self._handlers = [];
    self.pluginElements = [];
    self.loadedPlugins = [];
    self._bind = bind;
    self._setHoursFromDate = setHoursFromDate;
    self._positionCalendar = positionCalendar;
    self.changeMonth = changeMonth;
    self.changeYear = changeYear;
    self.clear = clear;
    self.close = close;
    self.onMouseOver = onMouseOver;
    self._createElement = _utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement;
    self.createDay = createDay;
    self.destroy = destroy;
    self.isEnabled = isEnabled;
    self.jumpToDate = jumpToDate;
    self.updateValue = updateValue;
    self.open = open;
    self.redraw = redraw;
    self.set = set;
    self.setDate = setDate;
    self.toggle = toggle;
    function setupHelperFunctions() {
        self.utils = {
            getDaysInMonth: function (month, yr) {
                if (month === void 0) { month = self.currentMonth; }
                if (yr === void 0) { yr = self.currentYear; }
                if (month === 1 && ((yr % 4 === 0 && yr % 100 !== 0) || yr % 400 === 0))
                    return 29;
                return self.l10n.daysInMonth[month];
            },
        };
    }
    function init() {
        self.element = self.input = element;
        self.isOpen = false;
        parseConfig();
        setupLocale();
        setupInputs();
        setupDates();
        setupHelperFunctions();
        if (!self.isMobile)
            build();
        bindEvents();
        if (self.selectedDates.length || self.config.noCalendar) {
            if (self.config.enableTime) {
                setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj : undefined);
            }
            updateValue(false);
        }
        setCalendarWidth();
        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (!self.isMobile && isSafari) {
            positionCalendar();
        }
        triggerEvent("onReady");
    }
    function getClosestActiveElement() {
        var _a;
        return (((_a = self.calendarContainer) === null || _a === void 0 ? void 0 : _a.getRootNode())
            .activeElement || document.activeElement);
    }
    function bindToInstance(fn) {
        return fn.bind(self);
    }
    function setCalendarWidth() {
        var config = self.config;
        if (config.weekNumbers === false && config.showMonths === 1) {
            return;
        }
        else if (config.noCalendar !== true) {
            window.requestAnimationFrame(function () {
                if (self.calendarContainer !== undefined) {
                    self.calendarContainer.style.visibility = "hidden";
                    self.calendarContainer.style.display = "block";
                }
                if (self.daysContainer !== undefined) {
                    var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
                    self.daysContainer.style.width = daysWidth + "px";
                    self.calendarContainer.style.width =
                        daysWidth +
                            (self.weekWrapper !== undefined
                                ? self.weekWrapper.offsetWidth
                                : 0) +
                            "px";
                    self.calendarContainer.style.removeProperty("visibility");
                    self.calendarContainer.style.removeProperty("display");
                }
            });
        }
    }
    function updateTime(e) {
        if (self.selectedDates.length === 0) {
            var defaultDate = self.config.minDate === undefined ||
                (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__.compareDates)(new Date(), self.config.minDate) >= 0
                ? new Date()
                : new Date(self.config.minDate.getTime());
            var defaults = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__.getDefaultHours)(self.config);
            defaultDate.setHours(defaults.hours, defaults.minutes, defaults.seconds, defaultDate.getMilliseconds());
            self.selectedDates = [defaultDate];
            self.latestSelectedDateObj = defaultDate;
        }
        if (e !== undefined && e.type !== "blur") {
            timeWrapper(e);
        }
        var prevValue = self._input.value;
        setHoursFromInputs();
        updateValue();
        if (self._input.value !== prevValue) {
            self._debouncedChange();
        }
    }
    function ampm2military(hour, amPM) {
        return (hour % 12) + 12 * (0,_utils__WEBPACK_IMPORTED_MODULE_2__.int)(amPM === self.l10n.amPM[1]);
    }
    function military2ampm(hour) {
        switch (hour % 24) {
            case 0:
            case 12:
                return 12;
            default:
                return hour % 12;
        }
    }
    function setHoursFromInputs() {
        if (self.hourElement === undefined || self.minuteElement === undefined)
            return;
        var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24, minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60, seconds = self.secondElement !== undefined
            ? (parseInt(self.secondElement.value, 10) || 0) % 60
            : 0;
        if (self.amPM !== undefined) {
            hours = ampm2military(hours, self.amPM.textContent);
        }
        var limitMinHours = self.config.minTime !== undefined ||
            (self.config.minDate &&
                self.minDateHasTime &&
                self.latestSelectedDateObj &&
                (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__.compareDates)(self.latestSelectedDateObj, self.config.minDate, true) ===
                    0);
        var limitMaxHours = self.config.maxTime !== undefined ||
            (self.config.maxDate &&
                self.maxDateHasTime &&
                self.latestSelectedDateObj &&
                (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__.compareDates)(self.latestSelectedDateObj, self.config.maxDate, true) ===
                    0);
        if (self.config.maxTime !== undefined &&
            self.config.minTime !== undefined &&
            self.config.minTime > self.config.maxTime) {
            var minBound = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__.calculateSecondsSinceMidnight)(self.config.minTime.getHours(), self.config.minTime.getMinutes(), self.config.minTime.getSeconds());
            var maxBound = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__.calculateSecondsSinceMidnight)(self.config.maxTime.getHours(), self.config.maxTime.getMinutes(), self.config.maxTime.getSeconds());
            var currentTime = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__.calculateSecondsSinceMidnight)(hours, minutes, seconds);
            if (currentTime > maxBound && currentTime < minBound) {
                var result = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__.parseSeconds)(minBound);
                hours = result[0];
                minutes = result[1];
                seconds = result[2];
            }
        }
        else {
            if (limitMaxHours) {
                var maxTime = self.config.maxTime !== undefined
                    ? self.config.maxTime
                    : self.config.maxDate;
                hours = Math.min(hours, maxTime.getHours());
                if (hours === maxTime.getHours())
                    minutes = Math.min(minutes, maxTime.getMinutes());
                if (minutes === maxTime.getMinutes())
                    seconds = Math.min(seconds, maxTime.getSeconds());
            }
            if (limitMinHours) {
                var minTime = self.config.minTime !== undefined
                    ? self.config.minTime
                    : self.config.minDate;
                hours = Math.max(hours, minTime.getHours());
                if (hours === minTime.getHours() && minutes < minTime.getMinutes())
                    minutes = minTime.getMinutes();
                if (minutes === minTime.getMinutes())
                    seconds = Math.max(seconds, minTime.getSeconds());
            }
        }
        setHours(hours, minutes, seconds);
    }
    function setHoursFromDate(dateObj) {
        var date = dateObj || self.latestSelectedDateObj;
        if (date && date instanceof Date) {
            setHours(date.getHours(), date.getMinutes(), date.getSeconds());
        }
    }
    function setHours(hours, minutes, seconds) {
        if (self.latestSelectedDateObj !== undefined) {
            self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
        }
        if (!self.hourElement || !self.minuteElement || self.isMobile)
            return;
        self.hourElement.value = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.pad)(!self.config.time_24hr
            ? ((12 + hours) % 12) + 12 * (0,_utils__WEBPACK_IMPORTED_MODULE_2__.int)(hours % 12 === 0)
            : hours);
        self.minuteElement.value = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.pad)(minutes);
        if (self.amPM !== undefined)
            self.amPM.textContent = self.l10n.amPM[(0,_utils__WEBPACK_IMPORTED_MODULE_2__.int)(hours >= 12)];
        if (self.secondElement !== undefined)
            self.secondElement.value = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.pad)(seconds);
    }
    function onYearInput(event) {
        var eventTarget = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.getEventTarget)(event);
        var year = parseInt(eventTarget.value) + (event.delta || 0);
        if (year / 1000 > 1 ||
            (event.key === "Enter" && !/[^\d]/.test(year.toString()))) {
            changeYear(year);
        }
    }
    function bind(element, event, handler, options) {
        if (event instanceof Array)
            return event.forEach(function (ev) { return bind(element, ev, handler, options); });
        if (element instanceof Array)
            return element.forEach(function (el) { return bind(el, event, handler, options); });
        element.addEventListener(event, handler, options);
        self._handlers.push({
            remove: function () { return element.removeEventListener(event, handler, options); },
        });
    }
    function triggerChange() {
        triggerEvent("onChange");
    }
    function bindEvents() {
        if (self.config.wrap) {
            ["open", "close", "toggle", "clear"].forEach(function (evt) {
                Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function (el) {
                    return bind(el, "click", self[evt]);
                });
            });
        }
        if (self.isMobile) {
            setupMobile();
            return;
        }
        var debouncedResize = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.debounce)(onResize, 50);
        self._debouncedChange = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.debounce)(triggerChange, DEBOUNCED_CHANGE_MS);
        if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent))
            bind(self.daysContainer, "mouseover", function (e) {
                if (self.config.mode === "range")
                    onMouseOver((0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.getEventTarget)(e));
            });
        bind(self._input, "keydown", onKeyDown);
        if (self.calendarContainer !== undefined) {
            bind(self.calendarContainer, "keydown", onKeyDown);
        }
        if (!self.config.inline && !self.config.static)
            bind(window, "resize", debouncedResize);
        if (window.ontouchstart !== undefined)
            bind(window.document, "touchstart", documentClick);
        else
            bind(window.document, "mousedown", documentClick);
        bind(window.document, "focus", documentClick, { capture: true });
        if (self.config.clickOpens === true) {
            bind(self._input, "focus", self.open);
            bind(self._input, "click", self.open);
        }
        if (self.daysContainer !== undefined) {
            bind(self.monthNav, "click", onMonthNavClick);
            bind(self.monthNav, ["keyup", "increment"], onYearInput);
            bind(self.daysContainer, "click", selectDate);
        }
        if (self.timeContainer !== undefined &&
            self.minuteElement !== undefined &&
            self.hourElement !== undefined) {
            var selText = function (e) {
                return (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.getEventTarget)(e).select();
            };
            bind(self.timeContainer, ["increment"], updateTime);
            bind(self.timeContainer, "blur", updateTime, { capture: true });
            bind(self.timeContainer, "click", timeIncrement);
            bind([self.hourElement, self.minuteElement], ["focus", "click"], selText);
            if (self.secondElement !== undefined)
                bind(self.secondElement, "focus", function () { return self.secondElement && self.secondElement.select(); });
            if (self.amPM !== undefined) {
                bind(self.amPM, "click", function (e) {
                    updateTime(e);
                });
            }
        }
        if (self.config.allowInput) {
            bind(self._input, "blur", onBlur);
        }
    }
    function jumpToDate(jumpDate, triggerChange) {
        var jumpTo = jumpDate !== undefined
            ? self.parseDate(jumpDate)
            : self.latestSelectedDateObj ||
                (self.config.minDate && self.config.minDate > self.now
                    ? self.config.minDate
                    : self.config.maxDate && self.config.maxDate < self.now
                        ? self.config.maxDate
                        : self.now);
        var oldYear = self.currentYear;
        var oldMonth = self.currentMonth;
        try {
            if (jumpTo !== undefined) {
                self.currentYear = jumpTo.getFullYear();
                self.currentMonth = jumpTo.getMonth();
            }
        }
        catch (e) {
            e.message = "Invalid date supplied: " + jumpTo;
            self.config.errorHandler(e);
        }
        if (triggerChange && self.currentYear !== oldYear) {
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        if (triggerChange &&
            (self.currentYear !== oldYear || self.currentMonth !== oldMonth)) {
            triggerEvent("onMonthChange");
        }
        self.redraw();
    }
    function timeIncrement(e) {
        var eventTarget = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.getEventTarget)(e);
        if (~eventTarget.className.indexOf("arrow"))
            incrementNumInput(e, eventTarget.classList.contains("arrowUp") ? 1 : -1);
    }
    function incrementNumInput(e, delta, inputElem) {
        var target = e && (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.getEventTarget)(e);
        var input = inputElem ||
            (target && target.parentNode && target.parentNode.firstChild);
        var event = createEvent("increment");
        event.delta = delta;
        input && input.dispatchEvent(event);
    }
    function build() {
        var fragment = window.document.createDocumentFragment();
        self.calendarContainer = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)("div", "flatpickr-calendar");
        self.calendarContainer.tabIndex = -1;
        if (!self.config.noCalendar) {
            fragment.appendChild(buildMonthNav());
            self.innerContainer = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)("div", "flatpickr-innerContainer");
            if (self.config.weekNumbers) {
                var _a = buildWeeks(), weekWrapper = _a.weekWrapper, weekNumbers = _a.weekNumbers;
                self.innerContainer.appendChild(weekWrapper);
                self.weekNumbers = weekNumbers;
                self.weekWrapper = weekWrapper;
            }
            self.rContainer = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)("div", "flatpickr-rContainer");
            self.rContainer.appendChild(buildWeekdays());
            if (!self.daysContainer) {
                self.daysContainer = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)("div", "flatpickr-days");
                self.daysContainer.tabIndex = -1;
            }
            buildDays();
            self.rContainer.appendChild(self.daysContainer);
            self.innerContainer.appendChild(self.rContainer);
            fragment.appendChild(self.innerContainer);
        }
        if (self.config.enableTime) {
            fragment.appendChild(buildTime());
        }
        (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.toggleClass)(self.calendarContainer, "rangeMode", self.config.mode === "range");
        (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.toggleClass)(self.calendarContainer, "animate", self.config.animate === true);
        (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.toggleClass)(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
        self.calendarContainer.appendChild(fragment);
        var customAppend = self.config.appendTo !== undefined &&
            self.config.appendTo.nodeType !== undefined;
        if (self.config.inline || self.config.static) {
            self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
            if (self.config.inline) {
                if (!customAppend && self.element.parentNode)
                    self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);
                else if (self.config.appendTo !== undefined)
                    self.config.appendTo.appendChild(self.calendarContainer);
            }
            if (self.config.static) {
                var wrapper = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)("div", "flatpickr-wrapper");
                if (self.element.parentNode)
                    self.element.parentNode.insertBefore(wrapper, self.element);
                wrapper.appendChild(self.element);
                if (self.altInput)
                    wrapper.appendChild(self.altInput);
                wrapper.appendChild(self.calendarContainer);
            }
        }
        if (!self.config.static && !self.config.inline)
            (self.config.appendTo !== undefined
                ? self.config.appendTo
                : window.document.body).appendChild(self.calendarContainer);
    }
    function createDay(className, date, _dayNumber, i) {
        var dateIsEnabled = isEnabled(date, true), dayElement = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)("span", className, date.getDate().toString());
        dayElement.dateObj = date;
        dayElement.$i = i;
        dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
        if (className.indexOf("hidden") === -1 &&
            (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__.compareDates)(date, self.now) === 0) {
            self.todayDateElem = dayElement;
            dayElement.classList.add("today");
            dayElement.setAttribute("aria-current", "date");
        }
        if (dateIsEnabled) {
            dayElement.tabIndex = -1;
            if (isDateSelected(date)) {
                dayElement.classList.add("selected");
                self.selectedDateElem = dayElement;
                if (self.config.mode === "range") {
                    (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.toggleClass)(dayElement, "startRange", self.selectedDates[0] &&
                        (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__.compareDates)(date, self.selectedDates[0], true) === 0);
                    (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.toggleClass)(dayElement, "endRange", self.selectedDates[1] &&
                        (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__.compareDates)(date, self.selectedDates[1], true) === 0);
                    if (className === "nextMonthDay")
                        dayElement.classList.add("inRange");
                }
            }
        }
        else {
            dayElement.classList.add("flatpickr-disabled");
        }
        if (self.config.mode === "range") {
            if (isDateInRange(date) && !isDateSelected(date))
                dayElement.classList.add("inRange");
        }
        if (self.weekNumbers &&
            self.config.showMonths === 1 &&
            className !== "prevMonthDay" &&
            i % 7 === 6) {
            self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
        }
        triggerEvent("onDayCreate", dayElement);
        return dayElement;
    }
    function focusOnDayElem(targetNode) {
        targetNode.focus();
        if (self.config.mode === "range")
            onMouseOver(targetNode);
    }
    function getFirstAvailableDay(delta) {
        var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        for (var m = startMonth; m != endMonth; m += delta) {
            var month = self.daysContainer.children[m];
            var startIndex = delta > 0 ? 0 : month.children.length - 1;
            var endIndex = delta > 0 ? month.children.length : -1;
            for (var i = startIndex; i != endIndex; i += delta) {
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj))
                    return c;
            }
        }
        return undefined;
    }
    function getNextAvailableDay(current, delta) {
        var givenMonth = current.className.indexOf("Month") === -1
            ? current.dateObj.getMonth()
            : self.currentMonth;
        var endMonth = delta > 0 ? self.config.showMonths : -1;
        var loopDelta = delta > 0 ? 1 : -1;
        for (var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta) {
            var month = self.daysContainer.children[m];
            var startIndex = givenMonth - self.currentMonth === m
                ? current.$i + delta
                : delta < 0
                    ? month.children.length - 1
                    : 0;
            var numMonthDays = month.children.length;
            for (var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta) {
                var c = month.children[i];
                if (c.className.indexOf("hidden") === -1 &&
                    isEnabled(c.dateObj) &&
                    Math.abs(current.$i - i) >= Math.abs(delta))
                    return focusOnDayElem(c);
            }
        }
        self.changeMonth(loopDelta);
        focusOnDay(getFirstAvailableDay(loopDelta), 0);
        return undefined;
    }
    function focusOnDay(current, offset) {
        var activeElement = getClosestActiveElement();
        var dayFocused = isInView(activeElement || document.body);
        var startElem = current !== undefined
            ? current
            : dayFocused
                ? activeElement
                : self.selectedDateElem !== undefined && isInView(self.selectedDateElem)
                    ? self.selectedDateElem
                    : self.todayDateElem !== undefined && isInView(self.todayDateElem)
                        ? self.todayDateElem
                        : getFirstAvailableDay(offset > 0 ? 1 : -1);
        if (startElem === undefined) {
            self._input.focus();
        }
        else if (!dayFocused) {
            focusOnDayElem(startElem);
        }
        else {
            getNextAvailableDay(startElem, offset);
        }
    }
    function buildMonthDays(year, month) {
        var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
        var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12, year);
        var daysInMonth = self.utils.getDaysInMonth(month, year), days = window.document.createDocumentFragment(), isMultiMonth = self.config.showMonths > 1, prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay", nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
        var dayNumber = prevMonthDays + 1 - firstOfMonth, dayIndex = 0;
        for (; dayNumber <= prevMonthDays; dayNumber++, dayIndex++) {
            days.appendChild(createDay("flatpickr-day " + prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
        }
        for (dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++) {
            days.appendChild(createDay("flatpickr-day", new Date(year, month, dayNumber), dayNumber, dayIndex));
        }
        for (var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth &&
            (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++) {
            days.appendChild(createDay("flatpickr-day " + nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
        }
        var dayContainer = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)("div", "dayContainer");
        dayContainer.appendChild(days);
        return dayContainer;
    }
    function buildDays() {
        if (self.daysContainer === undefined) {
            return;
        }
        (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.clearNode)(self.daysContainer);
        if (self.weekNumbers)
            (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.clearNode)(self.weekNumbers);
        var frag = document.createDocumentFragment();
        for (var i = 0; i < self.config.showMonths; i++) {
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
        }
        self.daysContainer.appendChild(frag);
        self.days = self.daysContainer.firstChild;
        if (self.config.mode === "range" && self.selectedDates.length === 1) {
            onMouseOver();
        }
    }
    function buildMonthSwitch() {
        if (self.config.showMonths > 1 ||
            self.config.monthSelectorType !== "dropdown")
            return;
        var shouldBuildMonth = function (month) {
            if (self.config.minDate !== undefined &&
                self.currentYear === self.config.minDate.getFullYear() &&
                month < self.config.minDate.getMonth()) {
                return false;
            }
            return !(self.config.maxDate !== undefined &&
                self.currentYear === self.config.maxDate.getFullYear() &&
                month > self.config.maxDate.getMonth());
        };
        self.monthsDropdownContainer.tabIndex = -1;
        self.monthsDropdownContainer.innerHTML = "";
        for (var i = 0; i < 12; i++) {
            if (!shouldBuildMonth(i))
                continue;
            var month = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)("option", "flatpickr-monthDropdown-month");
            month.value = new Date(self.currentYear, i).getMonth().toString();
            month.textContent = (0,_utils_formatting__WEBPACK_IMPORTED_MODULE_5__.monthToStr)(i, self.config.shorthandCurrentMonth, self.l10n);
            month.tabIndex = -1;
            if (self.currentMonth === i) {
                month.selected = true;
            }
            self.monthsDropdownContainer.appendChild(month);
        }
    }
    function buildMonth() {
        var container = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)("div", "flatpickr-month");
        var monthNavFragment = window.document.createDocumentFragment();
        var monthElement;
        if (self.config.showMonths > 1 ||
            self.config.monthSelectorType === "static") {
            monthElement = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)("span", "cur-month");
        }
        else {
            self.monthsDropdownContainer = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)("select", "flatpickr-monthDropdown-months");
            self.monthsDropdownContainer.setAttribute("aria-label", self.l10n.monthAriaLabel);
            bind(self.monthsDropdownContainer, "change", function (e) {
                var target = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.getEventTarget)(e);
                var selectedMonth = parseInt(target.value, 10);
                self.changeMonth(selectedMonth - self.currentMonth);
                triggerEvent("onMonthChange");
            });
            buildMonthSwitch();
            monthElement = self.monthsDropdownContainer;
        }
        var yearInput = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createNumberInput)("cur-year", { tabindex: "-1" });
        var yearElement = yearInput.getElementsByTagName("input")[0];
        yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
        if (self.config.minDate) {
            yearElement.setAttribute("min", self.config.minDate.getFullYear().toString());
        }
        if (self.config.maxDate) {
            yearElement.setAttribute("max", self.config.maxDate.getFullYear().toString());
            yearElement.disabled =
                !!self.config.minDate &&
                    self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
        }
        var currentMonth = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)("div", "flatpickr-current-month");
        currentMonth.appendChild(monthElement);
        currentMonth.appendChild(yearInput);
        monthNavFragment.appendChild(currentMonth);
        container.appendChild(monthNavFragment);
        return {
            container: container,
            yearElement: yearElement,
            monthElement: monthElement,
        };
    }
    function buildMonths() {
        (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.clearNode)(self.monthNav);
        self.monthNav.appendChild(self.prevMonthNav);
        if (self.config.showMonths) {
            self.yearElements = [];
            self.monthElements = [];
        }
        for (var m = self.config.showMonths; m--;) {
            var month = buildMonth();
            self.yearElements.push(month.yearElement);
            self.monthElements.push(month.monthElement);
            self.monthNav.appendChild(month.container);
        }
        self.monthNav.appendChild(self.nextMonthNav);
    }
    function buildMonthNav() {
        self.monthNav = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)("div", "flatpickr-months");
        self.yearElements = [];
        self.monthElements = [];
        self.prevMonthNav = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)("span", "flatpickr-prev-month");
        self.prevMonthNav.innerHTML = self.config.prevArrow;
        self.nextMonthNav = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)("span", "flatpickr-next-month");
        self.nextMonthNav.innerHTML = self.config.nextArrow;
        buildMonths();
        Object.defineProperty(self, "_hidePrevMonthArrow", {
            get: function () { return self.__hidePrevMonthArrow; },
            set: function (bool) {
                if (self.__hidePrevMonthArrow !== bool) {
                    (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.toggleClass)(self.prevMonthNav, "flatpickr-disabled", bool);
                    self.__hidePrevMonthArrow = bool;
                }
            },
        });
        Object.defineProperty(self, "_hideNextMonthArrow", {
            get: function () { return self.__hideNextMonthArrow; },
            set: function (bool) {
                if (self.__hideNextMonthArrow !== bool) {
                    (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.toggleClass)(self.nextMonthNav, "flatpickr-disabled", bool);
                    self.__hideNextMonthArrow = bool;
                }
            },
        });
        self.currentYearElement = self.yearElements[0];
        updateNavigationCurrentMonth();
        return self.monthNav;
    }
    function buildTime() {
        self.calendarContainer.classList.add("hasTime");
        if (self.config.noCalendar)
            self.calendarContainer.classList.add("noCalendar");
        var defaults = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__.getDefaultHours)(self.config);
        self.timeContainer = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)("div", "flatpickr-time");
        self.timeContainer.tabIndex = -1;
        var separator = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)("span", "flatpickr-time-separator", ":");
        var hourInput = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createNumberInput)("flatpickr-hour", {
            "aria-label": self.l10n.hourAriaLabel,
        });
        self.hourElement = hourInput.getElementsByTagName("input")[0];
        var minuteInput = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createNumberInput)("flatpickr-minute", {
            "aria-label": self.l10n.minuteAriaLabel,
        });
        self.minuteElement = minuteInput.getElementsByTagName("input")[0];
        self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
        self.hourElement.value = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.pad)(self.latestSelectedDateObj
            ? self.latestSelectedDateObj.getHours()
            : self.config.time_24hr
                ? defaults.hours
                : military2ampm(defaults.hours));
        self.minuteElement.value = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.pad)(self.latestSelectedDateObj
            ? self.latestSelectedDateObj.getMinutes()
            : defaults.minutes);
        self.hourElement.setAttribute("step", self.config.hourIncrement.toString());
        self.minuteElement.setAttribute("step", self.config.minuteIncrement.toString());
        self.hourElement.setAttribute("min", self.config.time_24hr ? "0" : "1");
        self.hourElement.setAttribute("max", self.config.time_24hr ? "23" : "12");
        self.hourElement.setAttribute("maxlength", "2");
        self.minuteElement.setAttribute("min", "0");
        self.minuteElement.setAttribute("max", "59");
        self.minuteElement.setAttribute("maxlength", "2");
        self.timeContainer.appendChild(hourInput);
        self.timeContainer.appendChild(separator);
        self.timeContainer.appendChild(minuteInput);
        if (self.config.time_24hr)
            self.timeContainer.classList.add("time24hr");
        if (self.config.enableSeconds) {
            self.timeContainer.classList.add("hasSeconds");
            var secondInput = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createNumberInput)("flatpickr-second");
            self.secondElement = secondInput.getElementsByTagName("input")[0];
            self.secondElement.value = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.pad)(self.latestSelectedDateObj
                ? self.latestSelectedDateObj.getSeconds()
                : defaults.seconds);
            self.secondElement.setAttribute("step", self.minuteElement.getAttribute("step"));
            self.secondElement.setAttribute("min", "0");
            self.secondElement.setAttribute("max", "59");
            self.secondElement.setAttribute("maxlength", "2");
            self.timeContainer.appendChild((0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)("span", "flatpickr-time-separator", ":"));
            self.timeContainer.appendChild(secondInput);
        }
        if (!self.config.time_24hr) {
            self.amPM = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)("span", "flatpickr-am-pm", self.l10n.amPM[(0,_utils__WEBPACK_IMPORTED_MODULE_2__.int)((self.latestSelectedDateObj
                ? self.hourElement.value
                : self.config.defaultHour) > 11)]);
            self.amPM.title = self.l10n.toggleTitle;
            self.amPM.tabIndex = -1;
            self.timeContainer.appendChild(self.amPM);
        }
        return self.timeContainer;
    }
    function buildWeekdays() {
        if (!self.weekdayContainer)
            self.weekdayContainer = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)("div", "flatpickr-weekdays");
        else
            (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.clearNode)(self.weekdayContainer);
        for (var i = self.config.showMonths; i--;) {
            var container = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)("div", "flatpickr-weekdaycontainer");
            self.weekdayContainer.appendChild(container);
        }
        updateWeekdays();
        return self.weekdayContainer;
    }
    function updateWeekdays() {
        if (!self.weekdayContainer) {
            return;
        }
        var firstDayOfWeek = self.l10n.firstDayOfWeek;
        var weekdays = __spreadArrays(self.l10n.weekdays.shorthand);
        if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) {
            weekdays = __spreadArrays(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
        }
        for (var i = self.config.showMonths; i--;) {
            self.weekdayContainer.children[i].innerHTML = "\n      <span class='flatpickr-weekday'>\n        " + weekdays.join("</span><span class='flatpickr-weekday'>") + "\n      </span>\n      ";
        }
    }
    function buildWeeks() {
        self.calendarContainer.classList.add("hasWeeks");
        var weekWrapper = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)("div", "flatpickr-weekwrapper");
        weekWrapper.appendChild((0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
        var weekNumbers = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)("div", "flatpickr-weeks");
        weekWrapper.appendChild(weekNumbers);
        return {
            weekWrapper: weekWrapper,
            weekNumbers: weekNumbers,
        };
    }
    function changeMonth(value, isOffset) {
        if (isOffset === void 0) { isOffset = true; }
        var delta = isOffset ? value : value - self.currentMonth;
        if ((delta < 0 && self._hidePrevMonthArrow === true) ||
            (delta > 0 && self._hideNextMonthArrow === true))
            return;
        self.currentMonth += delta;
        if (self.currentMonth < 0 || self.currentMonth > 11) {
            self.currentYear += self.currentMonth > 11 ? 1 : -1;
            self.currentMonth = (self.currentMonth + 12) % 12;
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
        buildDays();
        triggerEvent("onMonthChange");
        updateNavigationCurrentMonth();
    }
    function clear(triggerChangeEvent, toInitial) {
        if (triggerChangeEvent === void 0) { triggerChangeEvent = true; }
        if (toInitial === void 0) { toInitial = true; }
        self.input.value = "";
        if (self.altInput !== undefined)
            self.altInput.value = "";
        if (self.mobileInput !== undefined)
            self.mobileInput.value = "";
        self.selectedDates = [];
        self.latestSelectedDateObj = undefined;
        if (toInitial === true) {
            self.currentYear = self._initialDate.getFullYear();
            self.currentMonth = self._initialDate.getMonth();
        }
        if (self.config.enableTime === true) {
            var _a = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__.getDefaultHours)(self.config), hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds;
            setHours(hours, minutes, seconds);
        }
        self.redraw();
        if (triggerChangeEvent)
            triggerEvent("onChange");
    }
    function close() {
        self.isOpen = false;
        if (!self.isMobile) {
            if (self.calendarContainer !== undefined) {
                self.calendarContainer.classList.remove("open");
            }
            if (self._input !== undefined) {
                self._input.classList.remove("active");
            }
        }
        triggerEvent("onClose");
    }
    function destroy() {
        if (self.config !== undefined)
            triggerEvent("onDestroy");
        for (var i = self._handlers.length; i--;) {
            self._handlers[i].remove();
        }
        self._handlers = [];
        if (self.mobileInput) {
            if (self.mobileInput.parentNode)
                self.mobileInput.parentNode.removeChild(self.mobileInput);
            self.mobileInput = undefined;
        }
        else if (self.calendarContainer && self.calendarContainer.parentNode) {
            if (self.config.static && self.calendarContainer.parentNode) {
                var wrapper = self.calendarContainer.parentNode;
                wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
                if (wrapper.parentNode) {
                    while (wrapper.firstChild)
                        wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
                    wrapper.parentNode.removeChild(wrapper);
                }
            }
            else
                self.calendarContainer.parentNode.removeChild(self.calendarContainer);
        }
        if (self.altInput) {
            self.input.type = "text";
            if (self.altInput.parentNode)
                self.altInput.parentNode.removeChild(self.altInput);
            delete self.altInput;
        }
        if (self.input) {
            self.input.type = self.input._type;
            self.input.classList.remove("flatpickr-input");
            self.input.removeAttribute("readonly");
        }
        [
            "_showTimeInput",
            "latestSelectedDateObj",
            "_hideNextMonthArrow",
            "_hidePrevMonthArrow",
            "__hideNextMonthArrow",
            "__hidePrevMonthArrow",
            "isMobile",
            "isOpen",
            "selectedDateElem",
            "minDateHasTime",
            "maxDateHasTime",
            "days",
            "daysContainer",
            "_input",
            "_positionElement",
            "innerContainer",
            "rContainer",
            "monthNav",
            "todayDateElem",
            "calendarContainer",
            "weekdayContainer",
            "prevMonthNav",
            "nextMonthNav",
            "monthsDropdownContainer",
            "currentMonthElement",
            "currentYearElement",
            "navigationCurrentMonth",
            "selectedDateElem",
            "config",
        ].forEach(function (k) {
            try {
                delete self[k];
            }
            catch (_) { }
        });
    }
    function isCalendarElem(elem) {
        return self.calendarContainer.contains(elem);
    }
    function documentClick(e) {
        if (self.isOpen && !self.config.inline) {
            var eventTarget_1 = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.getEventTarget)(e);
            var isCalendarElement = isCalendarElem(eventTarget_1);
            var isInput = eventTarget_1 === self.input ||
                eventTarget_1 === self.altInput ||
                self.element.contains(eventTarget_1) ||
                (e.path &&
                    e.path.indexOf &&
                    (~e.path.indexOf(self.input) ||
                        ~e.path.indexOf(self.altInput)));
            var lostFocus = !isInput &&
                !isCalendarElement &&
                !isCalendarElem(e.relatedTarget);
            var isIgnored = !self.config.ignoredFocusElements.some(function (elem) {
                return elem.contains(eventTarget_1);
            });
            if (lostFocus && isIgnored) {
                if (self.config.allowInput) {
                    self.setDate(self._input.value, false, self.config.altInput
                        ? self.config.altFormat
                        : self.config.dateFormat);
                }
                if (self.timeContainer !== undefined &&
                    self.minuteElement !== undefined &&
                    self.hourElement !== undefined &&
                    self.input.value !== "" &&
                    self.input.value !== undefined) {
                    updateTime();
                }
                self.close();
                if (self.config &&
                    self.config.mode === "range" &&
                    self.selectedDates.length === 1)
                    self.clear(false);
            }
        }
    }
    function changeYear(newYear) {
        if (!newYear ||
            (self.config.minDate && newYear < self.config.minDate.getFullYear()) ||
            (self.config.maxDate && newYear > self.config.maxDate.getFullYear()))
            return;
        var newYearNum = newYear, isNewYear = self.currentYear !== newYearNum;
        self.currentYear = newYearNum || self.currentYear;
        if (self.config.maxDate &&
            self.currentYear === self.config.maxDate.getFullYear()) {
            self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
        }
        else if (self.config.minDate &&
            self.currentYear === self.config.minDate.getFullYear()) {
            self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
        }
        if (isNewYear) {
            self.redraw();
            triggerEvent("onYearChange");
            buildMonthSwitch();
        }
    }
    function isEnabled(date, timeless) {
        var _a;
        if (timeless === void 0) { timeless = true; }
        var dateToCheck = self.parseDate(date, undefined, timeless);
        if ((self.config.minDate &&
            dateToCheck &&
            (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__.compareDates)(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0) ||
            (self.config.maxDate &&
                dateToCheck &&
                (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__.compareDates)(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0))
            return false;
        if (!self.config.enable && self.config.disable.length === 0)
            return true;
        if (dateToCheck === undefined)
            return false;
        var bool = !!self.config.enable, array = (_a = self.config.enable) !== null && _a !== void 0 ? _a : self.config.disable;
        for (var i = 0, d = void 0; i < array.length; i++) {
            d = array[i];
            if (typeof d === "function" &&
                d(dateToCheck))
                return bool;
            else if (d instanceof Date &&
                dateToCheck !== undefined &&
                d.getTime() === dateToCheck.getTime())
                return bool;
            else if (typeof d === "string") {
                var parsed = self.parseDate(d, undefined, true);
                return parsed && parsed.getTime() === dateToCheck.getTime()
                    ? bool
                    : !bool;
            }
            else if (typeof d === "object" &&
                dateToCheck !== undefined &&
                d.from &&
                d.to &&
                dateToCheck.getTime() >= d.from.getTime() &&
                dateToCheck.getTime() <= d.to.getTime())
                return bool;
        }
        return !bool;
    }
    function isInView(elem) {
        if (self.daysContainer !== undefined)
            return (elem.className.indexOf("hidden") === -1 &&
                elem.className.indexOf("flatpickr-disabled") === -1 &&
                self.daysContainer.contains(elem));
        return false;
    }
    function onBlur(e) {
        var isInput = e.target === self._input;
        var valueChanged = self._input.value.trimEnd() !== getDateStr();
        if (isInput &&
            valueChanged &&
            !(e.relatedTarget && isCalendarElem(e.relatedTarget))) {
            self.setDate(self._input.value, true, e.target === self.altInput
                ? self.config.altFormat
                : self.config.dateFormat);
        }
    }
    function onKeyDown(e) {
        var eventTarget = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.getEventTarget)(e);
        var isInput = self.config.wrap
            ? element.contains(eventTarget)
            : eventTarget === self._input;
        var allowInput = self.config.allowInput;
        var allowKeydown = self.isOpen && (!allowInput || !isInput);
        var allowInlineKeydown = self.config.inline && isInput && !allowInput;
        if (e.keyCode === 13 && isInput) {
            if (allowInput) {
                self.setDate(self._input.value, true, eventTarget === self.altInput
                    ? self.config.altFormat
                    : self.config.dateFormat);
                self.close();
                return eventTarget.blur();
            }
            else {
                self.open();
            }
        }
        else if (isCalendarElem(eventTarget) ||
            allowKeydown ||
            allowInlineKeydown) {
            var isTimeObj = !!self.timeContainer &&
                self.timeContainer.contains(eventTarget);
            switch (e.keyCode) {
                case 13:
                    if (isTimeObj) {
                        e.preventDefault();
                        updateTime();
                        focusAndClose();
                    }
                    else
                        selectDate(e);
                    break;
                case 27:
                    e.preventDefault();
                    focusAndClose();
                    break;
                case 8:
                case 46:
                    if (isInput && !self.config.allowInput) {
                        e.preventDefault();
                        self.clear();
                    }
                    break;
                case 37:
                case 39:
                    if (!isTimeObj && !isInput) {
                        e.preventDefault();
                        var activeElement = getClosestActiveElement();
                        if (self.daysContainer !== undefined &&
                            (allowInput === false ||
                                (activeElement && isInView(activeElement)))) {
                            var delta_1 = e.keyCode === 39 ? 1 : -1;
                            if (!e.ctrlKey)
                                focusOnDay(undefined, delta_1);
                            else {
                                e.stopPropagation();
                                changeMonth(delta_1);
                                focusOnDay(getFirstAvailableDay(1), 0);
                            }
                        }
                    }
                    else if (self.hourElement)
                        self.hourElement.focus();
                    break;
                case 38:
                case 40:
                    e.preventDefault();
                    var delta = e.keyCode === 40 ? 1 : -1;
                    if ((self.daysContainer &&
                        eventTarget.$i !== undefined) ||
                        eventTarget === self.input ||
                        eventTarget === self.altInput) {
                        if (e.ctrlKey) {
                            e.stopPropagation();
                            changeYear(self.currentYear - delta);
                            focusOnDay(getFirstAvailableDay(1), 0);
                        }
                        else if (!isTimeObj)
                            focusOnDay(undefined, delta * 7);
                    }
                    else if (eventTarget === self.currentYearElement) {
                        changeYear(self.currentYear - delta);
                    }
                    else if (self.config.enableTime) {
                        if (!isTimeObj && self.hourElement)
                            self.hourElement.focus();
                        updateTime(e);
                        self._debouncedChange();
                    }
                    break;
                case 9:
                    if (isTimeObj) {
                        var elems = [
                            self.hourElement,
                            self.minuteElement,
                            self.secondElement,
                            self.amPM,
                        ]
                            .concat(self.pluginElements)
                            .filter(function (x) { return x; });
                        var i = elems.indexOf(eventTarget);
                        if (i !== -1) {
                            var target = elems[i + (e.shiftKey ? -1 : 1)];
                            e.preventDefault();
                            (target || self._input).focus();
                        }
                    }
                    else if (!self.config.noCalendar &&
                        self.daysContainer &&
                        self.daysContainer.contains(eventTarget) &&
                        e.shiftKey) {
                        e.preventDefault();
                        self._input.focus();
                    }
                    break;
                default:
                    break;
            }
        }
        if (self.amPM !== undefined && eventTarget === self.amPM) {
            switch (e.key) {
                case self.l10n.amPM[0].charAt(0):
                case self.l10n.amPM[0].charAt(0).toLowerCase():
                    self.amPM.textContent = self.l10n.amPM[0];
                    setHoursFromInputs();
                    updateValue();
                    break;
                case self.l10n.amPM[1].charAt(0):
                case self.l10n.amPM[1].charAt(0).toLowerCase():
                    self.amPM.textContent = self.l10n.amPM[1];
                    setHoursFromInputs();
                    updateValue();
                    break;
            }
        }
        if (isInput || isCalendarElem(eventTarget)) {
            triggerEvent("onKeyDown", e);
        }
    }
    function onMouseOver(elem, cellClass) {
        if (cellClass === void 0) { cellClass = "flatpickr-day"; }
        if (self.selectedDates.length !== 1 ||
            (elem &&
                (!elem.classList.contains(cellClass) ||
                    elem.classList.contains("flatpickr-disabled"))))
            return;
        var hoverDate = elem
            ? elem.dateObj.getTime()
            : self.days.firstElementChild.dateObj.getTime(), initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(), rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()), rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime());
        var containsDisabled = false;
        var minRange = 0, maxRange = 0;
        for (var t = rangeStartDate; t < rangeEndDate; t += _utils_dates__WEBPACK_IMPORTED_MODULE_4__.duration.DAY) {
            if (!isEnabled(new Date(t), true)) {
                containsDisabled =
                    containsDisabled || (t > rangeStartDate && t < rangeEndDate);
                if (t < initialDate && (!minRange || t > minRange))
                    minRange = t;
                else if (t > initialDate && (!maxRange || t < maxRange))
                    maxRange = t;
            }
        }
        var hoverableCells = Array.from(self.rContainer.querySelectorAll("*:nth-child(-n+" + self.config.showMonths + ") > ." + cellClass));
        hoverableCells.forEach(function (dayElem) {
            var date = dayElem.dateObj;
            var timestamp = date.getTime();
            var outOfRange = (minRange > 0 && timestamp < minRange) ||
                (maxRange > 0 && timestamp > maxRange);
            if (outOfRange) {
                dayElem.classList.add("notAllowed");
                ["inRange", "startRange", "endRange"].forEach(function (c) {
                    dayElem.classList.remove(c);
                });
                return;
            }
            else if (containsDisabled && !outOfRange)
                return;
            ["startRange", "inRange", "endRange", "notAllowed"].forEach(function (c) {
                dayElem.classList.remove(c);
            });
            if (elem !== undefined) {
                elem.classList.add(hoverDate <= self.selectedDates[0].getTime()
                    ? "startRange"
                    : "endRange");
                if (initialDate < hoverDate && timestamp === initialDate)
                    dayElem.classList.add("startRange");
                else if (initialDate > hoverDate && timestamp === initialDate)
                    dayElem.classList.add("endRange");
                if (timestamp >= minRange &&
                    (maxRange === 0 || timestamp <= maxRange) &&
                    (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__.isBetween)(timestamp, initialDate, hoverDate))
                    dayElem.classList.add("inRange");
            }
        });
    }
    function onResize() {
        if (self.isOpen && !self.config.static && !self.config.inline)
            positionCalendar();
    }
    function open(e, positionElement) {
        if (positionElement === void 0) { positionElement = self._positionElement; }
        if (self.isMobile === true) {
            if (e) {
                e.preventDefault();
                var eventTarget = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.getEventTarget)(e);
                if (eventTarget) {
                    eventTarget.blur();
                }
            }
            if (self.mobileInput !== undefined) {
                self.mobileInput.focus();
                self.mobileInput.click();
            }
            triggerEvent("onOpen");
            return;
        }
        else if (self._input.disabled || self.config.inline) {
            return;
        }
        var wasOpen = self.isOpen;
        self.isOpen = true;
        if (!wasOpen) {
            self.calendarContainer.classList.add("open");
            self._input.classList.add("active");
            triggerEvent("onOpen");
            positionCalendar(positionElement);
        }
        if (self.config.enableTime === true && self.config.noCalendar === true) {
            if (self.config.allowInput === false &&
                (e === undefined ||
                    !self.timeContainer.contains(e.relatedTarget))) {
                setTimeout(function () { return self.hourElement.select(); }, 50);
            }
        }
    }
    function minMaxDateSetter(type) {
        return function (date) {
            var dateObj = (self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat));
            var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
            if (dateObj !== undefined) {
                self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] =
                    dateObj.getHours() > 0 ||
                        dateObj.getMinutes() > 0 ||
                        dateObj.getSeconds() > 0;
            }
            if (self.selectedDates) {
                self.selectedDates = self.selectedDates.filter(function (d) { return isEnabled(d); });
                if (!self.selectedDates.length && type === "min")
                    setHoursFromDate(dateObj);
                updateValue();
            }
            if (self.daysContainer) {
                redraw();
                if (dateObj !== undefined)
                    self.currentYearElement[type] = dateObj.getFullYear().toString();
                else
                    self.currentYearElement.removeAttribute(type);
                self.currentYearElement.disabled =
                    !!inverseDateObj &&
                        dateObj !== undefined &&
                        inverseDateObj.getFullYear() === dateObj.getFullYear();
            }
        };
    }
    function parseConfig() {
        var boolOpts = [
            "wrap",
            "weekNumbers",
            "allowInput",
            "allowInvalidPreload",
            "clickOpens",
            "time_24hr",
            "enableTime",
            "noCalendar",
            "altInput",
            "shorthandCurrentMonth",
            "inline",
            "static",
            "enableSeconds",
            "disableMobile",
        ];
        var userConfig = __assign(__assign({}, JSON.parse(JSON.stringify(element.dataset || {}))), instanceConfig);
        var formats = {};
        self.config.parseDate = userConfig.parseDate;
        self.config.formatDate = userConfig.formatDate;
        Object.defineProperty(self.config, "enable", {
            get: function () { return self.config._enable; },
            set: function (dates) {
                self.config._enable = parseDateRules(dates);
            },
        });
        Object.defineProperty(self.config, "disable", {
            get: function () { return self.config._disable; },
            set: function (dates) {
                self.config._disable = parseDateRules(dates);
            },
        });
        var timeMode = userConfig.mode === "time";
        if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
            var defaultDateFormat = flatpickr.defaultConfig.dateFormat || _types_options__WEBPACK_IMPORTED_MODULE_0__.defaults.dateFormat;
            formats.dateFormat =
                userConfig.noCalendar || timeMode
                    ? "H:i" + (userConfig.enableSeconds ? ":S" : "")
                    : defaultDateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
        }
        if (userConfig.altInput &&
            (userConfig.enableTime || timeMode) &&
            !userConfig.altFormat) {
            var defaultAltFormat = flatpickr.defaultConfig.altFormat || _types_options__WEBPACK_IMPORTED_MODULE_0__.defaults.altFormat;
            formats.altFormat =
                userConfig.noCalendar || timeMode
                    ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K")
                    : defaultAltFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
        }
        Object.defineProperty(self.config, "minDate", {
            get: function () { return self.config._minDate; },
            set: minMaxDateSetter("min"),
        });
        Object.defineProperty(self.config, "maxDate", {
            get: function () { return self.config._maxDate; },
            set: minMaxDateSetter("max"),
        });
        var minMaxTimeSetter = function (type) { return function (val) {
            self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i:S");
        }; };
        Object.defineProperty(self.config, "minTime", {
            get: function () { return self.config._minTime; },
            set: minMaxTimeSetter("min"),
        });
        Object.defineProperty(self.config, "maxTime", {
            get: function () { return self.config._maxTime; },
            set: minMaxTimeSetter("max"),
        });
        if (userConfig.mode === "time") {
            self.config.noCalendar = true;
            self.config.enableTime = true;
        }
        Object.assign(self.config, formats, userConfig);
        for (var i = 0; i < boolOpts.length; i++)
            self.config[boolOpts[i]] =
                self.config[boolOpts[i]] === true ||
                    self.config[boolOpts[i]] === "true";
        _types_options__WEBPACK_IMPORTED_MODULE_0__.HOOKS.filter(function (hook) { return self.config[hook] !== undefined; }).forEach(function (hook) {
            self.config[hook] = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.arrayify)(self.config[hook] || []).map(bindToInstance);
        });
        self.isMobile =
            !self.config.disableMobile &&
                !self.config.inline &&
                self.config.mode === "single" &&
                !self.config.disable.length &&
                !self.config.enable &&
                !self.config.weekNumbers &&
                /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        for (var i = 0; i < self.config.plugins.length; i++) {
            var pluginConf = self.config.plugins[i](self) || {};
            for (var key in pluginConf) {
                if (_types_options__WEBPACK_IMPORTED_MODULE_0__.HOOKS.indexOf(key) > -1) {
                    self.config[key] = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.arrayify)(pluginConf[key])
                        .map(bindToInstance)
                        .concat(self.config[key]);
                }
                else if (typeof userConfig[key] === "undefined")
                    self.config[key] = pluginConf[key];
            }
        }
        if (!userConfig.altInputClass) {
            self.config.altInputClass =
                getInputElem().className + " " + self.config.altInputClass;
        }
        triggerEvent("onParseConfig");
    }
    function getInputElem() {
        return self.config.wrap
            ? element.querySelector("[data-input]")
            : element;
    }
    function setupLocale() {
        if (typeof self.config.locale !== "object" &&
            typeof flatpickr.l10ns[self.config.locale] === "undefined")
            self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
        self.l10n = __assign(__assign({}, flatpickr.l10ns.default), (typeof self.config.locale === "object"
            ? self.config.locale
            : self.config.locale !== "default"
                ? flatpickr.l10ns[self.config.locale]
                : undefined));
        _utils_formatting__WEBPACK_IMPORTED_MODULE_5__.tokenRegex.D = "(" + self.l10n.weekdays.shorthand.join("|") + ")";
        _utils_formatting__WEBPACK_IMPORTED_MODULE_5__.tokenRegex.l = "(" + self.l10n.weekdays.longhand.join("|") + ")";
        _utils_formatting__WEBPACK_IMPORTED_MODULE_5__.tokenRegex.M = "(" + self.l10n.months.shorthand.join("|") + ")";
        _utils_formatting__WEBPACK_IMPORTED_MODULE_5__.tokenRegex.F = "(" + self.l10n.months.longhand.join("|") + ")";
        _utils_formatting__WEBPACK_IMPORTED_MODULE_5__.tokenRegex.K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
        var userConfig = __assign(__assign({}, instanceConfig), JSON.parse(JSON.stringify(element.dataset || {})));
        if (userConfig.time_24hr === undefined &&
            flatpickr.defaultConfig.time_24hr === undefined) {
            self.config.time_24hr = self.l10n.time_24hr;
        }
        self.formatDate = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__.createDateFormatter)(self);
        self.parseDate = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__.createDateParser)({ config: self.config, l10n: self.l10n });
    }
    function positionCalendar(customPositionElement) {
        if (typeof self.config.position === "function") {
            return void self.config.position(self, customPositionElement);
        }
        if (self.calendarContainer === undefined)
            return;
        triggerEvent("onPreCalendarPosition");
        var positionElement = customPositionElement || self._positionElement;
        var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, (function (acc, child) { return acc + child.offsetHeight; }), 0), calendarWidth = self.calendarContainer.offsetWidth, configPos = self.config.position.split(" "), configPosVertical = configPos[0], configPosHorizontal = configPos.length > 1 ? configPos[1] : null, inputBounds = positionElement.getBoundingClientRect(), distanceFromBottom = window.innerHeight - inputBounds.bottom, showOnTop = configPosVertical === "above" ||
            (configPosVertical !== "below" &&
                distanceFromBottom < calendarHeight &&
                inputBounds.top > calendarHeight);
        var top = window.pageYOffset +
            inputBounds.top +
            (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
        (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.toggleClass)(self.calendarContainer, "arrowTop", !showOnTop);
        (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.toggleClass)(self.calendarContainer, "arrowBottom", showOnTop);
        if (self.config.inline)
            return;
        var left = window.pageXOffset + inputBounds.left;
        var isCenter = false;
        var isRight = false;
        if (configPosHorizontal === "center") {
            left -= (calendarWidth - inputBounds.width) / 2;
            isCenter = true;
        }
        else if (configPosHorizontal === "right") {
            left -= calendarWidth - inputBounds.width;
            isRight = true;
        }
        (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.toggleClass)(self.calendarContainer, "arrowLeft", !isCenter && !isRight);
        (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.toggleClass)(self.calendarContainer, "arrowCenter", isCenter);
        (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.toggleClass)(self.calendarContainer, "arrowRight", isRight);
        var right = window.document.body.offsetWidth -
            (window.pageXOffset + inputBounds.right);
        var rightMost = left + calendarWidth > window.document.body.offsetWidth;
        var centerMost = right + calendarWidth > window.document.body.offsetWidth;
        (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.toggleClass)(self.calendarContainer, "rightMost", rightMost);
        if (self.config.static)
            return;
        self.calendarContainer.style.top = top + "px";
        if (!rightMost) {
            self.calendarContainer.style.left = left + "px";
            self.calendarContainer.style.right = "auto";
        }
        else if (!centerMost) {
            self.calendarContainer.style.left = "auto";
            self.calendarContainer.style.right = right + "px";
        }
        else {
            var doc = getDocumentStyleSheet();
            if (doc === undefined)
                return;
            var bodyWidth = window.document.body.offsetWidth;
            var centerLeft = Math.max(0, bodyWidth / 2 - calendarWidth / 2);
            var centerBefore = ".flatpickr-calendar.centerMost:before";
            var centerAfter = ".flatpickr-calendar.centerMost:after";
            var centerIndex = doc.cssRules.length;
            var centerStyle = "{left:" + inputBounds.left + "px;right:auto;}";
            (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.toggleClass)(self.calendarContainer, "rightMost", false);
            (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.toggleClass)(self.calendarContainer, "centerMost", true);
            doc.insertRule(centerBefore + "," + centerAfter + centerStyle, centerIndex);
            self.calendarContainer.style.left = centerLeft + "px";
            self.calendarContainer.style.right = "auto";
        }
    }
    function getDocumentStyleSheet() {
        var editableSheet = null;
        for (var i = 0; i < document.styleSheets.length; i++) {
            var sheet = document.styleSheets[i];
            if (!sheet.cssRules)
                continue;
            try {
                sheet.cssRules;
            }
            catch (err) {
                continue;
            }
            editableSheet = sheet;
            break;
        }
        return editableSheet != null ? editableSheet : createStyleSheet();
    }
    function createStyleSheet() {
        var style = document.createElement("style");
        document.head.appendChild(style);
        return style.sheet;
    }
    function redraw() {
        if (self.config.noCalendar || self.isMobile)
            return;
        buildMonthSwitch();
        updateNavigationCurrentMonth();
        buildDays();
    }
    function focusAndClose() {
        self._input.focus();
        if (window.navigator.userAgent.indexOf("MSIE") !== -1 ||
            navigator.msMaxTouchPoints !== undefined) {
            setTimeout(self.close, 0);
        }
        else {
            self.close();
        }
    }
    function selectDate(e) {
        e.preventDefault();
        e.stopPropagation();
        var isSelectable = function (day) {
            return day.classList &&
                day.classList.contains("flatpickr-day") &&
                !day.classList.contains("flatpickr-disabled") &&
                !day.classList.contains("notAllowed");
        };
        var t = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.findParent)((0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.getEventTarget)(e), isSelectable);
        if (t === undefined)
            return;
        var target = t;
        var selectedDate = (self.latestSelectedDateObj = new Date(target.dateObj.getTime()));
        var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth ||
            selectedDate.getMonth() >
                self.currentMonth + self.config.showMonths - 1) &&
            self.config.mode !== "range";
        self.selectedDateElem = target;
        if (self.config.mode === "single")
            self.selectedDates = [selectedDate];
        else if (self.config.mode === "multiple") {
            var selectedIndex = isDateSelected(selectedDate);
            if (selectedIndex)
                self.selectedDates.splice(parseInt(selectedIndex), 1);
            else
                self.selectedDates.push(selectedDate);
        }
        else if (self.config.mode === "range") {
            if (self.selectedDates.length === 2) {
                self.clear(false, false);
            }
            self.latestSelectedDateObj = selectedDate;
            self.selectedDates.push(selectedDate);
            if ((0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__.compareDates)(selectedDate, self.selectedDates[0], true) !== 0)
                self.selectedDates.sort(function (a, b) { return a.getTime() - b.getTime(); });
        }
        setHoursFromInputs();
        if (shouldChangeMonth) {
            var isNewYear = self.currentYear !== selectedDate.getFullYear();
            self.currentYear = selectedDate.getFullYear();
            self.currentMonth = selectedDate.getMonth();
            if (isNewYear) {
                triggerEvent("onYearChange");
                buildMonthSwitch();
            }
            triggerEvent("onMonthChange");
        }
        updateNavigationCurrentMonth();
        buildDays();
        updateValue();
        if (!shouldChangeMonth &&
            self.config.mode !== "range" &&
            self.config.showMonths === 1)
            focusOnDayElem(target);
        else if (self.selectedDateElem !== undefined &&
            self.hourElement === undefined) {
            self.selectedDateElem && self.selectedDateElem.focus();
        }
        if (self.hourElement !== undefined)
            self.hourElement !== undefined && self.hourElement.focus();
        if (self.config.closeOnSelect) {
            var single = self.config.mode === "single" && !self.config.enableTime;
            var range = self.config.mode === "range" &&
                self.selectedDates.length === 2 &&
                !self.config.enableTime;
            if (single || range) {
                focusAndClose();
            }
        }
        triggerChange();
    }
    var CALLBACKS = {
        locale: [setupLocale, updateWeekdays],
        showMonths: [buildMonths, setCalendarWidth, buildWeekdays],
        minDate: [jumpToDate],
        maxDate: [jumpToDate],
        positionElement: [updatePositionElement],
        clickOpens: [
            function () {
                if (self.config.clickOpens === true) {
                    bind(self._input, "focus", self.open);
                    bind(self._input, "click", self.open);
                }
                else {
                    self._input.removeEventListener("focus", self.open);
                    self._input.removeEventListener("click", self.open);
                }
            },
        ],
    };
    function set(option, value) {
        if (option !== null && typeof option === "object") {
            Object.assign(self.config, option);
            for (var key in option) {
                if (CALLBACKS[key] !== undefined)
                    CALLBACKS[key].forEach(function (x) { return x(); });
            }
        }
        else {
            self.config[option] = value;
            if (CALLBACKS[option] !== undefined)
                CALLBACKS[option].forEach(function (x) { return x(); });
            else if (_types_options__WEBPACK_IMPORTED_MODULE_0__.HOOKS.indexOf(option) > -1)
                self.config[option] = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.arrayify)(value);
        }
        self.redraw();
        updateValue(true);
    }
    function setSelectedDate(inputDate, format) {
        var dates = [];
        if (inputDate instanceof Array)
            dates = inputDate.map(function (d) { return self.parseDate(d, format); });
        else if (inputDate instanceof Date || typeof inputDate === "number")
            dates = [self.parseDate(inputDate, format)];
        else if (typeof inputDate === "string") {
            switch (self.config.mode) {
                case "single":
                case "time":
                    dates = [self.parseDate(inputDate, format)];
                    break;
                case "multiple":
                    dates = inputDate
                        .split(self.config.conjunction)
                        .map(function (date) { return self.parseDate(date, format); });
                    break;
                case "range":
                    dates = inputDate
                        .split(self.l10n.rangeSeparator)
                        .map(function (date) { return self.parseDate(date, format); });
                    break;
                default:
                    break;
            }
        }
        else
            self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
        self.selectedDates = (self.config.allowInvalidPreload
            ? dates
            : dates.filter(function (d) { return d instanceof Date && isEnabled(d, false); }));
        if (self.config.mode === "range")
            self.selectedDates.sort(function (a, b) { return a.getTime() - b.getTime(); });
    }
    function setDate(date, triggerChange, format) {
        if (triggerChange === void 0) { triggerChange = false; }
        if (format === void 0) { format = self.config.dateFormat; }
        if ((date !== 0 && !date) || (date instanceof Array && date.length === 0))
            return self.clear(triggerChange);
        setSelectedDate(date, format);
        self.latestSelectedDateObj =
            self.selectedDates[self.selectedDates.length - 1];
        self.redraw();
        jumpToDate(undefined, triggerChange);
        setHoursFromDate();
        if (self.selectedDates.length === 0) {
            self.clear(false);
        }
        updateValue(triggerChange);
        if (triggerChange)
            triggerEvent("onChange");
    }
    function parseDateRules(arr) {
        return arr
            .slice()
            .map(function (rule) {
            if (typeof rule === "string" ||
                typeof rule === "number" ||
                rule instanceof Date) {
                return self.parseDate(rule, undefined, true);
            }
            else if (rule &&
                typeof rule === "object" &&
                rule.from &&
                rule.to)
                return {
                    from: self.parseDate(rule.from, undefined),
                    to: self.parseDate(rule.to, undefined),
                };
            return rule;
        })
            .filter(function (x) { return x; });
    }
    function setupDates() {
        self.selectedDates = [];
        self.now = self.parseDate(self.config.now) || new Date();
        var preloadedDate = self.config.defaultDate ||
            ((self.input.nodeName === "INPUT" ||
                self.input.nodeName === "TEXTAREA") &&
                self.input.placeholder &&
                self.input.value === self.input.placeholder
                ? null
                : self.input.value);
        if (preloadedDate)
            setSelectedDate(preloadedDate, self.config.dateFormat);
        self._initialDate =
            self.selectedDates.length > 0
                ? self.selectedDates[0]
                : self.config.minDate &&
                    self.config.minDate.getTime() > self.now.getTime()
                    ? self.config.minDate
                    : self.config.maxDate &&
                        self.config.maxDate.getTime() < self.now.getTime()
                        ? self.config.maxDate
                        : self.now;
        self.currentYear = self._initialDate.getFullYear();
        self.currentMonth = self._initialDate.getMonth();
        if (self.selectedDates.length > 0)
            self.latestSelectedDateObj = self.selectedDates[0];
        if (self.config.minTime !== undefined)
            self.config.minTime = self.parseDate(self.config.minTime, "H:i");
        if (self.config.maxTime !== undefined)
            self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
        self.minDateHasTime =
            !!self.config.minDate &&
                (self.config.minDate.getHours() > 0 ||
                    self.config.minDate.getMinutes() > 0 ||
                    self.config.minDate.getSeconds() > 0);
        self.maxDateHasTime =
            !!self.config.maxDate &&
                (self.config.maxDate.getHours() > 0 ||
                    self.config.maxDate.getMinutes() > 0 ||
                    self.config.maxDate.getSeconds() > 0);
    }
    function setupInputs() {
        self.input = getInputElem();
        if (!self.input) {
            self.config.errorHandler(new Error("Invalid input element specified"));
            return;
        }
        self.input._type = self.input.type;
        self.input.type = "text";
        self.input.classList.add("flatpickr-input");
        self._input = self.input;
        if (self.config.altInput) {
            self.altInput = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)(self.input.nodeName, self.config.altInputClass);
            self._input = self.altInput;
            self.altInput.placeholder = self.input.placeholder;
            self.altInput.disabled = self.input.disabled;
            self.altInput.required = self.input.required;
            self.altInput.tabIndex = self.input.tabIndex;
            self.altInput.type = "text";
            self.input.setAttribute("type", "hidden");
            if (!self.config.static && self.input.parentNode)
                self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
        }
        if (!self.config.allowInput)
            self._input.setAttribute("readonly", "readonly");
        updatePositionElement();
    }
    function updatePositionElement() {
        self._positionElement = self.config.positionElement || self._input;
    }
    function setupMobile() {
        var inputType = self.config.enableTime
            ? self.config.noCalendar
                ? "time"
                : "datetime-local"
            : "date";
        self.mobileInput = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.createElement)("input", self.input.className + " flatpickr-mobile");
        self.mobileInput.tabIndex = 1;
        self.mobileInput.type = inputType;
        self.mobileInput.disabled = self.input.disabled;
        self.mobileInput.required = self.input.required;
        self.mobileInput.placeholder = self.input.placeholder;
        self.mobileFormatStr =
            inputType === "datetime-local"
                ? "Y-m-d\\TH:i:S"
                : inputType === "date"
                    ? "Y-m-d"
                    : "H:i:S";
        if (self.selectedDates.length > 0) {
            self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
        }
        if (self.config.minDate)
            self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
        if (self.config.maxDate)
            self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
        if (self.input.getAttribute("step"))
            self.mobileInput.step = String(self.input.getAttribute("step"));
        self.input.type = "hidden";
        if (self.altInput !== undefined)
            self.altInput.type = "hidden";
        try {
            if (self.input.parentNode)
                self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
        }
        catch (_a) { }
        bind(self.mobileInput, "change", function (e) {
            self.setDate((0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.getEventTarget)(e).value, false, self.mobileFormatStr);
            triggerEvent("onChange");
            triggerEvent("onClose");
        });
    }
    function toggle(e) {
        if (self.isOpen === true)
            return self.close();
        self.open(e);
    }
    function triggerEvent(event, data) {
        if (self.config === undefined)
            return;
        var hooks = self.config[event];
        if (hooks !== undefined && hooks.length > 0) {
            for (var i = 0; hooks[i] && i < hooks.length; i++)
                hooks[i](self.selectedDates, self.input.value, self, data);
        }
        if (event === "onChange") {
            self.input.dispatchEvent(createEvent("change"));
            self.input.dispatchEvent(createEvent("input"));
        }
    }
    function createEvent(name) {
        var e = document.createEvent("Event");
        e.initEvent(name, true, true);
        return e;
    }
    function isDateSelected(date) {
        for (var i = 0; i < self.selectedDates.length; i++) {
            var selectedDate = self.selectedDates[i];
            if (selectedDate instanceof Date &&
                (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__.compareDates)(selectedDate, date) === 0)
                return "" + i;
        }
        return false;
    }
    function isDateInRange(date) {
        if (self.config.mode !== "range" || self.selectedDates.length < 2)
            return false;
        return ((0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__.compareDates)(date, self.selectedDates[0]) >= 0 &&
            (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__.compareDates)(date, self.selectedDates[1]) <= 0);
    }
    function updateNavigationCurrentMonth() {
        if (self.config.noCalendar || self.isMobile || !self.monthNav)
            return;
        self.yearElements.forEach(function (yearElement, i) {
            var d = new Date(self.currentYear, self.currentMonth, 1);
            d.setMonth(self.currentMonth + i);
            if (self.config.showMonths > 1 ||
                self.config.monthSelectorType === "static") {
                self.monthElements[i].textContent =
                    (0,_utils_formatting__WEBPACK_IMPORTED_MODULE_5__.monthToStr)(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
            }
            else {
                self.monthsDropdownContainer.value = d.getMonth().toString();
            }
            yearElement.value = d.getFullYear().toString();
        });
        self._hidePrevMonthArrow =
            self.config.minDate !== undefined &&
                (self.currentYear === self.config.minDate.getFullYear()
                    ? self.currentMonth <= self.config.minDate.getMonth()
                    : self.currentYear < self.config.minDate.getFullYear());
        self._hideNextMonthArrow =
            self.config.maxDate !== undefined &&
                (self.currentYear === self.config.maxDate.getFullYear()
                    ? self.currentMonth + 1 > self.config.maxDate.getMonth()
                    : self.currentYear > self.config.maxDate.getFullYear());
    }
    function getDateStr(specificFormat) {
        var format = specificFormat ||
            (self.config.altInput ? self.config.altFormat : self.config.dateFormat);
        return self.selectedDates
            .map(function (dObj) { return self.formatDate(dObj, format); })
            .filter(function (d, i, arr) {
            return self.config.mode !== "range" ||
                self.config.enableTime ||
                arr.indexOf(d) === i;
        })
            .join(self.config.mode !== "range"
            ? self.config.conjunction
            : self.l10n.rangeSeparator);
    }
    function updateValue(triggerChange) {
        if (triggerChange === void 0) { triggerChange = true; }
        if (self.mobileInput !== undefined && self.mobileFormatStr) {
            self.mobileInput.value =
                self.latestSelectedDateObj !== undefined
                    ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr)
                    : "";
        }
        self.input.value = getDateStr(self.config.dateFormat);
        if (self.altInput !== undefined) {
            self.altInput.value = getDateStr(self.config.altFormat);
        }
        if (triggerChange !== false)
            triggerEvent("onValueUpdate");
    }
    function onMonthNavClick(e) {
        var eventTarget = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.getEventTarget)(e);
        var isPrevMonth = self.prevMonthNav.contains(eventTarget);
        var isNextMonth = self.nextMonthNav.contains(eventTarget);
        if (isPrevMonth || isNextMonth) {
            changeMonth(isPrevMonth ? -1 : 1);
        }
        else if (self.yearElements.indexOf(eventTarget) >= 0) {
            eventTarget.select();
        }
        else if (eventTarget.classList.contains("arrowUp")) {
            self.changeYear(self.currentYear + 1);
        }
        else if (eventTarget.classList.contains("arrowDown")) {
            self.changeYear(self.currentYear - 1);
        }
    }
    function timeWrapper(e) {
        e.preventDefault();
        var isKeyDown = e.type === "keydown", eventTarget = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_3__.getEventTarget)(e), input = eventTarget;
        if (self.amPM !== undefined && eventTarget === self.amPM) {
            self.amPM.textContent =
                self.l10n.amPM[(0,_utils__WEBPACK_IMPORTED_MODULE_2__.int)(self.amPM.textContent === self.l10n.amPM[0])];
        }
        var min = parseFloat(input.getAttribute("min")), max = parseFloat(input.getAttribute("max")), step = parseFloat(input.getAttribute("step")), curValue = parseInt(input.value, 10), delta = e.delta ||
            (isKeyDown ? (e.which === 38 ? 1 : -1) : 0);
        var newValue = curValue + step * delta;
        if (typeof input.value !== "undefined" && input.value.length === 2) {
            var isHourElem = input === self.hourElement, isMinuteElem = input === self.minuteElement;
            if (newValue < min) {
                newValue =
                    max +
                        newValue +
                        (0,_utils__WEBPACK_IMPORTED_MODULE_2__.int)(!isHourElem) +
                        ((0,_utils__WEBPACK_IMPORTED_MODULE_2__.int)(isHourElem) && (0,_utils__WEBPACK_IMPORTED_MODULE_2__.int)(!self.amPM));
                if (isMinuteElem)
                    incrementNumInput(undefined, -1, self.hourElement);
            }
            else if (newValue > max) {
                newValue =
                    input === self.hourElement ? newValue - max - (0,_utils__WEBPACK_IMPORTED_MODULE_2__.int)(!self.amPM) : min;
                if (isMinuteElem)
                    incrementNumInput(undefined, 1, self.hourElement);
            }
            if (self.amPM &&
                isHourElem &&
                (step === 1
                    ? newValue + curValue === 23
                    : Math.abs(newValue - curValue) > step)) {
                self.amPM.textContent =
                    self.l10n.amPM[(0,_utils__WEBPACK_IMPORTED_MODULE_2__.int)(self.amPM.textContent === self.l10n.amPM[0])];
            }
            input.value = (0,_utils__WEBPACK_IMPORTED_MODULE_2__.pad)(newValue);
        }
    }
    init();
    return self;
}
function _flatpickr(nodeList, config) {
    var nodes = Array.prototype.slice
        .call(nodeList)
        .filter(function (x) { return x instanceof HTMLElement; });
    var instances = [];
    for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        try {
            if (node.getAttribute("data-fp-omit") !== null)
                continue;
            if (node._flatpickr !== undefined) {
                node._flatpickr.destroy();
                node._flatpickr = undefined;
            }
            node._flatpickr = FlatpickrInstance(node, config || {});
            instances.push(node._flatpickr);
        }
        catch (e) {
            console.error(e);
        }
    }
    return instances.length === 1 ? instances[0] : instances;
}
if (typeof HTMLElement !== "undefined" &&
    typeof HTMLCollection !== "undefined" &&
    typeof NodeList !== "undefined") {
    HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function (config) {
        return _flatpickr(this, config);
    };
    HTMLElement.prototype.flatpickr = function (config) {
        return _flatpickr([this], config);
    };
}
var flatpickr = function (selector, config) {
    if (typeof selector === "string") {
        return _flatpickr(window.document.querySelectorAll(selector), config);
    }
    else if (selector instanceof Node) {
        return _flatpickr([selector], config);
    }
    else {
        return _flatpickr(selector, config);
    }
};
flatpickr.defaultConfig = {};
flatpickr.l10ns = {
    en: __assign({}, _l10n_default__WEBPACK_IMPORTED_MODULE_1__["default"]),
    default: __assign({}, _l10n_default__WEBPACK_IMPORTED_MODULE_1__["default"]),
};
flatpickr.localize = function (l10n) {
    flatpickr.l10ns.default = __assign(__assign({}, flatpickr.l10ns.default), l10n);
};
flatpickr.setDefaults = function (config) {
    flatpickr.defaultConfig = __assign(__assign({}, flatpickr.defaultConfig), config);
};
flatpickr.parseDate = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__.createDateParser)({});
flatpickr.formatDate = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__.createDateFormatter)({});
flatpickr.compareDates = _utils_dates__WEBPACK_IMPORTED_MODULE_4__.compareDates;
if (typeof jQuery !== "undefined" && typeof jQuery.fn !== "undefined") {
    jQuery.fn.flatpickr = function (config) {
        return _flatpickr(this, config);
    };
}
Date.prototype.fp_incr = function (days) {
    return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
};
if (typeof window !== "undefined") {
    window.flatpickr = flatpickr;
}
/* harmony default export */ __webpack_exports__["default"] = (flatpickr);


/***/ }),

/***/ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/l10n/default.js":
/*!*********************************************************************************************!*\
  !*** ./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/l10n/default.js ***!
  \*********************************************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   english: function() { return /* binding */ english; }
/* harmony export */ });
var english = {
    weekdays: {
        shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
        ],
    },
    months: {
        shorthand: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ],
        longhand: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ],
    },
    daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    firstDayOfWeek: 0,
    ordinal: function (nth) {
        var s = nth % 100;
        if (s > 3 && s < 21)
            return "th";
        switch (s % 10) {
            case 1:
                return "st";
            case 2:
                return "nd";
            case 3:
                return "rd";
            default:
                return "th";
        }
    },
    rangeSeparator: " to ",
    weekAbbreviation: "Wk",
    scrollTitle: "Scroll to increment",
    toggleTitle: "Click to toggle",
    amPM: ["AM", "PM"],
    yearAriaLabel: "Year",
    monthAriaLabel: "Month",
    hourAriaLabel: "Hour",
    minuteAriaLabel: "Minute",
    time_24hr: false,
};
/* harmony default export */ __webpack_exports__["default"] = (english);


/***/ }),

/***/ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/types/options.js":
/*!**********************************************************************************************!*\
  !*** ./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/types/options.js ***!
  \**********************************************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   HOOKS: function() { return /* binding */ HOOKS; },
/* harmony export */   defaults: function() { return /* binding */ defaults; }
/* harmony export */ });
var HOOKS = [
    "onChange",
    "onClose",
    "onDayCreate",
    "onDestroy",
    "onKeyDown",
    "onMonthChange",
    "onOpen",
    "onParseConfig",
    "onReady",
    "onValueUpdate",
    "onYearChange",
    "onPreCalendarPosition",
];
var defaults = {
    _disable: [],
    allowInput: false,
    allowInvalidPreload: false,
    altFormat: "F j, Y",
    altInput: false,
    altInputClass: "form-control input",
    animate: typeof window === "object" &&
        window.navigator.userAgent.indexOf("MSIE") === -1,
    ariaDateFormat: "F j, Y",
    autoFillDefaultTime: true,
    clickOpens: true,
    closeOnSelect: true,
    conjunction: ", ",
    dateFormat: "Y-m-d",
    defaultHour: 12,
    defaultMinute: 0,
    defaultSeconds: 0,
    disable: [],
    disableMobile: false,
    enableSeconds: false,
    enableTime: false,
    errorHandler: function (err) {
        return typeof console !== "undefined" && console.warn(err);
    },
    getWeek: function (givenDate) {
        var date = new Date(givenDate.getTime());
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
        var week1 = new Date(date.getFullYear(), 0, 4);
        return (1 +
            Math.round(((date.getTime() - week1.getTime()) / 86400000 -
                3 +
                ((week1.getDay() + 6) % 7)) /
                7));
    },
    hourIncrement: 1,
    ignoredFocusElements: [],
    inline: false,
    locale: "default",
    minuteIncrement: 5,
    mode: "single",
    monthSelectorType: "dropdown",
    nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
    noCalendar: false,
    now: new Date(),
    onChange: [],
    onClose: [],
    onDayCreate: [],
    onDestroy: [],
    onKeyDown: [],
    onMonthChange: [],
    onOpen: [],
    onParseConfig: [],
    onReady: [],
    onValueUpdate: [],
    onYearChange: [],
    onPreCalendarPosition: [],
    plugins: [],
    position: "auto",
    positionElement: undefined,
    prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
    shorthandCurrentMonth: false,
    showMonths: 1,
    static: false,
    time_24hr: false,
    weekNumbers: false,
    wrap: false,
};


/***/ }),

/***/ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/utils/dates.js":
/*!********************************************************************************************!*\
  !*** ./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/utils/dates.js ***!
  \********************************************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   calculateSecondsSinceMidnight: function() { return /* binding */ calculateSecondsSinceMidnight; },
/* harmony export */   compareDates: function() { return /* binding */ compareDates; },
/* harmony export */   compareTimes: function() { return /* binding */ compareTimes; },
/* harmony export */   createDateFormatter: function() { return /* binding */ createDateFormatter; },
/* harmony export */   createDateParser: function() { return /* binding */ createDateParser; },
/* harmony export */   duration: function() { return /* binding */ duration; },
/* harmony export */   getDefaultHours: function() { return /* binding */ getDefaultHours; },
/* harmony export */   isBetween: function() { return /* binding */ isBetween; },
/* harmony export */   parseSeconds: function() { return /* binding */ parseSeconds; }
/* harmony export */ });
/* harmony import */ var _formatting__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./formatting */ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/utils/formatting.js");
/* harmony import */ var _types_options__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../types/options */ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/types/options.js");
/* harmony import */ var _l10n_default__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../l10n/default */ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/l10n/default.js");



var createDateFormatter = function (_a) {
    var _b = _a.config, config = _b === void 0 ? _types_options__WEBPACK_IMPORTED_MODULE_1__.defaults : _b, _c = _a.l10n, l10n = _c === void 0 ? _l10n_default__WEBPACK_IMPORTED_MODULE_2__.english : _c, _d = _a.isMobile, isMobile = _d === void 0 ? false : _d;
    return function (dateObj, frmt, overrideLocale) {
        var locale = overrideLocale || l10n;
        if (config.formatDate !== undefined && !isMobile) {
            return config.formatDate(dateObj, frmt, locale);
        }
        return frmt
            .split("")
            .map(function (c, i, arr) {
            return _formatting__WEBPACK_IMPORTED_MODULE_0__.formats[c] && arr[i - 1] !== "\\"
                ? _formatting__WEBPACK_IMPORTED_MODULE_0__.formats[c](dateObj, locale, config)
                : c !== "\\"
                    ? c
                    : "";
        })
            .join("");
    };
};
var createDateParser = function (_a) {
    var _b = _a.config, config = _b === void 0 ? _types_options__WEBPACK_IMPORTED_MODULE_1__.defaults : _b, _c = _a.l10n, l10n = _c === void 0 ? _l10n_default__WEBPACK_IMPORTED_MODULE_2__.english : _c;
    return function (date, givenFormat, timeless, customLocale) {
        if (date !== 0 && !date)
            return undefined;
        var locale = customLocale || l10n;
        var parsedDate;
        var dateOrig = date;
        if (date instanceof Date)
            parsedDate = new Date(date.getTime());
        else if (typeof date !== "string" &&
            date.toFixed !== undefined)
            parsedDate = new Date(date);
        else if (typeof date === "string") {
            var format = givenFormat || (config || _types_options__WEBPACK_IMPORTED_MODULE_1__.defaults).dateFormat;
            var datestr = String(date).trim();
            if (datestr === "today") {
                parsedDate = new Date();
                timeless = true;
            }
            else if (config && config.parseDate) {
                parsedDate = config.parseDate(date, format);
            }
            else if (/Z$/.test(datestr) ||
                /GMT$/.test(datestr)) {
                parsedDate = new Date(date);
            }
            else {
                var matched = void 0, ops = [];
                for (var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++) {
                    var token = format[i];
                    var isBackSlash = token === "\\";
                    var escaped = format[i - 1] === "\\" || isBackSlash;
                    if (_formatting__WEBPACK_IMPORTED_MODULE_0__.tokenRegex[token] && !escaped) {
                        regexStr += _formatting__WEBPACK_IMPORTED_MODULE_0__.tokenRegex[token];
                        var match = new RegExp(regexStr).exec(date);
                        if (match && (matched = true)) {
                            ops[token !== "Y" ? "push" : "unshift"]({
                                fn: _formatting__WEBPACK_IMPORTED_MODULE_0__.revFormat[token],
                                val: match[++matchIndex],
                            });
                        }
                    }
                    else if (!isBackSlash)
                        regexStr += ".";
                }
                parsedDate =
                    !config || !config.noCalendar
                        ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0)
                        : new Date(new Date().setHours(0, 0, 0, 0));
                ops.forEach(function (_a) {
                    var fn = _a.fn, val = _a.val;
                    return (parsedDate = fn(parsedDate, val, locale) || parsedDate);
                });
                parsedDate = matched ? parsedDate : undefined;
            }
        }
        if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
            config.errorHandler(new Error("Invalid date provided: " + dateOrig));
            return undefined;
        }
        if (timeless === true)
            parsedDate.setHours(0, 0, 0, 0);
        return parsedDate;
    };
};
function compareDates(date1, date2, timeless) {
    if (timeless === void 0) { timeless = true; }
    if (timeless !== false) {
        return (new Date(date1.getTime()).setHours(0, 0, 0, 0) -
            new Date(date2.getTime()).setHours(0, 0, 0, 0));
    }
    return date1.getTime() - date2.getTime();
}
function compareTimes(date1, date2) {
    return (3600 * (date1.getHours() - date2.getHours()) +
        60 * (date1.getMinutes() - date2.getMinutes()) +
        date1.getSeconds() -
        date2.getSeconds());
}
var isBetween = function (ts, ts1, ts2) {
    return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
};
var calculateSecondsSinceMidnight = function (hours, minutes, seconds) {
    return hours * 3600 + minutes * 60 + seconds;
};
var parseSeconds = function (secondsSinceMidnight) {
    var hours = Math.floor(secondsSinceMidnight / 3600), minutes = (secondsSinceMidnight - hours * 3600) / 60;
    return [hours, minutes, secondsSinceMidnight - hours * 3600 - minutes * 60];
};
var duration = {
    DAY: 86400000,
};
function getDefaultHours(config) {
    var hours = config.defaultHour;
    var minutes = config.defaultMinute;
    var seconds = config.defaultSeconds;
    if (config.minDate !== undefined) {
        var minHour = config.minDate.getHours();
        var minMinutes = config.minDate.getMinutes();
        var minSeconds = config.minDate.getSeconds();
        if (hours < minHour) {
            hours = minHour;
        }
        if (hours === minHour && minutes < minMinutes) {
            minutes = minMinutes;
        }
        if (hours === minHour && minutes === minMinutes && seconds < minSeconds)
            seconds = config.minDate.getSeconds();
    }
    if (config.maxDate !== undefined) {
        var maxHr = config.maxDate.getHours();
        var maxMinutes = config.maxDate.getMinutes();
        hours = Math.min(hours, maxHr);
        if (hours === maxHr)
            minutes = Math.min(maxMinutes, minutes);
        if (hours === maxHr && minutes === maxMinutes)
            seconds = config.maxDate.getSeconds();
    }
    return { hours: hours, minutes: minutes, seconds: seconds };
}


/***/ }),

/***/ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/utils/dom.js":
/*!******************************************************************************************!*\
  !*** ./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/utils/dom.js ***!
  \******************************************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   clearNode: function() { return /* binding */ clearNode; },
/* harmony export */   createElement: function() { return /* binding */ createElement; },
/* harmony export */   createNumberInput: function() { return /* binding */ createNumberInput; },
/* harmony export */   findParent: function() { return /* binding */ findParent; },
/* harmony export */   getEventTarget: function() { return /* binding */ getEventTarget; },
/* harmony export */   toggleClass: function() { return /* binding */ toggleClass; }
/* harmony export */ });
function toggleClass(elem, className, bool) {
    if (bool === true)
        return elem.classList.add(className);
    elem.classList.remove(className);
}
function createElement(tag, className, content) {
    var e = window.document.createElement(tag);
    className = className || "";
    content = content || "";
    e.className = className;
    if (content !== undefined)
        e.textContent = content;
    return e;
}
function clearNode(node) {
    while (node.firstChild)
        node.removeChild(node.firstChild);
}
function findParent(node, condition) {
    if (condition(node))
        return node;
    else if (node.parentNode)
        return findParent(node.parentNode, condition);
    return undefined;
}
function createNumberInput(inputClassName, opts) {
    var wrapper = createElement("div", "numInputWrapper"), numInput = createElement("input", "numInput " + inputClassName), arrowUp = createElement("span", "arrowUp"), arrowDown = createElement("span", "arrowDown");
    if (navigator.userAgent.indexOf("MSIE 9.0") === -1) {
        numInput.type = "number";
    }
    else {
        numInput.type = "text";
        numInput.pattern = "\\d*";
    }
    if (opts !== undefined)
        for (var key in opts)
            numInput.setAttribute(key, opts[key]);
    wrapper.appendChild(numInput);
    wrapper.appendChild(arrowUp);
    wrapper.appendChild(arrowDown);
    return wrapper;
}
function getEventTarget(event) {
    try {
        if (typeof event.composedPath === "function") {
            var path = event.composedPath();
            return path[0];
        }
        return event.target;
    }
    catch (error) {
        return event.target;
    }
}


/***/ }),

/***/ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/utils/formatting.js":
/*!*************************************************************************************************!*\
  !*** ./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/utils/formatting.js ***!
  \*************************************************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   formats: function() { return /* binding */ formats; },
/* harmony export */   monthToStr: function() { return /* binding */ monthToStr; },
/* harmony export */   revFormat: function() { return /* binding */ revFormat; },
/* harmony export */   tokenRegex: function() { return /* binding */ tokenRegex; }
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils */ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/utils/index.js");

var doNothing = function () { return undefined; };
var monthToStr = function (monthNumber, shorthand, locale) { return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber]; };
var revFormat = {
    D: doNothing,
    F: function (dateObj, monthName, locale) {
        dateObj.setMonth(locale.months.longhand.indexOf(monthName));
    },
    G: function (dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    H: function (dateObj, hour) {
        dateObj.setHours(parseFloat(hour));
    },
    J: function (dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    K: function (dateObj, amPM, locale) {
        dateObj.setHours((dateObj.getHours() % 12) +
            12 * (0,_utils__WEBPACK_IMPORTED_MODULE_0__.int)(new RegExp(locale.amPM[1], "i").test(amPM)));
    },
    M: function (dateObj, shortMonth, locale) {
        dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
    },
    S: function (dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    U: function (_, unixSeconds) { return new Date(parseFloat(unixSeconds) * 1000); },
    W: function (dateObj, weekNum, locale) {
        var weekNumber = parseInt(weekNum);
        var date = new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
        date.setDate(date.getDate() - date.getDay() + locale.firstDayOfWeek);
        return date;
    },
    Y: function (dateObj, year) {
        dateObj.setFullYear(parseFloat(year));
    },
    Z: function (_, ISODate) { return new Date(ISODate); },
    d: function (dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    h: function (dateObj, hour) {
        dateObj.setHours((dateObj.getHours() >= 12 ? 12 : 0) + parseFloat(hour));
    },
    i: function (dateObj, minutes) {
        dateObj.setMinutes(parseFloat(minutes));
    },
    j: function (dateObj, day) {
        dateObj.setDate(parseFloat(day));
    },
    l: doNothing,
    m: function (dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    n: function (dateObj, month) {
        dateObj.setMonth(parseFloat(month) - 1);
    },
    s: function (dateObj, seconds) {
        dateObj.setSeconds(parseFloat(seconds));
    },
    u: function (_, unixMillSeconds) {
        return new Date(parseFloat(unixMillSeconds));
    },
    w: doNothing,
    y: function (dateObj, year) {
        dateObj.setFullYear(2000 + parseFloat(year));
    },
};
var tokenRegex = {
    D: "",
    F: "",
    G: "(\\d\\d|\\d)",
    H: "(\\d\\d|\\d)",
    J: "(\\d\\d|\\d)\\w+",
    K: "",
    M: "",
    S: "(\\d\\d|\\d)",
    U: "(.+)",
    W: "(\\d\\d|\\d)",
    Y: "(\\d{4})",
    Z: "(.+)",
    d: "(\\d\\d|\\d)",
    h: "(\\d\\d|\\d)",
    i: "(\\d\\d|\\d)",
    j: "(\\d\\d|\\d)",
    l: "",
    m: "(\\d\\d|\\d)",
    n: "(\\d\\d|\\d)",
    s: "(\\d\\d|\\d)",
    u: "(.+)",
    w: "(\\d\\d|\\d)",
    y: "(\\d{2})",
};
var formats = {
    Z: function (date) { return date.toISOString(); },
    D: function (date, locale, options) {
        return locale.weekdays.shorthand[formats.w(date, locale, options)];
    },
    F: function (date, locale, options) {
        return monthToStr(formats.n(date, locale, options) - 1, false, locale);
    },
    G: function (date, locale, options) {
        return (0,_utils__WEBPACK_IMPORTED_MODULE_0__.pad)(formats.h(date, locale, options));
    },
    H: function (date) { return (0,_utils__WEBPACK_IMPORTED_MODULE_0__.pad)(date.getHours()); },
    J: function (date, locale) {
        return locale.ordinal !== undefined
            ? date.getDate() + locale.ordinal(date.getDate())
            : date.getDate();
    },
    K: function (date, locale) { return locale.amPM[(0,_utils__WEBPACK_IMPORTED_MODULE_0__.int)(date.getHours() > 11)]; },
    M: function (date, locale) {
        return monthToStr(date.getMonth(), true, locale);
    },
    S: function (date) { return (0,_utils__WEBPACK_IMPORTED_MODULE_0__.pad)(date.getSeconds()); },
    U: function (date) { return date.getTime() / 1000; },
    W: function (date, _, options) {
        return options.getWeek(date);
    },
    Y: function (date) { return (0,_utils__WEBPACK_IMPORTED_MODULE_0__.pad)(date.getFullYear(), 4); },
    d: function (date) { return (0,_utils__WEBPACK_IMPORTED_MODULE_0__.pad)(date.getDate()); },
    h: function (date) { return (date.getHours() % 12 ? date.getHours() % 12 : 12); },
    i: function (date) { return (0,_utils__WEBPACK_IMPORTED_MODULE_0__.pad)(date.getMinutes()); },
    j: function (date) { return date.getDate(); },
    l: function (date, locale) {
        return locale.weekdays.longhand[date.getDay()];
    },
    m: function (date) { return (0,_utils__WEBPACK_IMPORTED_MODULE_0__.pad)(date.getMonth() + 1); },
    n: function (date) { return date.getMonth() + 1; },
    s: function (date) { return date.getSeconds(); },
    u: function (date) { return date.getTime(); },
    w: function (date) { return date.getDay(); },
    y: function (date) { return String(date.getFullYear()).substring(2); },
};


/***/ }),

/***/ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/utils/index.js":
/*!********************************************************************************************!*\
  !*** ./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/utils/index.js ***!
  \********************************************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   arrayify: function() { return /* binding */ arrayify; },
/* harmony export */   debounce: function() { return /* binding */ debounce; },
/* harmony export */   int: function() { return /* binding */ int; },
/* harmony export */   pad: function() { return /* binding */ pad; }
/* harmony export */ });
var pad = function (number, length) {
    if (length === void 0) { length = 2; }
    return ("000" + number).slice(length * -1);
};
var int = function (bool) { return (bool === true ? 1 : 0); };
function debounce(fn, wait) {
    var t;
    return function () {
        var _this = this;
        var args = arguments;
        clearTimeout(t);
        t = setTimeout(function () { return fn.apply(_this, args); }, wait);
    };
}
var arrayify = function (obj) {
    return obj instanceof Array ? obj : [obj];
};


/***/ }),

/***/ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/utils/polyfills.js":
/*!************************************************************************************************!*\
  !*** ./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/utils/polyfills.js ***!
  \************************************************************************************************/
/***/ (function() {

"use strict";

if (typeof Object.assign !== "function") {
    Object.assign = function (target) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!target) {
            throw TypeError("Cannot convert undefined or null to object");
        }
        var _loop_1 = function (source) {
            if (source) {
                Object.keys(source).forEach(function (key) { return (target[key] = source[key]); });
            }
        };
        for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
            var source = args_1[_a];
            _loop_1(source);
        }
        return target;
    };
}


/***/ }),

/***/ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/l10n/de.js":
/*!************************************************************************************!*\
  !*** ./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/l10n/de.js ***!
  \************************************************************************************/
/***/ (function(__unused_webpack_module, exports) {

(function (global, factory) {
   true ? factory(exports) :
  0;
}(this, (function (exports) { 'use strict';

  var fp = typeof window !== "undefined" && window.flatpickr !== undefined
      ? window.flatpickr
      : {
          l10ns: {},
      };
  var German = {
      weekdays: {
          shorthand: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
          longhand: [
              "Sonntag",
              "Montag",
              "Dienstag",
              "Mittwoch",
              "Donnerstag",
              "Freitag",
              "Samstag",
          ],
      },
      months: {
          shorthand: [
              "Jan",
              "Feb",
              "Mär",
              "Apr",
              "Mai",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Okt",
              "Nov",
              "Dez",
          ],
          longhand: [
              "Januar",
              "Februar",
              "März",
              "April",
              "Mai",
              "Juni",
              "Juli",
              "August",
              "September",
              "Oktober",
              "November",
              "Dezember",
          ],
      },
      firstDayOfWeek: 1,
      weekAbbreviation: "KW",
      rangeSeparator: " bis ",
      scrollTitle: "Zum Ändern scrollen",
      toggleTitle: "Zum Umschalten klicken",
      time_24hr: true,
  };
  fp.l10ns.de = German;
  var de = fp.l10ns;

  exports.German = German;
  exports.default = de;

  Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),

/***/ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/l10n/fr.js":
/*!************************************************************************************!*\
  !*** ./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/l10n/fr.js ***!
  \************************************************************************************/
/***/ (function(__unused_webpack_module, exports) {

(function (global, factory) {
   true ? factory(exports) :
  0;
}(this, (function (exports) { 'use strict';

  var fp = typeof window !== "undefined" && window.flatpickr !== undefined
      ? window.flatpickr
      : {
          l10ns: {},
      };
  var French = {
      firstDayOfWeek: 1,
      weekdays: {
          shorthand: ["dim", "lun", "mar", "mer", "jeu", "ven", "sam"],
          longhand: [
              "dimanche",
              "lundi",
              "mardi",
              "mercredi",
              "jeudi",
              "vendredi",
              "samedi",
          ],
      },
      months: {
          shorthand: [
              "janv",
              "févr",
              "mars",
              "avr",
              "mai",
              "juin",
              "juil",
              "août",
              "sept",
              "oct",
              "nov",
              "déc",
          ],
          longhand: [
              "janvier",
              "février",
              "mars",
              "avril",
              "mai",
              "juin",
              "juillet",
              "août",
              "septembre",
              "octobre",
              "novembre",
              "décembre",
          ],
      },
      ordinal: function (nth) {
          if (nth > 1)
              return "";
          return "er";
      },
      rangeSeparator: " au ",
      weekAbbreviation: "Sem",
      scrollTitle: "Défiler pour augmenter la valeur",
      toggleTitle: "Cliquer pour basculer",
      time_24hr: true,
  };
  fp.l10ns.fr = French;
  var fr = fp.l10ns;

  exports.French = French;
  exports.default = fr;

  Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),

/***/ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/l10n/it.js":
/*!************************************************************************************!*\
  !*** ./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/l10n/it.js ***!
  \************************************************************************************/
/***/ (function(__unused_webpack_module, exports) {

(function (global, factory) {
   true ? factory(exports) :
  0;
}(this, (function (exports) { 'use strict';

  var fp = typeof window !== "undefined" && window.flatpickr !== undefined
      ? window.flatpickr
      : {
          l10ns: {},
      };
  var Italian = {
      weekdays: {
          shorthand: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
          longhand: [
              "Domenica",
              "Lunedì",
              "Martedì",
              "Mercoledì",
              "Giovedì",
              "Venerdì",
              "Sabato",
          ],
      },
      months: {
          shorthand: [
              "Gen",
              "Feb",
              "Mar",
              "Apr",
              "Mag",
              "Giu",
              "Lug",
              "Ago",
              "Set",
              "Ott",
              "Nov",
              "Dic",
          ],
          longhand: [
              "Gennaio",
              "Febbraio",
              "Marzo",
              "Aprile",
              "Maggio",
              "Giugno",
              "Luglio",
              "Agosto",
              "Settembre",
              "Ottobre",
              "Novembre",
              "Dicembre",
          ],
      },
      firstDayOfWeek: 1,
      ordinal: function () { return "°"; },
      rangeSeparator: " al ",
      weekAbbreviation: "Se",
      scrollTitle: "Scrolla per aumentare",
      toggleTitle: "Clicca per cambiare",
      time_24hr: true,
  };
  fp.l10ns.it = Italian;
  var it = fp.l10ns;

  exports.Italian = Italian;
  exports.default = it;

  Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),

/***/ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/flatpickr.min.css":
/*!*******************************************************************************************!*\
  !*** ./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/flatpickr.min.css ***!
  \*******************************************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./node_modules/.pnpm/nouislider@15.8.1/node_modules/nouislider/dist/nouislider.css":
/*!******************************************************************************************!*\
  !*** ./node_modules/.pnpm/nouislider@15.8.1/node_modules/nouislider/dist/nouislider.css ***!
  \******************************************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/swiper.css":
/*!*************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/swiper.css ***!
  \*************************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./styles/index.css":
/*!**************************!*\
  !*** ./styles/index.css ***!
  \**************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js":
/*!**********************************************************************************!*\
  !*** ./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js ***!
  \**********************************************************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   component: function() { return /* binding */ u; },
/* harmony export */   picoapp: function() { return /* binding */ c; }
/* harmony export */ });
var n=function(n){if("object"!=typeof(t=n)||Array.isArray(t))throw"state should be an object";var t},t=function(n,t,r,e){return(o=n,o.reduce(function(n,t,r){return n.indexOf(t)>-1?n:n.concat(t)},[])).reduce(function(n,r){return n.concat(t[r]||[])},[]).map(function(n){return n(r,e)});// removed by dead control flow
 var o; };function r(r){void 0===r&&(r={});var e={};return{getState:function(){return Object.assign({},r)},hydrate:function(o){return n(o),Object.assign(r,o),function(){var n=["*"].concat(Object.keys(o));t(n,e,r)}},on:function(n,t){return(n=[].concat(n)).map(function(n){return e[n]=(e[n]||[]).concat(t)}),function(){return n.map(function(n){return e[n].splice(e[n].indexOf(t),1)})}},emit:function(o,u,c){var i=("*"===o?[]:["*"]).concat(o);(u="function"==typeof u?u(r):u)&&(n(u),Object.assign(r,u),i=i.concat(Object.keys(u))),t(i,e,r,c)}}}r();var e=function(n){return"object"==typeof n&&!Array.isArray(n)},o=function(n){return"function"==typeof n};function u(n){return function(t,r){var e=[];return{subs:e,unmount:n(t,Object.assign({},r,{on:function(n,t){var o=r.on(n,t);return e.push(o),o}})),node:t}}}function c(n,t,u){void 0===n&&(n={}),void 0===t&&(t={}),void 0===u&&(u=[]);var c=r(t),i=[];return{on:c.on,emit:c.emit,getState:function(){return c.getState()},add:function(t){if(!e(t))throw"components should be an object";Object.assign(n,t)},use:function(n){if(!o(n))throw"plugins should be a function";u.push(n)},hydrate:function(n){return c.hydrate(n)},mount:function(t){void 0===t&&(t="data-component"),t=[].concat(t);for(var r=0;r<t.length;r++){for(var a=t[r],f=[].slice.call(document.querySelectorAll("["+a+"]")),s=function(){for(var t=f.pop(),r=t.getAttribute(a).split(/\s/),s=0;s<r.length;s++){var v=n[r[s]];if(v){t.removeAttribute(a);try{var d=u.reduce(function(n,r){var o=r(t,c);return e(o)?Object.assign(n,o):n},{}),m=v(t,Object.assign({},d,c));o(m.unmount)&&i.push(m)}catch(n){console.error(n),c.emit("error",{error:n}),c.hydrate({error:void 0})}}}};f.length;)s();c.emit("mount")}},unmount:function(){for(var n=i.length-1;n>-1;n--){var t=i[n],r=t.subs;(0,t.unmount)(t.node),r.map(function(n){return n()}),i.splice(n,1)}c.emit("unmount")}}}
//# sourceMappingURL=picoapp.es.js.map


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js ***!
  \*************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js":
/*!***********************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js ***!
  \***********************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js":
/*!**************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js ***!
  \**************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _arrayWithoutHoles; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./arrayLikeToArray.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js");

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__["default"])(r);
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js":
/*!******************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js ***!
  \******************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js ***!
  \*************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/callSuper.js":
/*!******************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/callSuper.js ***!
  \******************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _callSuper; }
/* harmony export */ });
/* harmony import */ var _getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./getPrototypeOf.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _isNativeReflectConstruct_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./isNativeReflectConstruct.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js");
/* harmony import */ var _possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./possibleConstructorReturn.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");



function _callSuper(t, o, e) {
  return o = (0,_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__["default"])(o), (0,_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_2__["default"])(t, (0,_isNativeReflectConstruct_js__WEBPACK_IMPORTED_MODULE_1__["default"])() ? Reflect.construct(o, e || [], (0,_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__["default"])(t).constructor) : o.apply(t, e));
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js":
/*!***********************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js ***!
  \***********************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/construct.js":
/*!******************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/construct.js ***!
  \******************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _construct; }
/* harmony export */ });
/* harmony import */ var _isNativeReflectConstruct_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./isNativeReflectConstruct.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js");
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./setPrototypeOf.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js");


function _construct(t, e, r) {
  if ((0,_isNativeReflectConstruct_js__WEBPACK_IMPORTED_MODULE_0__["default"])()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__["default"])(p, r.prototype), p;
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/createClass.js":
/*!********************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/createClass.js ***!
  \********************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _createClass; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./toPropertyKey.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js");

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__["default"])(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/defineProperty.js":
/*!***********************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/defineProperty.js ***!
  \***********************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./toPropertyKey.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js");

function _defineProperty(e, r, t) {
  return (r = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__["default"])(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js":
/*!***********************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js ***!
  \***********************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/inherits.js":
/*!*****************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/inherits.js ***!
  \*****************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./setPrototypeOf.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js");

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__["default"])(t, e);
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/isNativeFunction.js":
/*!*************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/isNativeFunction.js ***!
  \*************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _isNativeFunction; }
/* harmony export */ });
function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js":
/*!*********************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js ***!
  \*********************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _isNativeReflectConstruct; }
/* harmony export */ });
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/iterableToArray.js":
/*!************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/iterableToArray.js ***!
  \************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js":
/*!*****************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js ***!
  \*****************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _iterableToArrayLimit; }
/* harmony export */ });
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js":
/*!************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js ***!
  \************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js":
/*!**************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js ***!
  \**************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _nonIterableSpread; }
/* harmony export */ });
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/objectSpread2.js":
/*!**********************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/objectSpread2.js ***!
  \**********************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _objectSpread2; }
/* harmony export */ });
/* harmony import */ var _defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./defineProperty.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/defineProperty.js");

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0,_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__["default"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js":
/*!**********************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js ***!
  \**********************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./assertThisInitialized.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");


function _possibleConstructorReturn(t, e) {
  if (e && ("object" == (0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__["default"])(t);
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/regenerator.js":
/*!********************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/regenerator.js ***!
  \********************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _regenerator; }
/* harmony export */ });
/* harmony import */ var _regeneratorDefine_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./regeneratorDefine.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/regeneratorDefine.js");

function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
  var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return (0,_regeneratorDefine_js__WEBPACK_IMPORTED_MODULE_0__["default"])(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : ((0,_regeneratorDefine_js__WEBPACK_IMPORTED_MODULE_0__["default"])(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, (0,_regeneratorDefine_js__WEBPACK_IMPORTED_MODULE_0__["default"])(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, (0,_regeneratorDefine_js__WEBPACK_IMPORTED_MODULE_0__["default"])(u, "constructor", GeneratorFunctionPrototype), (0,_regeneratorDefine_js__WEBPACK_IMPORTED_MODULE_0__["default"])(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", (0,_regeneratorDefine_js__WEBPACK_IMPORTED_MODULE_0__["default"])(GeneratorFunctionPrototype, o, "GeneratorFunction"), (0,_regeneratorDefine_js__WEBPACK_IMPORTED_MODULE_0__["default"])(u), (0,_regeneratorDefine_js__WEBPACK_IMPORTED_MODULE_0__["default"])(u, o, "Generator"), (0,_regeneratorDefine_js__WEBPACK_IMPORTED_MODULE_0__["default"])(u, n, function () {
    return this;
  }), (0,_regeneratorDefine_js__WEBPACK_IMPORTED_MODULE_0__["default"])(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/regeneratorDefine.js":
/*!**************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/regeneratorDefine.js ***!
  \**************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _regeneratorDefine; }
/* harmony export */ });
function _regeneratorDefine(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine = function regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine(e, r, n, t);
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/regeneratorValues.js":
/*!**************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/regeneratorValues.js ***!
  \**************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _regeneratorValues; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/typeof.js");

function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(e) + " is not iterable");
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js":
/*!***********************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js ***!
  \***********************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js":
/*!**********************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js ***!
  \**********************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _slicedToArray; }
/* harmony export */ });
/* harmony import */ var _arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./arrayWithHoles.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js");
/* harmony import */ var _iterableToArrayLimit_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./iterableToArrayLimit.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js");
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./unsupportedIterableToArray.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js");
/* harmony import */ var _nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./nonIterableRest.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js");




function _slicedToArray(r, e) {
  return (0,_arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__["default"])(r) || (0,_iterableToArrayLimit_js__WEBPACK_IMPORTED_MODULE_1__["default"])(r, e) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__["default"])(r, e) || (0,_nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__["default"])();
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js":
/*!**************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js ***!
  \**************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _toConsumableArray; }
/* harmony export */ });
/* harmony import */ var _arrayWithoutHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./arrayWithoutHoles.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js");
/* harmony import */ var _iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./iterableToArray.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/iterableToArray.js");
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./unsupportedIterableToArray.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js");
/* harmony import */ var _nonIterableSpread_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./nonIterableSpread.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js");




function _toConsumableArray(r) {
  return (0,_arrayWithoutHoles_js__WEBPACK_IMPORTED_MODULE_0__["default"])(r) || (0,_iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__["default"])(r) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__["default"])(r) || (0,_nonIterableSpread_js__WEBPACK_IMPORTED_MODULE_3__["default"])();
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/toPrimitive.js":
/*!********************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/toPrimitive.js ***!
  \********************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ toPrimitive; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/typeof.js");

function toPrimitive(t, r) {
  if ("object" != (0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != (0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js":
/*!**********************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js ***!
  \**********************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ toPropertyKey; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _toPrimitive_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./toPrimitive.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/toPrimitive.js");


function toPropertyKey(t) {
  var i = (0,_toPrimitive_js__WEBPACK_IMPORTED_MODULE_1__["default"])(t, "string");
  return "symbol" == (0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(i) ? i : i + "";
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/typeof.js":
/*!***************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/typeof.js ***!
  \***************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js":
/*!***********************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js ***!
  \***********************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./arrayLikeToArray.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js");

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__["default"])(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__["default"])(r, a) : void 0;
  }
}


/***/ }),

/***/ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js":
/*!************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js ***!
  \************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _wrapNativeSuper; }
/* harmony export */ });
/* harmony import */ var _getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./getPrototypeOf.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./setPrototypeOf.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js");
/* harmony import */ var _isNativeFunction_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./isNativeFunction.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/isNativeFunction.js");
/* harmony import */ var _construct_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./construct.js */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/construct.js");




function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !(0,_isNativeFunction_js__WEBPACK_IMPORTED_MODULE_2__["default"])(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return (0,_construct_js__WEBPACK_IMPORTED_MODULE_3__["default"])(t, arguments, (0,_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__["default"])(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_1__["default"])(Wrapper, t);
  }, _wrapNativeSuper(t);
}


/***/ }),

/***/ "./scripts/api/sections.js":
/*!*********************************!*\
  !*** ./scripts/api/sections.js ***!
  \*********************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/regenerator */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/regenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");


var getSection = /*#__PURE__*/function () {
  var _getSection = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_0__["default"])().m(function _callee(href, ids) {
    var sectionIDs, url, params, sections;
    return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_0__["default"])().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          sectionIDs = Array.isArray(ids) ? ids.join(',') : ids;
          url = new URL(href);
          params = {
            sections: sectionIDs
          };
          Object.keys(params).forEach(function (key) {
            return url.searchParams.append(key, params[key]);
          });
          _context.n = 1;
          return fetch(url).then(function (res) {
            return res.json();
          });
        case 1:
          sections = _context.v;
          return _context.a(2, sections);
      }
    }, _callee);
  }));
  function getSection(_x, _x2) {
    return _getSection.apply(this, arguments);
  }
  return getSection;
}();
/* harmony default export */ __webpack_exports__["default"] = (getSection);

/***/ }),

/***/ "./scripts/api/subscriptions.js":
/*!**************************************!*\
  !*** ./scripts/api/subscriptions.js ***!
  \**************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   activate: function() { return /* binding */ activate; },
/* harmony export */   addLine: function() { return /* binding */ addLine; },
/* harmony export */   cancel: function() { return /* binding */ cancel; },
/* harmony export */   getOrders: function() { return /* binding */ getOrders; },
/* harmony export */   getPaymentMethods: function() { return /* binding */ getPaymentMethods; },
/* harmony export */   getRecalcStatus: function() { return /* binding */ getRecalcStatus; },
/* harmony export */   getSubscription: function() { return /* binding */ getSubscription; },
/* harmony export */   getUpcoming: function() { return /* binding */ getUpcoming; },
/* harmony export */   listFrequencies: function() { return /* binding */ listFrequencies; },
/* harmony export */   listProducts: function() { return /* binding */ listProducts; },
/* harmony export */   listSubscriptions: function() { return /* binding */ listSubscriptions; },
/* harmony export */   orderNow: function() { return /* binding */ orderNow; },
/* harmony export */   pause: function() { return /* binding */ pause; },
/* harmony export */   removeLine: function() { return /* binding */ removeLine; },
/* harmony export */   reschedule: function() { return /* binding */ reschedule; },
/* harmony export */   rescheduleUpcoming: function() { return /* binding */ rescheduleUpcoming; },
/* harmony export */   skip: function() { return /* binding */ skip; },
/* harmony export */   updateFrequency: function() { return /* binding */ updateFrequency; },
/* harmony export */   updateLines: function() { return /* binding */ updateLines; },
/* harmony export */   updatePaymentMethod: function() { return /* binding */ updatePaymentMethod; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/regenerator */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/regenerator.js");
/* harmony import */ var _babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/objectSpread2 */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/objectSpread2.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_callSuper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/callSuper */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/callSuper.js");
/* harmony import */ var _babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @babel/runtime/helpers/wrapNativeSuper */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js");









var API_BASE = '/apps/subscriptions';
var SubscriptionApiError = /*#__PURE__*/function (_Error) {
  function SubscriptionApiError(type, status) {
    var _this;
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__["default"])(this, SubscriptionApiError);
    _this = (0,_babel_runtime_helpers_callSuper__WEBPACK_IMPORTED_MODULE_7__["default"])(this, SubscriptionApiError, ["Subscription API request failed (".concat(status, ")")]);
    _this.type = type;
    _this.status = status;
    return _this;
  }
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__["default"])(SubscriptionApiError, _Error);
  return (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__["default"])(SubscriptionApiError);
}(/*#__PURE__*/(0,_babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_8__["default"])(Error));
var errorTypeForStatus = function errorTypeForStatus(status) {
  if (status === 401) return 'auth';
  if (status === 404) return 'not-found';
  if (status === 409) return 'not-live';
  if (status === 422) return 'rejected';
  if (status === 502 || status === 503) return 'retry';
  if (status === 504) return 'timeout';
  return 'error';
};
function request(_x) {
  return _request.apply(this, arguments);
}
function _request() {
  _request = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_0__["default"])().m(function _callee(path) {
    var options,
      response,
      _args = arguments;
    return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_0__["default"])().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          _context.n = 1;
          return fetch("".concat(API_BASE).concat(path), (0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_1__["default"])({
            credentials: 'same-origin',
            headers: (0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_1__["default"])((0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_1__["default"])({
              Accept: 'application/json'
            }, options.body ? {
              'Content-Type': 'application/json'
            } : {}), options.headers)
          }, options));
        case 1:
          response = _context.v;
          if (response.ok) {
            _context.n = 2;
            break;
          }
          throw new SubscriptionApiError(errorTypeForStatus(response.status), response.status);
        case 2:
          return _context.a(2, response.json());
      }
    }, _callee);
  }));
  return _request.apply(this, arguments);
}
var listSubscriptions = function listSubscriptions() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var query = new URLSearchParams(Object.entries(params).filter(function (_ref) {
    var _ref2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__["default"])(_ref, 2),
      value = _ref2[1];
    return value !== undefined && value !== null;
  })).toString();
  return request("/subscriptions".concat(query ? "?".concat(query) : ''));
};
var getSubscription = function getSubscription(id) {
  return request("/subscriptions/".concat(id));
};
var getRecalcStatus = function getRecalcStatus(id, since) {
  return request("/subscriptions/".concat(id, "/recalc-status?since=").concat(encodeURIComponent(since)));
};
var getUpcoming = function getUpcoming(id) {
  return request("/subscriptions/".concat(id, "/upcoming"));
};
var getOrders = function getOrders(id) {
  return request("/subscriptions/".concat(id, "/orders"));
};
var listFrequencies = function listFrequencies(id) {
  return request("/subscriptions/".concat(id, "/frequencies"));
};
var skip = function skip(id) {
  return request("/subscriptions/".concat(id, "/skip"), {
    method: 'POST'
  });
};
var pause = function pause(id) {
  return request("/subscriptions/".concat(id, "/pause"), {
    method: 'POST'
  });
};
var cancel = function cancel(id) {
  return request("/subscriptions/".concat(id, "/cancel"), {
    method: 'POST'
  });
};
var activate = function activate(id) {
  return request("/subscriptions/".concat(id, "/activate"), {
    method: 'POST'
  });
};
var updateLines = function updateLines(id, lines) {
  return request("/subscriptions/".concat(id, "/lines"), {
    method: 'PATCH',
    body: JSON.stringify({
      lines: lines
    })
  });
};
var removeLine = function removeLine(id, lineId) {
  return request("/subscriptions/".concat(id, "/lines"), {
    method: 'DELETE',
    body: JSON.stringify({
      lineId: lineId
    })
  });
};
var addLine = function addLine(id, variantId) {
  var quantity = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return request("/subscriptions/".concat(id, "/lines"), {
    method: 'POST',
    body: JSON.stringify({
      variantId: variantId,
      quantity: quantity
    })
  });
};
var reschedule = function reschedule(id, date) {
  return request("/subscriptions/".concat(id, "/reschedule"), {
    method: 'POST',
    body: JSON.stringify({
      date: date
    })
  });
};
var rescheduleUpcoming = function rescheduleUpcoming(id, date) {
  return request("/subscriptions/".concat(id, "/reschedule-upcoming"), {
    method: 'POST',
    body: JSON.stringify({
      date: date
    })
  });
};
var orderNow = function orderNow(id, mode) {
  return request("/subscriptions/".concat(id, "/order-now"), {
    method: 'POST',
    body: JSON.stringify({
      mode: mode
    })
  });
};
var updateFrequency = function updateFrequency(id, intervalValue, intervalType) {
  return request("/subscriptions/".concat(id, "/frequency"), {
    method: 'PUT',
    body: JSON.stringify({
      interval_value: intervalValue,
      interval_type: intervalType
    })
  });
};
var listProducts = function listProducts() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var query = new URLSearchParams(Object.entries(params).filter(function (_ref3) {
    var _ref4 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__["default"])(_ref3, 2),
      value = _ref4[1];
    return value !== undefined && value !== null && value !== '';
  })).toString();
  return request("/products".concat(query ? "?".concat(query) : ''));
};
var getPaymentMethods = function getPaymentMethods() {
  return request('/payment-methods');
};
var updatePaymentMethod = function updatePaymentMethod(id, customerPaymentMethodId) {
  return request("/subscriptions/".concat(id, "/payment-method"), {
    method: 'POST',
    body: JSON.stringify({
      customerPaymentMethodId: customerPaymentMethodId
    })
  });
};

/***/ }),

/***/ "./scripts/app.js":
/*!************************!*\
  !*** ./scripts/app.js ***!
  \************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! swiper */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/swiper.mjs");
/* harmony import */ var _components_blog_block_categories__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/components/blog-block-categories */ "./scripts/components/blog-block-categories.js");
/* harmony import */ var _components_blog_tag_filter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/components/blog-tag-filter */ "./scripts/components/blog-tag-filter.js");
/* harmony import */ var _components_cart_gift_items__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @/components/cart-gift-items */ "./scripts/components/cart-gift-items.js");
/* harmony import */ var _components_cart_item_subscription__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @/components/cart-item-subscription */ "./scripts/components/cart-item-subscription.js");
/* harmony import */ var _components_cart_progress_bar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @/components/cart-progress-bar */ "./scripts/components/cart-progress-bar.js");
/* harmony import */ var _components_cart_subscription__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @/components/cart-subscription */ "./scripts/components/cart-subscription.js");
/* harmony import */ var _components_collapsible_text__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @/components/collapsible-text */ "./scripts/components/collapsible-text.js");
/* harmony import */ var _components_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @/components/copy-to-clipboard */ "./scripts/components/copy-to-clipboard.js");
/* harmony import */ var _components_country_selector__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @/components/country-selector */ "./scripts/components/country-selector.js");
/* harmony import */ var _components_customer_account_header__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @/components/customer-account-header */ "./scripts/components/customer-account-header.js");
/* harmony import */ var _components_facets_drawer__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @/components/facets-drawer */ "./scripts/components/facets-drawer.js");
/* harmony import */ var _components_facets_inline__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @/components/facets-inline */ "./scripts/components/facets-inline.js");
/* harmony import */ var _components_free_shipping__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @/components/free-shipping */ "./scripts/components/free-shipping.js");
/* harmony import */ var _components_localization_global__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @/components/localization-global */ "./scripts/components/localization-global.js");
/* harmony import */ var _components_modal__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @/components/modal */ "./scripts/components/modal.js");
/* harmony import */ var _components_price_range__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! @/components/price-range */ "./scripts/components/price-range.js");
/* harmony import */ var _components_product_announcements__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! @/components/product-announcements */ "./scripts/components/product-announcements.js");
/* harmony import */ var _components_product_form__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! @/components/product-form */ "./scripts/components/product-form.js");
/* harmony import */ var _components_product_item__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! @/components/product-item */ "./scripts/components/product-item.js");
/* harmony import */ var _components_product_quantity__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! @/components/product-quantity */ "./scripts/components/product-quantity.js");
/* harmony import */ var _components_product_selector__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! @/components/product-selector */ "./scripts/components/product-selector.js");
/* harmony import */ var _components_product_similar__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! @/components/product-similar */ "./scripts/components/product-similar.js");
/* harmony import */ var _components_product_sticky__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! @/components/product-sticky */ "./scripts/components/product-sticky.js");
/* harmony import */ var _components_product_variant_quantity__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! @/components/product-variant-quantity */ "./scripts/components/product-variant-quantity.js");
/* harmony import */ var _components_similar_products__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! @/components/similar-products */ "./scripts/components/similar-products.js");
/* harmony import */ var _components_sortby_drawer__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! @/components/sortby-drawer */ "./scripts/components/sortby-drawer.js");
/* harmony import */ var _components_subscription_manager__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! @/components/subscription-manager */ "./scripts/components/subscription-manager.js");
/* harmony import */ var _components_swiper_slider__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! @/components/swiper-slider */ "./scripts/components/swiper-slider.js");
/* harmony import */ var _components_wishlist__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! @/components/wishlist */ "./scripts/components/wishlist.js");
/* harmony import */ var _components_wishlist_button__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! @/components/wishlist-button */ "./scripts/components/wishlist-button.js");
/* harmony import */ var _components_wishlist_item__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! @/components/wishlist-item */ "./scripts/components/wishlist-item.js");
/* harmony import */ var _pages_cart__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! @/pages/cart */ "./scripts/pages/cart.js");
/* harmony import */ var _pages_product__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! @/pages/product */ "./scripts/pages/product.js");
/* harmony import */ var _pages_wishlist__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! @/pages/wishlist */ "./scripts/pages/wishlist.js");
/* harmony import */ var _sections_featured_products__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! @/sections/featured-products */ "./scripts/sections/featured-products.js");





































var components = {
  Cart: _pages_cart__WEBPACK_IMPORTED_MODULE_33__["default"],
  CollapsibleText: _components_collapsible_text__WEBPACK_IMPORTED_MODULE_8__["default"],
  CountrySelector: _components_country_selector__WEBPACK_IMPORTED_MODULE_10__["default"],
  CustomerAccountHeader: _components_customer_account_header__WEBPACK_IMPORTED_MODULE_11__["default"],
  FeaturedProducts: _sections_featured_products__WEBPACK_IMPORTED_MODULE_36__["default"],
  FacetsDrawer: _components_facets_drawer__WEBPACK_IMPORTED_MODULE_12__["default"],
  FacetsInline: _components_facets_inline__WEBPACK_IMPORTED_MODULE_13__["default"],
  CartGiftItems: _components_cart_gift_items__WEBPACK_IMPORTED_MODULE_4__["default"],
  CartItemSubscription: _components_cart_item_subscription__WEBPACK_IMPORTED_MODULE_5__["default"],
  CartProgressBar: _components_cart_progress_bar__WEBPACK_IMPORTED_MODULE_6__["default"],
  CartSubscription: _components_cart_subscription__WEBPACK_IMPORTED_MODULE_7__["default"],
  Modal: _components_modal__WEBPACK_IMPORTED_MODULE_16__["default"],
  QuantitySelector: _components_product_quantity__WEBPACK_IMPORTED_MODULE_21__["default"],
  PriceRange: _components_price_range__WEBPACK_IMPORTED_MODULE_17__["default"],
  Product: _pages_product__WEBPACK_IMPORTED_MODULE_34__["default"],
  ProductItem: _components_product_item__WEBPACK_IMPORTED_MODULE_20__["default"],
  ProductForm: _components_product_form__WEBPACK_IMPORTED_MODULE_19__["default"],
  SortbyDrawer: _components_sortby_drawer__WEBPACK_IMPORTED_MODULE_27__["default"],
  FreeShipping: _components_free_shipping__WEBPACK_IMPORTED_MODULE_14__["default"],
  LocalizationGlobal: _components_localization_global__WEBPACK_IMPORTED_MODULE_15__["default"],
  ProductAnnouncements: _components_product_announcements__WEBPACK_IMPORTED_MODULE_18__["default"],
  ProductSelector: _components_product_selector__WEBPACK_IMPORTED_MODULE_22__["default"],
  ProductSticky: _components_product_sticky__WEBPACK_IMPORTED_MODULE_24__["default"],
  ProductQuantity: _components_product_variant_quantity__WEBPACK_IMPORTED_MODULE_25__["default"],
  Wishlist: _components_wishlist__WEBPACK_IMPORTED_MODULE_30__["default"],
  WishlistButton: _components_wishlist_button__WEBPACK_IMPORTED_MODULE_31__["default"],
  WishlistItem: _components_wishlist_item__WEBPACK_IMPORTED_MODULE_32__["default"],
  ProductSimilar: _components_product_similar__WEBPACK_IMPORTED_MODULE_23__["default"],
  SimilarProducts: _components_similar_products__WEBPACK_IMPORTED_MODULE_26__["default"],
  Swiper: swiper__WEBPACK_IMPORTED_MODULE_1__["default"],
  SwiperSlider: _components_swiper_slider__WEBPACK_IMPORTED_MODULE_29__["default"],
  WishlistPage: _pages_wishlist__WEBPACK_IMPORTED_MODULE_35__["default"],
  SubscriptionManager: _components_subscription_manager__WEBPACK_IMPORTED_MODULE_28__["default"],
  CopyToClipboard: _components_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_9__["default"],
  BlogTagFilter: _components_blog_tag_filter__WEBPACK_IMPORTED_MODULE_3__["default"],
  BlogBlockCategories: _components_blog_block_categories__WEBPACK_IMPORTED_MODULE_2__["default"]
};
/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.picoapp)(components));

/***/ }),

/***/ "./scripts/components/blog-block-categories.js":
/*!*****************************************************!*\
  !*** ./scripts/components/blog-block-categories.js ***!
  \*****************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! swiper */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/swiper.mjs");
/* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! swiper/modules */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/index.mjs");



swiper__WEBPACK_IMPORTED_MODULE_1__["default"].use([swiper_modules__WEBPACK_IMPORTED_MODULE_2__.Navigation]);
/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node) {
  var options = {
    wrapperClass: 'article-block-categories__wrapper',
    slideClass: 'article-block-categories__item',
    slidesPerView: 'auto',
    spaceBetween: 4,
    loop: node.querySelectorAll('.article-block-categories__item').length > 1,
    autoHeight: true,
    navigation: {
      nextEl: '.article-block-categories__next',
      prevEl: '.article-block-categories__prev'
    },
    breakpoints: {
      1200: {
        spaceBetween: 80
      },
      769: {
        spaceBetween: 48
      }
    }
  };
  var slider = new swiper__WEBPACK_IMPORTED_MODULE_1__["default"](node, options);
  return function () {
    return slider === null || slider === void 0 ? void 0 : slider.destroy();
  };
}));

/***/ }),

/***/ "./scripts/components/blog-tag-filter.js":
/*!***********************************************!*\
  !*** ./scripts/components/blog-tag-filter.js ***!
  \***********************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! swiper */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/swiper.mjs");
/* harmony import */ var _lib_throttle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/lib/throttle */ "./scripts/lib/throttle.js");



/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node) {
  var options = {
    wrapperClass: 'blog-tag-filter__wrapper',
    slideClass: 'blog-tag-filter__item',
    slidesPerView: 'auto',
    spaceBetween: 12,
    initialSlide: activeIndex()
  };
  var slider = null;
  function checkSlider() {
    if (slider === null) {
      slider = new swiper__WEBPACK_IMPORTED_MODULE_1__["default"](node, options);
    } else {
      slider.destroy();
      slider = null;
    }
  }
  function activeIndex() {
    var items = Array.from(node.querySelectorAll('a'));
    return items.findIndex(function (item) {
      return item.classList.contains('active');
    });
  }
  checkSlider();
  window.addEventListener('resize', (0,_lib_throttle__WEBPACK_IMPORTED_MODULE_2__["default"])(checkSlider, 100));
  return function () {
    var _slider;
    return (_slider = slider) === null || _slider === void 0 ? void 0 : _slider.destroy();
  };
}));

/***/ }),

/***/ "./scripts/components/cart-gift-items.js":
/*!***********************************************!*\
  !*** ./scripts/components/cart-gift-items.js ***!
  \***********************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_regeneratorValues__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/regeneratorValues */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/regeneratorValues.js");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/regenerator */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/regenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");






var isGiftLine = function isGiftLine(item) {
  var prop = item.properties && item.properties._gift;
  return prop === true || prop === 'true';
};
var linePlanId = function linePlanId(item) {
  return item.selling_plan_allocation ? String(item.selling_plan_allocation.selling_plan.id) : null;
};
var headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};
/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_5__.component)(function (node, ctx) {
  var _node$dataset;
  var giftProductIds = (((_node$dataset = node.dataset) === null || _node$dataset === void 0 || (_node$dataset = _node$dataset.items) === null || _node$dataset === void 0 ? void 0 : _node$dataset.split(',')) || []).map(Number);
  var strings = window.theme.strings;
  if (giftProductIds.length === 0) return null;
  var money = function money(cents) {
    return window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat);
  };
  var giftLines = function giftLines(cart) {
    return cart.items.filter(function (item) {
      return giftProductIds.includes(item.product_id) && isGiftLine(item);
    });
  };
  var countText = function countText(entry, count) {
    return (count === 1 ? entry.one : entry.other).replace('[count]', count);
  };
  function getCartPlan() {
    var _node$closest;
    var widget = (_node$closest = node.closest('.cart-page')) === null || _node$closest === void 0 ? void 0 : _node$closest.querySelector('[data-cart-subscription]');
    if (!widget || widget.dataset.mixed === 'true') return null;
    var checked = widget.querySelector('[data-subscription-plan][checked]');
    return checked ? checked.value : null;
  }
  var subtitle = node.querySelector('[data-gift-subtitle]');
  var subtitleDefault = subtitle === null || subtitle === void 0 ? void 0 : subtitle.innerHTML;
  function renderSubtitle(_ref) {
    var nextTier = _ref.nextTier,
      toNext = _ref.toNext,
      unlockedLevels = _ref.unlockedLevels,
      giftsInCart = _ref.giftsInCart;
    if (!subtitle) return;
    if (unlockedLevels === 0) {
      subtitle.innerHTML = subtitleDefault;
      return;
    }
    var base = giftsInCart.length > 0 ? strings.giftSubtitleAdded : countText(strings.giftSubtitleUnlocked, unlockedLevels);
    subtitle.innerHTML = nextTier ? "".concat(base, " \xB7 ").concat(strings.giftSubtitleNext.replace('[price]', toNext).replace('[count]', unlockedLevels + 1)) : "".concat(base, ".");
  }
  function setCardState(el, state, text) {
    el.dataset.state = state;
    var status = el.querySelector('[data-gift-item-progress]');
    var submit = el.querySelector('[data-gift-item-submit]');
    if (status) status.innerHTML = text || '';
    if (submit) submit.disabled = state !== 'unlocked';
  }
  function renderCards(_ref2) {
    var tiers = _ref2.tiers,
      cartTotal = _ref2.cartTotal,
      unlockedLevels = _ref2.unlockedLevels,
      giftsInCart = _ref2.giftsInCart;
    var nextTier = tiers.find(function (tier) {
      return cartTotal < tier;
    });
    var toFirst = money(Math.max(0, (tiers[0] || 0) - cartTotal) * 100);
    var toNext = nextTier ? money((nextTier - cartTotal) * 100) : '';
    var giftIdsInCart = giftsInCart.map(function (line) {
      return line.product_id;
    });
    var giftQuantity = giftsInCart.reduce(function (sum, line) {
      return sum + line.quantity;
    }, 0);
    renderSubtitle({
      nextTier: nextTier,
      toNext: toNext,
      unlockedLevels: unlockedLevels,
      giftsInCart: giftsInCart
    });
    node.querySelectorAll('[data-gift-item]').forEach(function (el) {
      var id = Number(el.dataset.giftItem);
      var tier = Number(el.dataset.giftTier);
      if (tier) {
        if (tier > unlockedLevels) {
          var toTier = money(Math.max(0, tiers[tier - 1] - cartTotal) * 100);
          setCardState(el, 'locked', strings.giftCardLocked.replace('[price]', toTier));
        } else if (giftQuantity >= tier) {
          setCardState(el, 'added', strings.giftCardInCart);
        } else {
          setCardState(el, 'unlocked', '');
        }
        return;
      }
      if (unlockedLevels === 0) {
        setCardState(el, 'locked', strings.giftCardLocked.replace('[price]', toFirst));
        return;
      }
      if (giftIdsInCart.includes(id)) {
        setCardState(el, 'added', countText(strings.giftCardAdded, giftQuantity));
        return;
      }
      if (giftIdsInCart.length > 0) {
        setCardState(el, 'muted', strings.giftCardMuted);
        return;
      }
      setCardState(el, 'unlocked', '');
    });
  }
  function computeTargets(cart, tiers, unlockedLevels) {
    var recurringTotal = cart.items.filter(function (item) {
      return !isGiftLine(item) && item.selling_plan_allocation;
    }).reduce(function (sum, item) {
      return sum + item.final_line_price;
    }, 0) / 100;
    var cartPlan = getCartPlan();
    var subLevels = cartPlan ? tiers.filter(function (tier) {
      return recurringTotal >= tier;
    }).length : 0;
    return [{
      plan: null,
      quantity: unlockedLevels - subLevels
    }, {
      plan: cartPlan,
      quantity: subLevels
    }].filter(function (target) {
      return target.quantity > 0;
    });
  }
  function changeLine(_x, _x2) {
    return _changeLine.apply(this, arguments);
  }
  function _changeLine() {
    _changeLine = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_3__["default"])().m(function _callee(key, quantity) {
      var response;
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_3__["default"])().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            ctx.emit('cart:updating');
            _context.n = 1;
            return fetch(window.theme.routes.cartChange, {
              method: 'POST',
              headers: headers,
              body: JSON.stringify({
                id: key,
                quantity: quantity
              })
            });
          case 1:
            response = _context.v;
            if (!response.ok) console.error('Failed to update the free gift', response.status);
            return _context.a(2, response.ok);
        }
      }, _callee);
    }));
    return _changeLine.apply(this, arguments);
  }
  function addLine(_x3, _x4, _x5) {
    return _addLine.apply(this, arguments);
  }
  function _addLine() {
    _addLine = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_3__["default"])().m(function _callee2(variantId, quantity, sellingPlan) {
      var item, response, _t;
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_3__["default"])().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            item = {
              id: variantId,
              quantity: quantity,
              properties: {
                _gift: 'true'
              }
            };
            if (sellingPlan) item.selling_plan = sellingPlan;
            ctx.emit('cart:updating');
            _context2.p = 1;
            _context2.n = 2;
            return fetch(window.theme.routes.cartAdd, {
              method: 'POST',
              headers: headers,
              body: JSON.stringify({
                items: [item]
              })
            });
          case 2:
            response = _context2.v;
            if (!response.ok) console.error('Failed to add the free gift', response.status);
            return _context2.a(2, response.ok);
          case 3:
            _context2.p = 3;
            _t = _context2.v;
            console.error('Failed to add the free gift', _t);
            return _context2.a(2, false);
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return _addLine.apply(this, arguments);
  }
  function syncGiftLines(_x6, _x7, _x8, _x9) {
    return _syncGiftLines.apply(this, arguments);
  }
  function _syncGiftLines() {
    _syncGiftLines = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_3__["default"])().m(function _callee3(giftsInCart, variantId, targets, allowAdd) {
      var changed, remaining, _loop, _ret, i, _i, _t3;
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_3__["default"])().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            changed = false;
            remaining = (0,_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__["default"])(giftsInCart);
            _loop = /*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_3__["default"])().m(function _loop() {
              var target, index, added, _remaining$splice, _remaining$splice2, line, _t2;
              return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_3__["default"])().w(function (_context3) {
                while (1) switch (_context3.n) {
                  case 0:
                    target = targets[i];
                    index = remaining.findIndex(function (line) {
                      return linePlanId(line) === target.plan;
                    });
                    if (!(index === -1)) {
                      _context3.n = 4;
                      break;
                    }
                    if (allowAdd) {
                      _context3.n = 1;
                      break;
                    }
                    return _context3.a(2, {
                      v: changed
                    });
                  case 1:
                    _context3.n = 2;
                    return addLine(variantId, target.quantity, target.plan);
                  case 2:
                    added = _context3.v;
                    if (added) {
                      _context3.n = 3;
                      break;
                    }
                    return _context3.a(2, {
                      v: changed
                    });
                  case 3:
                    changed = true;
                    _context3.n = 7;
                    break;
                  case 4:
                    _remaining$splice = remaining.splice(index, 1), _remaining$splice2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__["default"])(_remaining$splice, 1), line = _remaining$splice2[0];
                    if (!(line.quantity !== target.quantity)) {
                      _context3.n = 7;
                      break;
                    }
                    _context3.n = 5;
                    return changeLine(line.key, target.quantity);
                  case 5:
                    _t2 = _context3.v;
                    if (_t2) {
                      _context3.n = 6;
                      break;
                    }
                    _t2 = changed;
                  case 6:
                    changed = _t2;
                  case 7:
                    return _context3.a(2);
                }
              }, _loop);
            });
            i = 0;
          case 1:
            if (!(i < targets.length)) {
              _context4.n = 4;
              break;
            }
            return _context4.d((0,_babel_runtime_helpers_regeneratorValues__WEBPACK_IMPORTED_MODULE_0__["default"])(_loop()), 2);
          case 2:
            _ret = _context4.v;
            if (!_ret) {
              _context4.n = 3;
              break;
            }
            return _context4.a(2, _ret.v);
          case 3:
            i += 1;
            _context4.n = 1;
            break;
          case 4:
            _i = 0;
          case 5:
            if (!(_i < remaining.length)) {
              _context4.n = 9;
              break;
            }
            _context4.n = 6;
            return changeLine(remaining[_i].key, 0);
          case 6:
            _t3 = _context4.v;
            if (_t3) {
              _context4.n = 7;
              break;
            }
            _t3 = changed;
          case 7:
            changed = _t3;
          case 8:
            _i += 1;
            _context4.n = 5;
            break;
          case 9:
            return _context4.a(2, changed);
        }
      }, _callee3);
    }));
    return _syncGiftLines.apply(this, arguments);
  }
  function updateItems(_x0) {
    return _updateItems.apply(this, arguments);
  }
  function _updateItems() {
    _updateItems = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_3__["default"])().m(function _callee4(_ref3) {
      var _giftsInCart$;
      var cart, tiers, unlockedLevels, paidLines, cartTotal, shippable, giftsInCart, _ctx$getState, _ctx$getState$removed, removedItems, manualAdd, variantId, _node$querySelector, targets, changed, _t4, _t5;
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_3__["default"])().w(function (_context5) {
        while (1) switch (_context5.n) {
          case 0:
            cart = _ref3.cart, tiers = _ref3.tiers, unlockedLevels = _ref3.unlockedLevels;
            paidLines = cart.items.filter(function (item) {
              return !isGiftLine(item);
            });
            cartTotal = paidLines.reduce(function (sum, item) {
              return sum + item.final_line_price;
            }, 0) / 100;
            shippable = paidLines.some(function (item) {
              return item.requires_shipping;
            });
            giftsInCart = giftLines(cart);
            _ctx$getState = ctx.getState(), _ctx$getState$removed = _ctx$getState.removedItems, removedItems = _ctx$getState$removed === void 0 ? [] : _ctx$getState$removed;
            manualAdd = giftProductIds.length > 1 || removedItems.length > 0;
            node.hidden = !shippable;
            if (!(!shippable || unlockedLevels === 0)) {
              _context5.n = 5;
              break;
            }
            if (!(giftsInCart.length > 0)) {
              _context5.n = 4;
              break;
            }
            _t4 = ctx;
            _context5.n = 1;
            return syncGiftLines(giftsInCart, null, [], false);
          case 1:
            if (!_context5.v) {
              _context5.n = 2;
              break;
            }
            _t5 = 'cart:update';
            _context5.n = 3;
            break;
          case 2:
            _t5 = 'cart:idle';
          case 3:
            _t4.emit.call(_t4, _t5);
          case 4:
            renderCards({
              tiers: tiers,
              cartTotal: cartTotal,
              unlockedLevels: unlockedLevels,
              giftsInCart: []
            });
            return _context5.a(2);
          case 5:
            variantId = (_giftsInCart$ = giftsInCart[0]) === null || _giftsInCart$ === void 0 ? void 0 : _giftsInCart$.variant_id;
            if (!variantId && !manualAdd) {
              variantId = Number((_node$querySelector = node.querySelector('[data-gift-item] form')) === null || _node$querySelector === void 0 || (_node$querySelector = _node$querySelector.elements) === null || _node$querySelector === void 0 || (_node$querySelector = _node$querySelector.id) === null || _node$querySelector === void 0 ? void 0 : _node$querySelector.value) || null;
            }
            if (variantId) {
              _context5.n = 6;
              break;
            }
            renderCards({
              tiers: tiers,
              cartTotal: cartTotal,
              unlockedLevels: unlockedLevels,
              giftsInCart: []
            });
            return _context5.a(2);
          case 6:
            targets = computeTargets(cart, tiers, unlockedLevels);
            _context5.n = 7;
            return syncGiftLines(giftsInCart, variantId, targets, removedItems.length === 0);
          case 7:
            changed = _context5.v;
            ctx.emit(changed ? 'cart:update' : 'cart:idle');
            renderCards({
              tiers: tiers,
              cartTotal: cartTotal,
              unlockedLevels: unlockedLevels,
              giftsInCart: giftsInCart
            });
          case 8:
            return _context5.a(2);
        }
      }, _callee4);
    }));
    return _updateItems.apply(this, arguments);
  }
  function handleSubmit(_x1) {
    return _handleSubmit.apply(this, arguments);
  }
  function _handleSubmit() {
    _handleSubmit = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_3__["default"])().m(function _callee5(event) {
      var id, _ctx$getState2, cart, _ctx$getState2$tiers, tiers, _ctx$getState2$unlock, unlockedLevels;
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_3__["default"])().w(function (_context6) {
        while (1) switch (_context6.n) {
          case 0:
            event.preventDefault();
            id = Number(new FormData(event.target).get('id'));
            _ctx$getState2 = ctx.getState(), cart = _ctx$getState2.cart, _ctx$getState2$tiers = _ctx$getState2.tiers, tiers = _ctx$getState2$tiers === void 0 ? [] : _ctx$getState2$tiers, _ctx$getState2$unlock = _ctx$getState2.unlockedLevels, unlockedLevels = _ctx$getState2$unlock === void 0 ? 0 : _ctx$getState2$unlock;
            _context6.n = 1;
            return syncGiftLines([], id, computeTargets(cart, tiers, unlockedLevels), true);
          case 1:
            ctx.emit('cart:update');
          case 2:
            return _context6.a(2);
        }
      }, _callee5);
    }));
    return _handleSubmit.apply(this, arguments);
  }
  ctx.on('cart-progress-bar:updated', updateItems);
  node.addEventListener('submit', handleSubmit);
  return function () {
    return node.removeEventListener('submit', handleSubmit);
  };
}));

/***/ }),

/***/ "./scripts/components/cart-item-subscription.js":
/*!******************************************************!*\
  !*** ./scripts/components/cart-item-subscription.js ***!
  \******************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");

/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node, ctx) {
  var _node$dataset = node.dataset,
    lineKey = _node$dataset.lineKey,
    requiresPlan = _node$dataset.requiresPlan;
  var input = node.querySelector('[data-subscription-input]');
  var requiresSellingPlan = requiresPlan === 'true';
  var committedOn = !!(input !== null && input !== void 0 && input.checked);
  var setLoading = function setLoading(state) {
    node.classList.toggle('is-loading', state);
  };
  var syncOnState = function syncOnState() {
    node.classList.toggle('is-on', !!(input !== null && input !== void 0 && input.checked));
  };
  node.classList.toggle('is-locked', requiresSellingPlan);
  syncOnState();
  input === null || input === void 0 || input.addEventListener('change', function () {
    var isOn = input.checked;
    syncOnState();
    if (isOn) {
      setLoading(true);
      ctx.emit('cart:set-selling-plan', {
        id: lineKey,
        autoship: true
      });
    } else if (!requiresSellingPlan) {
      setLoading(true);
      ctx.emit('cart:set-selling-plan', {
        id: lineKey,
        autoship: false
      });
    }
  });
  ctx.on('cart:set-selling-plan-error', function (payload) {
    if (!payload || String(payload.id) !== String(lineKey)) {
      return;
    }
    setLoading(false);
    if (input) {
      input.checked = committedOn;
    }
    syncOnState();
  });
}));

/***/ }),

/***/ "./scripts/components/cart-progress-bar.js":
/*!*************************************************!*\
  !*** ./scripts/components/cart-progress-bar.js ***!
  \*************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");

var DEFAULT_FREE_SHIPPING_THRESHOLD = 40;
/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node, ctx) {
  var strings = window.theme.strings;
  var title = node.querySelector('#next-goal-text');
  var fill = node.querySelector('#progress-fill');
  function updateProgress(cart) {
    var _window$country_shipp;
    var tiers = node.dataset.tiers ? node.dataset.tiers.split(',').map(Number) : [];
    var cartTotal = cart ? cart.total_price / 100 : parseFloat(node.dataset.cartTotal) || 0;
    var country = (_window$country_shipp = window.country_shipping) === null || _window$country_shipp === void 0 ? void 0 : _window$country_shipp.find(function (c) {
      return c.current;
    });
    var freeShippingThreshold = country ? country.number : Number(node.dataset.freeShippingThreshold) || DEFAULT_FREE_SHIPPING_THRESHOLD;
    if (title && fill) {
      if (cartTotal >= freeShippingThreshold) {
        title.textContent = strings.giftUnlockedAll;
        fill.style.width = '100%';
      } else {
        var amountNeeded = window.theme.Currency.formatMoney((freeShippingThreshold - cartTotal) * 100, window.theme.settings.moneyFormat);
        title.innerHTML = strings.giftUnlockedProgress.replace('[price]', amountNeeded).replace('[text]', strings.giftUnlockedShipping);
        fill.style.width = "".concat(Math.min(100, cartTotal / freeShippingThreshold * 100), "%");
      }
    }
    var unlockedLevels = tiers.filter(function (tier) {
      return cartTotal >= tier;
    }).length;
    ctx.emit('cart-progress-bar:updated', {
      tiers: tiers,
      unlockedLevels: unlockedLevels
    });
  }
  ctx.on('cart:fetched', function (state) {
    return updateProgress(state.cart);
  });
  ctx.on('cart:updated', function (state) {
    return updateProgress(state.cart);
  });
}));

/***/ }),

/***/ "./scripts/components/cart-subscription.js":
/*!*************************************************!*\
  !*** ./scripts/components/cart-subscription.js ***!
  \*************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");

/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node, ctx) {
  var radios = Array.from(node.querySelectorAll('[data-subscription-plan]'));
  function onPlanChange(event) {
    var radio = event.target;
    if (!radio.checked) return;
    node.classList.add('is-loading');
    ctx.emit('cart:set-cart-selling-plan', {
      sellingPlan: radio.value
    });
  }
  radios.forEach(function (radio) {
    return radio.addEventListener('change', onPlanChange);
  });
  return function () {
    radios.forEach(function (radio) {
      return radio.removeEventListener('change', onPlanChange);
    });
  };
}));

/***/ }),

/***/ "./scripts/components/collapsible-text.js":
/*!************************************************!*\
  !*** ./scripts/components/collapsible-text.js ***!
  \************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");

/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node) {
  var trigger = node.querySelector("[data-collapsible='trigger']");
  var content = node.querySelector("[data-collapsible='content']");
  var _window$theme$strings = window.theme.strings.collapsible,
    more = _window$theme$strings.more,
    less = _window$theme$strings.less;
  var MAX_HEIGHT = 160;
  var classes = {
    open: 'is-open',
    active: 'is-active'
  };
  var handleClick = function handleClick(_ref) {
    var target = _ref.target;
    node.classList.toggle(classes.open);
    if (node.classList.contains(classes.open)) {
      target.textContent = less;
    } else {
      target.textContent = more;
    }
  };
  var checkElementHeight = function checkElementHeight(element) {
    element.setAttribute('style', "--max-height: ".concat(MAX_HEIGHT, "px"));
    if (element.clientHeight > MAX_HEIGHT) {
      node.classList.add(classes.active);
    } else {
      node.classList.remove(classes.active);
    }
  };
  checkElementHeight(content);
  trigger.addEventListener('click', handleClick);
}));

/***/ }),

/***/ "./scripts/components/copy-to-clipboard.js":
/*!*************************************************!*\
  !*** ./scripts/components/copy-to-clipboard.js ***!
  \*************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");

/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node) {
  var trigger = node.querySelector('[data-copy-to-clipboard=trigger]');
  var text = node.querySelector('[data-copy-to-clipboard=text]');
  if (trigger && text && window.navigator.clipboard) {
    trigger.addEventListener('click', function () {
      navigator.clipboard.writeText(text.innerText).then(function () {
        return console.log('Copying to clipboard was successful!', text.innerText);
      }, function (error) {
        return console.error('Could not copy text: ', error);
      });
    });
  }
}));

/***/ }),

/***/ "./scripts/components/country-selector.js":
/*!************************************************!*\
  !*** ./scripts/components/country-selector.js ***!
  \************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/objectSpread2 */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/objectSpread2.js");
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! js-cookie */ "./node_modules/.pnpm/js-cookie@3.0.8/node_modules/js-cookie/dist/js.cookie.mjs");
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");



/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_2__.component)(function (node, ctx) {
  var modalId = node.dataset.modalId;
  var confirm = node.querySelector('[data-confirm]');
  var detail = node.querySelector('[data-detail]');
  var options = [];
  ctx.hydrate({
    countrySelector: {
      setDefaultCountry: true,
      selectedCountry: null
    }
  });
  var selectedOption = node.querySelector('[data-option-selected]');
  var allOptions = node.querySelectorAll('[data-option]');
  var triggers = document.querySelectorAll("#".concat(modalId));
  var defaultOptionHTML = '';
  if (triggers.length === 0) {
    return;
  }
  var handleChangeSelectedOption = function handleChangeSelectedOption() {
    var html = '';
    allOptions.forEach(function (option) {
      var selectedCountry = ctx.getState().countrySelector.selectedCountry;
      var _JSON$parse = JSON.parse(option.dataset.props || {}),
        name = _JSON$parse.name;
      if (name === selectedCountry) {
        html = option.innerHTML;
      }
    });
    selectedOption.innerHTML = html;
    triggers.forEach(function (trigger) {
      trigger.style.display = '';
      trigger.innerHTML = html;
    });
  };
  var onSelectedCountryChange = function onSelectedCountryChange(event) {
    var _ctx$getState = ctx.getState(),
      countrySelector = _ctx$getState.countrySelector;
    var target = event.target.closest('.CountrySelector__Option');
    var _JSON$parse2 = JSON.parse(target.dataset.props || {}),
      targetName = _JSON$parse2.name;
    ctx.hydrate({
      countrySelector: (0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_0__["default"])((0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_0__["default"])({}, countrySelector), {}, {
        selectedCountry: targetName
      })
    });
    handleChangeSelectedOption();
    detail.removeAttribute('open');
  };
  var checkUrlHasLanguage = function checkUrlHasLanguage(pathname) {
    var maybeLanguage = pathname.split('/')[1];
    var pathnameHasLanguage = maybeLanguage.length === 2;
    return pathnameHasLanguage ? maybeLanguage : false;
  };
  var getCurrentUrl = function getCurrentUrl() {
    var selectedCountry = ctx.getState().countrySelector.selectedCountry;
    var _options$find = options.find(function (option) {
        return option.name === selectedCountry;
      }),
      url = _options$find.url;
    return {
      hostname: url.split('/')[0],
      pathname: url.split('/')[1]
    };
  };
  var getRedirectionUrl = function getRedirectionUrl(url) {
    var lang = checkUrlHasLanguage(window.location.pathname);
    var pathname = lang ? window.location.pathname.slice(3) : window.location.pathname;
    var targetUrl = url.pathname ? "".concat(window.location.protocol, "//").concat(url.hostname, "/").concat(url.pathname).concat(pathname) : "".concat(window.location.protocol, "//").concat(url.hostname).concat(pathname);
    return targetUrl;
  };
  var redirectToUrl = function redirectToUrl() {
    var url = getCurrentUrl();
    window.location.href = getRedirectionUrl(url);
  };
  var stayHere = function stayHere() {
    var url = getCurrentUrl();
    var lang = checkUrlHasLanguage(window.location.pathname);
    return lang && url.pathname && url.pathname === lang || !lang && !url.pathname && url.hostname === window.location.hostname || window.Shopify.designMode;
  };
  var onContryChange = function onContryChange() {
    var selectedCountry = ctx.getState().countrySelector.selectedCountry;
    js_cookie__WEBPACK_IMPORTED_MODULE_1__["default"].set('country', selectedCountry, {
      expires: 7,
      domain: 'snuzone.com'
    });
    if (stayHere()) {
      ctx.emit("modal-".concat(modalId, ":close"), function (state) {
        return {
          countrySelector: (0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_0__["default"])((0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_0__["default"])({}, state.countrySelector), {}, {
            setDefaultCountry: true
          })
        };
      });
      return;
    }
    ctx.emit("modal-".concat(modalId, ":close"), function (state) {
      return {
        countrySelector: (0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_0__["default"])((0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_0__["default"])({}, state.countrySelector), {}, {
          setDefaultCountry: false
        })
      };
    });
    redirectToUrl();
  };
  allOptions.forEach(function (option) {
    var _JSON$parse3 = JSON.parse(option.dataset.props || {}),
      name = _JSON$parse3.name,
      url = _JSON$parse3.url,
      isDefault = _JSON$parse3.default;
    options.push({
      name: name,
      url: url,
      default: isDefault
    });
    if (isDefault) {
      defaultOptionHTML = option.innerHTML;
    }
    option.addEventListener('click', onSelectedCountryChange);
  });
  var defaultOption = options.find(function (option) {
    return option.default;
  });
  var localCountryInOptions = options.find(function (option) {
    return option.name === js_cookie__WEBPACK_IMPORTED_MODULE_1__["default"].get('country');
  });
  ctx.hydrate({
    countrySelector: (0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_0__["default"])((0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_0__["default"])({}, ctx.getState().countrySelector), {}, {
      selectedCountry: localCountryInOptions ? js_cookie__WEBPACK_IMPORTED_MODULE_1__["default"].get('country') : defaultOption.name
    })
  });
  if (!js_cookie__WEBPACK_IMPORTED_MODULE_1__["default"].get('show_modal')) {
    setTimeout(function () {
      if (window.Shopify.designMode || window.location.pathname.includes('apps')) {
        return;
      }
      ctx.emit("modal-".concat(modalId, ":open"));
      js_cookie__WEBPACK_IMPORTED_MODULE_1__["default"].set('show_modal', 'true', {
        expires: 7,
        domain: 'snuzone.com'
      });
    }, 2000);
  }
  handleChangeSelectedOption();
  if (js_cookie__WEBPACK_IMPORTED_MODULE_1__["default"].get('country')) {
    if (!stayHere()) {
      redirectToUrl();
    }
  }
  ctx.on("modal-".concat(modalId, ":closed"), function (state) {
    if (state.countrySelector.setDefaultCountry) {
      selectedOption.innerHTML = defaultOptionHTML;
      triggers.forEach(function (trigger) {
        trigger.innerHTML = defaultOptionHTML;
      });
      ctx.hydrate({
        countrySelector: (0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_0__["default"])((0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_0__["default"])({}, state.countrySelector), {}, {
          selectedCountry: defaultOption.name
        })
      });
    }
    detail.removeAttribute('open');
  });
  confirm.addEventListener('click', onContryChange);
}));

/***/ }),

/***/ "./scripts/components/customer-account-header.js":
/*!*******************************************************!*\
  !*** ./scripts/components/customer-account-header.js ***!
  \*******************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");

/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node) {
  var menu = node.querySelector('[data-menu]');
  var openButton = node.querySelector('[data-menu-open]');
  var closeButton = node.querySelector('[data-menu-close]');
  var lastScrollY = window.scrollY;
  var handleOpen = function handleOpen() {
    return menu.showModal();
  };
  var handleClose = function handleClose() {
    return menu.close();
  };
  var handleMenuClick = function handleMenuClick(event) {
    if (event.target === menu) handleClose();
  };
  var handleScroll = function handleScroll() {
    var _window = window,
      scrollY = _window.scrollY;
    var isHidden = scrollY > lastScrollY && scrollY > node.offsetHeight;
    node.classList.toggle('customer-account__header--hidden', isHidden);
    lastScrollY = scrollY;
  };
  openButton.addEventListener('click', handleOpen);
  closeButton.addEventListener('click', handleClose);
  menu.addEventListener('click', handleMenuClick);
  window.addEventListener('scroll', handleScroll, {
    passive: true
  });
  return function () {
    openButton.removeEventListener('click', handleOpen);
    closeButton.removeEventListener('click', handleClose);
    menu.removeEventListener('click', handleMenuClick);
    window.removeEventListener('scroll', handleScroll);
  };
}));

/***/ }),

/***/ "./scripts/components/facets-drawer.js":
/*!*********************************************!*\
  !*** ./scripts/components/facets-drawer.js ***!
  \*********************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var _facets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./facets */ "./scripts/components/facets.js");


/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node, ctx) {
  var facets = (0,_facets__WEBPACK_IMPORTED_MODULE_1__["default"])(node, ctx);
  node.addEventListener('click', function (event) {
    var target = event.target;
    if (target.hasAttribute('data-apply')) {
      target.disabled = true;
      facets.onFilterChanged();
      ctx.on('facets:update', function () {
        if (target) {
          target.disabled = false;
        }
      });
    }
    if (target.hasAttribute('data-clear')) {
      event.preventDefault();
      target.disabled = true;
      var href = target.href ? target.href : "".concat(window.location.origin).concat(window.location.pathname);
      facets.renderSection(href);
    }
  });
}));

/***/ }),

/***/ "./scripts/components/facets-inline.js":
/*!*********************************************!*\
  !*** ./scripts/components/facets-inline.js ***!
  \*********************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var _facets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./facets */ "./scripts/components/facets.js");


/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node, ctx) {
  var facets = (0,_facets__WEBPACK_IMPORTED_MODULE_1__["default"])(node, ctx);
  node.addEventListener('click', function (event) {
    var target = event.target;
    if (target.hasAttribute('data-apply')) {
      target.disabled = true;
      facets.onFilterChanged();
    }
    if (target.hasAttribute('data-clear')) {
      event.preventDefault();
      target.disabled = true;
      var href = target.href ? target.href : "".concat(window.location.origin).concat(window.location.pathname);
      facets.renderSection(href);
    }
  });
}));

/***/ }),

/***/ "./scripts/components/facets.js":
/*!**************************************!*\
  !*** ./scripts/components/facets.js ***!
  \**************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Facets; }
/* harmony export */ });
/* harmony import */ var _api_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @/api/sections */ "./scripts/api/sections.js");

function debounce(fn, wait) {
  var _this = this;
  var t;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(t);
    t = setTimeout(function () {
      return fn.apply(_this, args);
    }, wait);
  };
}
function Facets(node, ctx) {
  var _document$querySelect, _document$querySelect2;
  var selectors = {
    grid: '#CollectionGrid',
    pagination: '#CollectionPagination',
    facets: '[data-facets-container]',
    count: '[data-product-count]'
  };
  var productGridId = ((_document$querySelect = document.querySelector('#CollectionAjaxResult')) === null || _document$querySelect === void 0 || (_document$querySelect = _document$querySelect.dataset) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.sectionId) || 'custom-collection-template';
  var filterSidebarId = ((_document$querySelect2 = document.querySelector('#CollectionSidebar')) === null || _document$querySelect2 === void 0 || (_document$querySelect2 = _document$querySelect2.dataset) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.sectionId) || 'custom-collection-sidebar';
  var productGrid = document.querySelector(selectors.grid);
  var pagination = document.querySelector(selectors.pagination);
  var filterCount = node.querySelector(selectors.count);
  var filterFacets = node.querySelector(selectors.facets);
  var insertContent = function insertContent(json) {
    var tempGrid = document.createElement('div');
    tempGrid.innerHTML = json[productGridId];
    var tempFilterSidebar = document.createElement('div');
    tempFilterSidebar.innerHTML = json[filterSidebarId];
    productGrid.innerHTML = tempGrid.querySelector(selectors.grid).innerHTML;
    pagination.innerHTML = tempGrid.querySelector(selectors.pagination).innerHTML;
    filterFacets.innerHTML = tempFilterSidebar.querySelector("#".concat(node.id, " ").concat(selectors.facets)).innerHTML;
    if (filterCount != null) {
      filterCount.innerHTML = tempFilterSidebar.querySelector(selectors.count).innerHTML;
    }
    ctx.emit('app:update');
    ctx.emit('images:update');
    ctx.emit('facets:update');
  };
  var _renderSection = function renderSection(href, ids) {
    (0,_api_sections__WEBPACK_IMPORTED_MODULE_0__["default"])(href, ids).then(function (json) {
      window.history.pushState({}, '', href);
      insertContent(json);
    }).catch(function (err) {
      return console.error(err);
    });
  };
  var onFilterChanged = debounce(function () {
    var selectedInputs = node.querySelectorAll("input:checked, input[type='number']");
    var searchParams = new URLSearchParams();
    var url = new URL(window.location.href);
    var oseid = new URLSearchParams(window.location.search).get('oseid');
    if (oseid) {
      searchParams.append('oseid', oseid);
    }
    selectedInputs.forEach(function (input) {
      var inputName = input.name;
      if (input.value !== '') {
        searchParams.append(inputName, input.value);
      }
    });
    url.search = searchParams.toString();
    _renderSection(url.href, [productGridId, filterSidebarId]);
  }, 1000);
  return {
    onFilterChanged: onFilterChanged,
    renderSection: function renderSection(url) {
      return _renderSection(url, [productGridId, filterSidebarId]);
    }
  };
}

/***/ }),

/***/ "./scripts/components/free-shipping.js":
/*!*********************************************!*\
  !*** ./scripts/components/free-shipping.js ***!
  \*********************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var _lib_currency__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/lib/currency */ "./scripts/lib/currency.js");


/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node) {
  var cartTotal = document.querySelector('[data-shipping-price]').getAttribute('data-shipping-price');
  var shippingFull = document.querySelector('[data-shipping-price]').getAttribute('data-shipping-full');
  var currentCountry = window.Shopify.country;
  var countries = window.country_shipping;
  var foundCountry = countries.find(function (countryObj) {
    return countryObj.iso_code === currentCountry;
  });
  console.log(!cartTotal);
  console.log(foundCountry !== undefined);
  if (foundCountry !== undefined) {
    console.log('12');
    var color = '#266923';
    var shippingPrice = document.querySelector('[data-shipping-price]');
    var freeShippingThreshold = "".concat(foundCountry.number, "00");
    var percentage = Number(cartTotal) / freeShippingThreshold * 100;
    console.log(Number(freeShippingThreshold));
    if (Number(freeShippingThreshold) >= Number(cartTotal)) {
      console.log('1');
      var numberSum = "<b>".concat((0,_lib_currency__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(freeShippingThreshold - Number(cartTotal), window.theme.settings.moneyFormat), "</b>");
      var textShipping = document.querySelector('[data-shipping-price]').textContent.replace('{{ price_subtotal }}', numberSum);
      shippingPrice.innerHTML = textShipping;
    } else {
      shippingPrice.innerHTML = shippingFull;
    }
    var svgElements = document.querySelectorAll('.cart__free-shipping [data-svg-shipping] path');
    var numberOfElementsToFill = Math.ceil(percentage / 100 * svgElements.length);
    svgElements.forEach(function (element, index) {
      if (index < numberOfElementsToFill) {
        element.style.fill = color;
      }
    });
    if (percentage < 100) {
      svgElements[svgElements.length - 1].style.fill = '#E7E8E7';
    }
    node.style.display = 'flex';
  }
}));

/***/ }),

/***/ "./scripts/components/localization-global.js":
/*!***************************************************!*\
  !*** ./scripts/components/localization-global.js ***!
  \***************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");

/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node) {
  // Capture phase runs before the theme's localization form submits the form.
  var handleChange = function handleChange(event) {
    var _target$selectedOptio;
    var target = event.target;
    var url = target.name === 'country_code' && ((_target$selectedOptio = target.selectedOptions[0]) === null || _target$selectedOptio === void 0 ? void 0 : _target$selectedOptio.dataset.url);
    if (url) {
      var _target$querySelector;
      event.stopPropagation();
      target.value = ((_target$querySelector = target.querySelector('option[selected]')) === null || _target$querySelector === void 0 ? void 0 : _target$querySelector.value) || '';
      window.location.href = url;
    }
  };
  node.addEventListener('change', handleChange, true);
  return function () {
    return node.removeEventListener('change', handleChange, true);
  };
}));

/***/ }),

/***/ "./scripts/components/modal.js":
/*!*************************************!*\
  !*** ./scripts/components/modal.js ***!
  \*************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");

/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node, ctx) {
  var overlay = node.querySelector('[data-modal-overlay]');
  var close = node.querySelector('[data-modal-close]');
  var modalId = node.dataset.modalId;
  var openButtons = document.querySelectorAll("#".concat(modalId));
  var closeButtons = document.querySelectorAll("[data-modal-close=\"".concat(modalId, "\"]"));
  var productPopup = document.querySelector('.product-custom-popup');
  if (!modalId) return;
  var handleOpen = function handleOpen() {
    node.classList.add('is-active');
    if (document.querySelector('.ModalForm.active') && productPopup) {
      productPopup.classList.add('hide');
    }
    ctx.emit('modal:toggle', function (state) {
      return {
        modalOpen: !state.modalOpen
      };
    });
    setTimeout(function () {
      node.classList.add('is-visible');
    }, 50);
  };
  var handleClose = function handleClose() {
    var _document$querySelect;
    node.classList.remove('is-visible');
    document.querySelector('body').style.overflow = 'initial';
    ctx.emit('modal:close', function () {
      return {
        modalOpen: false
      };
    });
    ctx.emit("modal-".concat(modalId, ":closed"));
    (_document$querySelect = document.querySelector('.ModalForm')) === null || _document$querySelect === void 0 || _document$querySelect.classList.add('close-animation');
    setTimeout(function () {
      var _document$querySelect2;
      node.classList.remove('is-active');
      if ((_document$querySelect2 = document.querySelector('.ModalForm')) !== null && _document$querySelect2 !== void 0 && _document$querySelect2.classList.contains('close-animation')) {
        document.querySelector('.ModalForm').classList.remove('close-animation');
        document.querySelector('.ModalForm').classList.remove('active');
      }
    }, 400);
    setTimeout(function () {
      productPopup && document.querySelector('.product-custom-popup').remove();
    }, 500);
  };
  overlay.addEventListener('click', handleClose);
  close.addEventListener('click', handleClose);
  openButtons.forEach(function (button) {
    button.addEventListener('click', handleOpen);
  });
  closeButtons.forEach(function (button) {
    button.addEventListener('click', handleClose);
  });
  ctx.on("modal-".concat(modalId, ":open"), handleOpen);
  ctx.on("modal-".concat(modalId, ":close"), handleClose);
}));

/***/ }),

/***/ "./scripts/components/price-range.js":
/*!*******************************************!*\
  !*** ./scripts/components/price-range.js ***!
  \*******************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
/* harmony import */ var nouislider_dist_nouislider_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! nouislider/dist/nouislider.css */ "./node_modules/.pnpm/nouislider@15.8.1/node_modules/nouislider/dist/nouislider.css");
/* harmony import */ var nouislider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! nouislider */ "./node_modules/.pnpm/nouislider@15.8.1/node_modules/nouislider/dist/nouislider.mjs");
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var _lib_currency__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @/lib/currency */ "./scripts/lib/currency.js");





/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_3__.component)(function (node) {
  var fromInput = node.querySelector('[data-from]');
  var toInput = node.querySelector('[data-to]');
  var _JSON$parse = JSON.parse(node.dataset.props || {}),
    min = _JSON$parse.min,
    max = _JSON$parse.max,
    step = _JSON$parse.step,
    minValue = _JSON$parse.minValue,
    maxValue = _JSON$parse.maxValue;
  var format = {
    to: function to(value) {
      return (0,_lib_currency__WEBPACK_IMPORTED_MODULE_4__.formatMoney)(Math.round(value), window.theme.moneyFormat, true);
    }
  };
  nouislider__WEBPACK_IMPORTED_MODULE_2__["default"].create(node, {
    start: [minValue, maxValue],
    connect: true,
    tooltips: [format, format],
    range: {
      min: min,
      max: max
    },
    step: step
  });
  node.noUiSlider.on('change', function (values) {
    var _values = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(values, 2),
      from = _values[0],
      to = _values[1];
    var fromRounded = Math.round(from);
    var toRounded = Math.round(to);
    if (fromRounded !== minValue) {
      fromInput.value = fromRounded / 100;
      fromInput.dispatchEvent(new Event('change', {
        bubbles: true
      }));
    }
    if (toRounded !== maxValue) {
      toInput.value = toRounded / 100;
      toInput.dispatchEvent(new Event('change', {
        bubbles: true
      }));
    }
  });
}));

/***/ }),

/***/ "./scripts/components/product-announcements.js":
/*!*****************************************************!*\
  !*** ./scripts/components/product-announcements.js ***!
  \*****************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! swiper */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/swiper.mjs");
/* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! swiper/modules */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/index.mjs");
/* harmony import */ var _lib_throttle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/lib/throttle */ "./scripts/lib/throttle.js");




swiper__WEBPACK_IMPORTED_MODULE_1__["default"].use([swiper_modules__WEBPACK_IMPORTED_MODULE_2__.Autoplay, swiper_modules__WEBPACK_IMPORTED_MODULE_2__.Navigation]);
/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node) {
  var slidesCount = node.querySelectorAll('.product-meta-announcements__item').length;
  var swiperInstance = initializeSwiper();
  window.addEventListener('resize', (0,_lib_throttle__WEBPACK_IMPORTED_MODULE_3__["default"])(handleResize, 200));
  function initializeSwiper() {
    if (slidesCount > 1) {
      var options = {
        wrapperClass: 'product-meta-announcements__wrapper',
        slideClass: 'product-meta-announcements__item',
        slidesPerView: 1,
        spaceBetween: 12,
        loop: true,
        autoplay: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      };
      return new swiper__WEBPACK_IMPORTED_MODULE_1__["default"](node, options);
    }
    return null;
  }
  function handleResize() {
    if (slidesCount > 1 && swiperInstance === null) {
      swiperInstance = initializeSwiper();
    } else if (slidesCount <= 1 && swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }
}));

/***/ }),

/***/ "./scripts/components/product-form.js":
/*!********************************************!*\
  !*** ./scripts/components/product-form.js ***!
  \********************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/objectSpread2 */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/objectSpread2.js");
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var _app__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @/app */ "./scripts/app.js");
/* harmony import */ var _lib_currency__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @/lib/currency */ "./scripts/lib/currency.js");






/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_3__.component)(function (node, ctx) {
  var _node$querySelector, _node$closest, _node$querySelector2;
  var currentProductId = ((_node$querySelector = node.querySelector('[data-product-custom-id]')) === null || _node$querySelector === void 0 ? void 0 : _node$querySelector.getAttribute('data-product-custom-id')) || ((_node$closest = node.closest("[data-component='ProductForm']")) === null || _node$closest === void 0 || (_node$closest = _node$closest.querySelector('[data-product-custom-id]')) === null || _node$closest === void 0 ? void 0 : _node$closest.getAttribute('data-product-custom-id'));

  // Exit early if we can't find a product ID
  if (!currentProductId) {
    console.warn('ProductForm component: No product ID found, component will not initialize');
    return;
  }
  console.log("ProductForm component initialized for product ".concat(currentProductId, ", node:"), node);
  var sectionId = (_node$querySelector2 = node.querySelector('[data-section-id]')) === null || _node$querySelector2 === void 0 ? void 0 : _node$querySelector2.getAttribute('data-section-id');
  var variantsElement = node.querySelector('[data-product-variants]');
  var rangeDiscountsElement = node.querySelector('[data-product-range]');

  // Exit early if required elements are missing
  if (!variantsElement) {
    console.warn('ProductForm component: No variants data found for product', currentProductId);
    return;
  }
  var variants = JSON.parse(variantsElement.innerText);
  var rangeDiscounts = rangeDiscountsElement ? JSON.parse(rangeDiscountsElement.innerText) : null;
  var quantityDiscount = null;
  var dataPercentEl = node.querySelector('.product-single__variants-wrapper-variant.discountPercent');
  var getCurrentOptions = function getCurrentOptions() {
    var optionElements = node.querySelectorAll('.variant-input input');
    console.log("getCurrentOptions for product ".concat(currentProductId, ":"), optionElements.length, 'elements found');
    var currentOptions = Array.from(optionElements).map(function (element) {
      var type = element.type;
      var currentOption = {};
      if (type === 'radio' || type === 'checkbox') {
        if (element.checked) {
          currentOption.value = element.value;
          currentOption.index = element.dataset.index;
          return currentOption;
        }
        return false;
      }
      currentOption.value = element.value;
      currentOption.index = element.dataset.index;
      return currentOption;
    });
    currentOptions = currentOptions.filter(function (option) {
      return option !== false;
    });
    return currentOptions;
  };
  var getVariantFromOptions = function getVariantFromOptions() {
    var selectedValues = getCurrentOptions();
    console.log("getVariantFromOptions for product ".concat(currentProductId, ":"), selectedValues);
    var found = false;
    variants.forEach(function (variant) {
      var match = true;
      selectedValues.forEach(function (option) {
        if (match) {
          match = variant[option.index] === option.value;
        }
      });
      if (match) {
        found = variant;
      }
    });
    console.log("Found variant for product ".concat(currentProductId, ":"), found);
    return found || null;
  };
  var discountComparePrice = function discountComparePrice(dataPercent) {
    if (dataPercent != null && node.querySelector('[data-discount-compare-price]')) {
      node.querySelector('[data-discount-compare-price] span').innerHTML = dataPercent.getAttribute('data-percent');
      node.querySelector('[data-discount-compare-price]').style.opacity = '1';
    }
    var savePrice = node.querySelector("#SavePrice-".concat(currentProductId));
    if (dataPercent != null && savePrice) {
      savePrice.innerHTML = dataPercent.getAttribute('data-percent');
    }
  };
  getVariantFromOptions();
  discountComparePrice(dataPercentEl);
  if (rangeDiscounts) {
    quantityDiscount = rangeDiscounts.reduce(function (obj, item) {
      var rangeAndDiscount = item.split('/');
      var range = rangeAndDiscount[0].split('-');
      var discountValue = rangeAndDiscount[1].split('%')[0];
      return (0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_2__["default"])((0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_2__["default"])({}, obj), {}, (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__["default"])({}, range[0], (100 - parseFloat(discountValue)) / 100));
    }, {});
  }
  var setImage = function setImage(src) {
    if (node.querySelector('[data-popup-image]') && src) {
      node.querySelector('[data-popup-image]').src = src;
    }
  };
  var changeVariantQuantity = function changeVariantQuantity(variantId) {
    var currentQuantity = node.querySelector("[data-quantity-variant-id=\"".concat(variantId, "\"]"));
    if (currentQuantity && currentQuantity.className.includes('hide')) {
      node.querySelectorAll('[data-quantity-variant-id]').forEach(function (element) {
        if (!element.className.includes('hide')) {
          element.classList.add('hide');
        }
      });
      currentQuantity.querySelector('input').checked = true;
      currentQuantity.classList.remove('hide');
    }
  };
  var setQuantity = function setQuantity(quantity) {
    // Find quantity input within THIS form instance only
    var quantityInput = node.querySelector("#selected_".concat(currentProductId, "_quantity")) || node.querySelector("input[name=\"quantity\"]") || node.querySelector("input[type=\"text\"][value]");
    if (quantityInput) {
      quantityInput.value = quantity;
      console.log("Set quantity ".concat(quantity, " for product ").concat(currentProductId, " in form:"), node);
    }
    var addToCartQuantityEl = node.querySelector("#product_".concat(currentProductId, "_add_to_cart_quantity"));
    if (addToCartQuantityEl) {
      addToCartQuantityEl.innerHTML = quantity;
    }

    // Update PostAddToCart__Quantity and other popup quantity displays
    var popupQuantityElements = [
    // First try to find elements within current node/form context
    node.querySelector('.PostAddToCart__Quantity'), node.querySelector('[class*="PostAddToCart__Quantity"]'), node.querySelector('[data-post-add-to-cart-quantity]'), node.querySelector('[data-popup-quantity]'), node.querySelector('.popup [data-quantity]'), node.querySelector('[data-modal-id] [data-quantity]'),
    // Then try to find elements specific to current product ID in modal popups
    document.querySelector("#product_".concat(currentProductId, "_add_to_cart_quantity")), document.querySelector("[data-post-add-to-cart-quantity][id*=\"".concat(currentProductId, "\"]")),
    // Look for active modals and their quantity displays
    document.querySelector(".Modal.is-active [data-post-add-to-cart-quantity]"), document.querySelector(".Modal.is-visible [data-post-add-to-cart-quantity]"), document.querySelector(".PostAddToCart [data-post-add-to-cart-quantity]"),
    // Fallback to global selectors but only for current product modal
    document.querySelector("[data-modal-id=\"post-add-to-cart\"] [data-quantity]"), document.querySelector("[data-modal-id=\"post-add-to-cart-popup\"] [data-quantity]")].filter(function (el) {
      return el;
    }); // Remove null elements

    console.log('Updating popup quantity elements:', popupQuantityElements, 'with quantity:', quantity);
    popupQuantityElements.forEach(function (el) {
      if (el) {
        // Check if element already contains "Menge:" text and preserve it
        if (el.textContent && el.textContent.includes('Menge:')) {
          el.textContent = "Menge: ".concat(quantity);
        } else if (el.innerHTML && el.innerHTML.includes('Menge:')) {
          el.innerHTML = "Menge: ".concat(quantity);
        } else {
          // For elements that should just show the number
          el.innerHTML = quantity;
          el.textContent = quantity;
        }
      }
    });
  };
  var changeForm = function changeForm() {
    var form = node.querySelector('.form-popup__modal-js');
    if (form) {
      var variant = getVariantFromOptions();
      if (variant) {
        var variantId = variant.id;
        console.log("changeForm for product ".concat(currentProductId, ", setting variant ").concat(variantId));
        var variantSelect = form.querySelector('select.product-single__variants') || form.querySelector("select[name=\"id\"]") || node.querySelector("select[name=\"id\"]");
        if (variantSelect) {
          var currentSelectOption = variantSelect.querySelector("option[value=\"".concat(variantId, "\"]"));
          if (currentSelectOption) {
            currentSelectOption.selected = true;
          }
        }
        var variantAvailable = variant.available;
        var buttomAddToCart = form.querySelector('button[name="add"]');
        // if(variantAvailable == "unavailable"){
        //   buttomAddToCart.add.classList('disabled')
        //   buttomAddToCart.setAttribute("disabled", "")
        // }
      }
    }
  };
  var setPrice = function setPrice(variantId, quantity, input) {
    setTimeout(function () {
      var _window$theme, _window$theme2, _window$Shopify;
      console.log('setPrice called with:', {
        variantId: variantId,
        quantity: quantity,
        currentProductId: currentProductId
      });
      var selectedVariant = variants.find(function (item) {
        return item.id === parseInt(variantId, 10);
      });
      console.log('selectedVariant found:', selectedVariant);
      if (!selectedVariant) {
        console.error('No variant found for ID:', variantId);
        return;
      }
      var priceEachItem = selectedVariant.price;
      var compareAtPriceEachItem = selectedVariant.compare_at_price || 0;
      var discount = quantityDiscount ? quantityDiscount[quantity] : 1;
      var totalRaw = quantity * discount * priceEachItem;
      var moneyFormat = ((_window$theme = window.theme) === null || _window$theme === void 0 || (_window$theme = _window$theme.settings) === null || _window$theme === void 0 ? void 0 : _window$theme.moneyFormat) || ((_window$theme2 = window.theme) === null || _window$theme2 === void 0 ? void 0 : _window$theme2.moneyFormat) || ((_window$Shopify = window.Shopify) === null || _window$Shopify === void 0 ? void 0 : _window$Shopify.money_format) || '€{{amount}}';
      var totalToDisplay = (0,_lib_currency__WEBPACK_IMPORTED_MODULE_5__.formatMoney)(totalRaw, moneyFormat);
      console.log('Price calculation:', {
        priceEachItem: priceEachItem,
        quantity: quantity,
        discount: discount,
        totalRaw: totalRaw,
        totalToDisplay: totalToDisplay
      });
      var compareAtPriceToDisplay = (0,_lib_currency__WEBPACK_IMPORTED_MODULE_5__.formatMoney)(compareAtPriceEachItem * quantity, moneyFormat);
      var productPrices = node.querySelectorAll("#ProductPrice-".concat(currentProductId));
      productPrices.forEach(function (elementPrice) {
        return elementPrice.innerHTML = totalToDisplay;
      });
      var totalPriceEl = node.querySelector("#total_price_".concat(currentProductId));
      console.log('totalPriceEl found:', totalPriceEl);
      if (totalPriceEl) {
        totalPriceEl.innerHTML = totalToDisplay;
        console.log('Total price set to:', totalToDisplay);
      } else {
        // Fallback: try to find any total_price element within the node
        var fallbackTotalPriceEl = node.querySelector('[data-total-price]') || node.querySelector('[id^="total_price_"]') || document.querySelector("[id^=\"total_price_\"]");
        console.log('fallbackTotalPriceEl found:', fallbackTotalPriceEl);
        if (fallbackTotalPriceEl) {
          fallbackTotalPriceEl.innerHTML = totalToDisplay;
          console.log('Fallback total price set to:', totalToDisplay);
        } else {
          console.warn("Total price element not found for product ID: ".concat(currentProductId));
        }
      }
      var compareAtPrices = [].concat((0,_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__["default"])(node.querySelectorAll("#ComparePrice-".concat(currentProductId))), (0,_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__["default"])(document.querySelectorAll("#ComparePrice-".concat(currentProductId)))).filter(function (el, index, self) {
        return self.indexOf(el) === index;
      }); // Remove duplicates
      var savePrice = node.querySelector("#SavePrice-".concat(currentProductId));
      var getInputAttribute = function getInputAttribute(attributeName) {
        return input && typeof input.getAttribute === 'function' ? input.getAttribute(attributeName) : null;
      };
      var pricePackWithoutCompare = getInputAttribute('data-input-compare-pack') || '';
      var percentPackWithoutCompare = parseInt(getInputAttribute('data-input-percent'), 10);
      var priceDiscountPerPack = getInputAttribute('data-input-discount-per-pack');
      var pricePerPack = node.querySelectorAll('[data-per-pack-price]');
      if (pricePerPack.length > 0) {
        pricePerPack.forEach(function (el) {
          el.innerText = priceDiscountPerPack;
          if (el.parentElement.getAttribute('ismodal') !== 'true') {
            el.innerText += '/pack';
          }
        });
      }
      if (quantity === '1') {
        pricePerPack.forEach(function (el) {
          if (el.parentElement.getAttribute('ismodal') !== 'true') {
            el.innerText = '';
          }
        });
      }
      var pouchPoints = node.querySelector('[data-pouch-points]');
      if (pouchPoints) pouchPoints.innerText = Math.floor(totalRaw);
      if (compareAtPriceEachItem !== 0) {
        compareAtPrices.forEach(function (elementCompare) {
          return elementCompare.innerHTML = compareAtPriceToDisplay;
        });
      } else {
        compareAtPrices.forEach(function (elementCompare) {
          return elementCompare.innerHTML = pricePackWithoutCompare;
        });
        if (savePrice) {
          savePrice.innerHTML = "".concat(percentPackWithoutCompare, "%");
          if (percentPackWithoutCompare) {
            savePrice.style.display = 'block';
            compareAtPrices.forEach(function (elementCompare) {
              return elementCompare.style.display = 'block';
            });
          } else {
            savePrice.style.display = 'none';
            compareAtPrices.forEach(function (elementCompare) {
              return elementCompare.style.display = 'none';
            });
          }
        }
      }
    }, 0);
  };

  // Set initial price when component loads
  setTimeout(function () {
    console.log("Initializing product form for product ".concat(currentProductId));
    var initialVariant = variants.find(function (variant) {
      return variant.available;
    }) || variants[0];
    if (initialVariant) {
      console.log("Setting initial price for product ".concat(currentProductId, ", variant ").concat(initialVariant.id));
      setPrice(initialVariant.id, 1, null);
    }
  }, 100);
  if (variants && variants.length) {
    for (var i = 0; i < variants.length; i++) {
      var variantInputs = node.querySelectorAll('input[name="quantity-variant"]');
      variantInputs.forEach(function (input) {
        input.addEventListener('click', function (event) {
          var targetInput = event.target;
          console.log("Quantity variant clicked for product ".concat(currentProductId, ", value:"), targetInput.value);
          var variantId = getVariantFromOptions().id;
          console.log("Setting quantity ".concat(targetInput.value, " for variant ").concat(variantId, " on product ").concat(currentProductId));
          setQuantity(targetInput.value);
          discountComparePrice(targetInput);
          setPrice(variantId, targetInput.value, targetInput);

          // const discountCompare = document.querySelector('[data-discount-compare-price] span');
          // const saleTag = targetInput.parentElement.closest('.grid__item').querySelector('[data-percent-pack]');
          // const activeOption = targetInput.getAttribute('data-percent');
          // if (activeOption != null && saleTag) {
          //   saleTag.innerText = activeOption;
          // }
          // if(discountCompare != undefined){
          //   discountCompare.innerHTML = activeOption;
          // }
        });
      });
    }
  }
  node.querySelectorAll(".variant__input-".concat(sectionId)).forEach(function (element) {
    element.addEventListener('change', function () {
      setTimeout(function () {
        console.log("Variant option changed for product ".concat(currentProductId));
        var variant = getVariantFromOptions();
        if (variant) {
          var _variant$featured_ima;
          var variantId = variant.id;
          var variantImage = (_variant$featured_ima = variant.featured_image) === null || _variant$featured_ima === void 0 ? void 0 : _variant$featured_ima.src;
          console.log("Selected variant ".concat(variantId, " for product ").concat(currentProductId));
          node.querySelectorAll('.selection-product').forEach(function (elementSelection) {
            if (!elementSelection.className.includes('hide')) {
              elementSelection.classList.add('hide');
            }
          });
          if (variantImage) {
            var imageSrc = variantImage.replace('.png', '_400x.png');
            setImage(imageSrc);
          }
          changeVariantQuantity(variantId);
          changeForm();
          setQuantity(1);
          setPrice(variantId, 1, element);
        }
      }, 0);
    });
  });
  // Try to find the button with multiple approaches, prioritizing node scope
  var findContinueButton = function findContinueButton() {
    return node.querySelector("#PostAddToCart_Detail_Continue_".concat(currentProductId)) || node.querySelector("[data-post-add-to-cart-continue]") || node.querySelector("[id*=\"PostAddToCart_Detail_Continue_\"]") ||
    // Only use global selectors as last resort, but be specific to current product
    document.querySelector("#PostAddToCart_Detail_Continue_".concat(currentProductId)) || document.querySelector("[data-modal-id=\"post-add-to-cart\"] [data-post-add-to-cart-continue]") || document.querySelector("[data-modal-id=\"post-add-to-cart-popup\"] [data-post-add-to-cart-continue]");
  };
  var attachButtonListener = function attachButtonListener() {
    var continueButton = findContinueButton();
    if (continueButton && !continueButton.dataset.listenerAttached) {
      console.log('Continue button found and attaching listener');
      continueButton.dataset.listenerAttached = 'true';
      continueButton.addEventListener('click', function (e) {
        var _node$closest2;
        console.log('Continue button clicked!');
        e.preventDefault();

        // Just close the modal - don't add to cart here as it's handled elsewhere
        var modal = continueButton.closest('.Modal') || node.closest('.Modal') || document.querySelector("[data-modal-id=\"post-add-to-cart-".concat(currentProductId, "\"]")) || document.querySelector('[data-modal-id="post-add-to-cart"]') || document.querySelector('[data-modal-id="post-add-to-cart-popup"]') || document.querySelector('.Modal.is-active');
        if (modal) {
          if (modal.className.includes('is-active') && modal.className.includes('is-visible')) {
            modal.classList.remove('is-visible');
            setTimeout(function () {
              modal.classList.remove('is-active');
            }, 400);
          } else if (modal.className.includes('is-active')) {
            modal.classList.remove('is-active');
          }
        }

        // Fallback: trigger close button, but be specific to current modal context
        var closeButton = (modal === null || modal === void 0 ? void 0 : modal.querySelector('[data-modal-close]')) || ((_node$closest2 = node.closest('.Modal')) === null || _node$closest2 === void 0 ? void 0 : _node$closest2.querySelector('[data-modal-close]')) || document.querySelector("[data-modal-id=\"post-add-to-cart-".concat(currentProductId, "\"] [data-modal-close]")) || document.querySelector("[data-modal-id=\"post-add-to-cart\"] [data-modal-close]");
        if (closeButton) {
          closeButton.click();
        }
      });
    } else if (!continueButton) {
      console.log('Continue button not found, will retry later');
    }
  };

  // Try to attach listener immediately
  attachButtonListener();

  // Also try again after a delay (for dynamically loaded content)
  setTimeout(attachButtonListener, 1000);

  // Try again when document is fully loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachButtonListener);
  }
}));

/***/ }),

/***/ "./scripts/components/product-item.js":
/*!********************************************!*\
  !*** ./scripts/components/product-item.js ***!
  \********************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var _app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/app */ "./scripts/app.js");


/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node) {
  function ProductModalClose() {
    var closePopup = document.querySelector('[data-close-popup]');
    closePopup && closePopup.addEventListener('click', function () {
      document.querySelector('.ModalForm').classList.add('close-animation');
      setTimeout(function () {
        document.querySelector('.ModalForm').classList.remove('close-animation');
        document.querySelector('.ModalForm').classList.remove('active');
      }, 400);
      setTimeout(function () {
        document.querySelector('.product-custom-popup').remove();
      }, 500);
    });
  }
  node.querySelector('[data-mobile-add-to-cart]') && node.querySelector('[data-mobile-add-to-cart]').addEventListener('click', function (event) {
    var addToCartButton = event.target.closest('[data-mobile-add-to-cart]');
    var productHandle = addToCartButton.getAttribute('data-handle');
    var productTemplateUrl = "".concat(window.Shopify.routes.root, "products/").concat(productHandle, "?view=ajax-product");
    fetch(productTemplateUrl).then(function (res) {
      return res.text();
    }).then(function (data) {
      document.querySelector('.ModalForm').innerHTML = data;
    }).then(function () {
      document.querySelector('.ModalForm').classList.add('active');
      ProductModalClose();
      _app__WEBPACK_IMPORTED_MODULE_1__["default"].mount();
    });
  });

  // document.addEventListener("click", (event) => {
  //   const popup = document.querySelector(
  //     ".ModalForm.active .shopify-product-form"
  //   )
  //   const btnPopups = document.querySelectorAll(".mobile-add-to-cart")
  //   isOpen = true
  //   btnPopups.forEach((btnPopup) => {
  //     if (
  //       popup != null &&
  //       !popup.contains(event.target) &&
  //       !event.target.classList.contains("mobile-add-to-cart")
  //     ) {
  //       node.parentNode.classList.remove("active")
  //       node.classList.remove("active")
  //       body.classList.remove("popupProductItem")
  //       console.log('cl')
  //       isOpen = false
  //     }
  //   })
  // })
}));

/***/ }),

/***/ "./scripts/components/product-quantity.js":
/*!************************************************!*\
  !*** ./scripts/components/product-quantity.js ***!
  \************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");

/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node) {
  var _window = window,
    theme = _window.theme,
    $ = _window.$;
  var qtySelector = new theme.QtySelector($(node), {
    namespace: '.cart'
  });
}));

/***/ }),

/***/ "./scripts/components/product-selector.js":
/*!************************************************!*\
  !*** ./scripts/components/product-selector.js ***!
  \************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");

/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node) {
  var _window = window,
    theme = _window.theme;
  var _JSON$parse = JSON.parse(node.dataset.props || {}),
    removeUrl = _JSON$parse.removeUrl,
    quantity = _JSON$parse.quantity;
  function handleSubmit(event) {
    var variantId = event.target.value;
    node.disabled = true;
    fetch(window.location.origin + theme.routes.cartAdd, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          quantity: quantity,
          id: parseInt(variantId, 10)
        }]
      })
    }).then(function () {
      window.location.href = removeUrl;
    }).catch(function (err) {
      console.error(err);
    }).finally(function () {
      node.disabled = false;
    });
  }
  node.addEventListener('change', handleSubmit);
}));

/***/ }),

/***/ "./scripts/components/product-similar.js":
/*!***********************************************!*\
  !*** ./scripts/components/product-similar.js ***!
  \***********************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/objectSpread2 */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/objectSpread2.js");
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var _lib_cart__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/lib/cart */ "./scripts/lib/cart.js");
/* harmony import */ var _lib_currency__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @/lib/currency */ "./scripts/lib/currency.js");





/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_2__.component)(function (node, ctx) {
  var _node$querySelector;
  var modalId = node.dataset.modalId;
  var form = node.querySelector("[action*='/cart/add']");
  var soldOut = form.querySelector('.product_sold_out');
  var postAddToCart = node.querySelector('[data-post-add-to-cart]');
  var submit = form.querySelector("[type='submit']");
  var select = form.querySelector("[name='id']");
  var variants = JSON.parse(node.querySelector("[id^='VariantsJson']").innerText);
  var _window$theme$strings = window.theme.strings,
    labelAddToCart = _window$theme$strings.addToCart,
    labelSoldOut = _window$theme$strings.soldOut;
  var addToCart = false;
  form.addEventListener('submit', function (event) {
    if (!addToCart) {
      event.preventDefault();
      ctx.emit("modal-".concat(modalId, ":open"));
    }
  });
  if (select !== null) {
    select.addEventListener('change', function (event) {
      var selectedId = event.target.value;
      var selectedVariant = variants.find(function (variant) {
        return variant.id === parseInt(selectedId, 10);
      });
      if (selectedVariant) {
        if (selectedVariant.available) {
          submit.disabled = false;
          submit.innerText = labelAddToCart;
        } else {
          submit.disabled = true;
          submit.innerText = labelSoldOut;
        }
      }
    });
  }
  if (postAddToCart !== null) {
    postAddToCart.addEventListener('click', function () {
      addToCart = true;
      form.submit();
    });
  }
  var overflowAnimation = node.closest('[data-aos="overflow__animation"]');
  if (overflowAnimation) {
    var transitionId;
    ctx.on("modal-".concat(modalId, ":open"), function () {
      clearTimeout(transitionId);
      overflowAnimation.style.transform = 'none';
      overflowAnimation.style.transition = 'none';
    });
    ctx.on("modal-".concat(modalId, ":closed"), function () {
      clearTimeout(transitionId);
      transitionId = setTimeout(function () {
        overflowAnimation.style.transform = '';
        overflowAnimation.style.transition = '';
      }, 200);
    });
  }
  var wrapper = node.closest('.similar-products-wrapper');
  if (wrapper) {
    ctx.on("modal-".concat(modalId, ":open"), function () {
      document.documentElement.classList.add('modal-post-add-to-cart-open');
    });
    ctx.on("modal-".concat(modalId, ":closed"), function () {
      document.documentElement.classList.remove('modal-post-add-to-cart-open');
    });
  }

  // DISCOUNT RANGES

  var variantSelector = node.querySelector('[data-variant-select]');
  var selectedVariant = node.querySelector('[data-selected-variant]');
  var selectedQuantity = node.querySelector('[data-selected-quantity]');
  var rangeDiscounts = JSON.parse(((_node$querySelector = node.querySelector("[id^='RangeDiscounts']")) === null || _node$querySelector === void 0 ? void 0 : _node$querySelector.innerText) || []);
  var currentVariant = variants[0];
  var calculateTotalPrice = function calculateTotalPrice(price, quantity, quantityDiscount) {
    var discount = quantityDiscount ? quantityDiscount[quantity] : 1;
    var total = (quantity * discount * price / 100).toFixed(2);
    return (0,_lib_currency__WEBPACK_IMPORTED_MODULE_4__.formatMoney)(total, window.theme.settings.moneyFormat);
  };
  variants.some(function (variant) {
    if (variant.available) {
      selectedVariant.value = variant.id;
      currentVariant = variant;
      return true;
    }
    return false;
  });
  var discounts = rangeDiscounts.reduce(function (obj, item) {
    var rangeAndDiscount = item.split('/');
    var range = rangeAndDiscount[0].split('-');
    var discountValue = rangeAndDiscount[1].split('%')[0];
    return (0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_1__["default"])((0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_1__["default"])({}, obj), {}, (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])({}, range[0], (100 - parseFloat(discountValue)) / 100));
  }, {});

  // INPUT CHANGE

  var totalPrice = node.querySelector('[data-total-price]');
  if (totalPrice != null) {
    totalPrice.innerHTML = calculateTotalPrice(currentVariant.price, 1, discounts);
  }

  // CONTINUE BUTTON

  var continueButton = node.querySelector('[data-post-add-to-cart-continue]');
  var handleAddItem = function handleAddItem() {
    var productQuantity = parseInt(selectedQuantity.value, 10);
    var variantId = parseInt(selectedVariant.value, 10);
    (0,_lib_cart__WEBPACK_IMPORTED_MODULE_3__.addItemById)(variantId, productQuantity).then(function () {
      var cart = document.querySelector('.cart-link__bubble');
      if (!cart.className.includes('cart-link__bubble--visible')) {
        cart.classList.add('cart-link__bubble--visible');
      }
    });
  };
  if (continueButton !== null) {
    continueButton.addEventListener('click', function () {
      ctx.emit("modal-".concat(modalId, ":close"));
    });
  }
  ctx.on("modal-".concat(modalId, ":closed"), handleAddItem);

  // VARIANT SELECTOR

  var popupQuantity = node.querySelector('[data-post-add-to-cart-quantity]');
  variantSelector.addEventListener('change', function (event) {
    var quantity = parseInt(event.target.value, 10);
    var currentVariantPrice = variants.find(function (variant) {
      return variant.id === parseInt(selectedVariant.value, 10);
    }).price;
    selectedQuantity.value = quantity;
    if (popupQuantity) {
      popupQuantity.innerHTML = quantity;
    }
    if (totalPrice) {
      totalPrice.innerHTML = calculateTotalPrice(currentVariantPrice, quantity, discounts);
    }
  });
}));

/***/ }),

/***/ "./scripts/components/product-sticky.js":
/*!**********************************************!*\
  !*** ./scripts/components/product-sticky.js ***!
  \**********************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");

/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node) {
  var triggers = node.querySelectorAll('button');
  var stickyQty = node.querySelector('input[name=sticky-qty]');
  var mainQty = document.querySelector('input[name=quantity]');
  var form = document.querySelector('.product-single__form');
  var submit = form && (form.querySelector('#pdp-buttons') || form.querySelector('[name="add"]'));
  if (mainQty && stickyQty) {
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        setTimeout(function () {
          mainQty.value = stickyQty.value;
        });
      });
    });
  }
  var submitObserver;
  if (submit) {
    submitObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          node.classList.add('is-visible');
        } else {
          node.classList.remove('is-visible');
        }
      });
    }, {
      threshold: 0
    });
    submitObserver.observe(submit);
  }
  return function () {
    if (submitObserver) {
      submitObserver.disconnect();
    }
  };
}));

/***/ }),

/***/ "./scripts/components/product-variant-quantity.js":
/*!********************************************************!*\
  !*** ./scripts/components/product-variant-quantity.js ***!
  \********************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! swiper */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/swiper.mjs");
/* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! swiper/modules */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/index.mjs");
/* harmony import */ var _lib_throttle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @/lib/throttle */ "./scripts/lib/throttle.js");




swiper__WEBPACK_IMPORTED_MODULE_1__["default"].use([swiper_modules__WEBPACK_IMPORTED_MODULE_2__.Navigation]);
/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node) {
  var slidesCount = node.querySelectorAll('.product-single__variants-wrapper-label').length;
  var minSlidesMobile = parseInt(node.dataset.minSlidesMobile, 10) || 4;
  var minSlidesDesktop = parseInt(node.dataset.minSlidesDesktop, 10) || 5;
  var swiperInstance = initializeSwiper();
  window.addEventListener('resize', (0,_lib_throttle__WEBPACK_IMPORTED_MODULE_3__["default"])(handleResize, 200));
  function initializeSwiper() {
    var isMobile = window.matchMedia('(max-width: 768px)').matches;
    var minSlides = isMobile ? minSlidesMobile : minSlidesDesktop;
    if (slidesCount > minSlides) {
      var options = {
        wrapperClass: 'product-single__variants-wrapper',
        slideClass: 'product-single__variants-wrapper-label',
        slidesPerView: 'auto',
        spaceBetween: 12,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      };
      return new swiper__WEBPACK_IMPORTED_MODULE_1__["default"](node, options);
    }
    return null;
  }
  function handleResize() {
    var isMobile = window.matchMedia('(max-width: 768px)').matches;
    var minSlides = isMobile ? minSlidesMobile : minSlidesDesktop;
    if (slidesCount > minSlides && swiperInstance === null) {
      swiperInstance = initializeSwiper();
    } else if (slidesCount <= minSlides && swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }
}));

/***/ }),

/***/ "./scripts/components/similar-products.js":
/*!************************************************!*\
  !*** ./scripts/components/similar-products.js ***!
  \************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! swiper */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/swiper.mjs");
/* harmony import */ var _lib_throttle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/lib/throttle */ "./scripts/lib/throttle.js");



/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node) {
  var slidesCount = node.querySelectorAll('.similar-product').length;
  var swiperInstance = initializeSwiper();
  window.addEventListener('resize', (0,_lib_throttle__WEBPACK_IMPORTED_MODULE_2__["default"])(handleResize, 200));
  function initializeSwiper() {
    if (slidesCount > 1) {
      var options = {
        wrapperClass: 'similar-products-wrapper',
        slideClass: 'similar-product',
        slidesPerView: 'auto',
        spaceBetween: 12
      };
      return new swiper__WEBPACK_IMPORTED_MODULE_1__["default"](node, options);
    }
    return null;
  }
  function handleResize() {
    if (slidesCount > 1 && swiperInstance === null) {
      swiperInstance = initializeSwiper();
    } else if (slidesCount <= 1 && swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }
}));

/***/ }),

/***/ "./scripts/components/sortby-drawer.js":
/*!*********************************************!*\
  !*** ./scripts/components/sortby-drawer.js ***!
  \*********************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var _facets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./facets */ "./scripts/components/facets.js");


/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node, ctx) {
  var facets = (0,_facets__WEBPACK_IMPORTED_MODULE_1__["default"])(node, ctx);
  node.addEventListener('click', function (event) {
    var target = event.target;
    if (target.hasAttribute('data-apply')) {
      target.disabled = true;
      facets.onFilterChanged();
      ctx.on('facets:update', function () {
        if (target) {
          target.disabled = false;
        }
      });
    }
    if (target.hasAttribute('data-clear')) {
      event.preventDefault();
      target.disabled = true;
      var href = target.href ? target.href : "".concat(window.location.origin).concat(window.location.pathname);
      facets.renderSection(href);
    }
  });
}));

/***/ }),

/***/ "./scripts/components/subscription-manager.js":
/*!****************************************************!*\
  !*** ./scripts/components/subscription-manager.js ***!
  \****************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js");
/* harmony import */ var _babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/objectSpread2 */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/objectSpread2.js");
/* harmony import */ var _babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/regenerator */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/regenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js");
/* harmony import */ var flatpickr_dist_flatpickr_min_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! flatpickr/dist/flatpickr.min.css */ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/flatpickr.min.css");
/* harmony import */ var flatpickr__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! flatpickr */ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/esm/index.js");
/* harmony import */ var flatpickr_dist_l10n_de__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! flatpickr/dist/l10n/de */ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/l10n/de.js");
/* harmony import */ var flatpickr_dist_l10n_fr__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! flatpickr/dist/l10n/fr */ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/l10n/fr.js");
/* harmony import */ var flatpickr_dist_l10n_it__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! flatpickr/dist/l10n/it */ "./node_modules/.pnpm/flatpickr@4.6.13/node_modules/flatpickr/dist/l10n/it.js");
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var _api_subscriptions__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @/api/subscriptions */ "./scripts/api/subscriptions.js");












var MODAL_ID = 'sm-modal';
var UPCOMING_COUNT = 5;
var MAX_LOAD_ATTEMPTS = 2;
var PRODUCT_PAGE_SIZE = 50;
var PRODUCT_SEARCH_DELAY = 400;
var DAY_MS = 24 * 60 * 60 * 1000;
var RESCHEDULE_WINDOW_DAYS = 365;
var RECALC_POLL_INTERVAL = 3000;
var RECALC_POLL_TIMEOUT = 60000;
var RECALC_NONE_GRACE = 10000;
var FOCUSABLE = 'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
var FLATPICKR_LOCALES = {
  de: flatpickr_dist_l10n_de__WEBPACK_IMPORTED_MODULE_7__.German,
  fr: flatpickr_dist_l10n_fr__WEBPACK_IMPORTED_MODULE_8__.French,
  it: flatpickr_dist_l10n_it__WEBPACK_IMPORTED_MODULE_9__.Italian
};
var STATUS_MODIFIERS = {
  ACTIVE: 'active',
  PAUSED: 'paused',
  CANCELLED: 'canceled'
};
var STATUS_ICONS = {
  active: '<svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 2.5v11M5 2.5 3 4.5M5 2.5l2 2M11 13.5v-11M11 13.5l-2-2M11 13.5l2-2"/></svg>',
  paused: '<svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"><circle cx="8" cy="8" r="6"/><path d="M4 4l8 8"/></svg>',
  canceled: '<svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"><circle cx="8" cy="8" r="6"/><path d="M6 6l4 4M10 6l-4 4"/></svg>'
};
var PENCIL_ICON = '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M11.5 2.5l2 2L6 12l-2.5.5L4 10z"/><path d="M10 4l2 2"/></svg>';
var CHEVRON_ICON = '<svg viewBox="0 0 16 16" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 6l4 4 4-4"/></svg>';
var CARD_ICON = '<svg viewBox="0 0 24 16" width="34" height="22" fill="none" stroke="currentColor" stroke-width="1.1"><rect x="0.6" y="0.6" width="22.8" height="14.8" rx="2.4"/><path d="M0.6 4.4h22.8" stroke-width="2.6"/></svg>';
var ESCAPE_MAP = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};
var escapeHtml = function escapeHtml(value) {
  return String(value !== null && value !== void 0 ? value : '').replace(/[&<>"']/g, function (char) {
    return ESCAPE_MAP[char];
  });
};
var isSafeUrl = function isSafeUrl(url) {
  return /^(https?:|mailto:|\/)/i.test(String(url !== null && url !== void 0 ? url : '').trim());
};
var formatDate = function formatDate(iso) {
  var date = new Date(iso);
  return Number.isNaN(date.getTime()) ? '' : date.toDateString();
};
var formatShortDate = function formatShortDate(iso) {
  var date = new Date(iso);
  return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString('en-US');
};
var formatMoney = function formatMoney(amount, currencyCode) {
  var value = Number(amount);
  if (Number.isNaN(value)) return '';
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currencyCode || 'USD'
    }).format(value);
  } catch (error) {
    return "".concat(value.toFixed(2)).concat(currencyCode ? " ".concat(currencyCode) : '');
  }
};
var addInterval = function addInterval(iso, type, multiplier) {
  var date = new Date(iso);
  var unit = (type || 'WEEK').toUpperCase();
  if (unit === 'DAY') date.setDate(date.getDate() + multiplier);else if (unit === 'MONTH') date.setMonth(date.getMonth() + multiplier);else if (unit === 'YEAR') date.setFullYear(date.getFullYear() + multiplier);else date.setDate(date.getDate() + multiplier * 7);
  return date;
};
var readJson = function readJson(selector) {
  var el = document.querySelector(selector);
  if (!el) return {};
  try {
    return JSON.parse(el.textContent);
  } catch (_unused) {
    return {};
  }
};
var numericId = function numericId(gid) {
  return String(gid !== null && gid !== void 0 ? gid : '').split('/').pop();
};
var normalizePayment = function normalizePayment(method) {
  if (!method) return null;
  var src = method.instrument || method;
  return {
    id: method.id,
    brand: src.brand,
    maskedNumber: src.maskedNumber,
    lastDigits: src.lastDigits,
    expiryMonth: src.expiryMonth,
    expiryYear: src.expiryYear
  };
};
/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_10__.component)(function (node, ctx) {
  var _node$dataset = node.dataset,
    loadingText = _node$dataset.loadingText,
    errorText = _node$dataset.errorText,
    retryText = _node$dataset.retryText,
    emptyText = _node$dataset.emptyText,
    badgeActiveText = _node$dataset.badgeActiveText,
    badgePausedText = _node$dataset.badgePausedText,
    badgeCanceledText = _node$dataset.badgeCanceledText,
    nextOrderText = _node$dataset.nextOrderText,
    itemsCountText = _node$dataset.itemsCountText,
    deliveryEveryText = _node$dataset.deliveryEveryText,
    viewMoreText = _node$dataset.viewMoreText,
    detailTitleText = _node$dataset.detailTitleText,
    shippingAddressText = _node$dataset.shippingAddressText,
    editAddressText = _node$dataset.editAddressText,
    shippingMethodText = _node$dataset.shippingMethodText,
    shippingMethodDefaultText = _node$dataset.shippingMethodDefaultText,
    deliveryFrequencyText = _node$dataset.deliveryFrequencyText,
    nextOrderDetailsText = _node$dataset.nextOrderDetailsText,
    productsText = _node$dataset.productsText,
    quantityActionText = _node$dataset.quantityActionText,
    orderHistoryText = _node$dataset.orderHistoryText,
    viewOrderText = _node$dataset.viewOrderText,
    upcomingText = _node$dataset.upcomingText,
    notFoundText = _node$dataset.notFoundText,
    backToListText = _node$dataset.backToListText,
    actionSkipText = _node$dataset.actionSkipText,
    actionPauseText = _node$dataset.actionPauseText,
    actionResumeText = _node$dataset.actionResumeText,
    actionCancelText = _node$dataset.actionCancelText,
    confirmSkipText = _node$dataset.confirmSkipText,
    confirmPauseText = _node$dataset.confirmPauseText,
    confirmResumeText = _node$dataset.confirmResumeText,
    confirmCancelText = _node$dataset.confirmCancelText,
    closeText = _node$dataset.closeText,
    saveText = _node$dataset.saveText,
    processingText = _node$dataset.processingText,
    priceUpdatingText = _node$dataset.priceUpdatingText,
    priceUpdateLaterText = _node$dataset.priceUpdateLaterText,
    actionErrorText = _node$dataset.actionErrorText,
    paymentTitleText = _node$dataset.paymentTitleText,
    replacePaymentTitleText = _node$dataset.replacePaymentTitleText,
    paymentMethodsLabelText = _node$dataset.paymentMethodsLabelText,
    editPaymentText = _node$dataset.editPaymentText,
    paymentNoneText = _node$dataset.paymentNoneText,
    paymentExpiresText = _node$dataset.paymentExpiresText,
    changePaymentText = _node$dataset.changePaymentText,
    updateFrequencyText = _node$dataset.updateFrequencyText,
    billingFrequencyText = _node$dataset.billingFrequencyText,
    selectFrequencyText = _node$dataset.selectFrequencyText,
    changeText = _node$dataset.changeText,
    removeProductText = _node$dataset.removeProductText,
    removeConfirmText = _node$dataset.removeConfirmText,
    removeText = _node$dataset.removeText,
    addProductText = _node$dataset.addProductText,
    searchProductText = _node$dataset.searchProductText,
    searchText = _node$dataset.searchText,
    loadMoreText = _node$dataset.loadMoreText,
    addText = _node$dataset.addText,
    noProductsText = _node$dataset.noProductsText,
    loadingProductsText = _node$dataset.loadingProductsText,
    addPartialText = _node$dataset.addPartialText,
    addNoneText = _node$dataset.addNoneText,
    errorStaleText = _node$dataset.errorStaleText,
    errorNotLiveText = _node$dataset.errorNotLiveText,
    errorRejectedText = _node$dataset.errorRejectedText,
    errorTimeoutText = _node$dataset.errorTimeoutText,
    errorInvalidDateText = _node$dataset.errorInvalidDateText,
    actionRescheduleText = _node$dataset.actionRescheduleText,
    actionRescheduleUpcomingText = _node$dataset.actionRescheduleUpcomingText,
    rescheduleDescriptionText = _node$dataset.rescheduleDescriptionText,
    rescheduleUpcomingDescriptionText = _node$dataset.rescheduleUpcomingDescriptionText,
    dateFieldLabelText = _node$dataset.dateFieldLabelText,
    actionOrderNowText = _node$dataset.actionOrderNowText,
    actionOrderNowAllText = _node$dataset.actionOrderNowAllText,
    confirmOrderNowText = _node$dataset.confirmOrderNowText,
    confirmOrderNowAllText = _node$dataset.confirmOrderNowAllText,
    orderNowUnavailableText = _node$dataset.orderNowUnavailableText,
    accountUrl = _node$dataset.accountUrl,
    customerAccountUrl = _node$dataset.customerAccountUrl,
    subscriptionPagePath = _node$dataset.subscriptionPagePath;
  var intervalUnits = readJson('[data-sm-interval-units]');
  var freeProductIds = new Set((node.dataset.freeProductIds || '').split(',').filter(Boolean));
  var freeVariantId = node.dataset.freeVariantId;
  var freeTiers = (node.dataset.freeProductTiers || '').split(',').map(Number).filter(function (tier) {
    return tier > 0;
  });
  var badgeLabels = {
    ACTIVE: badgeActiveText,
    PAUSED: badgePausedText,
    CANCELLED: badgeCanceledText
  };
  var ACTIONS = {
    skip: {
      run: _api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.skip,
      label: actionSkipText,
      confirm: confirmSkipText
    },
    pause: {
      run: _api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.pause,
      label: actionPauseText,
      confirm: confirmPauseText
    },
    resume: {
      run: _api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.activate,
      label: actionResumeText,
      confirm: confirmResumeText,
      recalc: true
    },
    orderNow: {
      run: function run(id) {
        return (0,_api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.orderNow)(id, 'next');
      },
      label: actionOrderNowText,
      confirm: confirmOrderNowText,
      recalc: true,
      refetchOnError: true
    },
    orderNowAll: {
      run: function run(id) {
        return (0,_api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.orderNow)(id, 'all');
      },
      label: actionOrderNowAllText,
      confirm: confirmOrderNowAllText,
      recalc: true,
      refetchOnError: true
    },
    cancel: {
      run: _api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.cancel,
      label: actionCancelText,
      confirm: confirmCancelText,
      destructive: true
    }
  };
  var CALENDAR_MODALS = {
    reschedule: {
      title: actionRescheduleText,
      description: rescheduleDescriptionText,
      run: _api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.reschedule
    },
    rescheduleUpcoming: {
      title: actionRescheduleUpcomingText,
      description: rescheduleUpcomingDescriptionText,
      run: _api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.rescheduleUpcoming
    }
  };
  var PRIMARY_ACTION = {
    ACTIVE: 'skip',
    PAUSED: 'resume',
    CANCELLED: null
  };
  var MENU_ACTIONS = {
    ACTIVE: ['pause', 'cancel'],
    PAUSED: ['cancel'],
    CANCELLED: []
  };
  var ORDER_NOW_MODES = {
    next: 'orderNow',
    all: 'orderNowAll'
  };
  var MENU_MODALS = {
    ACTIVE: ['reschedule', 'rescheduleUpcoming'],
    PAUSED: [],
    CANCELLED: []
  };
  var listRows = [];
  var current = null;
  var menuOpen = false;
  var modalKind = null;
  var busy = false;
  var detailMessage = null;
  var priceUpdating = false;
  var pricePollToken = 0;
  var confirming = null;
  var actionMessage = null;
  var pendingQty = {};
  var pendingPayment = null;
  var pendingFrequencyKey = null;
  var pendingDate = null;
  var datePicker = null;
  var modalLineId = null;
  var productQuery = '';
  var productRows = [];
  var productCursor = null;
  var productHasNext = false;
  var selectedRows = new Map();
  var productsLoading = false;
  var addResults = null;
  var searchTimer = null;
  var modalSession = 0;
  var returnFocusSelector = null;
  var resetModalState = function resetModalState() {
    modalSession += 1;
    clearTimeout(searchTimer);
    confirming = null;
    actionMessage = null;
    pendingQty = {};
    pendingPayment = null;
    pendingFrequencyKey = null;
    pendingDate = null;
    modalLineId = null;
    productQuery = '';
    productRows = [];
    productCursor = null;
    productHasNext = false;
    selectedRows = new Map();
    productsLoading = false;
    addResults = null;
  };
  var modalRoot = document.querySelector(".model-id-".concat(MODAL_ID));
  var modalMain = function modalMain() {
    return modalRoot === null || modalRoot === void 0 ? void 0 : modalRoot.querySelector('.Modal__Main');
  };
  if (modalRoot && modalRoot.parentElement !== document.body) {
    document.body.appendChild(modalRoot);
  }
  var canEdit = function canEdit() {
    var _current, _current2;
    return ((_current = current) === null || _current === void 0 ? void 0 : _current.contract.status) === 'ACTIVE' || ((_current2 = current) === null || _current2 === void 0 ? void 0 : _current2.contract.status) === 'PAUSED';
  };
  var ownedVariantIds = function ownedVariantIds() {
    var _current3;
    return new Set((((_current3 = current) === null || _current3 === void 0 ? void 0 : _current3.contract.products) || []).map(function (line) {
      return line.variantId;
    }));
  };
  var isFreeLine = function isFreeLine(line) {
    return freeProductIds.has(String(line.productId || '').split('/').pop());
  };
  var paidLineCount = function paidLineCount() {
    var _current4;
    return (((_current4 = current) === null || _current4 === void 0 ? void 0 : _current4.contract.products) || []).filter(function (line) {
      return !isFreeLine(line);
    }).length;
  };
  var contractCurrency = function contractCurrency() {
    var _find, _current5;
    return (_find = (((_current5 = current) === null || _current5 === void 0 ? void 0 : _current5.contract.products) || []).find(function (line) {
      var _line$currentPrice;
      return (_line$currentPrice = line.currentPrice) === null || _line$currentPrice === void 0 ? void 0 : _line$currentPrice.currencyCode;
    })) === null || _find === void 0 || (_find = _find.currentPrice) === null || _find === void 0 ? void 0 : _find.currencyCode;
  };
  var qtyFor = function qtyFor(line) {
    var _pendingQty$line$id;
    return (_pendingQty$line$id = pendingQty[line.id]) !== null && _pendingQty$line$id !== void 0 ? _pendingQty$line$id : line.quantity;
  };
  var hasQtyChanges = function hasQtyChanges() {
    var _current6;
    return (((_current6 = current) === null || _current6 === void 0 ? void 0 : _current6.contract.products) || []).some(function (line) {
      return qtyFor(line) !== line.quantity;
    });
  };
  var getBadgeInfo = function getBadgeInfo(status) {
    return {
      modifier: STATUS_MODIFIERS[status] || 'default',
      label: badgeLabels[status] || status
    };
  };
  var getNextOrderText = function getNextOrderText(contract) {
    return contract.status === 'ACTIVE' && contract.next_billing_date ? nextOrderText.replace('[date]', formatDate(contract.next_billing_date)) : null;
  };
  var intervalUnit = function intervalUnit(type, value) {
    var forms = intervalUnits[String(type !== null && type !== void 0 ? type : '').toUpperCase()];
    return (forms === null || forms === void 0 ? void 0 : forms[Number(value) === 1 ? 0 : 1]) || type || '';
  };
  var getFrequencyText = function getFrequencyText(contract) {
    var _contract$interval_va;
    return deliveryEveryText.replace('[value]', (_contract$interval_va = contract.interval_value) !== null && _contract$interval_va !== void 0 ? _contract$interval_va : '').replace('[unit]', intervalUnit(contract.interval_type, contract.interval_value));
  };
  var frequencyKey = function frequencyKey(source) {
    var _source$interval_type;
    return "".concat(source.interval_value, "-").concat(String((_source$interval_type = source.interval_type) !== null && _source$interval_type !== void 0 ? _source$interval_type : '').toUpperCase());
  };
  var currentFrequencyKey = function currentFrequencyKey() {
    return current ? frequencyKey(current.contract) : null;
  };
  var frequencyOptions = function frequencyOptions() {
    if (!current) return [];
    var _current7 = current,
      frequencies = _current7.frequencies,
      contract = _current7.contract;
    if (frequencies.some(function (option) {
      return frequencyKey(option) === currentFrequencyKey();
    })) return frequencies;
    return [{
      interval_value: contract.interval_value,
      interval_type: contract.interval_type
    }].concat((0,_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__["default"])(frequencies));
  };
  var hasUniformCadence = function hasUniformCadence() {
    return current.contract.delivery_interval_value == null || current.contract.delivery_interval_value === current.contract.interval_value;
  };
  var canEditFrequency = function canEditFrequency() {
    return canEdit() && hasUniformCadence() && frequencyOptions().some(function (option) {
      return frequencyKey(option) !== currentFrequencyKey();
    });
  };
  var getShippingMethod = function getShippingMethod(contract) {
    var _contract$more_detail, _method$shippingOptio;
    var method = (_contract$more_detail = contract.more_details) === null || _contract$more_detail === void 0 || (_contract$more_detail = _contract$more_detail.subscriptionContract) === null || _contract$more_detail === void 0 ? void 0 : _contract$more_detail.deliveryMethod;
    return (method === null || method === void 0 || (_method$shippingOptio = method.shippingOption) === null || _method$shippingOptio === void 0 ? void 0 : _method$shippingOptio.title) || shippingMethodDefaultText;
  };
  var subscriptionPageUrl = function subscriptionPageUrl(contract) {
    if (!subscriptionPagePath || !customerAccountUrl || !isSafeUrl(customerAccountUrl)) return '';
    var root = customerAccountUrl.split('?')[0].replace(/\/profile\/?$/, '');
    return "".concat(root, "/").concat(subscriptionPagePath.replace('[id]', contract.shopify_id));
  };
  var orderUrls = readJson('[data-sm-order-urls]');
  var getOrderUrl = function getOrderUrl(order) {
    var url = order.order_status_url || orderUrls[numericId(order.shopify_id || order.id)];
    if (url && isSafeUrl(url)) return url;
    return accountUrl && isSafeUrl(accountUrl) ? accountUrl : '';
  };
  var getUpcomingDates = function getUpcomingDates() {
    var cycles = current.contract.billing_cycles;
    if (Array.isArray(cycles) && cycles.length) {
      return cycles.filter(function (cycle) {
        return !cycle.skipped;
      }).map(function (cycle) {
        return cycle.billingAttemptExpectedDate;
      }).filter(Boolean).map(formatDate).filter(Boolean);
    }
    return Array.from({
      length: UPCOMING_COUNT
    }, function (_, i) {
      return addInterval(current.contract.next_billing_date, current.contract.interval_type, (current.contract.interval_value || 1) * (i + 1));
    }).filter(function (date) {
      return !Number.isNaN(date.getTime());
    }).map(function (date) {
      return date.toDateString();
    });
  };
  var getSubscriptionId = function getSubscriptionId() {
    return new URLSearchParams(window.location.search).get('subscription');
  };
  var resetTransient = function resetTransient() {
    menuOpen = false;
    modalKind = null;
    busy = false;
    resetModalState();
  };
  var paymentLabel = function paymentLabel(method) {
    var payment = normalizePayment(method);
    if (!payment) return '';
    var number = payment.maskedNumber || (payment.lastDigits ? "\u2022\u2022\u2022\u2022 ".concat(payment.lastDigits) : '');
    return "".concat(payment.brand || '', " ").concat(number).trim();
  };
  var currentPaymentMethod = function currentPaymentMethod() {
    var _contract$selected_pa;
    var _current8 = current,
      contract = _current8.contract,
      paymentMethods = _current8.paymentMethods;
    var currentId = (_contract$selected_pa = contract.selected_payment) === null || _contract$selected_pa === void 0 ? void 0 : _contract$selected_pa.id;
    return (paymentMethods || []).find(function (m) {
      return m.id === currentId;
    }) || contract.selected_payment;
  };
  var renderMessage = function renderMessage(text) {
    node.innerHTML = "<p class=\"subscription-manager__message\">".concat(escapeHtml(text), "</p>");
  };
  var renderError = function renderError() {
    node.innerHTML = "\n      <p class=\"subscription-manager__message\">".concat(escapeHtml(errorText), "</p>\n      <button type=\"button\" class=\"subscription-manager__btn subscription-manager__btn--ghost\" data-subscription-retry>").concat(escapeHtml(retryText), "</button>\n    ");
  };
  var renderNotFound = function renderNotFound() {
    node.innerHTML = "\n      <p class=\"subscription-manager__message\">".concat(escapeHtml(notFoundText), "</p>\n      <button type=\"button\" class=\"subscription-manager__btn subscription-manager__btn--ghost\" data-subscription-back>").concat(escapeHtml(backToListText), "</button>\n    ");
  };
  var renderCard = function renderCard(contract) {
    var _products$;
    var _getBadgeInfo = getBadgeInfo(contract.status),
      modifier = _getBadgeInfo.modifier,
      label = _getBadgeInfo.label;
    var nextOrder = getNextOrderText(contract);
    var products = contract.products || [];
    var title = products.length > 1 ? itemsCountText.replace('[count]', products.length) : ((_products$ = products[0]) === null || _products$ === void 0 ? void 0 : _products$.title) || '';
    var images = products.map(function (p) {
      var _p$variantImage;
      return (_p$variantImage = p.variantImage) === null || _p$variantImage === void 0 ? void 0 : _p$variantImage.url;
    }).filter(Boolean);
    var imagesMarkup = images.length ? images.map(function (url) {
      return "<img class=\"subscription-manager__card-image\" src=\"".concat(escapeHtml(url), "\" alt=\"").concat(escapeHtml(title), "\" loading=\"lazy\">");
    }).join('') : '<div class="subscription-manager__card-image subscription-manager__card-image--placeholder"></div>';
    return "\n      <div class=\"subscription-manager__card\" data-subscription-view-more data-subscription-id=\"".concat(escapeHtml(contract.shopify_id), "\" role=\"link\" tabindex=\"0\">\n        <div class=\"subscription-manager__card-header subscription-manager__card-header--").concat(modifier, "\">\n          <span class=\"subscription-manager__card-status-icon\">").concat(STATUS_ICONS[modifier] || '', "</span>\n          <div class=\"subscription-manager__card-status-text\">\n            <span class=\"subscription-manager__card-status-label\">").concat(escapeHtml(label), "</span>\n            ").concat(nextOrder ? "<span class=\"subscription-manager__card-next-order\">".concat(escapeHtml(nextOrder), "</span>") : '', "\n          </div>\n        </div>\n        <div class=\"subscription-manager__card-images\">").concat(imagesMarkup, "</div>\n        <div class=\"subscription-manager__card-meta\">\n          <p class=\"subscription-manager__card-title\">").concat(escapeHtml(title), "</p>\n          <p class=\"subscription-manager__card-frequency\">").concat(escapeHtml(getFrequencyText(contract)), "</p>\n        </div>\n      </div>\n    ");
  };
  var renderList = function renderList() {
    node.innerHTML = "<div class=\"subscription-manager__grid\">".concat(listRows.map(renderCard).join(''), "</div>");
  };
  var renderAddress = function renderAddress(address) {
    if (!address) return '';
    var firstName = address.firstName,
      lastName = address.lastName,
      address1 = address.address1,
      address2 = address.address2,
      city = address.city,
      provinceCode = address.provinceCode,
      zip = address.zip,
      country = address.country;
    var name = [firstName, lastName].filter(Boolean).join(' ');
    var cityLine = [city, provinceCode, zip].filter(Boolean).join(', ');
    return [name, address1, address2, cityLine, country].filter(Boolean).map(function (line) {
      return "<p class=\"subscription-manager__address-line\">".concat(escapeHtml(line), "</p>");
    }).join('');
  };
  var renderProductLine = function renderProductLine(line) {
    var _line$variantImage, _line$currentPrice2, _line$currentPrice3;
    var imageUrl = (_line$variantImage = line.variantImage) === null || _line$variantImage === void 0 ? void 0 : _line$variantImage.url;
    var imageMarkup = imageUrl ? "<img class=\"subscription-manager__line-image\" src=\"".concat(escapeHtml(imageUrl), "\" alt=\"").concat(escapeHtml(line.title), "\" loading=\"lazy\">") : '<div class="subscription-manager__line-image subscription-manager__line-image--placeholder"></div>';
    var variantMarkup = line.variantTitle ? "<p class=\"subscription-manager__line-variant\">".concat(escapeHtml(line.variantTitle), "</p>") : '';
    var unit = Number((_line$currentPrice2 = line.currentPrice) === null || _line$currentPrice2 === void 0 ? void 0 : _line$currentPrice2.amount);
    var currency = (_line$currentPrice3 = line.currentPrice) === null || _line$currentPrice3 === void 0 ? void 0 : _line$currentPrice3.currencyCode;
    var lineTotal = Number.isNaN(unit) ? '' : formatMoney(unit * line.quantity, currency);
    var perUnitMarkup = !Number.isNaN(unit) && line.quantity > 1 ? "<p class=\"subscription-manager__line-unit\">".concat(escapeHtml(line.quantity), " &times; ").concat(escapeHtml(formatMoney(unit, currency)), "</p>") : '';
    var canChangeQty = canEdit() && !isFreeLine(line);
    var canRemove = canEdit() && !isFreeLine(line) && paidLineCount() > 1;
    var buttons = [canChangeQty ? "<button type=\"button\" class=\"subscription-manager__link\" data-subscription-modal=\"quantity\" data-line-id=\"".concat(escapeHtml(line.id), "\">").concat(escapeHtml(quantityActionText), "</button>") : '', canRemove ? "<button type=\"button\" class=\"subscription-manager__link\" data-subscription-modal=\"removeLine\" data-line-id=\"".concat(escapeHtml(line.id), "\">").concat(escapeHtml(removeText), "</button>") : ''].filter(Boolean).join('');
    var actions = buttons ? "<div class=\"subscription-manager__line-actions\">".concat(buttons, "</div>") : '';
    return "\n      <div class=\"subscription-manager__product\">\n        <div class=\"subscription-manager__line\">\n          <div class=\"subscription-manager__line-thumb\">\n            ".concat(imageMarkup, "\n            <span class=\"subscription-manager__line-qty-badge\">").concat(escapeHtml(line.quantity), "</span>\n          </div>\n          <div class=\"subscription-manager__line-info\">\n            <p class=\"subscription-manager__line-title\">").concat(escapeHtml(line.title), "</p>\n            ").concat(variantMarkup, "\n            ").concat(perUnitMarkup, "\n          </div>\n          <p class=\"subscription-manager__line-price\">").concat(escapeHtml(lineTotal), "</p>\n        </div>\n        ").concat(actions, "\n      </div>\n    ");
  };
  var renderOrderRow = function renderOrderRow(order) {
    var label = [order.name, formatDate(order.created_at)].filter(Boolean).join(' at ');
    var url = getOrderUrl(order);
    var link = url ? "<a class=\"subscription-manager__order-link\" href=\"".concat(escapeHtml(url), "\">").concat(escapeHtml(viewOrderText), "</a>") : '';
    return "\n      <div class=\"subscription-manager__order-row\">\n        <span>".concat(escapeHtml(label), "</span>\n        ").concat(link, "\n      </div>\n    ");
  };
  var renderHeaderActions = function renderHeaderActions(contract) {
    var primary = PRIMARY_ACTION[contract.status];
    var menuKinds = MENU_MODALS[contract.status] || [];
    var menuNames = MENU_ACTIONS[contract.status] || [];
    if (!primary && !menuKinds.length && !menuNames.length) return '';
    var primaryButton = primary ? "<button type=\"button\" class=\"subscription-manager__btn subscription-manager__btn--ghost\" data-subscription-action=\"".concat(escapeHtml(primary), "\">").concat(escapeHtml(ACTIONS[primary].label), "</button>") : '';
    var menu = '';
    if (menuKinds.length || menuNames.length) {
      var modalItems = menuKinds.map(function (kind) {
        return "<button type=\"button\" class=\"subscription-manager__menu-item\" data-subscription-modal=\"".concat(escapeHtml(kind), "\">").concat(escapeHtml(CALENDAR_MODALS[kind].title), "</button>");
      }).join('');
      var items = menuNames.map(function (name) {
        var modifier = ACTIONS[name].destructive ? ' subscription-manager__menu-item--destructive' : '';
        return "<button type=\"button\" class=\"subscription-manager__menu-item".concat(modifier, "\" data-subscription-action=\"").concat(escapeHtml(name), "\">").concat(escapeHtml(ACTIONS[name].label), "</button>");
      }).join('');
      menu = "\n        <div class=\"subscription-manager__menu\">\n          <button type=\"button\" class=\"subscription-manager__btn subscription-manager__btn--ghost subscription-manager__menu-toggle\" data-subscription-menu-toggle aria-expanded=\"".concat(menuOpen, "\">\n            <span>").concat(escapeHtml(viewMoreText), "</span>").concat(CHEVRON_ICON, "\n          </button>\n          ").concat(menuOpen ? "<div class=\"subscription-manager__menu-list\">".concat(modalItems).concat(items, "</div>") : '', "\n        </div>\n      ");
    }
    return "<div class=\"subscription-manager__detail-actions\">".concat(primaryButton).concat(menu, "</div>");
  };
  var renderPriceNotice = function renderPriceNotice() {
    var text = priceUpdating ? priceUpdatingText : detailMessage;
    if (!text) return '';
    var icon = priceUpdating ? '<span class="subscription-manager__card-status-icon"><span class="subscription-manager__spinner" aria-hidden="true"></span></span>' : '';
    return "\n      <div class=\"subscription-manager__panel subscription-manager__panel--status\" role=\"status\">\n        <div class=\"subscription-manager__card-header subscription-manager__card-header--notice\">\n          ".concat(icon, "\n          <div class=\"subscription-manager__card-status-text\">\n            <span class=\"subscription-manager__card-status-label\">").concat(escapeHtml(text), "</span>\n          </div>\n        </div>\n      </div>\n    ");
  };
  var renderDetail = function renderDetail() {
    var _current9 = current,
      contract = _current9.contract,
      orders = _current9.orders;
    var _getBadgeInfo2 = getBadgeInfo(contract.status),
      modifier = _getBadgeInfo2.modifier,
      label = _getBadgeInfo2.label;
    var nextOrder = getNextOrderText(contract);
    var nextOrderDate = contract.next_billing_date ? formatShortDate(contract.next_billing_date) : '—';
    var method = currentPaymentMethod();
    var paymentSummary = method ? escapeHtml(paymentLabel(method)) : escapeHtml(paymentNoneText);
    var addressEditUrl = subscriptionPageUrl(contract);
    var lines = (contract.products || []).map(renderProductLine).join('');
    var orderRows = orders.length ? orders.map(renderOrderRow).join('') : "<p class=\"subscription-manager__message\">".concat(escapeHtml(emptyText), "</p>");
    node.innerHTML = "\n      <div class=\"subscription-manager__detail".concat(priceUpdating ? ' subscription-manager__detail--pricing' : '', "\">\n        <div class=\"subscription-manager__detail-header\">\n          <button type=\"button\" class=\"subscription-manager__back\" data-subscription-back>\n            <span aria-hidden=\"true\">&larr;</span>\n            <span>").concat(escapeHtml(detailTitleText.replace('[id]', contract.shopify_id)), "</span>\n          </button>\n          ").concat(renderHeaderActions(contract), "\n        </div>\n\n        <div class=\"subscription-manager__detail-grid\">\n          <div class=\"subscription-manager__detail-col\">\n            ").concat(renderPriceNotice(), "\n            <div class=\"subscription-manager__panel subscription-manager__panel--status\">\n              <div class=\"subscription-manager__card-header subscription-manager__card-header--").concat(modifier, "\">\n                <span class=\"subscription-manager__card-status-icon\">").concat(STATUS_ICONS[modifier] || '', "</span>\n                <div class=\"subscription-manager__card-status-text\">\n                  <span class=\"subscription-manager__card-status-label\">").concat(escapeHtml(label), "</span>\n                  ").concat(nextOrder ? "<span class=\"subscription-manager__card-next-order\">".concat(escapeHtml(nextOrder), "</span>") : '', "\n                </div>\n              </div>\n            </div>\n\n            <div class=\"subscription-manager__panel\">\n              <div class=\"subscription-manager__panel-title-row\">\n                <h3 class=\"subscription-manager__panel-title\">").concat(escapeHtml(nextOrderDetailsText), "</h3>\n                <button type=\"button\" class=\"subscription-manager__link\" data-subscription-modal=\"upcoming\">").concat(escapeHtml(upcomingText), "</button>\n              </div>\n              <p>").concat(escapeHtml(nextOrderDate), "</p>\n            </div>\n\n            <div class=\"subscription-manager__panel subscription-manager__panel--info\">\n              <div class=\"subscription-manager__info-main\">\n                <div class=\"subscription-manager__info-block\">\n                  <div class=\"subscription-manager__panel-title-row\">\n                    <h3 class=\"subscription-manager__panel-title\">").concat(escapeHtml(deliveryFrequencyText), "</h3>\n                    ").concat(canEditFrequency() ? "<button type=\"button\" class=\"subscription-manager__icon-btn\" data-subscription-modal=\"frequency\" aria-label=\"".concat(escapeHtml(updateFrequencyText), "\">").concat(PENCIL_ICON, "</button>") : '', "\n                  </div>\n                  <p>").concat(escapeHtml(getFrequencyText(contract)), "</p>\n                </div>\n                <div class=\"subscription-manager__info-block\">\n                  <div class=\"subscription-manager__panel-title-row\">\n                    <h3 class=\"subscription-manager__panel-title\">").concat(escapeHtml(shippingAddressText), "</h3>\n                    ").concat(canEdit() && addressEditUrl ? "<a class=\"subscription-manager__icon-btn\" href=\"".concat(escapeHtml(addressEditUrl), "\" aria-label=\"").concat(escapeHtml(editAddressText), "\">").concat(PENCIL_ICON, "</a>") : '', "\n                  </div>\n                  <div class=\"subscription-manager__address\">").concat(renderAddress(contract.shipping_address), "</div>\n                </div>\n                <div class=\"subscription-manager__info-block\">\n                  <h3 class=\"subscription-manager__panel-title\">").concat(escapeHtml(shippingMethodText), "</h3>\n                  <p>").concat(escapeHtml(getShippingMethod(contract)), "</p>\n                </div>\n              </div>\n              <div class=\"subscription-manager__info-side\">\n                <div class=\"subscription-manager__panel-title-row\">\n                  <h3 class=\"subscription-manager__panel-title\">").concat(escapeHtml(paymentTitleText), "</h3>\n                  ").concat(canEdit() ? "<button type=\"button\" class=\"subscription-manager__icon-btn\" data-subscription-modal=\"payment\" aria-label=\"".concat(escapeHtml(changePaymentText), "\">").concat(PENCIL_ICON, "</button>") : '', "\n                </div>\n                <div class=\"subscription-manager__payment-current\">\n                  <span class=\"subscription-manager__payment-card\">").concat(CARD_ICON, "</span>\n                  <span>").concat(paymentSummary, "</span>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"subscription-manager__panel\">\n              <h3 class=\"subscription-manager__panel-title\">").concat(escapeHtml(orderHistoryText), "</h3>\n              ").concat(orderRows, "\n            </div>\n          </div>\n\n          <div class=\"subscription-manager__detail-col\">\n            <div class=\"subscription-manager__panel\">\n              <div class=\"subscription-manager__panel-title-row\">\n                <h3 class=\"subscription-manager__panel-title\">").concat(escapeHtml(productsText), "</h3>\n                ").concat(canEdit() ? "<button type=\"button\" class=\"subscription-manager__btn subscription-manager__btn--primary subscription-manager__btn--small\" data-subscription-modal=\"addProduct\">".concat(escapeHtml(addText), "</button>") : '', "\n              </div>\n              ").concat(lines, "\n            </div>\n          </div>\n        </div>\n      </div>\n    ");
  };
  var modalStatus = function modalStatus() {
    return "".concat(busy ? "<p class=\"subscription-manager__modal-status\">".concat(escapeHtml(processingText), "</p>") : '').concat(actionMessage ? "<p class=\"subscription-manager__modal-error\">".concat(escapeHtml(actionMessage), "</p>") : '');
  };
  var modalFooter = function modalFooter(primary) {
    return "<div class=\"subscription-manager__modal-actions\">\n      <button type=\"button\" class=\"subscription-manager__btn subscription-manager__btn--link\" data-subscription-modal-close".concat(busy ? ' disabled' : '', ">").concat(escapeHtml(closeText), "</button>\n      ").concat(primary, "\n    </div>");
  };
  var patchCalendarStatus = function patchCalendarStatus() {
    var _modalRoot$querySelec, _modalRoot$querySelec2;
    var status = modalRoot === null || modalRoot === void 0 ? void 0 : modalRoot.querySelector('[data-calendar-status]');
    if (status) {
      status.textContent = busy ? processingText : actionMessage !== null && actionMessage !== void 0 ? actionMessage : '';
      status.classList.toggle('subscription-manager__modal-error', Boolean(actionMessage) && !busy);
    }
    modalRoot === null || modalRoot === void 0 || (_modalRoot$querySelec = modalRoot.querySelector('[data-calendar-save]')) === null || _modalRoot$querySelec === void 0 || _modalRoot$querySelec.toggleAttribute('disabled', !pendingDate || busy);
    modalRoot === null || modalRoot === void 0 || (_modalRoot$querySelec2 = modalRoot.querySelector('[data-subscription-modal-close]')) === null || _modalRoot$querySelec2 === void 0 || _modalRoot$querySelec2.toggleAttribute('disabled', busy);
  };
  var confirmModal = function confirmModal() {
    var action = ACTIONS[confirming];
    if (!action) return '';
    var yesModifier = action.destructive ? ' subscription-manager__btn--destructive' : '';
    var primary = "<button type=\"button\" class=\"subscription-manager__btn subscription-manager__btn--primary".concat(yesModifier, "\" data-subscription-confirm=\"").concat(escapeHtml(confirming), "\"").concat(busy ? ' disabled' : '', ">").concat(escapeHtml(action.label), "</button>");
    return "\n      <h2 class=\"subscription-manager__modal-title\">".concat(escapeHtml(action.label), "</h2>\n      <p class=\"subscription-manager__modal-message\">").concat(escapeHtml(action.confirm), "</p>\n      ").concat(modalStatus(), "\n      ").concat(modalFooter(primary), "\n    ");
  };
  var upcomingModal = function upcomingModal() {
    var dates = getUpcomingDates();
    var body = dates.length ? dates.map(function (date) {
      return "<p class=\"subscription-manager__upcoming-item\">".concat(escapeHtml(date), "</p>");
    }).join('') : "<p class=\"subscription-manager__modal-message\">".concat(escapeHtml(emptyText), "</p>");
    return "<h2 class=\"subscription-manager__modal-title\">".concat(escapeHtml(upcomingText), "</h2>").concat(body).concat(modalFooter(''));
  };
  var paymentModal = function paymentModal() {
    var _contract$selected_pa2;
    var _current0 = current,
      contract = _current0.contract,
      paymentMethods = _current0.paymentMethods;
    var currentId = (_contract$selected_pa2 = contract.selected_payment) === null || _contract$selected_pa2 === void 0 ? void 0 : _contract$selected_pa2.id;
    var options = (paymentMethods || []).map(function (method) {
      var payment = normalizePayment(method);
      var checked = (pendingPayment !== null && pendingPayment !== void 0 ? pendingPayment : currentId) === payment.id;
      var expiry = payment.expiryMonth && payment.expiryYear ? "<span class=\"subscription-manager__payment-exp\">".concat(escapeHtml(paymentExpiresText.replace('[month]', payment.expiryMonth).replace('[year]', payment.expiryYear)), "</span>") : '';
      return "\n          <label class=\"subscription-manager__payment-option".concat(checked ? ' is-selected' : '', "\">\n            <input type=\"radio\" name=\"subscription-payment\" data-payment-select=\"").concat(escapeHtml(payment.id), "\"").concat(checked ? ' checked' : '').concat(busy ? ' disabled' : '', ">\n            <span class=\"subscription-manager__payment-card\">").concat(CARD_ICON, "</span>\n            <span class=\"subscription-manager__payment-option-label\">").concat(escapeHtml(paymentLabel(method)), "</span>\n            ").concat(expiry, "\n          </label>\n        ");
    }).join('');
    var changed = pendingPayment && pendingPayment !== currentId;
    var editUrl = customerAccountUrl || accountUrl;
    var editLink = editUrl && isSafeUrl(editUrl) ? "<a class=\"subscription-manager__link\" href=\"".concat(escapeHtml(editUrl), "\">").concat(escapeHtml(editPaymentText), "</a>") : '';
    var primary = "<button type=\"button\" class=\"subscription-manager__btn subscription-manager__btn--primary\" data-payment-save".concat(!changed || busy ? ' disabled' : '', ">").concat(escapeHtml(saveText), "</button>");
    return "\n      <h2 class=\"subscription-manager__modal-title\">".concat(escapeHtml(replacePaymentTitleText), "</h2>\n      <div class=\"subscription-manager__panel-title-row\">\n        <span class=\"subscription-manager__payment-methods-label\">").concat(escapeHtml(paymentMethodsLabelText), "</span>\n        ").concat(editLink, "\n      </div>\n      ").concat(options ? "<div class=\"subscription-manager__payment-options\">".concat(options, "</div>") : "<p class=\"subscription-manager__modal-message\">".concat(escapeHtml(paymentNoneText), "</p>"), "\n      ").concat(modalStatus(), "\n      ").concat(modalFooter(primary), "\n    ");
  };
  var quantityModal = function quantityModal() {
    var rows = (current.contract.products || []).filter(function (line) {
      return !modalLineId || line.id === modalLineId;
    }).map(function (line) {
      var _line$variantImage2;
      var imageUrl = (_line$variantImage2 = line.variantImage) === null || _line$variantImage2 === void 0 ? void 0 : _line$variantImage2.url;
      var imageMarkup = imageUrl ? "<img class=\"subscription-manager__line-image\" src=\"".concat(escapeHtml(imageUrl), "\" alt=\"").concat(escapeHtml(line.title), "\" loading=\"lazy\">") : '<div class="subscription-manager__line-image subscription-manager__line-image--placeholder"></div>';
      return "\n          <div class=\"subscription-manager__line\">\n            ".concat(imageMarkup, "\n            <div class=\"subscription-manager__line-info\">\n              <p class=\"subscription-manager__line-title\">").concat(escapeHtml(line.title), "</p>\n              ").concat(line.variantTitle ? "<p class=\"subscription-manager__line-variant\">".concat(escapeHtml(line.variantTitle), "</p>") : '', "\n            </div>\n            <div class=\"subscription-manager__qty\">\n              <button type=\"button\" class=\"subscription-manager__qty-btn\" data-qty-dec=\"").concat(escapeHtml(line.id), "\" aria-label=\"Decrease quantity\"").concat(qtyFor(line) <= 1 || busy ? ' disabled' : '', ">&minus;</button>\n              <input type=\"text\" inputmode=\"numeric\" class=\"subscription-manager__qty-input\" data-qty-input=\"").concat(escapeHtml(line.id), "\" value=\"").concat(escapeHtml(qtyFor(line)), "\" aria-label=\"Quantity\"").concat(busy ? ' disabled' : '', ">\n              <button type=\"button\" class=\"subscription-manager__qty-btn\" data-qty-inc=\"").concat(escapeHtml(line.id), "\" aria-label=\"Increase quantity\"").concat(busy ? ' disabled' : '', ">+</button>\n            </div>\n          </div>\n        ");
    }).join('');
    var primary = "<button type=\"button\" class=\"subscription-manager__btn subscription-manager__btn--primary\" data-qty-save".concat(!hasQtyChanges() || busy ? ' disabled' : '', ">").concat(escapeHtml(saveText), "</button>");
    return "\n      <h2 class=\"subscription-manager__modal-title\">".concat(escapeHtml(quantityActionText), "</h2>\n      ").concat(rows, "\n      ").concat(modalStatus(), "\n      ").concat(modalFooter(primary), "\n    ");
  };
  var removeLineModal = function removeLineModal() {
    var primary = "<button type=\"button\" class=\"subscription-manager__btn subscription-manager__btn--primary\" data-remove-confirm".concat(busy ? ' disabled' : '', ">").concat(escapeHtml(removeText), "</button>");
    return "\n      <h2 class=\"subscription-manager__modal-title\">".concat(escapeHtml(removeProductText), "</h2>\n      <p class=\"subscription-manager__modal-message\">").concat(escapeHtml(removeConfirmText), "</p>\n      ").concat(modalStatus(), "\n      ").concat(modalFooter(primary), "\n    ");
  };
  var frequencyModal = function frequencyModal() {
    var _contract$interval_va2;
    var _current1 = current,
      contract = _current1.contract;
    var selected = pendingFrequencyKey !== null && pendingFrequencyKey !== void 0 ? pendingFrequencyKey : currentFrequencyKey();
    var options = frequencyOptions().map(function (option) {
      var key = frequencyKey(option);
      return "<option value=\"".concat(escapeHtml(key), "\"").concat(key === selected ? ' selected' : '', ">").concat(escapeHtml(getFrequencyText(option)), "</option>");
    }).join('');
    var changed = Boolean(selected) && selected !== currentFrequencyKey();
    var primary = "<button type=\"button\" class=\"subscription-manager__btn subscription-manager__btn--primary\" data-frequency-save".concat(!changed || busy ? ' disabled' : '', ">").concat(escapeHtml(changeText), "</button>");
    return "\n      <h2 class=\"subscription-manager__modal-title\">".concat(escapeHtml(updateFrequencyText), "</h2>\n      <div class=\"subscription-manager__field\">\n        <span class=\"subscription-manager__field-label\">").concat(escapeHtml(billingFrequencyText), "</span>\n        <input class=\"subscription-manager__field-input\" type=\"text\" value=\"").concat(escapeHtml((_contract$interval_va2 = contract.interval_value) !== null && _contract$interval_va2 !== void 0 ? _contract$interval_va2 : ''), "\" disabled>\n      </div>\n      <label class=\"subscription-manager__field\">\n        <span class=\"subscription-manager__field-label\">").concat(escapeHtml(selectFrequencyText), "</span>\n        <select class=\"subscription-manager__field-input subscription-manager__select\" data-frequency-select").concat(busy ? ' disabled' : '', ">").concat(options, "</select>\n      </label>\n      ").concat(modalStatus(), "\n      ").concat(modalFooter(primary), "\n    ");
  };
  var calendarModal = function calendarModal(kind) {
    var _CALENDAR_MODALS$kind = CALENDAR_MODALS[kind],
      title = _CALENDAR_MODALS$kind.title,
      description = _CALENDAR_MODALS$kind.description;
    var primary = "<button type=\"button\" class=\"subscription-manager__btn subscription-manager__btn--primary\" data-calendar-save disabled>".concat(escapeHtml(title), "</button>");
    return "\n      <h2 class=\"subscription-manager__modal-title\">".concat(escapeHtml(title), "</h2>\n      <p class=\"subscription-manager__modal-message\">").concat(escapeHtml(description), "</p>\n      <div class=\"subscription-manager__calendar\">\n        <input class=\"subscription-manager__calendar-input\" type=\"text\" data-calendar-input aria-label=\"").concat(escapeHtml(dateFieldLabelText), "\">\n      </div>\n      <p class=\"subscription-manager__modal-status\" data-calendar-status></p>\n      ").concat(modalFooter(primary), "\n    ");
  };
  var addProductModal = function addProductModal() {
    var currency = contractCurrency();
    var rows = productRows.map(function (row) {
      var checked = selectedRows.has(row.id);
      var image = row.image && isSafeUrl(row.image) ? "<img class=\"subscription-manager__picker-image\" src=\"".concat(escapeHtml(row.image), "\" alt=\"\" loading=\"lazy\">") : '<div class="subscription-manager__picker-image subscription-manager__picker-image--placeholder"></div>';
      var label = [row.title, row.variantTitle].filter(Boolean).join(' - ');
      var price = currency ? formatMoney(row.price, currency) : '';
      return "\n          <label class=\"subscription-manager__picker-row\">\n            <input type=\"checkbox\" data-product-select=\"".concat(escapeHtml(row.id), "\"").concat(checked ? ' checked' : '').concat(busy ? ' disabled' : '', ">\n            ").concat(image, "\n            <span class=\"subscription-manager__picker-label\">").concat(escapeHtml(label), "</span>\n            <span class=\"subscription-manager__picker-price\">").concat(escapeHtml(price), "</span>\n          </label>\n        ");
    }).join('');
    var disabled = busy || productsLoading ? ' disabled' : '';
    var loading = productsLoading ? "<p class=\"subscription-manager__modal-message\">".concat(escapeHtml(loadingProductsText), "</p>") : '';
    var emptyBody = productsLoading ? '' : "<p class=\"subscription-manager__modal-message\">".concat(escapeHtml(noProductsText), "</p>");
    var body = rows ? "<div class=\"subscription-manager__picker\" data-product-list>".concat(rows, "</div>") : emptyBody;
    var primary = "<button type=\"button\" class=\"subscription-manager__btn subscription-manager__btn--primary\" data-add-save".concat(!selectedRows.size || busy || productsLoading ? ' disabled' : '', ">").concat(escapeHtml(addText), "</button>");
    return "\n      <h2 class=\"subscription-manager__modal-title\">".concat(escapeHtml(addProductText), "</h2>\n      <div class=\"subscription-manager__picker-search\">\n        <input class=\"subscription-manager__field-input\" type=\"search\" data-product-query value=\"").concat(escapeHtml(productQuery), "\" placeholder=\"").concat(escapeHtml(searchProductText), "\"").concat(busy ? ' disabled' : '', ">\n        <button type=\"button\" class=\"subscription-manager__btn subscription-manager__btn--ghost\" data-product-search").concat(disabled, ">").concat(escapeHtml(searchText), "</button>\n      </div>\n      ").concat(body, "\n      ").concat(loading, "\n      ").concat(productHasNext && !productsLoading ? "<button type=\"button\" class=\"subscription-manager__link subscription-manager__picker-more\" data-product-more".concat(disabled, ">").concat(escapeHtml(loadMoreText), "</button>") : '', "\n      ").concat(addResults ? "<p class=\"subscription-manager__modal-status\">".concat(escapeHtml(addResults), "</p>") : '', "\n      ").concat(modalStatus(), "\n      ").concat(modalFooter(primary), "\n    ");
  };
  var MODAL_BUILDERS = {
    confirm: confirmModal,
    upcoming: upcomingModal,
    payment: paymentModal,
    quantity: quantityModal,
    removeLine: removeLineModal,
    frequency: frequencyModal,
    addProduct: addProductModal,
    reschedule: function reschedule() {
      return calendarModal('reschedule');
    },
    rescheduleUpcoming: function rescheduleUpcoming() {
      return calendarModal('rescheduleUpcoming');
    }
  };
  var renderModal = function renderModal() {
    var _datePicker, _MODAL_BUILDERS$modal;
    var main = modalMain();
    if (!main || !modalKind) return;
    (_datePicker = datePicker) === null || _datePicker === void 0 || _datePicker.destroy();
    datePicker = null;
    main.innerHTML = ((_MODAL_BUILDERS$modal = MODAL_BUILDERS[modalKind]) === null || _MODAL_BUILDERS$modal === void 0 ? void 0 : _MODAL_BUILDERS$modal.call(MODAL_BUILDERS)) || '';
  };
  var repaintModal = function repaintModal() {
    return CALENDAR_MODALS[modalKind] ? patchCalendarStatus() : renderModal();
  };
  var buildDatePicker = function buildDatePicker() {
    var input = modalRoot === null || modalRoot === void 0 ? void 0 : modalRoot.querySelector('[data-calendar-input]');
    if (!input) return;
    var minDate = new Date(Date.now() + DAY_MS).toISOString().slice(0, 10);
    var maxDate = new Date(Date.now() + RESCHEDULE_WINDOW_DAYS * DAY_MS).toISOString().slice(0, 10);
    var language = document.documentElement.lang.split('-')[0].toLowerCase();
    datePicker = (0,flatpickr__WEBPACK_IMPORTED_MODULE_6__["default"])(input, {
      inline: true,
      dateFormat: 'Y-m-d',
      minDate: minDate,
      maxDate: maxDate,
      closeOnSelect: false,
      locale: FLATPICKR_LOCALES[language] || 'default',
      onChange: function onChange(_, dateStr, picker) {
        pendingDate = dateStr;
        patchCalendarStatus();
        var calendarContainer = picker.calendarContainer;
        if (!calendarContainer.contains(document.activeElement)) {
          var _calendarContainer$qu;
          (_calendarContainer$qu = calendarContainer.querySelector('.flatpickr-day.selected')) === null || _calendarContainer$qu === void 0 || _calendarContainer$qu.focus();
        }
      }
    });
  };
  var modalFocusables = function modalFocusables() {
    return (0,_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__["default"])((modalRoot === null || modalRoot === void 0 ? void 0 : modalRoot.querySelectorAll(FOCUSABLE)) || []).filter(function (el) {
      return el.getClientRects().length;
    });
  };
  var focusSelector = function focusSelector(el) {
    var attrs = (0,_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__["default"])((el === null || el === void 0 ? void 0 : el.attributes) || []).filter(function (attr) {
      return attr.name.startsWith('data-subscription-') || attr.name === 'data-line-id';
    });
    return attrs.length ? attrs.map(function (attr) {
      return "[".concat(attr.name, "=\"").concat(CSS.escape(attr.value), "\"]");
    }).join('') : null;
  };
  var openModal = function openModal(kind) {
    var _ref, _modalMain;
    returnFocusSelector = node.contains(document.activeElement) ? focusSelector(document.activeElement) : null;
    modalKind = kind;
    menuOpen = false;
    detailMessage = null;
    renderModal();
    if (CALENDAR_MODALS[kind]) buildDatePicker();
    ctx.emit("modal-".concat(MODAL_ID, ":open"));
    (_ref = ((_modalMain = modalMain()) === null || _modalMain === void 0 ? void 0 : _modalMain.querySelector(FOCUSABLE)) || (modalRoot === null || modalRoot === void 0 ? void 0 : modalRoot.querySelector('[data-modal-close]'))) === null || _ref === void 0 || _ref.focus();
  };
  var restoreFocus = function restoreFocus() {
    var active = document.activeElement;
    if (active && active !== document.body && !(modalRoot !== null && modalRoot !== void 0 && modalRoot.contains(active))) return;
    var target = returnFocusSelector && node.querySelector(returnFocusSelector) || node.querySelector('[data-subscription-menu-toggle]');
    returnFocusSelector = null;
    target === null || target === void 0 || target.focus();
  };
  var closeModal = function closeModal() {
    if (!modalKind) return;
    ctx.emit("modal-".concat(MODAL_ID, ":close"));
  };
  ctx.on("modal-".concat(MODAL_ID, ":closed"), function () {
    var wasOpen = modalKind !== null;
    modalKind = null;
    menuOpen = false;
    resetModalState();
    if (wasOpen && current && !busy) renderDetail();
    if (wasOpen) restoreFocus();
  });
  var refreshContract = /*#__PURE__*/function () {
    var _refreshContract = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().m(function _callee() {
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return (0,_api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.getSubscription)(current.contract.shopify_id);
          case 1:
            current.contract = _context.v;
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    function refreshContract() {
      return _refreshContract.apply(this, arguments);
    }
    return refreshContract;
  }();
  var MUTATION_MESSAGES = {
    'not-found': errorStaleText,
    'not-live': errorNotLiveText,
    rejected: errorRejectedText,
    timeout: errorTimeoutText
  };
  var handleMutationError = /*#__PURE__*/function () {
    var _handleMutationError = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().m(function _callee2(error, didItLand) {
      var alwaysRecover,
        type,
        needsRecovery,
        _MUTATION_MESSAGES$ty,
        _args2 = arguments,
        _t;
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            alwaysRecover = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;
            console.error(error);
            type = error === null || error === void 0 ? void 0 : error.type;
            needsRecovery = alwaysRecover || type === 'not-found' || type === 'not-live' || type === 'timeout';
            if (!needsRecovery) {
              _context2.n = 5;
              break;
            }
            _context2.p = 1;
            _context2.n = 2;
            return refreshContract();
          case 2:
            busy = false;
            if (!(type === 'timeout' && didItLand !== null && didItLand !== void 0 && didItLand(current.contract))) {
              _context2.n = 3;
              break;
            }
            renderDetail();
            closeModal();
            return _context2.a(2);
          case 3:
            actionMessage = (_MUTATION_MESSAGES$ty = MUTATION_MESSAGES[type]) !== null && _MUTATION_MESSAGES$ty !== void 0 ? _MUTATION_MESSAGES$ty : actionErrorText;
            renderDetail();
            repaintModal();
            return _context2.a(2);
          case 4:
            _context2.p = 4;
            _t = _context2.v;
            console.error(_t);
            _context2.n = 6;
            break;
          case 5:
            if (!MUTATION_MESSAGES[type]) {
              _context2.n = 6;
              break;
            }
            actionMessage = MUTATION_MESSAGES[type];
            busy = false;
            repaintModal();
            return _context2.a(2);
          case 6:
            actionMessage = actionErrorText;
            busy = false;
            repaintModal();
          case 7:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 4]]);
    }));
    function handleMutationError(_x, _x2) {
      return _handleMutationError.apply(this, arguments);
    }
    return handleMutationError;
  }();
  var wait = function wait(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  };
  var awaitRecalc = /*#__PURE__*/function () {
    var _awaitRecalc = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().m(function _callee3(token, id, since, sawPending) {
      var started, pending, state, status, _t2;
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            started = Date.now();
            pending = sawPending;
          case 1:
            if (!(Date.now() - started < RECALC_POLL_TIMEOUT)) {
              _context3.n = 12;
              break;
            }
            _context3.n = 2;
            return wait(RECALC_POLL_INTERVAL);
          case 2:
            if (!(token !== pricePollToken)) {
              _context3.n = 3;
              break;
            }
            return _context3.a(2, null);
          case 3:
            state = null;
            _context3.p = 4;
            _context3.n = 5;
            return (0,_api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.getRecalcStatus)(id, since);
          case 5:
            status = _context3.v;
            state = status === null || status === void 0 ? void 0 : status.state;
            _context3.n = 7;
            break;
          case 6:
            _context3.p = 6;
            _t2 = _context3.v;
            console.error(_t2);
            state = 'none';
          case 7:
            if (!(token !== pricePollToken)) {
              _context3.n = 8;
              break;
            }
            return _context3.a(2, null);
          case 8:
            if (!(state === 'done')) {
              _context3.n = 9;
              break;
            }
            return _context3.a(2, 'done');
          case 9:
            if (state === 'pending') pending = true;
            if (!(state === 'none' && pending)) {
              _context3.n = 10;
              break;
            }
            return _context3.a(2, 'done');
          case 10:
            if (!(state === 'none' && Date.now() - started >= RECALC_NONE_GRACE)) {
              _context3.n = 11;
              break;
            }
            return _context3.a(2, 'none');
          case 11:
            _context3.n = 1;
            break;
          case 12:
            return _context3.a(2, 'timeout');
        }
      }, _callee3, null, [[4, 6]]);
    }));
    function awaitRecalc(_x3, _x4, _x5, _x6) {
      return _awaitRecalc.apply(this, arguments);
    }
    return awaitRecalc;
  }();
  var stopPricePoll = function stopPricePoll() {
    pricePollToken += 1;
    priceUpdating = false;
  };
  var freeCanTarget = function freeCanTarget(contract) {
    var total = (contract.products || []).filter(function (line) {
      return !isFreeLine(line);
    }).reduce(function (sum, line) {
      var _line$currentPrice4;
      return sum + (Number((_line$currentPrice4 = line.currentPrice) === null || _line$currentPrice4 === void 0 ? void 0 : _line$currentPrice4.amount) || 0) * line.quantity;
    }, 0);
    var cents = Math.round(total * 100);
    return freeTiers.filter(function (tier) {
      return cents >= Math.round(tier * 100);
    }).length;
  };
  var keptFreeCan = function keptFreeCan(contract) {
    var _contract$more_detail2;
    return (contract.products || []).some(isFreeLine) || (((_contract$more_detail2 = contract.more_details) === null || _contract$more_detail2 === void 0 || (_contract$more_detail2 = _contract$more_detail2.subscriptionContract) === null || _contract$more_detail2 === void 0 || (_contract$more_detail2 = _contract$more_detail2.originOrder) === null || _contract$more_detail2 === void 0 || (_contract$more_detail2 = _contract$more_detail2.lineItems) === null || _contract$more_detail2 === void 0 ? void 0 : _contract$more_detail2.edges) || []).some(function (edge) {
      var _edge$node;
      return freeProductIds.has(numericId((_edge$node = edge.node) === null || _edge$node === void 0 || (_edge$node = _edge$node.variant) === null || _edge$node === void 0 || (_edge$node = _edge$node.product) === null || _edge$node === void 0 ? void 0 : _edge$node.id));
    });
  };
  var syncFreeCans = /*#__PURE__*/function () {
    var _syncFreeCans = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().m(function _callee4(id) {
      var _current10, contract, target, freeLines, first, writes, i, _t3, _t4;
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            _current10 = current, contract = _current10.contract;
            if (!(!freeVariantId || !freeTiers.length || !canEdit() || !keptFreeCan(contract))) {
              _context4.n = 1;
              break;
            }
            return _context4.a(2, false);
          case 1:
            target = freeCanTarget(contract);
            freeLines = (contract.products || []).filter(isFreeLine);
            first = freeLines[0];
            writes = freeLines.slice(1).map(function (line) {
              return function () {
                return (0,_api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.removeLine)(id, line.id);
              };
            });
            if (!first && target > 0) {
              writes.push(function () {
                return (0,_api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.addLine)(id, "gid://shopify/ProductVariant/".concat(freeVariantId), target);
              });
            } else if (first && target === 0) {
              writes.push(function () {
                return (0,_api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.removeLine)(id, first.id);
              });
            } else if (first && first.quantity !== target) {
              writes.push(function () {
                return (0,_api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.updateLines)(id, [{
                  id: first.id,
                  quantity: target
                }]);
              });
            }
            if (writes.length) {
              _context4.n = 2;
              break;
            }
            return _context4.a(2, false);
          case 2:
            i = 0;
          case 3:
            if (!(i < writes.length)) {
              _context4.n = 8;
              break;
            }
            _context4.p = 4;
            _context4.n = 5;
            return writes[i]();
          case 5:
            _context4.n = 7;
            break;
          case 6:
            _context4.p = 6;
            _t3 = _context4.v;
            console.error(_t3);
          case 7:
            i += 1;
            _context4.n = 3;
            break;
          case 8:
            _context4.p = 8;
            _context4.n = 9;
            return refreshContract();
          case 9:
            _context4.n = 11;
            break;
          case 10:
            _context4.p = 10;
            _t4 = _context4.v;
            console.error(_t4);
          case 11:
            return _context4.a(2, true);
        }
      }, _callee4, null, [[8, 10], [4, 6]]);
    }));
    function syncFreeCans(_x7) {
      return _syncFreeCans.apply(this, arguments);
    }
    return syncFreeCans;
  }();
  var _pollPrice = /*#__PURE__*/function () {
    var _pollPrice2 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().m(function _callee5(id, since) {
      var _ref2,
        _ref2$sawPending,
        sawPending,
        _ref2$syncFree,
        syncFree,
        token,
        outcome,
        refreshed,
        syncSince,
        wrote,
        _args5 = arguments,
        _t5;
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            _ref2 = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {}, _ref2$sawPending = _ref2.sawPending, sawPending = _ref2$sawPending === void 0 ? false : _ref2$sawPending, _ref2$syncFree = _ref2.syncFree, syncFree = _ref2$syncFree === void 0 ? false : _ref2$syncFree;
            pricePollToken += 1;
            token = pricePollToken;
            priceUpdating = true;
            detailMessage = null;
            renderDetail();
            _context5.n = 1;
            return awaitRecalc(token, id, since, sawPending);
          case 1:
            outcome = _context5.v;
            if (!(outcome === null)) {
              _context5.n = 2;
              break;
            }
            return _context5.a(2);
          case 2:
            refreshed = outcome === 'none';
            if (!(outcome === 'done')) {
              _context5.n = 6;
              break;
            }
            _context5.p = 3;
            _context5.n = 4;
            return refreshContract();
          case 4:
            refreshed = true;
            _context5.n = 6;
            break;
          case 5:
            _context5.p = 5;
            _t5 = _context5.v;
            console.error(_t5);
            detailMessage = priceUpdateLaterText;
          case 6:
            if (!(token !== pricePollToken)) {
              _context5.n = 7;
              break;
            }
            return _context5.a(2);
          case 7:
            if (!(syncFree && refreshed)) {
              _context5.n = 10;
              break;
            }
            syncSince = new Date().toISOString();
            _context5.n = 8;
            return syncFreeCans(id);
          case 8:
            wrote = _context5.v;
            if (!(token !== pricePollToken)) {
              _context5.n = 9;
              break;
            }
            return _context5.a(2);
          case 9:
            if (!wrote) {
              _context5.n = 10;
              break;
            }
            _pollPrice(id, syncSince);
            return _context5.a(2);
          case 10:
            priceUpdating = false;
            if (outcome === 'timeout') detailMessage = priceUpdateLaterText;
            renderDetail();
          case 11:
            return _context5.a(2);
        }
      }, _callee5, null, [[3, 5]]);
    }));
    function pollPrice(_x8, _x9) {
      return _pollPrice2.apply(this, arguments);
    }
    return pollPrice;
  }();
  var ACTION_LANDED = {
    pause: function pause(contract) {
      return contract.status === 'PAUSED';
    },
    resume: function resume(contract) {
      return contract.status === 'ACTIVE';
    },
    cancel: function cancel(contract) {
      return contract.status === 'CANCELLED';
    }
  };
  var runAction = /*#__PURE__*/function () {
    var _runAction = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().m(function _callee6(name) {
      var before, didItLand, id, since, _t6;
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            if (!(busy || !current || !ACTIONS[name])) {
              _context6.n = 1;
              break;
            }
            return _context6.a(2);
          case 1:
            before = current.contract.next_billing_date;
            didItLand = ACTION_LANDED[name] || function (contract) {
              return contract.next_billing_date !== before;
            };
            busy = true;
            actionMessage = null;
            menuOpen = false;
            renderModal();
            _context6.p = 2;
            id = current.contract.shopify_id;
            since = new Date().toISOString();
            _context6.n = 3;
            return ACTIONS[name].run(id);
          case 3:
            _context6.n = 4;
            return refreshContract();
          case 4:
            busy = false;
            renderDetail();
            closeModal();
            if (ACTIONS[name].recalc) _pollPrice(id, since);
            _context6.n = 6;
            break;
          case 5:
            _context6.p = 5;
            _t6 = _context6.v;
            _context6.n = 6;
            return handleMutationError(_t6, didItLand, ACTIONS[name].refetchOnError);
          case 6:
            return _context6.a(2);
        }
      }, _callee6, null, [[2, 5]]);
    }));
    function runAction(_x0) {
      return _runAction.apply(this, arguments);
    }
    return runAction;
  }();
  var setQty = function setQty(lineId, next) {
    var _current11;
    var line = (((_current11 = current) === null || _current11 === void 0 ? void 0 : _current11.contract.products) || []).find(function (p) {
      return p.id === lineId;
    });
    if (!line || busy || !Number.isInteger(next) || next < 1) return false;
    if (next === line.quantity) delete pendingQty[lineId];else pendingQty[lineId] = next;
    return true;
  };
  var adjustQty = function adjustQty(lineId, delta) {
    var _current12;
    var line = (((_current12 = current) === null || _current12 === void 0 ? void 0 : _current12.contract.products) || []).find(function (p) {
      return p.id === lineId;
    });
    if (line && setQty(lineId, qtyFor(line) + delta)) renderModal();
  };
  var typeQty = function typeQty(input) {
    var lineId = input.dataset.qtyInput;
    if (!setQty(lineId, Number.parseInt(input.value, 10))) return;
    var caret = input.selectionStart;
    renderModal();
    var next = modalRoot === null || modalRoot === void 0 ? void 0 : modalRoot.querySelector("[data-qty-input=\"".concat(lineId, "\"]"));
    if (!next) return;
    next.focus();
    var position = Math.min(caret !== null && caret !== void 0 ? caret : next.value.length, next.value.length);
    next.setSelectionRange(position, position);
  };
  var runLineUpdate = /*#__PURE__*/function () {
    var _runLineUpdate = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().m(function _callee7() {
      var wanted, lines, id, since, _t7;
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            if (!(busy || !current || !hasQtyChanges())) {
              _context7.n = 1;
              break;
            }
            return _context7.a(2);
          case 1:
            wanted = Object.fromEntries((current.contract.products || []).map(function (line) {
              return [line.id, qtyFor(line)];
            }));
            busy = true;
            actionMessage = null;
            renderModal();
            _context7.p = 2;
            lines = (current.contract.products || []).map(function (line) {
              return (0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_1__["default"])((0,_babel_runtime_helpers_objectSpread2__WEBPACK_IMPORTED_MODULE_1__["default"])({}, line), {}, {
                quantity: qtyFor(line)
              });
            });
            id = current.contract.shopify_id;
            since = new Date().toISOString();
            _context7.n = 3;
            return (0,_api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.updateLines)(id, lines);
          case 3:
            _context7.n = 4;
            return refreshContract();
          case 4:
            pendingQty = {};
            busy = false;
            renderDetail();
            closeModal();
            _pollPrice(id, since, {
              syncFree: true
            });
            _context7.n = 6;
            break;
          case 5:
            _context7.p = 5;
            _t7 = _context7.v;
            _context7.n = 6;
            return handleMutationError(_t7, function (contract) {
              return (contract.products || []).every(function (line) {
                return line.quantity === wanted[line.id];
              });
            });
          case 6:
            return _context7.a(2);
        }
      }, _callee7, null, [[2, 5]]);
    }));
    function runLineUpdate() {
      return _runLineUpdate.apply(this, arguments);
    }
    return runLineUpdate;
  }();
  var runPaymentUpdate = /*#__PURE__*/function () {
    var _runPaymentUpdate = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().m(function _callee8() {
      var _current13;
      var currentId, wanted, _t8;
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().w(function (_context8) {
        while (1) switch (_context8.p = _context8.n) {
          case 0:
            currentId = (_current13 = current) === null || _current13 === void 0 || (_current13 = _current13.contract.selected_payment) === null || _current13 === void 0 ? void 0 : _current13.id;
            if (!(busy || !current || !pendingPayment || pendingPayment === currentId)) {
              _context8.n = 1;
              break;
            }
            return _context8.a(2);
          case 1:
            wanted = pendingPayment;
            busy = true;
            actionMessage = null;
            renderModal();
            _context8.p = 2;
            _context8.n = 3;
            return (0,_api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.updatePaymentMethod)(current.contract.shopify_id, pendingPayment);
          case 3:
            _context8.n = 4;
            return refreshContract();
          case 4:
            pendingPayment = null;
            busy = false;
            renderDetail();
            closeModal();
            _context8.n = 6;
            break;
          case 5:
            _context8.p = 5;
            _t8 = _context8.v;
            _context8.n = 6;
            return handleMutationError(_t8, function (contract) {
              var _contract$selected_pa3;
              return ((_contract$selected_pa3 = contract.selected_payment) === null || _contract$selected_pa3 === void 0 ? void 0 : _contract$selected_pa3.id) === wanted;
            });
          case 6:
            return _context8.a(2);
        }
      }, _callee8, null, [[2, 5]]);
    }));
    function runPaymentUpdate() {
      return _runPaymentUpdate.apply(this, arguments);
    }
    return runPaymentUpdate;
  }();
  var runRemoveLine = /*#__PURE__*/function () {
    var _runRemoveLine = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().m(function _callee9() {
      var lineId, id, since, _t9;
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().w(function (_context9) {
        while (1) switch (_context9.p = _context9.n) {
          case 0:
            lineId = modalLineId;
            if (!(busy || !current || !lineId)) {
              _context9.n = 1;
              break;
            }
            return _context9.a(2);
          case 1:
            busy = true;
            actionMessage = null;
            renderModal();
            _context9.p = 2;
            id = current.contract.shopify_id;
            since = new Date().toISOString();
            _context9.n = 3;
            return (0,_api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.removeLine)(id, lineId);
          case 3:
            _context9.n = 4;
            return refreshContract();
          case 4:
            busy = false;
            renderDetail();
            closeModal();
            _pollPrice(id, since, {
              syncFree: true
            });
            _context9.n = 6;
            break;
          case 5:
            _context9.p = 5;
            _t9 = _context9.v;
            _context9.n = 6;
            return handleMutationError(_t9, function (contract) {
              return !(contract.products || []).some(function (line) {
                return line.id === lineId;
              });
            });
          case 6:
            return _context9.a(2);
        }
      }, _callee9, null, [[2, 5]]);
    }));
    function runRemoveLine() {
      return _runRemoveLine.apply(this, arguments);
    }
    return runRemoveLine;
  }();
  var runFrequencyUpdate = /*#__PURE__*/function () {
    var _runFrequencyUpdate = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().m(function _callee0() {
      var option, wanted, _t0;
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().w(function (_context0) {
        while (1) switch (_context0.p = _context0.n) {
          case 0:
            option = frequencyOptions().find(function (candidate) {
              return frequencyKey(candidate) === pendingFrequencyKey;
            });
            if (!(busy || !current || !option || frequencyKey(option) === currentFrequencyKey())) {
              _context0.n = 1;
              break;
            }
            return _context0.a(2);
          case 1:
            wanted = frequencyKey(option);
            busy = true;
            actionMessage = null;
            renderModal();
            _context0.p = 2;
            _context0.n = 3;
            return (0,_api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.updateFrequency)(current.contract.shopify_id, option.interval_value, option.interval_type);
          case 3:
            _context0.n = 4;
            return refreshContract();
          case 4:
            pendingFrequencyKey = null;
            busy = false;
            renderDetail();
            closeModal();
            _context0.n = 6;
            break;
          case 5:
            _context0.p = 5;
            _t0 = _context0.v;
            _context0.n = 6;
            return handleMutationError(_t0, function (contract) {
              return frequencyKey(contract) === wanted;
            });
          case 6:
            return _context0.a(2);
        }
      }, _callee0, null, [[2, 5]]);
    }));
    function runFrequencyUpdate() {
      return _runFrequencyUpdate.apply(this, arguments);
    }
    return runFrequencyUpdate;
  }();
  var runReschedule = /*#__PURE__*/function () {
    var _runReschedule = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().m(function _callee1(kind) {
      var config, date, before, didItLand, id, since, _t1;
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().w(function (_context1) {
        while (1) switch (_context1.p = _context1.n) {
          case 0:
            config = CALENDAR_MODALS[kind];
            if (!(busy || !current || !config || !pendingDate)) {
              _context1.n = 1;
              break;
            }
            return _context1.a(2);
          case 1:
            date = pendingDate;
            before = current.contract.next_billing_date;
            didItLand = function didItLand(contract) {
              return contract.next_billing_date !== before;
            };
            busy = true;
            actionMessage = null;
            patchCalendarStatus();
            _context1.p = 2;
            id = current.contract.shopify_id;
            since = new Date().toISOString();
            _context1.n = 3;
            return config.run(id, date);
          case 3:
            _context1.n = 4;
            return refreshContract();
          case 4:
            busy = false;
            renderDetail();
            closeModal();
            _pollPrice(id, since);
            _context1.n = 7;
            break;
          case 5:
            _context1.p = 5;
            _t1 = _context1.v;
            if (!((_t1 === null || _t1 === void 0 ? void 0 : _t1.status) === 400)) {
              _context1.n = 6;
              break;
            }
            console.error(_t1);
            actionMessage = errorInvalidDateText;
            busy = false;
            patchCalendarStatus();
            return _context1.a(2);
          case 6:
            _context1.n = 7;
            return handleMutationError(_t1, didItLand);
          case 7:
            return _context1.a(2);
        }
      }, _callee1, null, [[2, 5]]);
    }));
    function runReschedule(_x1) {
      return _runReschedule.apply(this, arguments);
    }
    return runReschedule;
  }();
  var syncProductQuery = function syncProductQuery() {
    var input = modalRoot === null || modalRoot === void 0 ? void 0 : modalRoot.querySelector('[data-product-query]');
    if (input) productQuery = input.value;
  };
  var flattenProducts = function flattenProducts(edges) {
    var owned = ownedVariantIds();
    return edges.map(function (edge) {
      return edge.node;
    }).filter(function (product) {
      return product && !freeProductIds.has(numericId(product.id));
    }).flatMap(function (product) {
      var _product$variants;
      return (((_product$variants = product.variants) === null || _product$variants === void 0 ? void 0 : _product$variants.edges) || []).map(function (edge) {
        return edge.node;
      }).filter(function (variant) {
        return variant && !owned.has(variant.id);
      }).map(function (variant) {
        var _variant$image, _product$featuredMedi;
        return {
          id: variant.id,
          title: product.title,
          variantTitle: variant.title,
          price: variant.price,
          image: (typeof variant.image === 'string' ? variant.image : (_variant$image = variant.image) === null || _variant$image === void 0 ? void 0 : _variant$image.url) || ((_product$featuredMedi = product.featuredMedia) === null || _product$featuredMedi === void 0 || (_product$featuredMedi = _product$featuredMedi.preview) === null || _product$featuredMedi === void 0 || (_product$featuredMedi = _product$featuredMedi.image) === null || _product$featuredMedi === void 0 ? void 0 : _product$featuredMedi.url) || ''
        };
      });
    });
  };
  var renderModalKeepingCaret = function renderModalKeepingCaret() {
    var _modalRoot$querySelec3;
    var keepScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var input = modalRoot === null || modalRoot === void 0 ? void 0 : modalRoot.querySelector('[data-product-query]');
    var caret = input && document.activeElement === input ? input.selectionStart : null;
    var scroll = (modalRoot === null || modalRoot === void 0 || (_modalRoot$querySelec3 = modalRoot.querySelector('[data-product-list]')) === null || _modalRoot$querySelec3 === void 0 ? void 0 : _modalRoot$querySelec3.scrollTop) || 0;
    renderModal();
    var list = modalRoot === null || modalRoot === void 0 ? void 0 : modalRoot.querySelector('[data-product-list]');
    if (list && keepScroll) list.scrollTop = scroll;
    if (caret === null) return;
    var next = modalRoot === null || modalRoot === void 0 ? void 0 : modalRoot.querySelector('[data-product-query]');
    if (!next) return;
    next.focus();
    next.setSelectionRange(caret, caret);
  };
  var loadProducts = /*#__PURE__*/function () {
    var _loadProducts = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().m(function _callee10() {
      var append,
        session,
        _yield$listProducts,
        _yield$listProducts$e,
        edges,
        _yield$listProducts$p,
        pageInfo,
        rows,
        _args10 = arguments,
        _t10;
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().w(function (_context10) {
        while (1) switch (_context10.p = _context10.n) {
          case 0:
            append = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : false;
            if (!(productsLoading || append && !productCursor)) {
              _context10.n = 1;
              break;
            }
            return _context10.a(2);
          case 1:
            session = modalSession;
            productsLoading = true;
            actionMessage = null;
            addResults = null;
            renderModalKeepingCaret(true);
            _context10.p = 2;
            _context10.n = 3;
            return (0,_api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.listProducts)({
              limit: PRODUCT_PAGE_SIZE,
              query: productQuery,
              cursor: append ? productCursor : ''
            });
          case 3:
            _yield$listProducts = _context10.v;
            _yield$listProducts$e = _yield$listProducts.edges;
            edges = _yield$listProducts$e === void 0 ? [] : _yield$listProducts$e;
            _yield$listProducts$p = _yield$listProducts.pageInfo;
            pageInfo = _yield$listProducts$p === void 0 ? {} : _yield$listProducts$p;
            if (!(session !== modalSession)) {
              _context10.n = 4;
              break;
            }
            return _context10.a(2);
          case 4:
            rows = flattenProducts(edges);
            productRows = append ? productRows.concat(rows) : rows;
            productCursor = pageInfo.endCursor || null;
            productHasNext = Boolean(pageInfo.hasNextPage);
            _context10.n = 7;
            break;
          case 5:
            _context10.p = 5;
            _t10 = _context10.v;
            console.error(_t10);
            if (!(session !== modalSession)) {
              _context10.n = 6;
              break;
            }
            return _context10.a(2);
          case 6:
            actionMessage = actionErrorText;
          case 7:
            productsLoading = false;
            renderModalKeepingCaret(append);
          case 8:
            return _context10.a(2);
        }
      }, _callee10, null, [[2, 5]]);
    }));
    function loadProducts() {
      return _loadProducts.apply(this, arguments);
    }
    return loadProducts;
  }();
  var _scheduleProductSearch = function scheduleProductSearch(delay) {
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () {
      if (productsLoading) {
        _scheduleProductSearch(PRODUCT_SEARCH_DELAY);
        return;
      }
      syncProductQuery();
      productCursor = null;
      loadProducts();
    }, delay);
  };
  var releaseOrphan = function releaseOrphan(attempted) {
    productRows = productRows.filter(function (row) {
      return !attempted.has(row.id);
    });
    selectedRows = new Map((0,_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__["default"])(selectedRows).filter(function (_ref3) {
      var _ref4 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_ref3, 1),
        id = _ref4[0];
      return !attempted.has(id);
    }));
    busy = false;
    renderDetail();
    repaintModal();
  };
  var runAddProducts = /*#__PURE__*/function () {
    var _runAddProducts = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().m(function _callee11() {
      var _MUTATION_MESSAGES$te;
      var targets, session, attempted, since, failed, timedOut, terminal, i, _MUTATION_MESSAGES$er, owned, added, outstanding, unconfirmed, stillFailed, _t11, _t12;
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().w(function (_context11) {
        while (1) switch (_context11.p = _context11.n) {
          case 0:
            targets = (0,_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__["default"])(selectedRows.values());
            if (!(busy || productsLoading || !current || !targets.length)) {
              _context11.n = 1;
              break;
            }
            return _context11.a(2);
          case 1:
            session = modalSession;
            attempted = new Set(targets.map(function (row) {
              return row.id;
            }));
            busy = true;
            actionMessage = null;
            addResults = null;
            renderModal();
            since = new Date().toISOString();
            failed = [];
            timedOut = new Set();
            terminal = null;
            i = 0;
          case 2:
            if (!(i < targets.length)) {
              _context11.n = 7;
              break;
            }
            _context11.p = 3;
            _context11.n = 4;
            return (0,_api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.addLine)(current.contract.shopify_id, targets[i].id);
          case 4:
            _context11.n = 6;
            break;
          case 5:
            _context11.p = 5;
            _t11 = _context11.v;
            console.error(_t11);
            failed.push(targets[i]);
            if ((_t11 === null || _t11 === void 0 ? void 0 : _t11.type) === 'timeout') timedOut.add(targets[i].id);
            if (!((_t11 === null || _t11 === void 0 ? void 0 : _t11.type) === 'auth' || (_t11 === null || _t11 === void 0 ? void 0 : _t11.type) === 'not-live' || (_t11 === null || _t11 === void 0 ? void 0 : _t11.type) === 'not-found' || (_t11 === null || _t11 === void 0 ? void 0 : _t11.type) === 'retry')) {
              _context11.n = 6;
              break;
            }
            terminal = _t11;
            failed.push.apply(failed, (0,_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__["default"])(targets.slice(i + 1)));
            return _context11.a(3, 7);
          case 6:
            i += 1;
            _context11.n = 2;
            break;
          case 7:
            _context11.p = 7;
            _context11.n = 8;
            return refreshContract();
          case 8:
            _context11.n = 11;
            break;
          case 9:
            _context11.p = 9;
            _t12 = _context11.v;
            console.error(_t12);
            if (!(session !== modalSession)) {
              _context11.n = 10;
              break;
            }
            releaseOrphan(attempted);
            return _context11.a(2);
          case 10:
            productRows = productRows.filter(function (row) {
              return !attempted.has(row.id);
            });
            selectedRows = new Map();
            actionMessage = (_MUTATION_MESSAGES$er = MUTATION_MESSAGES[_t12 === null || _t12 === void 0 ? void 0 : _t12.type]) !== null && _MUTATION_MESSAGES$er !== void 0 ? _MUTATION_MESSAGES$er : errorTimeoutText;
            busy = false;
            renderModal();
            return _context11.a(2);
          case 11:
            if (!(session !== modalSession)) {
              _context11.n = 12;
              break;
            }
            releaseOrphan(attempted);
            return _context11.a(2);
          case 12:
            owned = ownedVariantIds();
            added = targets.filter(function (row) {
              return owned.has(row.id);
            }).length;
            outstanding = failed.filter(function (row) {
              return !owned.has(row.id);
            });
            unconfirmed = outstanding.filter(function (row) {
              return timedOut.has(row.id);
            });
            stillFailed = outstanding.filter(function (row) {
              return !timedOut.has(row.id);
            });
            selectedRows = new Map(stillFailed.map(function (row) {
              return [row.id, row];
            }));
            productRows = productRows.filter(function (row) {
              return !owned.has(row.id) && !timedOut.has(row.id);
            });
            busy = false;
            if (added) _pollPrice(current.contract.shopify_id, since, {
              syncFree: true
            });
            if (outstanding.length) {
              _context11.n = 13;
              break;
            }
            renderDetail();
            closeModal();
            return _context11.a(2);
          case 13:
            if (unconfirmed.length) actionMessage = errorTimeoutText;else if (terminal && !added) actionMessage = (_MUTATION_MESSAGES$te = MUTATION_MESSAGES[terminal.type]) !== null && _MUTATION_MESSAGES$te !== void 0 ? _MUTATION_MESSAGES$te : actionErrorText;
            if (unconfirmed.length && !added) addResults = null;else {
              addResults = added ? addPartialText.replace('[added]', added).replace('[failed]', outstanding.length).replace('[names]', outstanding.map(function (row) {
                return row.title;
              }).join(', ')) : addNoneText;
            }
            renderDetail();
            renderModal();
          case 14:
            return _context11.a(2);
        }
      }, _callee11, null, [[7, 9], [3, 5]]);
    }));
    function runAddProducts() {
      return _runAddProducts.apply(this, arguments);
    }
    return runAddProducts;
  }();
  var checkPendingPrice = /*#__PURE__*/function () {
    var _checkPendingPrice = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().m(function _callee12(subscriptionId) {
      var since, _current14, status, same, _t13;
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().w(function (_context12) {
        while (1) switch (_context12.p = _context12.n) {
          case 0:
            since = new Date().toISOString();
            _context12.p = 1;
            _context12.n = 2;
            return (0,_api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.getRecalcStatus)(subscriptionId, since);
          case 2:
            status = _context12.v;
            same = String((_current14 = current) === null || _current14 === void 0 ? void 0 : _current14.contract.shopify_id) === String(subscriptionId);
            if ((status === null || status === void 0 ? void 0 : status.state) === 'pending' && same && !priceUpdating) _pollPrice(subscriptionId, since, {
              sawPending: true,
              syncFree: true
            });
            _context12.n = 4;
            break;
          case 3:
            _context12.p = 3;
            _t13 = _context12.v;
            console.error(_t13);
          case 4:
            return _context12.a(2);
        }
      }, _callee12, null, [[1, 3]]);
    }));
    function checkPendingPrice(_x10) {
      return _checkPendingPrice.apply(this, arguments);
    }
    return checkPendingPrice;
  }();
  var takeOrderNowLink = function takeOrderNowLink() {
    var url = new URL(window.location.href);
    var name = ORDER_NOW_MODES[url.searchParams.get('order_now')] || null;
    if (url.searchParams.has('order_now')) {
      url.searchParams.delete('order_now');
      window.history.replaceState(window.history.state, '', url.toString());
    }
    return name;
  };
  var orderNowLink = takeOrderNowLink();
  var openOrderNowLink = function openOrderNowLink() {
    var name = orderNowLink;
    orderNowLink = null;
    if (!name) return;
    if (current.contract.status !== 'ACTIVE' || name === 'orderNowAll' && !hasUniformCadence()) {
      detailMessage = current.contract.status === 'ACTIVE' ? errorRejectedText : orderNowUnavailableText;
      renderDetail();
      return;
    }
    resetModalState();
    confirming = name;
    openModal('confirm');
  };
  var _loadDetail = /*#__PURE__*/function () {
    var _loadDetail2 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().m(function _callee13(subscriptionId) {
      var attempt,
        contract,
        _yield$Promise$all,
        _yield$Promise$all2,
        orders,
        payments,
        frequencies,
        _args13 = arguments,
        _t14;
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().w(function (_context13) {
        while (1) switch (_context13.p = _context13.n) {
          case 0:
            attempt = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : 0;
            stopPricePoll();
            renderMessage(loadingText);
            _context13.p = 1;
            _context13.n = 2;
            return (0,_api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.getSubscription)(subscriptionId);
          case 2:
            contract = _context13.v;
            _context13.n = 3;
            return Promise.all([(0,_api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.getOrders)(subscriptionId).catch(function () {
              return {
                rows: []
              };
            }), (0,_api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.getPaymentMethods)().catch(function () {
              return {
                paymentMethods: []
              };
            }), (0,_api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.listFrequencies)(subscriptionId).catch(function () {
              return [];
            })]);
          case 3:
            _yield$Promise$all = _context13.v;
            _yield$Promise$all2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__["default"])(_yield$Promise$all, 3);
            orders = _yield$Promise$all2[0];
            payments = _yield$Promise$all2[1];
            frequencies = _yield$Promise$all2[2];
            current = {
              contract: contract,
              orders: orders.rows || [],
              paymentMethods: payments.paymentMethods || [],
              frequencies: Array.isArray(frequencies) ? frequencies : []
            };
            resetTransient();
            renderDetail();
            openOrderNowLink();
            checkPendingPrice(subscriptionId);
            _context13.n = 7;
            break;
          case 4:
            _context13.p = 4;
            _t14 = _context13.v;
            console.error(_t14);
            if (!(_t14.type === 'not-found')) {
              _context13.n = 5;
              break;
            }
            renderNotFound();
            return _context13.a(2);
          case 5:
            if (!(attempt < MAX_LOAD_ATTEMPTS - 1)) {
              _context13.n = 6;
              break;
            }
            setTimeout(function () {
              return _loadDetail(subscriptionId, attempt + 1);
            }, 600 * (attempt + 1));
            return _context13.a(2);
          case 6:
            renderError();
          case 7:
            return _context13.a(2);
        }
      }, _callee13, null, [[1, 4]]);
    }));
    function loadDetail(_x11) {
      return _loadDetail2.apply(this, arguments);
    }
    return loadDetail;
  }();
  var _loadList = /*#__PURE__*/function () {
    var _loadList2 = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().m(function _callee14() {
      var attempt,
        _yield$listSubscripti,
        _yield$listSubscripti2,
        rows,
        _args14 = arguments,
        _t15;
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().w(function (_context14) {
        while (1) switch (_context14.p = _context14.n) {
          case 0:
            attempt = _args14.length > 0 && _args14[0] !== undefined ? _args14[0] : 0;
            stopPricePoll();
            renderMessage(loadingText);
            _context14.p = 1;
            _context14.n = 2;
            return (0,_api_subscriptions__WEBPACK_IMPORTED_MODULE_11__.listSubscriptions)();
          case 2:
            _yield$listSubscripti = _context14.v;
            _yield$listSubscripti2 = _yield$listSubscripti.rows;
            rows = _yield$listSubscripti2 === void 0 ? [] : _yield$listSubscripti2;
            listRows = rows;
            if (!listRows.length) renderMessage(emptyText);else renderList();
            _context14.n = 5;
            break;
          case 3:
            _context14.p = 3;
            _t15 = _context14.v;
            console.error(_t15);
            if (!(attempt < MAX_LOAD_ATTEMPTS - 1)) {
              _context14.n = 4;
              break;
            }
            setTimeout(function () {
              return _loadList(attempt + 1);
            }, 600 * (attempt + 1));
            return _context14.a(2);
          case 4:
            renderError();
          case 5:
            return _context14.a(2);
        }
      }, _callee14, null, [[1, 3]]);
    }));
    function loadList() {
      return _loadList2.apply(this, arguments);
    }
    return loadList;
  }();
  var load = /*#__PURE__*/function () {
    var _load = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().m(function _callee15() {
      var subscriptionId;
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().w(function (_context15) {
        while (1) switch (_context15.n) {
          case 0:
            subscriptionId = getSubscriptionId();
            if (!subscriptionId) {
              _context15.n = 2;
              break;
            }
            _context15.n = 1;
            return _loadDetail(subscriptionId);
          case 1:
            _context15.n = 3;
            break;
          case 2:
            _context15.n = 3;
            return _loadList();
          case 3:
            return _context15.a(2);
        }
      }, _callee15);
    }));
    function load() {
      return _load.apply(this, arguments);
    }
    return load;
  }();
  var goToList = function goToList() {
    var url = new URL(window.location.href);
    url.searchParams.delete('subscription');
    window.location.href = url.toString();
  };
  var goToDetail = function goToDetail(id) {
    var url = new URL(window.location.href);
    url.searchParams.set('subscription', id);
    window.location.href = url.toString();
  };
  node.addEventListener('click', function (event) {
    if (event.target.closest('[data-subscription-retry]')) {
      load();
      return;
    }
    if (event.target.closest('[data-subscription-back]')) {
      goToList();
      return;
    }
    if (event.target.closest('[data-subscription-menu-toggle]')) {
      menuOpen = !menuOpen;
      renderDetail();
      return;
    }
    var actionButton = event.target.closest('[data-subscription-action]');
    if (actionButton) {
      resetModalState();
      confirming = actionButton.dataset.subscriptionAction;
      openModal('confirm');
      return;
    }
    var modalButton = event.target.closest('[data-subscription-modal]');
    if (modalButton) {
      var kind = modalButton.dataset.subscriptionModal;
      resetModalState();
      modalLineId = modalButton.dataset.lineId || null;
      openModal(kind);
      if (kind === 'addProduct') loadProducts();
      return;
    }
    var cardButton = event.target.closest('[data-subscription-view-more]');
    if (cardButton) {
      goToDetail(cardButton.dataset.subscriptionId);
    }
  });
  node.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var card = event.target.closest('[data-subscription-view-more]');
    if (card) {
      event.preventDefault();
      goToDetail(card.dataset.subscriptionId);
    }
  });
  modalRoot === null || modalRoot === void 0 || modalRoot.addEventListener('click', function (event) {
    if (event.target.closest('[data-subscription-modal-close]')) {
      closeModal();
      return;
    }
    var confirmButton = event.target.closest('[data-subscription-confirm]');
    if (confirmButton) {
      runAction(confirmButton.dataset.subscriptionConfirm);
      return;
    }
    var qtyDec = event.target.closest('[data-qty-dec]');
    if (qtyDec) {
      adjustQty(qtyDec.dataset.qtyDec, -1);
      return;
    }
    var qtyInc = event.target.closest('[data-qty-inc]');
    if (qtyInc) {
      adjustQty(qtyInc.dataset.qtyInc, 1);
      return;
    }
    if (event.target.closest('[data-qty-save]')) {
      runLineUpdate();
      return;
    }
    var paymentRadio = event.target.closest('[data-payment-select]');
    if (paymentRadio) {
      pendingPayment = paymentRadio.dataset.paymentSelect;
      renderModal();
      return;
    }
    if (event.target.closest('[data-payment-save]')) {
      runPaymentUpdate();
      return;
    }
    if (event.target.closest('[data-remove-confirm]')) {
      runRemoveLine();
      return;
    }
    if (event.target.closest('[data-frequency-save]')) {
      runFrequencyUpdate();
      return;
    }
    if (event.target.closest('[data-calendar-save]')) {
      runReschedule(modalKind);
      return;
    }
    var productCheckbox = event.target.closest('[data-product-select]');
    if (productCheckbox) {
      var _modalRoot$querySelec4;
      var productSelect = productCheckbox.dataset.productSelect;
      if (selectedRows.has(productSelect)) selectedRows.delete(productSelect);else {
        var row = productRows.find(function (candidate) {
          return candidate.id === productSelect;
        });
        if (row) selectedRows.set(productSelect, row);
      }
      (_modalRoot$querySelec4 = modalRoot.querySelector('[data-add-save]')) === null || _modalRoot$querySelec4 === void 0 || _modalRoot$querySelec4.toggleAttribute('disabled', !selectedRows.size || busy || productsLoading);
      return;
    }
    if (event.target.closest('[data-product-search]')) {
      _scheduleProductSearch(0);
      return;
    }
    if (event.target.closest('[data-product-more]')) {
      syncProductQuery();
      loadProducts(true);
      return;
    }
    if (event.target.closest('[data-add-save]')) {
      runAddProducts();
    }
  });
  modalRoot === null || modalRoot === void 0 || modalRoot.addEventListener('change', function (event) {
    var _modalRoot$querySelec5;
    var select = event.target.closest('[data-frequency-select]');
    if (!select) return;
    pendingFrequencyKey = select.value;
    (_modalRoot$querySelec5 = modalRoot.querySelector('[data-frequency-save]')) === null || _modalRoot$querySelec5 === void 0 || _modalRoot$querySelec5.toggleAttribute('disabled', !pendingFrequencyKey || pendingFrequencyKey === currentFrequencyKey());
  });
  modalRoot === null || modalRoot === void 0 || modalRoot.addEventListener('input', function (event) {
    var qtyInput = event.target.closest('[data-qty-input]');
    if (qtyInput) {
      typeQty(qtyInput);
      return;
    }
    if (!event.target.closest('[data-product-query]')) return;
    syncProductQuery();
    _scheduleProductSearch(PRODUCT_SEARCH_DELAY);
  });
  modalRoot === null || modalRoot === void 0 || modalRoot.addEventListener('change', function (event) {
    if (event.target.closest('[data-qty-input]')) renderModal();
  });
  modalRoot === null || modalRoot === void 0 || modalRoot.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || !event.target.closest('[data-product-query]')) return;
    event.preventDefault();
    _scheduleProductSearch(0);
  });
  document.addEventListener('keydown', function (event) {
    var _event$target$closest, _event$target;
    if (!modalKind) return;
    var onClose = ((_event$target$closest = (_event$target = event.target).closest) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.call(_event$target, '[data-modal-close]')) && (modalRoot === null || modalRoot === void 0 ? void 0 : modalRoot.contains(event.target));
    if (event.key === 'Escape' || onClose && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      if (!busy) closeModal();
      return;
    }
    if (event.key !== 'Tab') return;
    var items = modalFocusables();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;
    if (!modalRoot.contains(active) || event.shiftKey && active === first) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  });
  document.addEventListener('click', function (event) {
    if (!menuOpen || event.target.closest('.subscription-manager__menu')) return;
    menuOpen = false;
    if (current) renderDetail();
  });
  load();
}));

/***/ }),

/***/ "./scripts/components/swiper-slider.js":
/*!*********************************************!*\
  !*** ./scripts/components/swiper-slider.js ***!
  \*********************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! swiper/css */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/swiper.css");
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! swiper */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/swiper.mjs");
/* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! swiper/modules */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/index.mjs");




swiper__WEBPACK_IMPORTED_MODULE_2__["default"].use([swiper_modules__WEBPACK_IMPORTED_MODULE_3__.FreeMode, swiper_modules__WEBPACK_IMPORTED_MODULE_3__.Mousewheel, swiper_modules__WEBPACK_IMPORTED_MODULE_3__.Navigation]);
/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_1__.component)(function (node) {
  // Check if this is a product recommendations slider
  var isProductRecommendations = node.classList.contains('product-recommendations');
  var sliderCount = node.getAttribute('data-slider-count');
  var slidesPerView = node.getAttribute('data-slider-per-view') || 2;
  var spaceBetween = node.getAttribute('data-space-between') || 8;
  var options = {
    slidesPerView: slidesPerView,
    spaceBetween: spaceBetween,
    freeMode: true,
    mousewheel: {
      forceToAxis: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      1200: {
        slidesPerView: sliderCount,
        spaceBetween: 28
      },
      1000: {
        slidesPerView: sliderCount - 1,
        spaceBetween: 28
      },
      768: {
        slidesPerView: sliderCount,
        spaceBetween: 28
      },
      700: {
        slidesPerView: slidesPerView,
        // Keep mobile slidesPerView
        spaceBetween: 28
      }
    }
  };

  // Special configuration for product recommendations
  if (isProductRecommendations) {
    options = {
      slidesPerView: '2.1',
      // Mobile: Use CSS width calculations
      spaceBetween: 6,
      freeMode: {
        enabled: true,
        sticky: false,
        momentumBounce: false
      },
      allowTouchMove: true,
      watchSlidesProgress: true,
      mousewheel: {
        forceToAxis: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        768: {
          slidesPerView: '5',
          // Desktop: Use CSS width calculations instead of JS calculations
          spaceBetween: 28,
          freeMode: {
            enabled: true,
            sticky: false,
            // No snapping to slides
            momentumBounce: false
          },
          grabCursor: true,
          allowTouchMove: true,
          resistanceRatio: 0,
          watchOverflow: false,
          preventClicks: false,
          preventClicksPropagation: false,
          centeredSlides: false,
          // Prevent centering behavior
          watchSlidesProgress: true,
          mousewheel: {
            forceToAxis: true
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
        },
        700: {
          slidesPerView: 'auto',
          // Mobile: Use CSS width calculations
          spaceBetween: 16,
          freeMode: {
            enabled: true,
            sticky: false,
            momentumBounce: false
          },
          allowTouchMove: true,
          mousewheel: {
            forceToAxis: true
          }
        }
      }
    };
  }
  var SwiperInstance = function SwiperInstance() {
    return new swiper__WEBPACK_IMPORTED_MODULE_2__["default"](node, options);
  };
  var popupModals = node.querySelectorAll('.Modal');
  popupModals.forEach(function (modal) {
    node.appendChild(modal);
  });

  // Always initialize Swiper
  var swiperInstance = SwiperInstance();
  node.style.opacity = '1';
}));

/***/ }),

/***/ "./scripts/components/wishlist-button.js":
/*!***********************************************!*\
  !*** ./scripts/components/wishlist-button.js ***!
  \***********************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");

/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node, ctx) {
  var productData = JSON.parse(node.dataset.props || {});
  var _window$theme$strings = window.theme.strings,
    addToWishlist = _window$theme$strings.addToWishlist,
    removeFromWishlist = _window$theme$strings.removeFromWishlist;
  var classes = {
    added: 'added'
  };
  var isAdded = false;
  node.addEventListener('click', function () {
    node.classList.add('heart-pulse');
    setTimeout(function () {
      node.classList.remove('heart-pulse');
    }, 500);
    if (isAdded) {
      ctx.emit('wishlist:remove', null, productData);
    } else {
      ctx.emit('wishlist:add', null, productData);
    }
  });
  ctx.on('wishlist:products:fetched', function (_ref) {
    var products = _ref.wishlist.products;
    var productId = productData.empi;
    var isInWishlist = products.find(function (item) {
      return item.empi === productId;
    });
    if (isInWishlist) {
      node.classList.add(classes.added);
      node.setAttribute('aria-label', removeFromWishlist);
      isAdded = true;
    } else {
      node.classList.remove(classes.added);
      // node.setAttribute("aria-label", addToWishlist)

      isAdded = false;
    }
  });
}));

/***/ }),

/***/ "./scripts/components/wishlist-item.js":
/*!*********************************************!*\
  !*** ./scripts/components/wishlist-item.js ***!
  \*********************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");

/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node, ctx) {
  var addToCart = node.querySelector('[data-add-to-cart]');
  var rangeSelector = node.querySelector('[data-range-select]');
  if (!rangeSelector || !addToCart) {
    return;
  }
  rangeSelector.addEventListener('change', function (event) {
    addToCart.setAttribute('data-product-quantity', event.target.value);
  });
}));

/***/ }),

/***/ "./scripts/components/wishlist.js":
/*!****************************************!*\
  !*** ./scripts/components/wishlist.js ***!
  \****************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var _app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/app */ "./scripts/app.js");


/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node, ctx) {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  var countElements = document.querySelectorAll('[data-wishlist-count]');
  var handleUpdateCount = function handleUpdateCount() {
    countElements.forEach(function (element) {
      window._swat.renderWishlistCount(element, function (count) {
        if (count === 0) {
          element.classList.remove('wishlist__bubble--visible');
        } else {
          element.classList.add('wishlist__bubble--visible');
        }
      });
    });
  };
  var swymCallbackFn = function swymCallbackFn() {
    window._swat.fetchWrtEventTypeET(function (products) {
      ctx.emit('wishlist:products:fetched', {
        wishlist: {
          products: products
        }
      });
      handleUpdateCount();
    }, window._swat.EventTypes.addToWishList);
  };
  var handleAddToWishlist = function handleAddToWishlist(_, data) {
    window._swat.addToWishList(data, swymCallbackFn);
  };
  var handleRemoveFromWishlist = function handleRemoveFromWishlist(_, data) {
    window._swat.removeFromWishList(data, swymCallbackFn);
  };
  ctx.on('wishlist:add', handleAddToWishlist);
  ctx.on('wishlist:remove', handleRemoveFromWishlist);
  window.SwymCallbacks.push(swymCallbackFn);
  document.addEventListener('wishlist:products:render', function () {
    _app__WEBPACK_IMPORTED_MODULE_1__["default"].mount();
  });
}));

/***/ }),

/***/ "./scripts/lib/cart.js":
/*!*****************************!*\
  !*** ./scripts/lib/cart.js ***!
  \*****************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   addItemById: function() { return /* binding */ addItemById; },
/* harmony export */   addVariant: function() { return /* binding */ addVariant; },
/* harmony export */   fetchCart: function() { return /* binding */ fetchCart; },
/* harmony export */   removeAddon: function() { return /* binding */ removeAddon; },
/* harmony export */   updateAddon: function() { return /* binding */ updateAddon; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/regenerator */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/regenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var _app__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @/app */ "./scripts/app.js");



function fetchCart() {
  return _fetchCart.apply(this, arguments);
}

/**
 * Warning: this does not check available products first
 */
function _fetchCart() {
  _fetchCart = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_0__["default"])().m(function _callee() {
    var response, cart, _t;
    return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_0__["default"])().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return fetch(window.theme.routes.cart, {
            headers: {
              Accept: 'application/json'
            }
          });
        case 1:
          response = _context.v;
          if (response.ok) {
            _context.n = 2;
            break;
          }
          throw new Error('Failed to retrieve cart data');
        case 2:
          _context.n = 3;
          return response.json();
        case 3:
          cart = _context.v;
          _app__WEBPACK_IMPORTED_MODULE_2__["default"].hydrate({
            cart: cart
          });
          _context.n = 5;
          break;
        case 4:
          _context.p = 4;
          _t = _context.v;
          console.error(_t);
        case 5:
          return _context.a(2);
      }
    }, _callee, null, [[0, 4]]);
  }));
  return _fetchCart.apply(this, arguments);
}
function addItemById(id, quantity, disableCartToggle) {
  _app__WEBPACK_IMPORTED_MODULE_2__["default"].emit('cart:updating');
  return fetch('/cart/add.js', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: id,
      quantity: quantity
    })
  }).then(function (r) {
    return r.json();
  }).then(function (item) {
    return fetchCart().then(function (cart) {
      _app__WEBPACK_IMPORTED_MODULE_2__["default"].hydrate({
        cart: cart
      });
      _app__WEBPACK_IMPORTED_MODULE_2__["default"].emit('cart:updated');
      !disableCartToggle && _app__WEBPACK_IMPORTED_MODULE_2__["default"].emit('cart:toggle', function (state) {
        return {
          cartOpen: !state.cartOpen
        };
      });
      // app.emit('updated', { item, cart })
      return {
        item: item,
        cart: cart
      };
    });
  });
}
function changeAddon(line, quantity) {
  _app__WEBPACK_IMPORTED_MODULE_2__["default"].emit('cart:updating');
  return fetch('/cart/change.js', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      line: line,
      quantity: quantity
    })
  }).then(function (res) {
    return res.json();
  }).then(function (cart) {
    _app__WEBPACK_IMPORTED_MODULE_2__["default"].hydrate({
      cart: cart
    });
    _app__WEBPACK_IMPORTED_MODULE_2__["default"].emit('cart:updated', {
      cart: cart
    });
    return cart;
  });
}
function addVariant(variant, quantity, disableCartToggle) {
  var numAvailable = variant.inventory_policy === 'deny' && variant.inventory_management === 'shopify' ? variant.inventory_quantity : null; // null means they can add as many as they want

  return fetchCart().then(function (_ref) {
    var items = _ref.items;
    var existing = items.filter(function (item) {
      return item.id === variant.id;
    })[0] || {};
    var numRequested = (existing.quantity || 0) + quantity;
    if (numAvailable !== null && numRequested > numAvailable) {
      var err = "There are only ".concat(numAvailable, " of that product available, requested ").concat(numRequested, ".");
      _app__WEBPACK_IMPORTED_MODULE_2__["default"].emit('error', err);
      throw new Error(err);
    } else {
      return addItemById(variant.id, quantity, disableCartToggle);
    }
  });
}
function updateAddon(id, quantity) {
  return fetchCart().then(function (_ref2) {
    var items = _ref2.items;
    for (var i = 0; i < items.length; i++) {
      if (items[i].variant_id === parseInt(id, 10)) {
        return changeAddon(i + 1, quantity); // shopify cart is a 1-based index
      }
    }
    return null;
  });
}
function removeAddon(id) {
  return updateAddon(id, 0);
}

/***/ }),

/***/ "./scripts/lib/currency.js":
/*!*********************************!*\
  !*** ./scripts/lib/currency.js ***!
  \*********************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   formatMoney: function() { return /* binding */ formatMoney; }
/* harmony export */ });
/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */

/* eslint-disable */

function formatMoney(cents) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '${{amount}}';
  var withoutZero = arguments.length > 2 ? arguments[2] : undefined;
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision !== null && precision !== void 0 ? precision : 2;
    thousands = thousands || ',';
    decimal = decimal || '.';
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsAmount = parts[1] ? decimal + parts[1] : '';
    if (withoutZero) {
      centsAmount = centsAmount.replace(/[\.,]0{2}/, '');
    }
    return dollarsAmount + centsAmount;
  }
  switch (format.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', ',');
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, ',', '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
  }
  return format.replace(placeholderRegex, value);
}

/***/ }),

/***/ "./scripts/lib/throttle.js":
/*!*********************************!*\
  !*** ./scripts/lib/throttle.js ***!
  \*********************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ throttle; }
/* harmony export */ });
function throttle(func, delay) {
  var timer = null;
  return function () {
    if (timer === null) {
      func.apply(void 0, arguments);
      timer = setTimeout(function () {
        timer = null;
      }, delay);
    }
  };
}

/***/ }),

/***/ "./scripts/pages/cart.js":
/*!*******************************!*\
  !*** ./scripts/pages/cart.js ***!
  \*******************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_regeneratorValues__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/regeneratorValues */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/regeneratorValues.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/regenerator */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/regenerator.js");
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/.pnpm/@babel+runtime@8.0.0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var _api_sections__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @/api/sections */ "./scripts/api/sections.js");
/* harmony import */ var _lib_cart__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @/lib/cart */ "./scripts/lib/cart.js");







/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_4__.component)(function (node, ctx) {
  var cartStickyCheckout = node.querySelector('.js-sticky-checkout');
  var checkoutBtnObserver;
  if (cartStickyCheckout && 'IntersectionObserver' in window) {
    checkoutBtnObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        cartStickyCheckout.classList.toggle('is-visible', !entry.isIntersecting);
      });
    });
  }
  function observeCheckoutBtn() {
    if (!checkoutBtnObserver) return;
    checkoutBtnObserver.disconnect();
    var checkoutBtn = node.querySelector('#cart-total-submit [name="checkout"]');
    if (checkoutBtn) {
      checkoutBtnObserver.observe(checkoutBtn);
    }
  }
  observeCheckoutBtn();
  var pendingAutoship = new Set();
  var loadingKeys = new Set();
  var inFlight = false;
  var busy = false;
  function setBusy(state) {
    busy = state;
    node.classList.toggle('is-busy', state);
    node.querySelectorAll('[name="checkout"]').forEach(function (btn) {
      btn.classList.toggle('btn--loading', inFlight || busy);
    });
    if (!state) {
      node.querySelectorAll('.is-updating').forEach(function (el) {
        return el.classList.remove('is-updating');
      });
    }
  }
  function getWidget() {
    return node.querySelector('[data-cart-subscription]');
  }
  function getCartPlan() {
    var widget = getWidget();
    if (!widget) return null;
    var checked = widget.querySelector('[data-subscription-plan][checked]');
    return checked ? checked.value : null;
  }
  function isSubscriptionActive() {
    var _getWidget;
    return ((_getWidget = getWidget()) === null || _getWidget === void 0 ? void 0 : _getWidget.dataset.hasSubscribed) === 'true';
  }
  function getLineToggles() {
    return Array.from(node.querySelectorAll('[data-line-key]'));
  }
  function getSubscribableKeys() {
    return new Set(getLineToggles().map(function (el) {
      return el.dataset.lineKey;
    }));
  }
  var queuedUpdate = null;
  var inTransition = false;
  function swapDom(update) {
    if (inTransition || typeof document.startViewTransition !== 'function') {
      update();
      return;
    }
    if (queuedUpdate) {
      queuedUpdate = update;
      return;
    }
    queuedUpdate = update;
    var run = function run() {
      var latest = queuedUpdate;
      queuedUpdate = null;
      inTransition = true;
      try {
        latest();
      } finally {
        inTransition = false;
      }
    };
    try {
      var transition = document.startViewTransition(run);
      transition.ready.catch(function () {});
      transition.finished.catch(function () {});
    } catch (_unused) {
      queuedUpdate = null;
      update();
    }
  }
  function canCountText(paid, free) {
    var strings = window.theme.strings;
    var countText = function countText(entry, count) {
      return (count === 1 ? entry.one : entry.other).replace('[count]', count);
    };
    if (free === 0) return countText(strings.canCount, paid);
    var freeText = countText(strings.freeCanCount, free);
    return paid > 0 ? "".concat(countText(strings.paidCanCount, paid), " + ").concat(freeText) : freeText;
  }
  function updateZoneCounts() {
    node.querySelectorAll('[data-zone]').forEach(function (zone) {
      var body = zone.querySelector('[data-zone-body]');
      if (!body) return;
      var lines = Array.from(body.querySelectorAll('[data-cart-line]'));
      var count = zone.querySelector('[data-zone-count]');
      if (count) {
        var paid = 0;
        var free = 0;
        lines.forEach(function (line) {
          var quantity = Number(line.dataset.lineQuantity) || 0;
          if (line.hasAttribute('data-line-free')) free += quantity;else paid += quantity;
        });
        count.textContent = canCountText(paid, free);
      }
      zone.hidden = lines.length === 0;
    });
  }
  function movePendingLines() {
    var subBody = node.querySelector('[data-zone-body="sub"]');
    var onceBody = node.querySelector('[data-zone-body="once"]');
    if (!subBody || !onceBody) return;
    var moves = [];
    getLineToggles().forEach(function (el) {
      var line = el.closest('[data-cart-line]');
      if (!line) return;
      var isPending = pendingAutoship.has(el.dataset.lineKey);
      if (isPending && !subBody.contains(line)) {
        moves.push(function () {
          line.dataset.pendingMoved = 'true';
          subBody.append(line);
        });
      } else if (!isPending && line.dataset.pendingMoved === 'true') {
        moves.push(function () {
          delete line.dataset.pendingMoved;
          onceBody.append(line);
        });
      }
    });
    if (moves.length === 0) return;
    swapDom(function () {
      moves.forEach(function (move) {
        return move();
      });
      updateZoneCounts();
    });
  }
  function applyPendingUI() {
    var liveKeys = getSubscribableKeys();
    Array.from(pendingAutoship).forEach(function (key) {
      if (!liveKeys.has(key)) {
        pendingAutoship.delete(key);
      }
    });
    getLineToggles().forEach(function (el) {
      var isPending = pendingAutoship.has(el.dataset.lineKey);
      el.classList.toggle('is-pending', isPending);
      el.classList.toggle('is-loading', loadingKeys.has(el.dataset.lineKey) && !isPending);
    });
    movePendingLines();
    var widget = getWidget();
    widget === null || widget === void 0 || widget.classList.toggle('is-loading', inFlight);
    node.querySelectorAll('[data-subscription-input]').forEach(function (input) {
      var line = input.closest('[data-line-key]');
      input.disabled = inFlight || (line === null || line === void 0 ? void 0 : line.dataset.requiresPlan) === 'true';
    });
    var zoneActive = isSubscriptionActive() || pendingAutoship.size > 0;
    node.querySelectorAll('[data-subscription-plan]').forEach(function (radio) {
      radio.disabled = inFlight || !zoneActive;
    });
    var mixed = (widget === null || widget === void 0 ? void 0 : widget.dataset.mixed) === 'true';
    var disabled = mixed || pendingAutoship.size > 0 || inFlight;
    node.querySelectorAll('[name="checkout"]').forEach(function (btn) {
      btn.disabled = disabled;
      btn.classList.toggle('btn--loading', inFlight || busy);
    });
  }
  var debounceTimer;
  function handleChangeCart(event) {
    var target = event.target,
      type = event.type;
    if (type === 'change' && target.classList.contains('js-qty__num')) {
      event.preventDefault();
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        changeItemQuantity(target.dataset.id, target.value);
      }, 500);
    }
    var removeButton = target.closest('.js-cart-item-remove');
    if (type === 'click' && removeButton) {
      event.preventDefault();
      clearTimeout(debounceTimer);
      var itemId = removeButton.dataset.id;
      changeItemQuantity(itemId, 0);
      ctx.hydrate({
        removedItems: [itemId]
      });
    }
  }
  function changeItemQuantity(_x, _x2) {
    return _changeItemQuantity.apply(this, arguments);
  }
  function _changeItemQuantity() {
    _changeItemQuantity = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().m(function _callee(id, quantity) {
      var _node$querySelector;
      var response, data, html, _t;
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            setBusy(true);
            (_node$querySelector = node.querySelector(".js-qty__num[data-id=\"".concat(id, "\"]"))) === null || _node$querySelector === void 0 || (_node$querySelector = _node$querySelector.closest('[data-cart-line]')) === null || _node$querySelector === void 0 || _node$querySelector.classList.add('is-updating');
            _context.p = 1;
            _context.n = 2;
            return fetch(window.theme.routes.cartChange, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                id: id,
                quantity: quantity,
                sections: node.id
              })
            });
          case 2:
            response = _context.v;
            if (response.ok) {
              _context.n = 3;
              break;
            }
            throw new Error('Failed to update cart item');
          case 3:
            _context.n = 4;
            return response.json();
          case 4:
            data = _context.v;
            html = data.sections[node.id];
            renderCart(html, data);
            _context.n = 6;
            break;
          case 5:
            _context.p = 5;
            _t = _context.v;
            console.error(_t);
            setBusy(false);
          case 6:
            return _context.a(2);
        }
      }, _callee, null, [[1, 5]]);
    }));
    return _changeItemQuantity.apply(this, arguments);
  }
  function updateCart() {
    return _updateCart.apply(this, arguments);
  }
  function _updateCart() {
    _updateCart = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().m(function _callee2() {
      var _ctx$getState, cart, sections, html, _t2;
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            setBusy(true);
            _context2.p = 1;
            _context2.n = 2;
            return (0,_lib_cart__WEBPACK_IMPORTED_MODULE_6__.fetchCart)();
          case 2:
            _ctx$getState = ctx.getState(), cart = _ctx$getState.cart;
            _context2.n = 3;
            return (0,_api_sections__WEBPACK_IMPORTED_MODULE_5__["default"])(window.location.href, node.id);
          case 3:
            sections = _context2.v;
            html = sections[node.id];
            renderCart(html, cart);
            _context2.n = 5;
            break;
          case 4:
            _context2.p = 4;
            _t2 = _context2.v;
            console.error(_t2);
            setBusy(false);
          case 5:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 4]]);
    }));
    return _updateCart.apply(this, arguments);
  }
  function changeSellingPlan(_x3, _x4) {
    return _changeSellingPlan.apply(this, arguments);
  }
  function _changeSellingPlan() {
    _changeSellingPlan = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().m(function _callee3(id, sellingPlan) {
      var qtyInput, quantity, body, response, data, html, _t3;
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            if (!inFlight) {
              _context3.n = 1;
              break;
            }
            ctx.emit('cart:set-selling-plan-error', {
              id: id
            });
            return _context3.a(2);
          case 1:
            inFlight = true;
            loadingKeys.add(id);
            applyPendingUI();
            _context3.p = 2;
            qtyInput = Array.from(node.querySelectorAll('.js-qty__num')).find(function (el) {
              return el.dataset.id === id;
            });
            quantity = qtyInput ? parseInt(qtyInput.value, 10) : NaN;
            body = {
              id: id,
              selling_plan: sellingPlan,
              sections: node.id
            };
            if (!Number.isNaN(quantity) && quantity > 0) {
              body.quantity = quantity;
            }
            _context3.n = 3;
            return fetch(window.theme.routes.cartChange, {
              method: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(body)
            });
          case 3:
            response = _context3.v;
            if (response.ok) {
              _context3.n = 4;
              break;
            }
            throw new Error('Failed to update selling plan');
          case 4:
            _context3.n = 5;
            return response.json();
          case 5:
            data = _context3.v;
            html = data.sections[node.id];
            inFlight = false;
            loadingKeys.clear();
            renderCart(html, data);
            _context3.n = 7;
            break;
          case 6:
            _context3.p = 6;
            _t3 = _context3.v;
            console.error(_t3);
            inFlight = false;
            loadingKeys.clear();
            ctx.emit('cart:set-selling-plan-error', {
              id: id
            });
            updateCart();
          case 7:
            _context3.p = 7;
            inFlight = false;
            loadingKeys.clear();
            return _context3.f(7);
          case 8:
            return _context3.a(2);
        }
      }, _callee3, null, [[2, 6, 7, 8]]);
    }));
    return _changeSellingPlan.apply(this, arguments);
  }
  function renderCart(htmlString, cart) {
    var domElement = new DOMParser().parseFromString(htmlString, 'text/html');
    if (cart.item_count === 0) {
      swapDom(function () {
        node.innerHTML = domElement.getElementById(node.id).innerHTML;
        observeCheckoutBtn();
        applyPendingUI();
        setBusy(false);
      });
      return;
    }
    var regions = ['#cart-items', '#cart-total-saves', '#cart-total-price', '#cart-total-submit', '#cart-sticky-checkout'];
    swapDom(function () {
      regions.forEach(function (selector) {
        var target = node.querySelector(selector);
        if (target) {
          var _domElement$querySele;
          target.innerHTML = ((_domElement$querySele = domElement.querySelector(selector)) === null || _domElement$querySele === void 0 ? void 0 : _domElement$querySele.innerHTML) || '';
        }
      });
      observeCheckoutBtn();
      ctx.emit('app:mount');
      ctx.emit('cart:updated', {
        cart: cart
      });
      applyPendingUI();
      setBusy(false);
    });
  }
  function previewCartSubscription(_ref) {
    var id = _ref.id,
      autoship = _ref.autoship;
    var widget = getWidget();
    if (!widget) return;
    widget.dataset.hasSubscribed = getLineToggles().some(function (el) {
      var _el$querySelector;
      if (el.dataset.lineKey === id) return autoship;
      return !!((_el$querySelector = el.querySelector('[data-subscription-input]')) !== null && _el$querySelector !== void 0 && _el$querySelector.checked);
    });
  }
  function resolveSellingPlan(_ref2) {
    var id = _ref2.id,
      autoship = _ref2.autoship;
    if (inFlight) {
      ctx.emit('cart:set-selling-plan-error', {
        id: id
      });
      return;
    }
    previewCartSubscription({
      id: id,
      autoship: autoship
    });
    if (autoship) {
      var plan = getCartPlan();
      if (plan != null) {
        changeSellingPlan(id, plan);
      } else {
        pendingAutoship.add(id);
        applyPendingUI();
      }
      return;
    }
    if (pendingAutoship.has(id)) {
      pendingAutoship.delete(id);
      node.querySelectorAll('[data-line-key]').forEach(function (el) {
        if (el.dataset.lineKey === id) {
          el.classList.remove('is-loading');
        }
      });
      applyPendingUI();
    } else {
      changeSellingPlan(id, null);
    }
  }
  function setCartSellingPlan(_x5) {
    return _setCartSellingPlan.apply(this, arguments);
  }
  function _setCartSellingPlan() {
    _setCartSellingPlan = (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__["default"])(/*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().m(function _callee4(_ref3) {
      var sellingPlan, failedKey, response, cart, chosen, cartKeys, pendingTargets, normalizeTargets, targets, _loop, i, _t4;
      return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            sellingPlan = _ref3.sellingPlan;
            if (!inFlight) {
              _context5.n = 1;
              break;
            }
            return _context5.a(2);
          case 1:
            if (!(sellingPlan == null)) {
              _context5.n = 2;
              break;
            }
            return _context5.a(2);
          case 2:
            inFlight = true;
            applyPendingUI();
            _context5.p = 3;
            _context5.n = 4;
            return fetch(window.theme.routes.cart, {
              headers: {
                Accept: 'application/json'
              }
            });
          case 4:
            response = _context5.v;
            if (response.ok) {
              _context5.n = 5;
              break;
            }
            throw new Error('Failed to retrieve cart data');
          case 5:
            _context5.n = 6;
            return response.json();
          case 6:
            cart = _context5.v;
            chosen = String(sellingPlan);
            cartKeys = new Set(cart.items.map(function (item) {
              return item.key;
            }));
            pendingTargets = Array.from(pendingAutoship).filter(function (key) {
              return cartKeys.has(key);
            });
            normalizeTargets = cart.items.filter(function (item) {
              var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
              return !!plan && String(plan.id) !== chosen;
            }).map(function (item) {
              return item.key;
            });
            targets = Array.from(new Set([].concat((0,_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__["default"])(pendingTargets), (0,_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__["default"])(normalizeTargets))));
            targets.forEach(function (key) {
              return loadingKeys.add(key);
            });
            applyPendingUI();
            if (!(targets.length === 0)) {
              _context5.n = 8;
              break;
            }
            pendingAutoship.clear();
            inFlight = false;
            _context5.n = 7;
            return updateCart();
          case 7:
            return _context5.a(2);
          case 8:
            _loop = /*#__PURE__*/(0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().m(function _loop() {
              var key, isFinal, qtyInput, quantity, stateItem, body, res, data, html;
              return (0,_babel_runtime_helpers_regenerator__WEBPACK_IMPORTED_MODULE_2__["default"])().w(function (_context4) {
                while (1) switch (_context4.n) {
                  case 0:
                    key = targets[i];
                    failedKey = key;
                    isFinal = i === targets.length - 1;
                    qtyInput = Array.from(node.querySelectorAll('.js-qty__num')).find(function (el) {
                      return el.dataset.id === key;
                    });
                    quantity = qtyInput ? parseInt(qtyInput.value, 10) : NaN;
                    if (Number.isNaN(quantity) || quantity <= 0) {
                      stateItem = cart.items.find(function (item) {
                        return item.key === key;
                      });
                      quantity = stateItem ? stateItem.quantity : NaN;
                    }
                    body = {
                      id: key,
                      selling_plan: sellingPlan
                    };
                    if (!Number.isNaN(quantity) && quantity > 0) {
                      body.quantity = quantity;
                    }
                    if (isFinal) {
                      body.sections = node.id;
                    }

                    // eslint-disable-next-line no-await-in-loop
                    _context4.n = 1;
                    return fetch(window.theme.routes.cartChange, {
                      method: 'POST',
                      headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json'
                      },
                      body: JSON.stringify(body)
                    });
                  case 1:
                    res = _context4.v;
                    if (res.ok) {
                      _context4.n = 2;
                      break;
                    }
                    throw new Error('Failed to update selling plan');
                  case 2:
                    if (!isFinal) {
                      _context4.n = 4;
                      break;
                    }
                    _context4.n = 3;
                    return res.json();
                  case 3:
                    data = _context4.v;
                    html = data.sections[node.id];
                    pendingAutoship.clear();
                    inFlight = false;
                    loadingKeys.clear();
                    renderCart(html, data);
                  case 4:
                    return _context4.a(2);
                }
              }, _loop);
            });
            i = 0;
          case 9:
            if (!(i < targets.length)) {
              _context5.n = 11;
              break;
            }
            return _context5.d((0,_babel_runtime_helpers_regeneratorValues__WEBPACK_IMPORTED_MODULE_0__["default"])(_loop()), 10);
          case 10:
            i++;
            _context5.n = 9;
            break;
          case 11:
            _context5.n = 13;
            break;
          case 12:
            _context5.p = 12;
            _t4 = _context5.v;
            console.error(_t4);
            pendingAutoship.clear();
            inFlight = false;
            loadingKeys.clear();
            ctx.emit('cart:set-selling-plan-error', {
              id: failedKey
            });
            updateCart();
          case 13:
            _context5.p = 13;
            inFlight = false;
            loadingKeys.clear();
            return _context5.f(13);
          case 14:
            return _context5.a(2);
        }
      }, _callee4, null, [[3, 12, 13, 14]]);
    }));
    return _setCartSellingPlan.apply(this, arguments);
  }
  function handleSubmitGuard(event) {
    var _event$submitter;
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.querySelector('[name="checkout"]')) return;
    var blocked = inFlight || pendingAutoship.size > 0 || isSubscriptionActive() && getCartPlan() == null;
    if (blocked) {
      event.preventDefault();
      var widget = getWidget();
      if (widget) {
        var _focusTarget$focus;
        var focusTarget = widget.querySelector('[data-subscription-plan]') || widget;
        (_focusTarget$focus = focusTarget.focus) === null || _focusTarget$focus === void 0 || _focusTarget$focus.call(focusTarget);
      }
      return;
    }
    if (((_event$submitter = event.submitter) === null || _event$submitter === void 0 ? void 0 : _event$submitter.name) === 'checkout') {
      event.submitter.classList.add('btn--loading');
    }
  }
  function handleStickyCheckout(event) {
    var _event$target$closest, _event$target, _focusTarget$focus2;
    var sticky = (_event$target$closest = (_event$target = event.target).closest) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.call(_event$target, '#cart-sticky-checkout');
    if (!sticky || !node.contains(sticky)) return;
    var btn = sticky.querySelector('[name="checkout"]');
    if (!btn || !btn.disabled) return;
    var widget = getWidget();
    if (!widget) return;
    widget.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
    var focusTarget = widget.querySelector('[data-subscription-plan]') || widget;
    (_focusTarget$focus2 = focusTarget.focus) === null || _focusTarget$focus2 === void 0 || _focusTarget$focus2.call(focusTarget, {
      preventScroll: true
    });
  }
  (0,_lib_cart__WEBPACK_IMPORTED_MODULE_6__.fetchCart)().then(function () {
    return ctx.emit('cart:fetched');
  });
  ctx.on('cart:update', updateCart);
  ctx.on('cart:updating', function () {
    return setBusy(true);
  });
  ctx.on('cart:idle', function () {
    return setBusy(false);
  });
  ctx.on('cart:set-selling-plan', resolveSellingPlan);
  ctx.on('cart:set-cart-selling-plan', setCartSellingPlan);
  node.addEventListener('change', handleChangeCart, true);
  node.addEventListener('click', handleChangeCart, true);
  node.addEventListener('click', handleStickyCheckout, true);
  node.addEventListener('submit', handleSubmitGuard, true);
  applyPendingUI();
  return function () {
    var _checkoutBtnObserver;
    clearTimeout(debounceTimer);
    (_checkoutBtnObserver = checkoutBtnObserver) === null || _checkoutBtnObserver === void 0 || _checkoutBtnObserver.disconnect();
    node.removeEventListener('change', handleChangeCart, true);
    node.removeEventListener('click', handleChangeCart, true);
    node.removeEventListener('click', handleStickyCheckout, true);
    node.removeEventListener('submit', handleSubmitGuard, true);
  };
}));

/***/ }),

/***/ "./scripts/pages/product.js":
/*!**********************************!*\
  !*** ./scripts/pages/product.js ***!
  \**********************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");

/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node, ctx) {
  var form = node.querySelector("[action*='/cart/add']");
  if (!form) {
    return;
  }
  var quantityInput = node.querySelector("[name='quantity']");
  var postAddToCart = node.querySelector('[data-post-add-to-cart]');
  var postAddToCartQuantity = node.querySelector('[data-post-add-to-cart-quantity]');
  function handleSubmit() {
    var _form$elements;
    var cartBubble = document.querySelectorAll('.cart-link__bubble');
    var _window = window,
      theme = _window.theme;
    var variantId = form.elements.id.value;
    var quantity = ((_form$elements = form.elements) === null || _form$elements === void 0 || (_form$elements = _form$elements.quantity) === null || _form$elements === void 0 ? void 0 : _form$elements.value) || 1;
    fetch(window.location.origin + theme.routes.cartAdd, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          quantity: quantity,
          id: parseInt(variantId, 10)
        }]
      })
    }).then(function () {
      return cartBubble.forEach(function (bubble) {
        return bubble.classList.add('cart-link__bubble--visible');
      });
    });
  }
  form.addEventListener('submit', function (event) {
    event.preventDefault();
    var submitBtn = form.querySelector("[type='submit']");
    if (!submitBtn) {
      return;
    }
    var originalText = submitBtn.innerText;
    submitBtn.innerText = window.theme.strings.adding;
    submitBtn.disabled = true;
    var formData = new FormData(form);
    fetch("".concat(window.Shopify.routes.root, "cart/add.js"), {
      method: 'POST',
      body: formData
    }).then(function (res) {
      if (!res.ok) {
        throw new Error('Failed adding product to cart');
      }
      return res.json();
    }).then(function () {
      submitBtn.innerText = window.theme.strings.addedToCart;
      submitBtn.style.backgroundColor = '#4CAF50';
      submitBtn.style.color = '#ffffff';
      ctx.emit('cart:update');
      setTimeout(function () {
        var activeModal = document.querySelector('.ModalForm.active');
        var productPopup = document.querySelector('.product-custom-popup');
        var cartBubble = document.querySelectorAll('.cart-link__bubble');
        cartBubble.forEach(function (bubble) {
          return bubble.classList.add('cart-link__bubble--visible');
        });
        if (activeModal) {
          activeModal.classList.add('close-animation');
          setTimeout(function () {
            activeModal.classList.remove('close-animation');
            activeModal.classList.remove('active');
            if (productPopup) {
              productPopup.remove();
            }
            submitBtn.innerText = originalText;
            submitBtn.disabled = false;
            submitBtn.style.backgroundColor = '';
            submitBtn.style.color = '';
          }, 400);
          return;
        }
        submitBtn.innerText = originalText;
        submitBtn.disabled = false;
        submitBtn.style.backgroundColor = '';
        submitBtn.style.color = '';
      }, 1000);
    }).catch(function (error) {
      console.error('Fehler:', error);
      submitBtn.innerText = 'Fehler';
      setTimeout(function () {
        submitBtn.innerText = originalText;
        submitBtn.disabled = false;
      }, 2000);
    });
  });
  var addToCart = false;

  // form.addEventListener("submit", (event) => {
  //   if (!addToCart) {
  //     event.preventDefault()
  //
  //     const modalData = node.querySelector(".Modal")?.getAttribute("data-modal-id")
  //
  //     if (!modalData) {
  //       return
  //     }
  //
  //     const closeModal = node.querySelector(".Modal [data-modal-close]")
  //     const overlayModal = node.querySelector(".Modal [data-modal-overlay]")
  //     closeModal && closeModal.addEventListener("click", handleSubmit)
  //     overlayModal && overlayModal.addEventListener("click", handleSubmit)
  //     ctx.emit(`modal-${modalData}:open`)
  //   }
  // })

  postAddToCart && postAddToCart.addEventListener('click', function () {
    addToCart = true;
    form.submit();
  });
  if (quantityInput && postAddToCartQuantity) {
    quantityInput.addEventListener('change', function () {
      postAddToCartQuantity.innerText = quantityInput.value;
    });
  }
}));

/***/ }),

/***/ "./scripts/pages/wishlist.js":
/*!***********************************!*\
  !*** ./scripts/pages/wishlist.js ***!
  \***********************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var _app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/app */ "./scripts/app.js");


/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_0__.component)(function (node) {
  var cache = {};
  var deleteAllBtn = node.querySelector('.wishlistBtnAll');
  var wishlistContainer = document.querySelector('#wishlist-items-container');
  var wishlistLoading = document.querySelector('.wishlist-loading');
  var wishlistEmpty = document.querySelector('#wishlist-empty');
  var swat = null;
  var wishlistProducts = [];
  var wishlistProductsInfo = [];
  function onSwymLoadCallback(_swat) {
    swat = _swat;
    swymRenderWishlist();
  }
  function swymRenderWishlist() {
    swat.fetchLists({
      callbackFn: function callbackFn(responce) {
        var _responce$0$listconte, _responce$;
        wishlistProductsInfo = responce;
        wishlistProducts = (_responce$0$listconte = (_responce$ = responce[0]) === null || _responce$ === void 0 ? void 0 : _responce$.listcontents) !== null && _responce$0$listconte !== void 0 ? _responce$0$listconte : [];
        if (wishlistProducts.length === 0) {
          emptyState();
          return;
        }
        var productsHandle = wishlistProducts.map(function (product) {
          return "".concat(window.Shopify.routes.root, "products/").concat(product.du.split('/').pop(), "?view=ajax-wishlist");
        });
        Promise.all(productsHandle.map(function (url) {
          if (cache[url]) {
            return Promise.resolve(cache[url]);
          }
          return fetch(url).then(function (res) {
            cache[url] = res.text();
            return cache[url];
          });
        })).then(function (dataArray) {
          var data = dataArray.join('');
          if (wishlistContainer.childElementCount > 0) {
            wishlistContainer.innerHTML = '';
            wishlistLoading.style.display = 'none';
            wishlistContainer.insertAdjacentHTML('beforeend', data);
          } else {
            wishlistLoading.style.display = 'none';
            wishlistContainer.insertAdjacentHTML('beforeend', data);
          }
          wishlistContainer.style.display = '';
          _app__WEBPACK_IMPORTED_MODULE_1__["default"].mount();
          attachClickListeners();
        });
      }
    });
  }
  function onRemoveBtnClick(e) {
    e.preventDefault();
    var target = e.currentTarget;
    var epi = parseInt(target.getAttribute('data-variant-id'), 10);
    var empi = parseInt(target.getAttribute('data-product-id'), 10);
    var lid = wishlistProductsInfo[0].lid;
    var products = wishlistProducts.map(function (item) {
      return {
        du: item.du,
        empi: item.empi,
        epi: item.epi
      };
    });
    var product = products.find(function (p) {
      return p.epi === epi && p.empi === empi;
    });
    function onSuccess(deletedProduct) {
      console.log('Successfully deleted the Product', deletedProduct);
      swymRenderWishlist();
    }
    function onError(error) {
      console.log('Error while deleting the Product', error);
      target.style.opacity = '';
      target.disabled = false;
    }
    target.style.opacity = '0.2';
    target.disabled = true;
    swat.deleteFromList(lid, product, onSuccess, onError);
  }
  function onRemoveAll(e) {
    e.preventDefault();
    var lid = wishlistProductsInfo[0].lid;
    var products = wishlistProducts.map(function (item) {
      return {
        du: item.du,
        empi: item.empi,
        epi: item.epi
      };
    });
    function onSuccess(removedProducts) {
      console.log("Successfully removed many Products from the List ".concat(lid), removedProducts);
    }
    function onError(error) {
      console.log('Error while removing many Products from the List', error);
      wishlistLoading.style.display = 'none';
      wishlistContainer.style.display = '';
    }
    function chunkArray(array, size) {
      var chunks = [];
      for (var i = 0; i < array.length; i += size) {
        chunks.push(array.slice(i, i + size));
      }
      return chunks;
    }
    var productChunks = chunkArray(products, 10);
    function processChunks(chunks) {
      if (chunks.length === 0) {
        emptyState();
        return;
      }
      var currentChunk = chunks.shift();
      swat.removeProductsFromList(lid, currentChunk, function (removedProducts) {
        onSuccess(removedProducts);
        processChunks(chunks);
      }, onError);
    }
    wishlistLoading.style.display = '';
    wishlistContainer.style.display = 'none';
    processChunks(productChunks);
  }
  function attachClickListeners() {
    var removeBtns = document.querySelectorAll('#swym-remove-productBtn');
    for (var k = 0; k < removeBtns.length; k++) {
      removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
    }
  }
  function emptyState() {
    wishlistEmpty.style.display = '';
    deleteAllBtn.style.display = 'none';
    wishlistLoading.style.display = 'none';
    wishlistContainer.style.display = '';
    wishlistContainer.innerHTML = '';
  }
  deleteAllBtn.addEventListener('click', onRemoveAll);
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(onSwymLoadCallback);
}));

/***/ }),

/***/ "./scripts/sections/featured-products.js":
/*!***********************************************!*\
  !*** ./scripts/sections/featured-products.js ***!
  \***********************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! swiper/css */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/swiper.css");
/* harmony import */ var picoapp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! picoapp */ "./node_modules/.pnpm/picoapp@3.6.2/node_modules/picoapp/dist/picoapp.es.js");
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! swiper */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/swiper.mjs");
/* harmony import */ var swiper_modules__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! swiper/modules */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/index.mjs");




swiper__WEBPACK_IMPORTED_MODULE_2__["default"].use([swiper_modules__WEBPACK_IMPORTED_MODULE_3__.FreeMode, swiper_modules__WEBPACK_IMPORTED_MODULE_3__.Mousewheel, swiper_modules__WEBPACK_IMPORTED_MODULE_3__.Navigation]);
/* harmony default export */ __webpack_exports__["default"] = ((0,picoapp__WEBPACK_IMPORTED_MODULE_1__.component)(function (node) {
  var navigation = node.querySelector('.featured-products__navigation');
  var options = {
    freeMode: true,
    mousewheel: {
      forceToAxis: true
    },
    slidesPerView: 'auto',
    spaceBetween: 8,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      700: {
        slidesPerView: 3,
        spaceBetween: 8
      },
      800: {
        slidesPerView: 4,
        spaceBetween: 16
      },
      1050: {
        slidesPerView: 5,
        spaceBetween: 16
      },
      1548: {
        slidesPerView: 'auto',
        spaceBetween: 16
      }
    },
    on: {
      afterInit: checkNavigation,
      resize: checkNavigation
    }
  };
  function checkNavigation(swiper) {
    if (navigation && !swiper.allowSlidePrev && !swiper.allowSlideNext) {
      navigation.style.display = 'none';
    }
  }
  var slider = new swiper__WEBPACK_IMPORTED_MODULE_2__["default"](node, options);
}));

/***/ }),

/***/ "./node_modules/.pnpm/js-cookie@3.0.8/node_modules/js-cookie/dist/js.cookie.mjs":
/*!**************************************************************************************!*\
  !*** ./node_modules/.pnpm/js-cookie@3.0.8/node_modules/js-cookie/dist/js.cookie.mjs ***!
  \**************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ api; }
/* harmony export */ });
/*! js-cookie v3.0.8 | MIT */
function assign (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (key === '__proto__') continue
      target[key] = source[key];
    }
  }
  return target
}

var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }
    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent)
  },
  write: function (value) {
    return encodeURIComponent(value).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    )
  }
};

function init(converter, defaultAttributes) {
  function set(name, value, attributes) {
    if (typeof document === 'undefined') {
      return
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }
    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    name = encodeURIComponent(name)
      .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
      .replace(/[()]/g, escape);

    var stringifiedAttributes = '';
    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue
      }

      // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...
      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return (document.cookie =
      name + '=' + converter.write(value, name) + stringifiedAttributes)
  }

  function get(name) {
    if (typeof document === 'undefined' || (arguments.length && !name)) {
      return
    }

    // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var found = decodeURIComponent(parts[0]);
        if (!(found in jar)) jar[found] = converter.read(value, found);
        if (name === found) {
          break
        }
      } catch (_e) {
        // Do nothing...
      }
    }

    return name ? jar[name] : jar
  }

  return Object.create(
    {
      set: set,
      get: get,
      remove: function (name, attributes) {
        set(
          name,
          '',
          assign({}, attributes, {
            expires: -1
          })
        );
      },
      withAttributes: function (attributes) {
        return init(this.converter, assign({}, this.attributes, attributes))
      },
      withConverter: function (converter) {
        return init(assign({}, this.converter, converter), this.attributes)
      }
    },
    {
      attributes: { value: Object.freeze(defaultAttributes) },
      converter: { value: Object.freeze(converter) }
    }
  )
}

var api = init(defaultConverter, { path: '/' });




/***/ }),

/***/ "./node_modules/.pnpm/nouislider@15.8.1/node_modules/nouislider/dist/nouislider.mjs":
/*!******************************************************************************************!*\
  !*** ./node_modules/.pnpm/nouislider@15.8.1/node_modules/nouislider/dist/nouislider.mjs ***!
  \******************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PipsMode: function() { return /* binding */ PipsMode; },
/* harmony export */   PipsType: function() { return /* binding */ PipsType; },
/* harmony export */   create: function() { return /* binding */ initialize; },
/* harmony export */   cssClasses: function() { return /* binding */ cssClasses; }
/* harmony export */ });

var PipsMode;
(function (PipsMode) {
    PipsMode["Range"] = "range";
    PipsMode["Steps"] = "steps";
    PipsMode["Positions"] = "positions";
    PipsMode["Count"] = "count";
    PipsMode["Values"] = "values";
})(PipsMode || (PipsMode = {}));
var PipsType;
(function (PipsType) {
    PipsType[PipsType["None"] = -1] = "None";
    PipsType[PipsType["NoValue"] = 0] = "NoValue";
    PipsType[PipsType["LargeValue"] = 1] = "LargeValue";
    PipsType[PipsType["SmallValue"] = 2] = "SmallValue";
})(PipsType || (PipsType = {}));
//region Helper Methods
function isValidFormatter(entry) {
    return isValidPartialFormatter(entry) && typeof entry.from === "function";
}
function isValidPartialFormatter(entry) {
    // partial formatters only need a to function and not a from function
    return typeof entry === "object" && typeof entry.to === "function";
}
function removeElement(el) {
    el.parentElement.removeChild(el);
}
function isSet(value) {
    return value !== null && value !== undefined;
}
// Bindable version
function preventDefault(e) {
    e.preventDefault();
}
// Removes duplicates from an array.
function unique(array) {
    return array.filter(function (a) {
        return !this[a] ? (this[a] = true) : false;
    }, {});
}
// Round a value to the closest 'to'.
function closest(value, to) {
    return Math.round(value / to) * to;
}
// Current position of an element relative to the document.
function offset(elem, orientation) {
    var rect = elem.getBoundingClientRect();
    var doc = elem.ownerDocument;
    var docElem = doc.documentElement;
    var pageOffset = getPageOffset(doc);
    // getBoundingClientRect contains left scroll in Chrome on Android.
    // I haven't found a feature detection that proves this. Worst case
    // scenario on mis-match: the 'tap' feature on horizontal sliders breaks.
    if (/webkit.*Chrome.*Mobile/i.test(navigator.userAgent)) {
        pageOffset.x = 0;
    }
    return orientation ? rect.top + pageOffset.y - docElem.clientTop : rect.left + pageOffset.x - docElem.clientLeft;
}
// Checks whether a value is numerical.
function isNumeric(a) {
    return typeof a === "number" && !isNaN(a) && isFinite(a);
}
// Sets a class and removes it after [duration] ms.
function addClassFor(element, className, duration) {
    if (duration > 0) {
        addClass(element, className);
        setTimeout(function () {
            removeClass(element, className);
        }, duration);
    }
}
// Limits a value to 0 - 100
function limit(a) {
    return Math.max(Math.min(a, 100), 0);
}
// Wraps a variable as an array, if it isn't one yet.
// Note that an input array is returned by reference!
function asArray(a) {
    return Array.isArray(a) ? a : [a];
}
// Counts decimals
function countDecimals(numStr) {
    numStr = String(numStr);
    var pieces = numStr.split(".");
    return pieces.length > 1 ? pieces[1].length : 0;
}
// http://youmightnotneedjquery.com/#add_class
function addClass(el, className) {
    if (el.classList && !/\s/.test(className)) {
        el.classList.add(className);
    }
    else {
        el.className += " " + className;
    }
}
// http://youmightnotneedjquery.com/#remove_class
function removeClass(el, className) {
    if (el.classList && !/\s/.test(className)) {
        el.classList.remove(className);
    }
    else {
        el.className = el.className.replace(new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }
}
// https://plainjs.com/javascript/attributes/adding-removing-and-testing-for-classes-9/
function hasClass(el, className) {
    return el.classList ? el.classList.contains(className) : new RegExp("\\b" + className + "\\b").test(el.className);
}
// https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY#Notes
function getPageOffset(doc) {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (doc.compatMode || "") === "CSS1Compat";
    var x = supportPageOffset
        ? window.pageXOffset
        : isCSS1Compat
            ? doc.documentElement.scrollLeft
            : doc.body.scrollLeft;
    var y = supportPageOffset
        ? window.pageYOffset
        : isCSS1Compat
            ? doc.documentElement.scrollTop
            : doc.body.scrollTop;
    return {
        x: x,
        y: y,
    };
}
// we provide a function to compute constants instead
// of accessing window.* as soon as the module needs it
// so that we do not compute anything if not needed
function getActions() {
    // Determine the events to bind. IE11 implements pointerEvents without
    // a prefix, which breaks compatibility with the IE10 implementation.
    return window.navigator.pointerEnabled
        ? {
            start: "pointerdown",
            move: "pointermove",
            end: "pointerup",
        }
        : window.navigator.msPointerEnabled
            ? {
                start: "MSPointerDown",
                move: "MSPointerMove",
                end: "MSPointerUp",
            }
            : {
                start: "mousedown touchstart",
                move: "mousemove touchmove",
                end: "mouseup touchend",
            };
}
// https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
// Issue #785
function getSupportsPassive() {
    var supportsPassive = false;
    /* eslint-disable */
    try {
        var opts = Object.defineProperty({}, "passive", {
            get: function () {
                supportsPassive = true;
            },
        });
        // @ts-ignore
        window.addEventListener("test", null, opts);
    }
    catch (e) { }
    /* eslint-enable */
    return supportsPassive;
}
function getSupportsTouchActionNone() {
    return window.CSS && CSS.supports && CSS.supports("touch-action", "none");
}
//endregion
//region Range Calculation
// Determine the size of a sub-range in relation to a full range.
function subRangeRatio(pa, pb) {
    return 100 / (pb - pa);
}
// (percentage) How many percent is this value of this range?
function fromPercentage(range, value, startRange) {
    return (value * 100) / (range[startRange + 1] - range[startRange]);
}
// (percentage) Where is this value on this range?
function toPercentage(range, value) {
    return fromPercentage(range, range[0] < 0 ? value + Math.abs(range[0]) : value - range[0], 0);
}
// (value) How much is this percentage on this range?
function isPercentage(range, value) {
    return (value * (range[1] - range[0])) / 100 + range[0];
}
function getJ(value, arr) {
    var j = 1;
    while (value >= arr[j]) {
        j += 1;
    }
    return j;
}
// (percentage) Input a value, find where, on a scale of 0-100, it applies.
function toStepping(xVal, xPct, value) {
    if (value >= xVal.slice(-1)[0]) {
        return 100;
    }
    var j = getJ(value, xVal);
    var va = xVal[j - 1];
    var vb = xVal[j];
    var pa = xPct[j - 1];
    var pb = xPct[j];
    return pa + toPercentage([va, vb], value) / subRangeRatio(pa, pb);
}
// (value) Input a percentage, find where it is on the specified range.
function fromStepping(xVal, xPct, value) {
    // There is no range group that fits 100
    if (value >= 100) {
        return xVal.slice(-1)[0];
    }
    var j = getJ(value, xPct);
    var va = xVal[j - 1];
    var vb = xVal[j];
    var pa = xPct[j - 1];
    var pb = xPct[j];
    return isPercentage([va, vb], (value - pa) * subRangeRatio(pa, pb));
}
// (percentage) Get the step that applies at a certain value.
function getStep(xPct, xSteps, snap, value) {
    if (value === 100) {
        return value;
    }
    var j = getJ(value, xPct);
    var a = xPct[j - 1];
    var b = xPct[j];
    // If 'snap' is set, steps are used as fixed points on the slider.
    if (snap) {
        // Find the closest position, a or b.
        if (value - a > (b - a) / 2) {
            return b;
        }
        return a;
    }
    if (!xSteps[j - 1]) {
        return value;
    }
    return xPct[j - 1] + closest(value - xPct[j - 1], xSteps[j - 1]);
}
//endregion
//region Spectrum
var Spectrum = /** @class */ (function () {
    function Spectrum(entry, snap, singleStep) {
        this.xPct = [];
        this.xVal = [];
        this.xSteps = [];
        this.xNumSteps = [];
        this.xHighestCompleteStep = [];
        this.xSteps = [singleStep || false];
        this.xNumSteps = [false];
        this.snap = snap;
        var index;
        var ordered = [];
        // Map the object keys to an array.
        Object.keys(entry).forEach(function (index) {
            ordered.push([asArray(entry[index]), index]);
        });
        // Sort all entries by value (numeric sort).
        ordered.sort(function (a, b) {
            return a[0][0] - b[0][0];
        });
        // Convert all entries to subranges.
        for (index = 0; index < ordered.length; index++) {
            this.handleEntryPoint(ordered[index][1], ordered[index][0]);
        }
        // Store the actual step values.
        // xSteps is sorted in the same order as xPct and xVal.
        this.xNumSteps = this.xSteps.slice(0);
        // Convert all numeric steps to the percentage of the subrange they represent.
        for (index = 0; index < this.xNumSteps.length; index++) {
            this.handleStepPoint(index, this.xNumSteps[index]);
        }
    }
    Spectrum.prototype.getDistance = function (value) {
        var distances = [];
        for (var index = 0; index < this.xNumSteps.length - 1; index++) {
            distances[index] = fromPercentage(this.xVal, value, index);
        }
        return distances;
    };
    // Calculate the percentual distance over the whole scale of ranges.
    // direction: 0 = backwards / 1 = forwards
    Spectrum.prototype.getAbsoluteDistance = function (value, distances, direction) {
        var xPct_index = 0;
        // Calculate range where to start calculation
        if (value < this.xPct[this.xPct.length - 1]) {
            while (value > this.xPct[xPct_index + 1]) {
                xPct_index++;
            }
        }
        else if (value === this.xPct[this.xPct.length - 1]) {
            xPct_index = this.xPct.length - 2;
        }
        // If looking backwards and the value is exactly at a range separator then look one range further
        if (!direction && value === this.xPct[xPct_index + 1]) {
            xPct_index++;
        }
        if (distances === null) {
            distances = [];
        }
        var start_factor;
        var rest_factor = 1;
        var rest_rel_distance = distances[xPct_index];
        var range_pct = 0;
        var rel_range_distance = 0;
        var abs_distance_counter = 0;
        var range_counter = 0;
        // Calculate what part of the start range the value is
        if (direction) {
            start_factor = (value - this.xPct[xPct_index]) / (this.xPct[xPct_index + 1] - this.xPct[xPct_index]);
        }
        else {
            start_factor = (this.xPct[xPct_index + 1] - value) / (this.xPct[xPct_index + 1] - this.xPct[xPct_index]);
        }
        // Do until the complete distance across ranges is calculated
        while (rest_rel_distance > 0) {
            // Calculate the percentage of total range
            range_pct = this.xPct[xPct_index + 1 + range_counter] - this.xPct[xPct_index + range_counter];
            // Detect if the margin, padding or limit is larger then the current range and calculate
            if (distances[xPct_index + range_counter] * rest_factor + 100 - start_factor * 100 > 100) {
                // If larger then take the percentual distance of the whole range
                rel_range_distance = range_pct * start_factor;
                // Rest factor of relative percentual distance still to be calculated
                rest_factor = (rest_rel_distance - 100 * start_factor) / distances[xPct_index + range_counter];
                // Set start factor to 1 as for next range it does not apply.
                start_factor = 1;
            }
            else {
                // If smaller or equal then take the percentual distance of the calculate percentual part of that range
                rel_range_distance = ((distances[xPct_index + range_counter] * range_pct) / 100) * rest_factor;
                // No rest left as the rest fits in current range
                rest_factor = 0;
            }
            if (direction) {
                abs_distance_counter = abs_distance_counter - rel_range_distance;
                // Limit range to first range when distance becomes outside of minimum range
                if (this.xPct.length + range_counter >= 1) {
                    range_counter--;
                }
            }
            else {
                abs_distance_counter = abs_distance_counter + rel_range_distance;
                // Limit range to last range when distance becomes outside of maximum range
                if (this.xPct.length - range_counter >= 1) {
                    range_counter++;
                }
            }
            // Rest of relative percentual distance still to be calculated
            rest_rel_distance = distances[xPct_index + range_counter] * rest_factor;
        }
        return value + abs_distance_counter;
    };
    Spectrum.prototype.toStepping = function (value) {
        value = toStepping(this.xVal, this.xPct, value);
        return value;
    };
    Spectrum.prototype.fromStepping = function (value) {
        return fromStepping(this.xVal, this.xPct, value);
    };
    Spectrum.prototype.getStep = function (value) {
        value = getStep(this.xPct, this.xSteps, this.snap, value);
        return value;
    };
    Spectrum.prototype.getDefaultStep = function (value, isDown, size) {
        var j = getJ(value, this.xPct);
        // When at the top or stepping down, look at the previous sub-range
        if (value === 100 || (isDown && value === this.xPct[j - 1])) {
            j = Math.max(j - 1, 1);
        }
        return (this.xVal[j] - this.xVal[j - 1]) / size;
    };
    Spectrum.prototype.getNearbySteps = function (value) {
        var j = getJ(value, this.xPct);
        return {
            stepBefore: {
                startValue: this.xVal[j - 2],
                step: this.xNumSteps[j - 2],
                highestStep: this.xHighestCompleteStep[j - 2],
            },
            thisStep: {
                startValue: this.xVal[j - 1],
                step: this.xNumSteps[j - 1],
                highestStep: this.xHighestCompleteStep[j - 1],
            },
            stepAfter: {
                startValue: this.xVal[j],
                step: this.xNumSteps[j],
                highestStep: this.xHighestCompleteStep[j],
            },
        };
    };
    Spectrum.prototype.countStepDecimals = function () {
        var stepDecimals = this.xNumSteps.map(countDecimals);
        return Math.max.apply(null, stepDecimals);
    };
    Spectrum.prototype.hasNoSize = function () {
        return this.xVal[0] === this.xVal[this.xVal.length - 1];
    };
    // Outside testing
    Spectrum.prototype.convert = function (value) {
        return this.getStep(this.toStepping(value));
    };
    Spectrum.prototype.handleEntryPoint = function (index, value) {
        var percentage;
        // Covert min/max syntax to 0 and 100.
        if (index === "min") {
            percentage = 0;
        }
        else if (index === "max") {
            percentage = 100;
        }
        else {
            percentage = parseFloat(index);
        }
        // Check for correct input.
        if (!isNumeric(percentage) || !isNumeric(value[0])) {
            throw new Error("noUiSlider: 'range' value isn't numeric.");
        }
        // Store values.
        this.xPct.push(percentage);
        this.xVal.push(value[0]);
        var value1 = Number(value[1]);
        // NaN will evaluate to false too, but to keep
        // logging clear, set step explicitly. Make sure
        // not to override the 'step' setting with false.
        if (!percentage) {
            if (!isNaN(value1)) {
                this.xSteps[0] = value1;
            }
        }
        else {
            this.xSteps.push(isNaN(value1) ? false : value1);
        }
        this.xHighestCompleteStep.push(0);
    };
    Spectrum.prototype.handleStepPoint = function (i, n) {
        // Ignore 'false' stepping.
        if (!n) {
            return;
        }
        // Step over zero-length ranges (#948);
        if (this.xVal[i] === this.xVal[i + 1]) {
            this.xSteps[i] = this.xHighestCompleteStep[i] = this.xVal[i];
            return;
        }
        // Factor to range ratio
        this.xSteps[i] =
            fromPercentage([this.xVal[i], this.xVal[i + 1]], n, 0) / subRangeRatio(this.xPct[i], this.xPct[i + 1]);
        var totalSteps = (this.xVal[i + 1] - this.xVal[i]) / this.xNumSteps[i];
        var highestStep = Math.ceil(Number(totalSteps.toFixed(3)) - 1);
        var step = this.xVal[i] + this.xNumSteps[i] * highestStep;
        this.xHighestCompleteStep[i] = step;
    };
    return Spectrum;
}());
//endregion
//region Options
/*	Every input option is tested and parsed. This will prevent
    endless validation in internal methods. These tests are
    structured with an item for every option available. An
    option can be marked as required by setting the 'r' flag.
    The testing function is provided with three arguments:
        - The provided value for the option;
        - A reference to the options object;
        - The name for the option;

    The testing function returns false when an error is detected,
    or true when everything is OK. It can also modify the option
    object, to make sure all values can be correctly looped elsewhere. */
//region Defaults
var defaultFormatter = {
    to: function (value) {
        return value === undefined ? "" : value.toFixed(2);
    },
    from: Number,
};
var cssClasses = {
    target: "target",
    base: "base",
    origin: "origin",
    handle: "handle",
    handleLower: "handle-lower",
    handleUpper: "handle-upper",
    touchArea: "touch-area",
    horizontal: "horizontal",
    vertical: "vertical",
    background: "background",
    connect: "connect",
    connects: "connects",
    ltr: "ltr",
    rtl: "rtl",
    textDirectionLtr: "txt-dir-ltr",
    textDirectionRtl: "txt-dir-rtl",
    draggable: "draggable",
    drag: "state-drag",
    tap: "state-tap",
    active: "active",
    tooltip: "tooltip",
    pips: "pips",
    pipsHorizontal: "pips-horizontal",
    pipsVertical: "pips-vertical",
    marker: "marker",
    markerHorizontal: "marker-horizontal",
    markerVertical: "marker-vertical",
    markerNormal: "marker-normal",
    markerLarge: "marker-large",
    markerSub: "marker-sub",
    value: "value",
    valueHorizontal: "value-horizontal",
    valueVertical: "value-vertical",
    valueNormal: "value-normal",
    valueLarge: "value-large",
    valueSub: "value-sub",
};
// Namespaces of internal event listeners
var INTERNAL_EVENT_NS = {
    tooltips: ".__tooltips",
    aria: ".__aria",
};
//endregion
function testStep(parsed, entry) {
    if (!isNumeric(entry)) {
        throw new Error("noUiSlider: 'step' is not numeric.");
    }
    // The step option can still be used to set stepping
    // for linear sliders. Overwritten if set in 'range'.
    parsed.singleStep = entry;
}
function testKeyboardPageMultiplier(parsed, entry) {
    if (!isNumeric(entry)) {
        throw new Error("noUiSlider: 'keyboardPageMultiplier' is not numeric.");
    }
    parsed.keyboardPageMultiplier = entry;
}
function testKeyboardMultiplier(parsed, entry) {
    if (!isNumeric(entry)) {
        throw new Error("noUiSlider: 'keyboardMultiplier' is not numeric.");
    }
    parsed.keyboardMultiplier = entry;
}
function testKeyboardDefaultStep(parsed, entry) {
    if (!isNumeric(entry)) {
        throw new Error("noUiSlider: 'keyboardDefaultStep' is not numeric.");
    }
    parsed.keyboardDefaultStep = entry;
}
function testRange(parsed, entry) {
    // Filter incorrect input.
    if (typeof entry !== "object" || Array.isArray(entry)) {
        throw new Error("noUiSlider: 'range' is not an object.");
    }
    // Catch missing start or end.
    if (entry.min === undefined || entry.max === undefined) {
        throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
    }
    parsed.spectrum = new Spectrum(entry, parsed.snap || false, parsed.singleStep);
}
function testStart(parsed, entry) {
    entry = asArray(entry);
    // Validate input. Values aren't tested, as the public .val method
    // will always provide a valid location.
    if (!Array.isArray(entry) || !entry.length) {
        throw new Error("noUiSlider: 'start' option is incorrect.");
    }
    // Store the number of handles.
    parsed.handles = entry.length;
    // When the slider is initialized, the .val method will
    // be called with the start options.
    parsed.start = entry;
}
function testSnap(parsed, entry) {
    if (typeof entry !== "boolean") {
        throw new Error("noUiSlider: 'snap' option must be a boolean.");
    }
    // Enforce 100% stepping within subranges.
    parsed.snap = entry;
}
function testAnimate(parsed, entry) {
    if (typeof entry !== "boolean") {
        throw new Error("noUiSlider: 'animate' option must be a boolean.");
    }
    // Enforce 100% stepping within subranges.
    parsed.animate = entry;
}
function testAnimationDuration(parsed, entry) {
    if (typeof entry !== "number") {
        throw new Error("noUiSlider: 'animationDuration' option must be a number.");
    }
    parsed.animationDuration = entry;
}
function testConnect(parsed, entry) {
    var connect = [false];
    var i;
    // Map legacy options
    if (entry === "lower") {
        entry = [true, false];
    }
    else if (entry === "upper") {
        entry = [false, true];
    }
    // Handle boolean options
    if (entry === true || entry === false) {
        for (i = 1; i < parsed.handles; i++) {
            connect.push(entry);
        }
        connect.push(false);
    }
    // Reject invalid input
    else if (!Array.isArray(entry) || !entry.length || entry.length !== parsed.handles + 1) {
        throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
    }
    else {
        connect = entry;
    }
    parsed.connect = connect;
}
function testOrientation(parsed, entry) {
    // Set orientation to an a numerical value for easy
    // array selection.
    switch (entry) {
        case "horizontal":
            parsed.ort = 0;
            break;
        case "vertical":
            parsed.ort = 1;
            break;
        default:
            throw new Error("noUiSlider: 'orientation' option is invalid.");
    }
}
function testMargin(parsed, entry) {
    if (!isNumeric(entry)) {
        throw new Error("noUiSlider: 'margin' option must be numeric.");
    }
    // Issue #582
    if (entry === 0) {
        return;
    }
    parsed.margin = parsed.spectrum.getDistance(entry);
}
function testLimit(parsed, entry) {
    if (!isNumeric(entry)) {
        throw new Error("noUiSlider: 'limit' option must be numeric.");
    }
    parsed.limit = parsed.spectrum.getDistance(entry);
    if (!parsed.limit || parsed.handles < 2) {
        throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.");
    }
}
function testPadding(parsed, entry) {
    var index;
    if (!isNumeric(entry) && !Array.isArray(entry)) {
        throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
    }
    if (Array.isArray(entry) && !(entry.length === 2 || isNumeric(entry[0]) || isNumeric(entry[1]))) {
        throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
    }
    if (entry === 0) {
        return;
    }
    if (!Array.isArray(entry)) {
        entry = [entry, entry];
    }
    // 'getDistance' returns false for invalid values.
    parsed.padding = [parsed.spectrum.getDistance(entry[0]), parsed.spectrum.getDistance(entry[1])];
    for (index = 0; index < parsed.spectrum.xNumSteps.length - 1; index++) {
        // last "range" can't contain step size as it is purely an endpoint.
        if (parsed.padding[0][index] < 0 || parsed.padding[1][index] < 0) {
            throw new Error("noUiSlider: 'padding' option must be a positive number(s).");
        }
    }
    var totalPadding = entry[0] + entry[1];
    var firstValue = parsed.spectrum.xVal[0];
    var lastValue = parsed.spectrum.xVal[parsed.spectrum.xVal.length - 1];
    if (totalPadding / (lastValue - firstValue) > 1) {
        throw new Error("noUiSlider: 'padding' option must not exceed 100% of the range.");
    }
}
function testDirection(parsed, entry) {
    // Set direction as a numerical value for easy parsing.
    // Invert connection for RTL sliders, so that the proper
    // handles get the connect/background classes.
    switch (entry) {
        case "ltr":
            parsed.dir = 0;
            break;
        case "rtl":
            parsed.dir = 1;
            break;
        default:
            throw new Error("noUiSlider: 'direction' option was not recognized.");
    }
}
function testBehaviour(parsed, entry) {
    // Make sure the input is a string.
    if (typeof entry !== "string") {
        throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
    }
    // Check if the string contains any keywords.
    // None are required.
    var tap = entry.indexOf("tap") >= 0;
    var drag = entry.indexOf("drag") >= 0;
    var fixed = entry.indexOf("fixed") >= 0;
    var snap = entry.indexOf("snap") >= 0;
    var hover = entry.indexOf("hover") >= 0;
    var unconstrained = entry.indexOf("unconstrained") >= 0;
    var invertConnects = entry.indexOf("invert-connects") >= 0;
    var dragAll = entry.indexOf("drag-all") >= 0;
    var smoothSteps = entry.indexOf("smooth-steps") >= 0;
    if (fixed) {
        if (parsed.handles !== 2) {
            throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");
        }
        // Use margin to enforce fixed state
        testMargin(parsed, parsed.start[1] - parsed.start[0]);
    }
    if (invertConnects && parsed.handles !== 2) {
        throw new Error("noUiSlider: 'invert-connects' behaviour must be used with 2 handles");
    }
    if (unconstrained && (parsed.margin || parsed.limit)) {
        throw new Error("noUiSlider: 'unconstrained' behaviour cannot be used with margin or limit");
    }
    parsed.events = {
        tap: tap || snap,
        drag: drag,
        dragAll: dragAll,
        smoothSteps: smoothSteps,
        fixed: fixed,
        snap: snap,
        hover: hover,
        unconstrained: unconstrained,
        invertConnects: invertConnects,
    };
}
function testTooltips(parsed, entry) {
    if (entry === false) {
        return;
    }
    if (entry === true || isValidPartialFormatter(entry)) {
        parsed.tooltips = [];
        for (var i = 0; i < parsed.handles; i++) {
            parsed.tooltips.push(entry);
        }
    }
    else {
        entry = asArray(entry);
        if (entry.length !== parsed.handles) {
            throw new Error("noUiSlider: must pass a formatter for all handles.");
        }
        entry.forEach(function (formatter) {
            if (typeof formatter !== "boolean" && !isValidPartialFormatter(formatter)) {
                throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
            }
        });
        parsed.tooltips = entry;
    }
}
function testHandleAttributes(parsed, entry) {
    if (entry.length !== parsed.handles) {
        throw new Error("noUiSlider: must pass a attributes for all handles.");
    }
    parsed.handleAttributes = entry;
}
function testAriaFormat(parsed, entry) {
    if (!isValidPartialFormatter(entry)) {
        throw new Error("noUiSlider: 'ariaFormat' requires 'to' method.");
    }
    parsed.ariaFormat = entry;
}
function testFormat(parsed, entry) {
    if (!isValidFormatter(entry)) {
        throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
    }
    parsed.format = entry;
}
function testKeyboardSupport(parsed, entry) {
    if (typeof entry !== "boolean") {
        throw new Error("noUiSlider: 'keyboardSupport' option must be a boolean.");
    }
    parsed.keyboardSupport = entry;
}
function testDocumentElement(parsed, entry) {
    // This is an advanced option. Passed values are used without validation.
    parsed.documentElement = entry;
}
function testCssPrefix(parsed, entry) {
    if (typeof entry !== "string" && entry !== false) {
        throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
    }
    parsed.cssPrefix = entry;
}
function testCssClasses(parsed, entry) {
    if (typeof entry !== "object") {
        throw new Error("noUiSlider: 'cssClasses' must be an object.");
    }
    if (typeof parsed.cssPrefix === "string") {
        parsed.cssClasses = {};
        Object.keys(entry).forEach(function (key) {
            parsed.cssClasses[key] = parsed.cssPrefix + entry[key];
        });
    }
    else {
        parsed.cssClasses = entry;
    }
}
// Test all developer settings and parse to assumption-safe values.
function testOptions(options) {
    // To prove a fix for #537, freeze options here.
    // If the object is modified, an error will be thrown.
    // Object.freeze(options);
    var parsed = {
        margin: null,
        limit: null,
        padding: null,
        animate: true,
        animationDuration: 300,
        ariaFormat: defaultFormatter,
        format: defaultFormatter,
    };
    // Tests are executed in the order they are presented here.
    var tests = {
        step: { r: false, t: testStep },
        keyboardPageMultiplier: { r: false, t: testKeyboardPageMultiplier },
        keyboardMultiplier: { r: false, t: testKeyboardMultiplier },
        keyboardDefaultStep: { r: false, t: testKeyboardDefaultStep },
        start: { r: true, t: testStart },
        connect: { r: true, t: testConnect },
        direction: { r: true, t: testDirection },
        snap: { r: false, t: testSnap },
        animate: { r: false, t: testAnimate },
        animationDuration: { r: false, t: testAnimationDuration },
        range: { r: true, t: testRange },
        orientation: { r: false, t: testOrientation },
        margin: { r: false, t: testMargin },
        limit: { r: false, t: testLimit },
        padding: { r: false, t: testPadding },
        behaviour: { r: true, t: testBehaviour },
        ariaFormat: { r: false, t: testAriaFormat },
        format: { r: false, t: testFormat },
        tooltips: { r: false, t: testTooltips },
        keyboardSupport: { r: true, t: testKeyboardSupport },
        documentElement: { r: false, t: testDocumentElement },
        cssPrefix: { r: true, t: testCssPrefix },
        cssClasses: { r: true, t: testCssClasses },
        handleAttributes: { r: false, t: testHandleAttributes },
    };
    var defaults = {
        connect: false,
        direction: "ltr",
        behaviour: "tap",
        orientation: "horizontal",
        keyboardSupport: true,
        cssPrefix: "noUi-",
        cssClasses: cssClasses,
        keyboardPageMultiplier: 5,
        keyboardMultiplier: 1,
        keyboardDefaultStep: 10,
    };
    // AriaFormat defaults to regular format, if any.
    if (options.format && !options.ariaFormat) {
        options.ariaFormat = options.format;
    }
    // Run all options through a testing mechanism to ensure correct
    // input. It should be noted that options might get modified to
    // be handled properly. E.g. wrapping integers in arrays.
    Object.keys(tests).forEach(function (name) {
        // If the option isn't set, but it is required, throw an error.
        if (!isSet(options[name]) && defaults[name] === undefined) {
            if (tests[name].r) {
                throw new Error("noUiSlider: '" + name + "' is required.");
            }
            return;
        }
        tests[name].t(parsed, !isSet(options[name]) ? defaults[name] : options[name]);
    });
    // Forward pips options
    parsed.pips = options.pips;
    // All recent browsers accept unprefixed transform.
    // We need -ms- for IE9 and -webkit- for older Android;
    // Assume use of -webkit- if unprefixed and -ms- are not supported.
    // https://caniuse.com/#feat=transforms2d
    var d = document.createElement("div");
    var msPrefix = d.style.msTransform !== undefined;
    var noPrefix = d.style.transform !== undefined;
    parsed.transformRule = noPrefix ? "transform" : msPrefix ? "msTransform" : "webkitTransform";
    // Pips don't move, so we can place them using left/top.
    var styles = [
        ["left", "top"],
        ["right", "bottom"],
    ];
    parsed.style = styles[parsed.dir][parsed.ort];
    return parsed;
}
//endregion
function scope(target, options, originalOptions) {
    var actions = getActions();
    var supportsTouchActionNone = getSupportsTouchActionNone();
    var supportsPassive = supportsTouchActionNone && getSupportsPassive();
    // All variables local to 'scope' are prefixed with 'scope_'
    // Slider DOM Nodes
    var scope_Target = target;
    var scope_Base;
    var scope_ConnectBase;
    var scope_Handles;
    var scope_Connects;
    var scope_Pips;
    var scope_Tooltips;
    // Slider state values
    var scope_Spectrum = options.spectrum;
    var scope_Values = [];
    var scope_Locations = [];
    var scope_HandleNumbers = [];
    var scope_ActiveHandlesCount = 0;
    var scope_Events = {};
    var scope_ConnectsInverted = false;
    // Document Nodes
    var scope_Document = target.ownerDocument;
    var scope_DocumentElement = options.documentElement || scope_Document.documentElement;
    var scope_Body = scope_Document.body;
    // For horizontal sliders in standard ltr documents,
    // make .noUi-origin overflow to the left so the document doesn't scroll.
    var scope_DirOffset = scope_Document.dir === "rtl" || options.ort === 1 ? 0 : 100;
    // Creates a node, adds it to target, returns the new node.
    function addNodeTo(addTarget, className) {
        var div = scope_Document.createElement("div");
        if (className) {
            addClass(div, className);
        }
        addTarget.appendChild(div);
        return div;
    }
    // Append a origin to the base
    function addOrigin(base, handleNumber) {
        var origin = addNodeTo(base, options.cssClasses.origin);
        var handle = addNodeTo(origin, options.cssClasses.handle);
        addNodeTo(handle, options.cssClasses.touchArea);
        handle.setAttribute("data-handle", String(handleNumber));
        if (options.keyboardSupport) {
            // https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex
            // 0 = focusable and reachable
            handle.setAttribute("tabindex", "0");
            handle.addEventListener("keydown", function (event) {
                return eventKeydown(event, handleNumber);
            });
        }
        if (options.handleAttributes !== undefined) {
            var attributes_1 = options.handleAttributes[handleNumber];
            Object.keys(attributes_1).forEach(function (attribute) {
                handle.setAttribute(attribute, attributes_1[attribute]);
            });
        }
        handle.setAttribute("role", "slider");
        handle.setAttribute("aria-orientation", options.ort ? "vertical" : "horizontal");
        if (handleNumber === 0) {
            addClass(handle, options.cssClasses.handleLower);
        }
        else if (handleNumber === options.handles - 1) {
            addClass(handle, options.cssClasses.handleUpper);
        }
        origin.handle = handle;
        return origin;
    }
    // Insert nodes for connect elements
    function addConnect(base, add) {
        if (!add) {
            return false;
        }
        return addNodeTo(base, options.cssClasses.connect);
    }
    // Add handles to the slider base.
    function addElements(connectOptions, base) {
        scope_ConnectBase = addNodeTo(base, options.cssClasses.connects);
        scope_Handles = [];
        scope_Connects = [];
        scope_Connects.push(addConnect(scope_ConnectBase, connectOptions[0]));
        // [::::O====O====O====]
        // connectOptions = [0, 1, 1, 1]
        for (var i = 0; i < options.handles; i++) {
            // Keep a list of all added handles.
            scope_Handles.push(addOrigin(base, i));
            scope_HandleNumbers[i] = i;
            scope_Connects.push(addConnect(scope_ConnectBase, connectOptions[i + 1]));
        }
    }
    // Initialize a single slider.
    function addSlider(addTarget) {
        // Apply classes and data to the target.
        addClass(addTarget, options.cssClasses.target);
        if (options.dir === 0) {
            addClass(addTarget, options.cssClasses.ltr);
        }
        else {
            addClass(addTarget, options.cssClasses.rtl);
        }
        if (options.ort === 0) {
            addClass(addTarget, options.cssClasses.horizontal);
        }
        else {
            addClass(addTarget, options.cssClasses.vertical);
        }
        var textDirection = getComputedStyle(addTarget).direction;
        if (textDirection === "rtl") {
            addClass(addTarget, options.cssClasses.textDirectionRtl);
        }
        else {
            addClass(addTarget, options.cssClasses.textDirectionLtr);
        }
        return addNodeTo(addTarget, options.cssClasses.base);
    }
    function addTooltip(handle, handleNumber) {
        if (!options.tooltips || !options.tooltips[handleNumber]) {
            return false;
        }
        return addNodeTo(handle.firstChild, options.cssClasses.tooltip);
    }
    function isSliderDisabled() {
        return scope_Target.hasAttribute("disabled");
    }
    // Disable the slider dragging if any handle is disabled
    function isHandleDisabled(handleNumber) {
        var handleOrigin = scope_Handles[handleNumber];
        return handleOrigin.hasAttribute("disabled");
    }
    function disable(handleNumber) {
        if (handleNumber !== null && handleNumber !== undefined) {
            scope_Handles[handleNumber].setAttribute("disabled", "");
            scope_Handles[handleNumber].handle.removeAttribute("tabindex");
        }
        else {
            scope_Target.setAttribute("disabled", "");
            scope_Handles.forEach(function (handle) {
                handle.handle.removeAttribute("tabindex");
            });
        }
    }
    function enable(handleNumber) {
        if (handleNumber !== null && handleNumber !== undefined) {
            scope_Handles[handleNumber].removeAttribute("disabled");
            scope_Handles[handleNumber].handle.setAttribute("tabindex", "0");
        }
        else {
            scope_Target.removeAttribute("disabled");
            scope_Handles.forEach(function (handle) {
                handle.removeAttribute("disabled");
                handle.handle.setAttribute("tabindex", "0");
            });
        }
    }
    function removeTooltips() {
        if (scope_Tooltips) {
            removeEvent("update" + INTERNAL_EVENT_NS.tooltips);
            scope_Tooltips.forEach(function (tooltip) {
                if (tooltip) {
                    removeElement(tooltip);
                }
            });
            scope_Tooltips = null;
        }
    }
    // The tooltips option is a shorthand for using the 'update' event.
    function tooltips() {
        removeTooltips();
        // Tooltips are added with options.tooltips in original order.
        scope_Tooltips = scope_Handles.map(addTooltip);
        bindEvent("update" + INTERNAL_EVENT_NS.tooltips, function (values, handleNumber, unencoded) {
            if (!scope_Tooltips || !options.tooltips) {
                return;
            }
            if (scope_Tooltips[handleNumber] === false) {
                return;
            }
            var formattedValue = values[handleNumber];
            if (options.tooltips[handleNumber] !== true) {
                formattedValue = options.tooltips[handleNumber].to(unencoded[handleNumber]);
            }
            scope_Tooltips[handleNumber].innerHTML = formattedValue;
        });
    }
    function aria() {
        removeEvent("update" + INTERNAL_EVENT_NS.aria);
        bindEvent("update" + INTERNAL_EVENT_NS.aria, function (values, handleNumber, unencoded, tap, positions) {
            // Update Aria Values for all handles, as a change in one changes min and max values for the next.
            scope_HandleNumbers.forEach(function (index) {
                var handle = scope_Handles[index];
                var min = checkHandlePosition(scope_Locations, index, 0, true, true, true);
                var max = checkHandlePosition(scope_Locations, index, 100, true, true, true);
                var now = positions[index];
                // Formatted value for display
                var text = String(options.ariaFormat.to(unencoded[index]));
                // Map to slider range values
                min = scope_Spectrum.fromStepping(min).toFixed(1);
                max = scope_Spectrum.fromStepping(max).toFixed(1);
                now = scope_Spectrum.fromStepping(now).toFixed(1);
                handle.children[0].setAttribute("aria-valuemin", min);
                handle.children[0].setAttribute("aria-valuemax", max);
                handle.children[0].setAttribute("aria-valuenow", now);
                handle.children[0].setAttribute("aria-valuetext", text);
            });
        });
    }
    function getGroup(pips) {
        // Use the range.
        if (pips.mode === PipsMode.Range || pips.mode === PipsMode.Steps) {
            return scope_Spectrum.xVal;
        }
        if (pips.mode === PipsMode.Count) {
            if (pips.values < 2) {
                throw new Error("noUiSlider: 'values' (>= 2) required for mode 'count'.");
            }
            // Divide 0 - 100 in 'count' parts.
            var interval = pips.values - 1;
            var spread = 100 / interval;
            var values = [];
            // List these parts and have them handled as 'positions'.
            while (interval--) {
                values[interval] = interval * spread;
            }
            values.push(100);
            return mapToRange(values, pips.stepped);
        }
        if (pips.mode === PipsMode.Positions) {
            // Map all percentages to on-range values.
            return mapToRange(pips.values, pips.stepped);
        }
        if (pips.mode === PipsMode.Values) {
            // If the value must be stepped, it needs to be converted to a percentage first.
            if (pips.stepped) {
                return pips.values.map(function (value) {
                    // Convert to percentage, apply step, return to value.
                    return scope_Spectrum.fromStepping(scope_Spectrum.getStep(scope_Spectrum.toStepping(value)));
                });
            }
            // Otherwise, we can simply use the values.
            return pips.values;
        }
        return []; // pips.mode = never
    }
    function mapToRange(values, stepped) {
        return values.map(function (value) {
            return scope_Spectrum.fromStepping(stepped ? scope_Spectrum.getStep(value) : value);
        });
    }
    function generateSpread(pips) {
        function safeIncrement(value, increment) {
            // Avoid floating point variance by dropping the smallest decimal places.
            return Number((value + increment).toFixed(7));
        }
        var group = getGroup(pips);
        var indexes = {};
        var firstInRange = scope_Spectrum.xVal[0];
        var lastInRange = scope_Spectrum.xVal[scope_Spectrum.xVal.length - 1];
        var ignoreFirst = false;
        var ignoreLast = false;
        var prevPct = 0;
        // Create a copy of the group, sort it and filter away all duplicates.
        group = unique(group.slice().sort(function (a, b) {
            return a - b;
        }));
        // Make sure the range starts with the first element.
        if (group[0] !== firstInRange) {
            group.unshift(firstInRange);
            ignoreFirst = true;
        }
        // Likewise for the last one.
        if (group[group.length - 1] !== lastInRange) {
            group.push(lastInRange);
            ignoreLast = true;
        }
        group.forEach(function (current, index) {
            // Get the current step and the lower + upper positions.
            var step;
            var i;
            var q;
            var low = current;
            var high = group[index + 1];
            var newPct;
            var pctDifference;
            var pctPos;
            var type;
            var steps;
            var realSteps;
            var stepSize;
            var isSteps = pips.mode === PipsMode.Steps;
            // When using 'steps' mode, use the provided steps.
            // Otherwise, we'll step on to the next subrange.
            if (isSteps) {
                step = scope_Spectrum.xNumSteps[index];
            }
            // Default to a 'full' step.
            if (!step) {
                step = high - low;
            }
            // If high is undefined we are at the last subrange. Make sure it iterates once (#1088)
            if (high === undefined) {
                high = low;
            }
            // Make sure step isn't 0, which would cause an infinite loop (#654)
            step = Math.max(step, 0.0000001);
            // Find all steps in the subrange.
            for (i = low; i <= high; i = safeIncrement(i, step)) {
                // Get the percentage value for the current step,
                // calculate the size for the subrange.
                newPct = scope_Spectrum.toStepping(i);
                pctDifference = newPct - prevPct;
                steps = pctDifference / (pips.density || 1);
                realSteps = Math.round(steps);
                // This ratio represents the amount of percentage-space a point indicates.
                // For a density 1 the points/percentage = 1. For density 2, that percentage needs to be re-divided.
                // Round the percentage offset to an even number, then divide by two
                // to spread the offset on both sides of the range.
                stepSize = pctDifference / realSteps;
                // Divide all points evenly, adding the correct number to this subrange.
                // Run up to <= so that 100% gets a point, event if ignoreLast is set.
                for (q = 1; q <= realSteps; q += 1) {
                    // The ratio between the rounded value and the actual size might be ~1% off.
                    // Correct the percentage offset by the number of points
                    // per subrange. density = 1 will result in 100 points on the
                    // full range, 2 for 50, 4 for 25, etc.
                    pctPos = prevPct + q * stepSize;
                    indexes[pctPos.toFixed(5)] = [scope_Spectrum.fromStepping(pctPos), 0];
                }
                // Determine the point type.
                type = group.indexOf(i) > -1 ? PipsType.LargeValue : isSteps ? PipsType.SmallValue : PipsType.NoValue;
                // Enforce the 'ignoreFirst' option by overwriting the type for 0.
                if (!index && ignoreFirst && i !== high) {
                    type = 0;
                }
                if (!(i === high && ignoreLast)) {
                    // Mark the 'type' of this point. 0 = plain, 1 = real value, 2 = step value.
                    indexes[newPct.toFixed(5)] = [i, type];
                }
                // Update the percentage count.
                prevPct = newPct;
            }
        });
        return indexes;
    }
    function addMarking(spread, filterFunc, formatter) {
        var _a, _b;
        var element = scope_Document.createElement("div");
        var valueSizeClasses = (_a = {},
            _a[PipsType.None] = "",
            _a[PipsType.NoValue] = options.cssClasses.valueNormal,
            _a[PipsType.LargeValue] = options.cssClasses.valueLarge,
            _a[PipsType.SmallValue] = options.cssClasses.valueSub,
            _a);
        var markerSizeClasses = (_b = {},
            _b[PipsType.None] = "",
            _b[PipsType.NoValue] = options.cssClasses.markerNormal,
            _b[PipsType.LargeValue] = options.cssClasses.markerLarge,
            _b[PipsType.SmallValue] = options.cssClasses.markerSub,
            _b);
        var valueOrientationClasses = [options.cssClasses.valueHorizontal, options.cssClasses.valueVertical];
        var markerOrientationClasses = [options.cssClasses.markerHorizontal, options.cssClasses.markerVertical];
        addClass(element, options.cssClasses.pips);
        addClass(element, options.ort === 0 ? options.cssClasses.pipsHorizontal : options.cssClasses.pipsVertical);
        function getClasses(type, source) {
            var a = source === options.cssClasses.value;
            var orientationClasses = a ? valueOrientationClasses : markerOrientationClasses;
            var sizeClasses = a ? valueSizeClasses : markerSizeClasses;
            return source + " " + orientationClasses[options.ort] + " " + sizeClasses[type];
        }
        function addSpread(offset, value, type) {
            // Apply the filter function, if it is set.
            type = filterFunc ? filterFunc(value, type) : type;
            if (type === PipsType.None) {
                return;
            }
            // Add a marker for every point
            var node = addNodeTo(element, false);
            node.className = getClasses(type, options.cssClasses.marker);
            node.style[options.style] = offset + "%";
            // Values are only appended for points marked '1' or '2'.
            if (type > PipsType.NoValue) {
                node = addNodeTo(element, false);
                node.className = getClasses(type, options.cssClasses.value);
                node.setAttribute("data-value", String(value));
                node.style[options.style] = offset + "%";
                node.innerHTML = String(formatter.to(value));
            }
        }
        // Append all points.
        Object.keys(spread).forEach(function (offset) {
            addSpread(offset, spread[offset][0], spread[offset][1]);
        });
        return element;
    }
    function removePips() {
        if (scope_Pips) {
            removeElement(scope_Pips);
            scope_Pips = null;
        }
    }
    function pips(pips) {
        // Fix #669
        removePips();
        var spread = generateSpread(pips);
        var filter = pips.filter;
        var format = pips.format || {
            to: function (value) {
                return String(Math.round(value));
            },
        };
        scope_Pips = scope_Target.appendChild(addMarking(spread, filter, format));
        return scope_Pips;
    }
    // Shorthand for base dimensions.
    function baseSize() {
        var rect = scope_Base.getBoundingClientRect();
        var alt = ("offset" + ["Width", "Height"][options.ort]);
        return options.ort === 0 ? rect.width || scope_Base[alt] : rect.height || scope_Base[alt];
    }
    // Handler for attaching events trough a proxy.
    function attachEvent(events, element, callback, data) {
        // This function can be used to 'filter' events to the slider.
        // element is a node, not a nodeList
        var method = function (event) {
            var e = fixEvent(event, data.pageOffset, data.target || element);
            // fixEvent returns false if this event has a different target
            // when handling (multi-) touch events;
            if (!e) {
                return false;
            }
            // doNotReject is passed by all end events to make sure released touches
            // are not rejected, leaving the slider "stuck" to the cursor;
            if (isSliderDisabled() && !data.doNotReject) {
                return false;
            }
            // Stop if an active 'tap' transition is taking place.
            if (hasClass(scope_Target, options.cssClasses.tap) && !data.doNotReject) {
                return false;
            }
            // Ignore right or middle clicks on start #454
            if (events === actions.start && e.buttons !== undefined && e.buttons > 1) {
                return false;
            }
            // Ignore right or middle clicks on start #454
            if (data.hover && e.buttons) {
                return false;
            }
            // 'supportsPassive' is only true if a browser also supports touch-action: none in CSS.
            // iOS safari does not, so it doesn't get to benefit from passive scrolling. iOS does support
            // touch-action: manipulation, but that allows panning, which breaks
            // sliders after zooming/on non-responsive pages.
            // See: https://bugs.webkit.org/show_bug.cgi?id=133112
            if (!supportsPassive) {
                e.preventDefault();
            }
            e.calcPoint = e.points[options.ort];
            // Call the event handler with the event [ and additional data ].
            callback(e, data);
            return;
        };
        var methods = [];
        // Bind a closure on the target for every event type.
        events.split(" ").forEach(function (eventName) {
            element.addEventListener(eventName, method, supportsPassive ? { passive: true } : false);
            methods.push([eventName, method]);
        });
        return methods;
    }
    // Provide a clean event with standardized offset values.
    function fixEvent(e, pageOffset, eventTarget) {
        // Filter the event to register the type, which can be
        // touch, mouse or pointer. Offset changes need to be
        // made on an event specific basis.
        var touch = e.type.indexOf("touch") === 0;
        var mouse = e.type.indexOf("mouse") === 0;
        var pointer = e.type.indexOf("pointer") === 0;
        var x = 0;
        var y = 0;
        // IE10 implemented pointer events with a prefix;
        if (e.type.indexOf("MSPointer") === 0) {
            pointer = true;
        }
        // Erroneous events seem to be passed in occasionally on iOS/iPadOS after user finishes interacting with
        // the slider. They appear to be of type MouseEvent, yet they don't have usual properties set. Ignore
        // events that have no touches or buttons associated with them. (#1057, #1079, #1095)
        if (e.type === "mousedown" && !e.buttons && !e.touches) {
            return false;
        }
        // The only thing one handle should be concerned about is the touches that originated on top of it.
        if (touch) {
            // Returns true if a touch originated on the target.
            var isTouchOnTarget = function (checkTouch) {
                var target = checkTouch.target;
                return (target === eventTarget ||
                    eventTarget.contains(target) ||
                    (e.composed && e.composedPath().shift() === eventTarget));
            };
            // In the case of touchstart events, we need to make sure there is still no more than one
            // touch on the target so we look amongst all touches.
            if (e.type === "touchstart") {
                var targetTouches = Array.prototype.filter.call(e.touches, isTouchOnTarget);
                // Do not support more than one touch per handle.
                if (targetTouches.length > 1) {
                    return false;
                }
                x = targetTouches[0].pageX;
                y = targetTouches[0].pageY;
            }
            else {
                // In the other cases, find on changedTouches is enough.
                var targetTouch = Array.prototype.find.call(e.changedTouches, isTouchOnTarget);
                // Cancel if the target touch has not moved.
                if (!targetTouch) {
                    return false;
                }
                x = targetTouch.pageX;
                y = targetTouch.pageY;
            }
        }
        pageOffset = pageOffset || getPageOffset(scope_Document);
        if (mouse || pointer) {
            x = e.clientX + pageOffset.x;
            y = e.clientY + pageOffset.y;
        }
        e.pageOffset = pageOffset;
        e.points = [x, y];
        e.cursor = mouse || pointer; // Fix #435
        return e;
    }
    // Translate a coordinate in the document to a percentage on the slider
    function calcPointToPercentage(calcPoint) {
        var location = calcPoint - offset(scope_Base, options.ort);
        var proposal = (location * 100) / baseSize();
        // Clamp proposal between 0% and 100%
        // Out-of-bound coordinates may occur when .noUi-base pseudo-elements
        // are used (e.g. contained handles feature)
        proposal = limit(proposal);
        return options.dir ? 100 - proposal : proposal;
    }
    // Find handle closest to a certain percentage on the slider
    function getClosestHandle(clickedPosition) {
        var smallestDifference = 100;
        var handleNumber = false;
        scope_Handles.forEach(function (handle, index) {
            // Disabled handles are ignored
            if (isHandleDisabled(index)) {
                return;
            }
            var handlePosition = scope_Locations[index];
            var differenceWithThisHandle = Math.abs(handlePosition - clickedPosition);
            // Initial state
            var clickAtEdge = differenceWithThisHandle === 100 && smallestDifference === 100;
            // Difference with this handle is smaller than the previously checked handle
            var isCloser = differenceWithThisHandle < smallestDifference;
            var isCloserAfter = differenceWithThisHandle <= smallestDifference && clickedPosition > handlePosition;
            if (isCloser || isCloserAfter || clickAtEdge) {
                handleNumber = index;
                smallestDifference = differenceWithThisHandle;
            }
        });
        return handleNumber;
    }
    // Fire 'end' when a mouse or pen leaves the document.
    function documentLeave(event, data) {
        if (event.type === "mouseout" &&
            event.target.nodeName === "HTML" &&
            event.relatedTarget === null) {
            eventEnd(event, data);
        }
    }
    // Handle movement on document for handle and range drag.
    function eventMove(event, data) {
        // Fix #498
        // Check value of .buttons in 'start' to work around a bug in IE10 mobile (data.buttonsProperty).
        // https://connect.microsoft.com/IE/feedback/details/927005/mobile-ie10-windows-phone-buttons-property-of-pointermove-event-always-zero
        // IE9 has .buttons and .which zero on mousemove.
        // Firefox breaks the spec MDN defines.
        if (navigator.appVersion.indexOf("MSIE 9") === -1 && event.buttons === 0 && data.buttonsProperty !== 0) {
            return eventEnd(event, data);
        }
        // Check if we are moving up or down
        var movement = (options.dir ? -1 : 1) * (event.calcPoint - data.startCalcPoint);
        // Convert the movement into a percentage of the slider width/height
        var proposal = (movement * 100) / data.baseSize;
        moveHandles(movement > 0, proposal, data.locations, data.handleNumbers, data.connect);
    }
    // Unbind move events on document, call callbacks.
    function eventEnd(event, data) {
        // The handle is no longer active, so remove the class.
        if (data.handle) {
            removeClass(data.handle, options.cssClasses.active);
            scope_ActiveHandlesCount -= 1;
        }
        // Unbind the move and end events, which are added on 'start'.
        data.listeners.forEach(function (c) {
            scope_DocumentElement.removeEventListener(c[0], c[1]);
        });
        if (scope_ActiveHandlesCount === 0) {
            // Remove dragging class.
            removeClass(scope_Target, options.cssClasses.drag);
            setZindex();
            // Remove cursor styles and text-selection events bound to the body.
            if (event.cursor) {
                scope_Body.style.cursor = "";
                scope_Body.removeEventListener("selectstart", preventDefault);
            }
        }
        if (options.events.smoothSteps) {
            data.handleNumbers.forEach(function (handleNumber) {
                setHandle(handleNumber, scope_Locations[handleNumber], true, true, false, false);
            });
            data.handleNumbers.forEach(function (handleNumber) {
                fireEvent("update", handleNumber);
            });
        }
        data.handleNumbers.forEach(function (handleNumber) {
            fireEvent("change", handleNumber);
            fireEvent("set", handleNumber);
            fireEvent("end", handleNumber);
        });
    }
    // Bind move events on document.
    function eventStart(event, data) {
        // Ignore event if any handle is disabled
        if (data.handleNumbers.some(isHandleDisabled)) {
            return;
        }
        var handle;
        if (data.handleNumbers.length === 1) {
            var handleOrigin = scope_Handles[data.handleNumbers[0]];
            handle = handleOrigin.children[0];
            scope_ActiveHandlesCount += 1;
            // Mark the handle as 'active' so it can be styled.
            addClass(handle, options.cssClasses.active);
        }
        // A drag should never propagate up to the 'tap' event.
        event.stopPropagation();
        // Record the event listeners.
        var listeners = [];
        // Attach the move and end events.
        var moveEvent = attachEvent(actions.move, scope_DocumentElement, eventMove, {
            // The event target has changed so we need to propagate the original one so that we keep
            // relying on it to extract target touches.
            target: event.target,
            handle: handle,
            connect: data.connect,
            listeners: listeners,
            startCalcPoint: event.calcPoint,
            baseSize: baseSize(),
            pageOffset: event.pageOffset,
            handleNumbers: data.handleNumbers,
            buttonsProperty: event.buttons,
            locations: scope_Locations.slice(),
        });
        var endEvent = attachEvent(actions.end, scope_DocumentElement, eventEnd, {
            target: event.target,
            handle: handle,
            listeners: listeners,
            doNotReject: true,
            handleNumbers: data.handleNumbers,
        });
        var outEvent = attachEvent("mouseout", scope_DocumentElement, documentLeave, {
            target: event.target,
            handle: handle,
            listeners: listeners,
            doNotReject: true,
            handleNumbers: data.handleNumbers,
        });
        // We want to make sure we pushed the listeners in the listener list rather than creating
        // a new one as it has already been passed to the event handlers.
        listeners.push.apply(listeners, moveEvent.concat(endEvent, outEvent));
        // Text selection isn't an issue on touch devices,
        // so adding cursor styles can be skipped.
        if (event.cursor) {
            // Prevent the 'I' cursor and extend the range-drag cursor.
            scope_Body.style.cursor = getComputedStyle(event.target).cursor;
            // Mark the target with a dragging state.
            if (scope_Handles.length > 1) {
                addClass(scope_Target, options.cssClasses.drag);
            }
            // Prevent text selection when dragging the handles.
            // In noUiSlider <= 9.2.0, this was handled by calling preventDefault on mouse/touch start/move,
            // which is scroll blocking. The selectstart event is supported by FireFox starting from version 52,
            // meaning the only holdout is iOS Safari. This doesn't matter: text selection isn't triggered there.
            // The 'cursor' flag is false.
            // See: http://caniuse.com/#search=selectstart
            scope_Body.addEventListener("selectstart", preventDefault, false);
        }
        data.handleNumbers.forEach(function (handleNumber) {
            fireEvent("start", handleNumber);
        });
    }
    // Move closest handle to tapped location.
    function eventTap(event) {
        // The tap event shouldn't propagate up
        event.stopPropagation();
        var proposal = calcPointToPercentage(event.calcPoint);
        var handleNumber = getClosestHandle(proposal);
        // Tackle the case that all handles are 'disabled'.
        if (handleNumber === false) {
            return;
        }
        // Flag the slider as it is now in a transitional state.
        // Transition takes a configurable amount of ms (default 300). Re-enable the slider after that.
        if (!options.events.snap) {
            addClassFor(scope_Target, options.cssClasses.tap, options.animationDuration);
        }
        setHandle(handleNumber, proposal, true, true);
        setZindex();
        fireEvent("slide", handleNumber, true);
        fireEvent("update", handleNumber, true);
        if (!options.events.snap) {
            fireEvent("change", handleNumber, true);
            fireEvent("set", handleNumber, true);
        }
        else {
            eventStart(event, { handleNumbers: [handleNumber] });
        }
    }
    // Fires a 'hover' event for a hovered mouse/pen position.
    function eventHover(event) {
        var proposal = calcPointToPercentage(event.calcPoint);
        var to = scope_Spectrum.getStep(proposal);
        var value = scope_Spectrum.fromStepping(to);
        Object.keys(scope_Events).forEach(function (targetEvent) {
            if ("hover" === targetEvent.split(".")[0]) {
                scope_Events[targetEvent].forEach(function (callback) {
                    callback.call(scope_Self, value);
                });
            }
        });
    }
    // Handles keydown on focused handles
    // Don't move the document when pressing arrow keys on focused handles
    function eventKeydown(event, handleNumber) {
        if (isSliderDisabled() || isHandleDisabled(handleNumber)) {
            return false;
        }
        var horizontalKeys = ["Left", "Right"];
        var verticalKeys = ["Down", "Up"];
        var largeStepKeys = ["PageDown", "PageUp"];
        var edgeKeys = ["Home", "End"];
        if (options.dir && !options.ort) {
            // On an right-to-left slider, the left and right keys act inverted
            horizontalKeys.reverse();
        }
        else if (options.ort && !options.dir) {
            // On a top-to-bottom slider, the up and down keys act inverted
            verticalKeys.reverse();
            largeStepKeys.reverse();
        }
        // Strip "Arrow" for IE compatibility. https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
        var key = event.key.replace("Arrow", "");
        var isLargeDown = key === largeStepKeys[0];
        var isLargeUp = key === largeStepKeys[1];
        var isDown = key === verticalKeys[0] || key === horizontalKeys[0] || isLargeDown;
        var isUp = key === verticalKeys[1] || key === horizontalKeys[1] || isLargeUp;
        var isMin = key === edgeKeys[0];
        var isMax = key === edgeKeys[1];
        if (!isDown && !isUp && !isMin && !isMax) {
            return true;
        }
        event.preventDefault();
        var to;
        if (isUp || isDown) {
            var direction = isDown ? 0 : 1;
            var steps = getNextStepsForHandle(handleNumber);
            var step = steps[direction];
            // At the edge of a slider, do nothing
            if (step === null) {
                return false;
            }
            // No step set, use the default of 10% of the sub-range
            if (step === false) {
                step = scope_Spectrum.getDefaultStep(scope_Locations[handleNumber], isDown, options.keyboardDefaultStep);
            }
            if (isLargeUp || isLargeDown) {
                step *= options.keyboardPageMultiplier;
            }
            else {
                step *= options.keyboardMultiplier;
            }
            // Step over zero-length ranges (#948);
            step = Math.max(step, 0.0000001);
            // Decrement for down steps
            step = (isDown ? -1 : 1) * step;
            to = scope_Values[handleNumber] + step;
        }
        else if (isMax) {
            // End key
            to = options.spectrum.xVal[options.spectrum.xVal.length - 1];
        }
        else {
            // Home key
            to = options.spectrum.xVal[0];
        }
        setHandle(handleNumber, scope_Spectrum.toStepping(to), true, true);
        fireEvent("slide", handleNumber);
        fireEvent("update", handleNumber);
        fireEvent("change", handleNumber);
        fireEvent("set", handleNumber);
        return false;
    }
    // Attach events to several slider parts.
    function bindSliderEvents(behaviour) {
        // Attach the standard drag event to the handles.
        if (!behaviour.fixed) {
            scope_Handles.forEach(function (handle, index) {
                // These events are only bound to the visual handle
                // element, not the 'real' origin element.
                attachEvent(actions.start, handle.children[0], eventStart, {
                    handleNumbers: [index],
                });
            });
        }
        // Attach the tap event to the slider base.
        if (behaviour.tap) {
            attachEvent(actions.start, scope_Base, eventTap, {});
        }
        // Fire hover events
        if (behaviour.hover) {
            attachEvent(actions.move, scope_Base, eventHover, {
                hover: true,
            });
        }
        // Make the range draggable.
        if (behaviour.drag) {
            scope_Connects.forEach(function (connect, index) {
                if (connect === false || index === 0 || index === scope_Connects.length - 1) {
                    return;
                }
                var handleBefore = scope_Handles[index - 1];
                var handleAfter = scope_Handles[index];
                var eventHolders = [connect];
                var handlesToDrag = [handleBefore, handleAfter];
                var handleNumbersToDrag = [index - 1, index];
                addClass(connect, options.cssClasses.draggable);
                // When the range is fixed, the entire range can
                // be dragged by the handles. The handle in the first
                // origin will propagate the start event upward,
                // but it needs to be bound manually on the other.
                if (behaviour.fixed) {
                    eventHolders.push(handleBefore.children[0]);
                    eventHolders.push(handleAfter.children[0]);
                }
                if (behaviour.dragAll) {
                    handlesToDrag = scope_Handles;
                    handleNumbersToDrag = scope_HandleNumbers;
                }
                eventHolders.forEach(function (eventHolder) {
                    attachEvent(actions.start, eventHolder, eventStart, {
                        handles: handlesToDrag,
                        handleNumbers: handleNumbersToDrag,
                        connect: connect,
                    });
                });
            });
        }
    }
    // Attach an event to this slider, possibly including a namespace
    function bindEvent(namespacedEvent, callback) {
        scope_Events[namespacedEvent] = scope_Events[namespacedEvent] || [];
        scope_Events[namespacedEvent].push(callback);
        // If the event bound is 'update,' fire it immediately for all handles.
        if (namespacedEvent.split(".")[0] === "update") {
            scope_Handles.forEach(function (a, index) {
                fireEvent("update", index);
            });
        }
    }
    function isInternalNamespace(namespace) {
        return namespace === INTERNAL_EVENT_NS.aria || namespace === INTERNAL_EVENT_NS.tooltips;
    }
    // Undo attachment of event
    function removeEvent(namespacedEvent) {
        var event = namespacedEvent && namespacedEvent.split(".")[0];
        var namespace = event ? namespacedEvent.substring(event.length) : namespacedEvent;
        Object.keys(scope_Events).forEach(function (bind) {
            var tEvent = bind.split(".")[0];
            var tNamespace = bind.substring(tEvent.length);
            if ((!event || event === tEvent) && (!namespace || namespace === tNamespace)) {
                // only delete protected internal event if intentional
                if (!isInternalNamespace(tNamespace) || namespace === tNamespace) {
                    delete scope_Events[bind];
                }
            }
        });
    }
    // External event handling
    function fireEvent(eventName, handleNumber, tap) {
        Object.keys(scope_Events).forEach(function (targetEvent) {
            var eventType = targetEvent.split(".")[0];
            if (eventName === eventType) {
                scope_Events[targetEvent].forEach(function (callback) {
                    callback.call(
                    // Use the slider public API as the scope ('this')
                    scope_Self, 
                    // Return values as array, so arg_1[arg_2] is always valid.
                    scope_Values.map(options.format.to), 
                    // Handle index, 0 or 1
                    handleNumber, 
                    // Un-formatted slider values
                    scope_Values.slice(), 
                    // Event is fired by tap, true or false
                    tap || false, 
                    // Left offset of the handle, in relation to the slider
                    scope_Locations.slice(), 
                    // add the slider public API to an accessible parameter when this is unavailable
                    scope_Self);
                });
            }
        });
    }
    // Split out the handle positioning logic so the Move event can use it, too
    function checkHandlePosition(reference, handleNumber, to, lookBackward, lookForward, getValue, smoothSteps) {
        var distance;
        // For sliders with multiple handles, limit movement to the other handle.
        // Apply the margin option by adding it to the handle positions.
        if (scope_Handles.length > 1 && !options.events.unconstrained) {
            if (lookBackward && handleNumber > 0) {
                distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber - 1], options.margin, false);
                to = Math.max(to, distance);
            }
            if (lookForward && handleNumber < scope_Handles.length - 1) {
                distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber + 1], options.margin, true);
                to = Math.min(to, distance);
            }
        }
        // The limit option has the opposite effect, limiting handles to a
        // maximum distance from another. Limit must be > 0, as otherwise
        // handles would be unmovable.
        if (scope_Handles.length > 1 && options.limit) {
            if (lookBackward && handleNumber > 0) {
                distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber - 1], options.limit, false);
                to = Math.min(to, distance);
            }
            if (lookForward && handleNumber < scope_Handles.length - 1) {
                distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber + 1], options.limit, true);
                to = Math.max(to, distance);
            }
        }
        // The padding option keeps the handles a certain distance from the
        // edges of the slider. Padding must be > 0.
        if (options.padding) {
            if (handleNumber === 0) {
                distance = scope_Spectrum.getAbsoluteDistance(0, options.padding[0], false);
                to = Math.max(to, distance);
            }
            if (handleNumber === scope_Handles.length - 1) {
                distance = scope_Spectrum.getAbsoluteDistance(100, options.padding[1], true);
                to = Math.min(to, distance);
            }
        }
        if (!smoothSteps) {
            to = scope_Spectrum.getStep(to);
        }
        // Limit percentage to the 0 - 100 range
        to = limit(to);
        // Return false if handle can't move
        if (to === reference[handleNumber] && !getValue) {
            return false;
        }
        return to;
    }
    // Uses slider orientation to create CSS rules. a = base value;
    function inRuleOrder(v, a) {
        var o = options.ort;
        return (o ? a : v) + ", " + (o ? v : a);
    }
    // Moves handle(s) by a percentage
    // (bool, % to move, [% where handle started, ...], [index in scope_Handles, ...])
    function moveHandles(upward, proposal, locations, handleNumbers, connect) {
        var proposals = locations.slice();
        // Store first handle now, so we still have it in case handleNumbers is reversed
        var firstHandle = handleNumbers[0];
        var smoothSteps = options.events.smoothSteps;
        var b = [!upward, upward];
        var f = [upward, !upward];
        // Copy handleNumbers so we don't change the dataset
        handleNumbers = handleNumbers.slice();
        // Check to see which handle is 'leading'.
        // If that one can't move the second can't either.
        if (upward) {
            handleNumbers.reverse();
        }
        // Step 1: get the maximum percentage that any of the handles can move
        if (handleNumbers.length > 1) {
            handleNumbers.forEach(function (handleNumber, o) {
                var to = checkHandlePosition(proposals, handleNumber, proposals[handleNumber] + proposal, b[o], f[o], false, smoothSteps);
                // Stop if one of the handles can't move.
                if (to === false) {
                    proposal = 0;
                }
                else {
                    proposal = to - proposals[handleNumber];
                    proposals[handleNumber] = to;
                }
            });
        }
        // If using one handle, check backward AND forward
        else {
            b = f = [true];
        }
        var state = false;
        // Step 2: Try to set the handles with the found percentage
        handleNumbers.forEach(function (handleNumber, o) {
            state =
                setHandle(handleNumber, locations[handleNumber] + proposal, b[o], f[o], false, smoothSteps) || state;
        });
        // Step 3: If a handle moved, fire events
        if (state) {
            handleNumbers.forEach(function (handleNumber) {
                fireEvent("update", handleNumber);
                fireEvent("slide", handleNumber);
            });
            // If target is a connect, then fire drag event
            if (connect != undefined) {
                fireEvent("drag", firstHandle);
            }
        }
    }
    // Takes a base value and an offset. This offset is used for the connect bar size.
    // In the initial design for this feature, the origin element was 1% wide.
    // Unfortunately, a rounding bug in Chrome makes it impossible to implement this feature
    // in this manner: https://bugs.chromium.org/p/chromium/issues/detail?id=798223
    function transformDirection(a, b) {
        return options.dir ? 100 - a - b : a;
    }
    // Updates scope_Locations and scope_Values, updates visual state
    function updateHandlePosition(handleNumber, to) {
        // Update locations.
        scope_Locations[handleNumber] = to;
        // Convert the value to the slider stepping/range.
        scope_Values[handleNumber] = scope_Spectrum.fromStepping(to);
        var translation = transformDirection(to, 0) - scope_DirOffset;
        var translateRule = "translate(" + inRuleOrder(translation + "%", "0") + ")";
        scope_Handles[handleNumber].style[options.transformRule] = translateRule;
        // sanity check for at least 2 handles (e.g. during setup)
        if (options.events.invertConnects && scope_Locations.length > 1) {
            // check if handles passed each other, but don't match the ConnectsInverted state
            var handlesAreInOrder = scope_Locations.every(function (position, index, locations) {
                return index === 0 || position >= locations[index - 1];
            });
            if (scope_ConnectsInverted !== !handlesAreInOrder) {
                // invert connects when handles pass each other
                invertConnects();
                // invertConnects already updates all connect elements
                return;
            }
        }
        updateConnect(handleNumber);
        updateConnect(handleNumber + 1);
        if (scope_ConnectsInverted) {
            // When connects are inverted, we also have to update adjacent connects
            updateConnect(handleNumber - 1);
            updateConnect(handleNumber + 2);
        }
    }
    // Handles before the slider middle are stacked later = higher,
    // Handles after the middle later is lower
    // [[7] [8] .......... | .......... [5] [4]
    function setZindex() {
        scope_HandleNumbers.forEach(function (handleNumber) {
            var dir = scope_Locations[handleNumber] > 50 ? -1 : 1;
            var zIndex = 3 + (scope_Handles.length + dir * handleNumber);
            scope_Handles[handleNumber].style.zIndex = String(zIndex);
        });
    }
    // Test suggested values and apply margin, step.
    // if exactInput is true, don't run checkHandlePosition, then the handle can be placed in between steps (#436)
    function setHandle(handleNumber, to, lookBackward, lookForward, exactInput, smoothSteps) {
        if (!exactInput) {
            to = checkHandlePosition(scope_Locations, handleNumber, to, lookBackward, lookForward, false, smoothSteps);
        }
        if (to === false) {
            return false;
        }
        updateHandlePosition(handleNumber, to);
        return true;
    }
    // Updates style attribute for connect nodes
    function updateConnect(index) {
        // Skip connects set to false
        if (!scope_Connects[index]) {
            return;
        }
        // Create a copy of locations, so we can sort them for the local scope logic
        var locations = scope_Locations.slice();
        if (scope_ConnectsInverted) {
            locations.sort(function (a, b) {
                return a - b;
            });
        }
        var l = 0;
        var h = 100;
        if (index !== 0) {
            l = locations[index - 1];
        }
        if (index !== scope_Connects.length - 1) {
            h = locations[index];
        }
        // We use two rules:
        // 'translate' to change the left/top offset;
        // 'scale' to change the width of the element;
        // As the element has a width of 100%, a translation of 100% is equal to 100% of the parent (.noUi-base)
        var connectWidth = h - l;
        var translateRule = "translate(" + inRuleOrder(transformDirection(l, connectWidth) + "%", "0") + ")";
        var scaleRule = "scale(" + inRuleOrder(connectWidth / 100, "1") + ")";
        scope_Connects[index].style[options.transformRule] =
            translateRule + " " + scaleRule;
    }
    // Parses value passed to .set method. Returns current value if not parse-able.
    function resolveToValue(to, handleNumber) {
        // Setting with null indicates an 'ignore'.
        // Inputting 'false' is invalid.
        if (to === null || to === false || to === undefined) {
            return scope_Locations[handleNumber];
        }
        // If a formatted number was passed, attempt to decode it.
        if (typeof to === "number") {
            to = String(to);
        }
        to = options.format.from(to);
        if (to !== false) {
            to = scope_Spectrum.toStepping(to);
        }
        // If parsing the number failed, use the current value.
        if (to === false || isNaN(to)) {
            return scope_Locations[handleNumber];
        }
        return to;
    }
    // Set the slider value.
    function valueSet(input, fireSetEvent, exactInput) {
        var values = asArray(input);
        var isInit = scope_Locations[0] === undefined;
        // Event fires by default
        fireSetEvent = fireSetEvent === undefined ? true : fireSetEvent;
        // Animation is optional.
        // Make sure the initial values were set before using animated placement.
        if (options.animate && !isInit) {
            addClassFor(scope_Target, options.cssClasses.tap, options.animationDuration);
        }
        // First pass, without lookAhead but with lookBackward. Values are set from left to right.
        scope_HandleNumbers.forEach(function (handleNumber) {
            setHandle(handleNumber, resolveToValue(values[handleNumber], handleNumber), true, false, exactInput);
        });
        var i = scope_HandleNumbers.length === 1 ? 0 : 1;
        // Spread handles evenly across the slider if the range has no size (min=max)
        if (isInit && scope_Spectrum.hasNoSize()) {
            exactInput = true;
            scope_Locations[0] = 0;
            if (scope_HandleNumbers.length > 1) {
                var space_1 = 100 / (scope_HandleNumbers.length - 1);
                scope_HandleNumbers.forEach(function (handleNumber) {
                    scope_Locations[handleNumber] = handleNumber * space_1;
                });
            }
        }
        // Secondary passes. Now that all base values are set, apply constraints.
        // Iterate all handles to ensure constraints are applied for the entire slider (Issue #1009)
        for (; i < scope_HandleNumbers.length; ++i) {
            scope_HandleNumbers.forEach(function (handleNumber) {
                setHandle(handleNumber, scope_Locations[handleNumber], true, true, exactInput);
            });
        }
        setZindex();
        scope_HandleNumbers.forEach(function (handleNumber) {
            fireEvent("update", handleNumber);
            // Fire the event only for handles that received a new value, as per #579
            if (values[handleNumber] !== null && fireSetEvent) {
                fireEvent("set", handleNumber);
            }
        });
    }
    // Reset slider to initial values
    function valueReset(fireSetEvent) {
        valueSet(options.start, fireSetEvent);
    }
    // Set value for a single handle
    function valueSetHandle(handleNumber, value, fireSetEvent, exactInput) {
        // Ensure numeric input
        handleNumber = Number(handleNumber);
        if (!(handleNumber >= 0 && handleNumber < scope_HandleNumbers.length)) {
            throw new Error("noUiSlider: invalid handle number, got: " + handleNumber);
        }
        // Look both backward and forward, since we don't want this handle to "push" other handles (#960);
        // The exactInput argument can be used to ignore slider stepping (#436)
        setHandle(handleNumber, resolveToValue(value, handleNumber), true, true, exactInput);
        fireEvent("update", handleNumber);
        if (fireSetEvent) {
            fireEvent("set", handleNumber);
        }
    }
    // Get the slider value.
    function valueGet(unencoded) {
        if (unencoded === void 0) { unencoded = false; }
        if (unencoded) {
            // return a copy of the raw values
            return scope_Values.length === 1 ? scope_Values[0] : scope_Values.slice(0);
        }
        var values = scope_Values.map(options.format.to);
        // If only one handle is used, return a single value.
        if (values.length === 1) {
            return values[0];
        }
        return values;
    }
    // Removes classes from the root and empties it.
    function destroy() {
        // remove protected internal listeners
        removeEvent(INTERNAL_EVENT_NS.aria);
        removeEvent(INTERNAL_EVENT_NS.tooltips);
        Object.keys(options.cssClasses).forEach(function (key) {
            removeClass(scope_Target, options.cssClasses[key]);
        });
        while (scope_Target.firstChild) {
            scope_Target.removeChild(scope_Target.firstChild);
        }
        delete scope_Target.noUiSlider;
    }
    function getNextStepsForHandle(handleNumber) {
        var location = scope_Locations[handleNumber];
        var nearbySteps = scope_Spectrum.getNearbySteps(location);
        var value = scope_Values[handleNumber];
        var increment = nearbySteps.thisStep.step;
        var decrement = null;
        // If snapped, directly use defined step value
        if (options.snap) {
            return [
                value - nearbySteps.stepBefore.startValue || null,
                nearbySteps.stepAfter.startValue - value || null,
            ];
        }
        // If the next value in this step moves into the next step,
        // the increment is the start of the next step - the current value
        if (increment !== false) {
            if (value + increment > nearbySteps.stepAfter.startValue) {
                increment = nearbySteps.stepAfter.startValue - value;
            }
        }
        // If the value is beyond the starting point
        if (value > nearbySteps.thisStep.startValue) {
            decrement = nearbySteps.thisStep.step;
        }
        else if (nearbySteps.stepBefore.step === false) {
            decrement = false;
        }
        // If a handle is at the start of a step, it always steps back into the previous step first
        else {
            decrement = value - nearbySteps.stepBefore.highestStep;
        }
        // Now, if at the slider edges, there is no in/decrement
        if (location === 100) {
            increment = null;
        }
        else if (location === 0) {
            decrement = null;
        }
        // As per #391, the comparison for the decrement step can have some rounding issues.
        var stepDecimals = scope_Spectrum.countStepDecimals();
        // Round per #391
        if (increment !== null && increment !== false) {
            increment = Number(increment.toFixed(stepDecimals));
        }
        if (decrement !== null && decrement !== false) {
            decrement = Number(decrement.toFixed(stepDecimals));
        }
        return [decrement, increment];
    }
    // Get the current step size for the slider.
    function getNextSteps() {
        return scope_HandleNumbers.map(getNextStepsForHandle);
    }
    // Updatable: margin, limit, padding, step, range, animate, snap
    function updateOptions(optionsToUpdate, fireSetEvent) {
        // Spectrum is created using the range, snap, direction and step options.
        // 'snap' and 'step' can be updated.
        // If 'snap' and 'step' are not passed, they should remain unchanged.
        var v = valueGet();
        var updateAble = [
            "margin",
            "limit",
            "padding",
            "range",
            "animate",
            "snap",
            "step",
            "format",
            "pips",
            "tooltips",
            "connect",
        ];
        // Only change options that we're actually passed to update.
        updateAble.forEach(function (name) {
            // Check for undefined. null removes the value.
            if (optionsToUpdate[name] !== undefined) {
                originalOptions[name] = optionsToUpdate[name];
            }
        });
        var newOptions = testOptions(originalOptions);
        // Load new options into the slider state
        updateAble.forEach(function (name) {
            if (optionsToUpdate[name] !== undefined) {
                options[name] = newOptions[name];
            }
        });
        scope_Spectrum = newOptions.spectrum;
        // Limit, margin and padding depend on the spectrum but are stored outside of it. (#677)
        options.margin = newOptions.margin;
        options.limit = newOptions.limit;
        options.padding = newOptions.padding;
        // Update pips, removes existing.
        if (options.pips) {
            pips(options.pips);
        }
        else {
            removePips();
        }
        // Update tooltips, removes existing.
        if (options.tooltips) {
            tooltips();
        }
        else {
            removeTooltips();
        }
        // Invalidate the current positioning so valueSet forces an update.
        scope_Locations = [];
        valueSet(isSet(optionsToUpdate.start) ? optionsToUpdate.start : v, fireSetEvent);
        // Update connects only if it was set
        if (optionsToUpdate.connect) {
            updateConnectOption();
        }
    }
    function updateConnectOption() {
        // IE supported way of removing children including event handlers
        while (scope_ConnectBase.firstChild) {
            scope_ConnectBase.removeChild(scope_ConnectBase.firstChild);
        }
        // Adding new connects according to the new connect options
        for (var i = 0; i <= options.handles; i++) {
            scope_Connects[i] = addConnect(scope_ConnectBase, options.connect[i]);
            updateConnect(i);
        }
        // re-adding drag events for the new connect elements
        // to ignore the other events we have to negate the 'if (!behaviour.fixed)' check
        bindSliderEvents({ drag: options.events.drag, fixed: true });
    }
    // Invert options for connect handles
    function invertConnects() {
        scope_ConnectsInverted = !scope_ConnectsInverted;
        testConnect(options, 
        // inverse the connect boolean array
        options.connect.map(function (b) { return !b; }));
        updateConnectOption();
    }
    // Initialization steps
    function setupSlider() {
        // Create the base element, initialize HTML and set classes.
        // Add handles and connect elements.
        scope_Base = addSlider(scope_Target);
        addElements(options.connect, scope_Base);
        // Attach user events.
        bindSliderEvents(options.events);
        // Use the public value method to set the start values.
        valueSet(options.start);
        if (options.pips) {
            pips(options.pips);
        }
        if (options.tooltips) {
            tooltips();
        }
        aria();
    }
    setupSlider();
    var scope_Self = {
        destroy: destroy,
        steps: getNextSteps,
        on: bindEvent,
        off: removeEvent,
        get: valueGet,
        set: valueSet,
        setHandle: valueSetHandle,
        reset: valueReset,
        disable: disable,
        enable: enable,
        // Exposed for unit testing, don't use this in your application.
        __moveHandles: function (upward, proposal, handleNumbers) {
            moveHandles(upward, proposal, scope_Locations, handleNumbers);
        },
        options: originalOptions,
        updateOptions: updateOptions,
        target: scope_Target,
        removePips: removePips,
        removeTooltips: removeTooltips,
        getPositions: function () {
            return scope_Locations.slice();
        },
        getTooltips: function () {
            return scope_Tooltips;
        },
        getOrigins: function () {
            return scope_Handles;
        },
        pips: pips, // Issue #594
    };
    return scope_Self;
}
// Run the standard initializer
function initialize(target, originalOptions) {
    if (!target || !target.nodeName) {
        throw new Error("noUiSlider: create requires a single element, got: " + target);
    }
    // Throw an error if the slider was already initialized.
    if (target.noUiSlider) {
        throw new Error("noUiSlider: Slider was already initialized.");
    }
    // Test the options and create the slider environment;
    var options = testOptions(originalOptions);
    var api = scope(target, options, originalOptions);
    target.noUiSlider = api;
    return api;
}


/* harmony default export */ __webpack_exports__["default"] = ({
    // Exposed for unit testing, don't use this in your application.
    __spectrum: Spectrum,
    // A reference to the default classes, allows global changes.
    // Use the cssClasses option for changes to one slider.
    cssClasses: cssClasses,
    create: initialize,
});


/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/a11y.mjs":
/*!*******************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/a11y.mjs ***!
  \*******************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ A11y; }
/* harmony export */ });
/* harmony import */ var _shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/classes-to-selector.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/classes-to-selector.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs");



const isVirtualEnabled = (swiper) => !!swiper.virtual && !!swiper.params.virtual?.enabled;
const A11y = ({ swiper, extendParams, on }) => {
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            containerRole: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group',
            id: null,
            scrollOnFocus: true,
            wrapperLiveRegion: true,
        },
    });
    swiper.a11y = {
        clicked: false,
    };
    let liveRegion = null;
    let preventFocusHandler = false;
    let focusTargetSlideEl;
    let visibilityChangedTimestamp = new Date().getTime();
    function getParams() {
        return swiper.params.a11y;
    }
    function notify(message) {
        const notification = liveRegion;
        if (!notification || !message)
            return;
        (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.w)(notification, message);
    }
    function getRandomNumber(size = 16) {
        const randomChar = () => Math.round(16 * Math.random()).toString(16);
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        const els = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(el);
        els.forEach((subEl) => {
            subEl.setAttribute('tabIndex', '0');
        });
    }
    function makeElNotFocusable(el) {
        const els = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(el);
        els.forEach((subEl) => {
            subEl.setAttribute('tabIndex', '-1');
        });
    }
    function addElRole(el, role) {
        const els = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(el);
        els.forEach((subEl) => {
            subEl.setAttribute('role', role);
        });
    }
    function addElRoleDescription(el, description) {
        const els = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(el);
        els.forEach((subEl) => {
            subEl.setAttribute('aria-roledescription', description);
        });
    }
    function addElLabel(el, label) {
        const els = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(el);
        els.forEach((subEl) => {
            subEl.setAttribute('aria-label', label);
        });
    }
    function addElId(el, id) {
        const els = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(el);
        els.forEach((subEl) => {
            subEl.setAttribute('id', id);
        });
    }
    function addElLive(el, live) {
        const els = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(el);
        els.forEach((subEl) => {
            subEl.setAttribute('aria-live', live);
        });
    }
    function disableEl(el) {
        const els = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(el);
        els.forEach((subEl) => {
            subEl.setAttribute('aria-disabled', 'true');
        });
    }
    function enableEl(el) {
        const els = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(el);
        els.forEach((subEl) => {
            subEl.removeAttribute('aria-disabled');
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32)
            return;
        const params = getParams();
        const paginationParams = swiper.params.pagination;
        const targetEl = e.target;
        if (swiper.pagination &&
            swiper.pagination.el &&
            (targetEl === swiper.pagination.el || swiper.pagination.el.contains(targetEl))) {
            if (!targetEl.matches((0,_shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(paginationParams?.bulletClass)))
                return;
        }
        if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
            const prevEls = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(swiper.navigation.prevEl);
            const nextEls = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(swiper.navigation.nextEl);
            if (nextEls.includes(targetEl)) {
                if (!(swiper.isEnd && !swiper.params.loop)) {
                    swiper.slideNext();
                }
                if (swiper.isEnd) {
                    notify(params.lastSlideMessage);
                }
                else {
                    notify(params.nextSlideMessage);
                }
            }
            if (prevEls.includes(targetEl)) {
                if (!(swiper.isBeginning && !swiper.params.loop)) {
                    swiper.slidePrev();
                }
                if (swiper.isBeginning) {
                    notify(params.firstSlideMessage);
                }
                else {
                    notify(params.prevSlideMessage);
                }
            }
        }
        if (swiper.pagination && targetEl.matches((0,_shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(paginationParams?.bulletClass))) {
            targetEl.click();
        }
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation)
            return;
        const { nextEl, prevEl } = swiper.navigation;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            }
            else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            }
            else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return !!(swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length);
    }
    function hasClickablePagination() {
        const paginationParams = swiper.params.pagination;
        return hasPagination() && !!paginationParams?.clickable;
    }
    function updatePagination() {
        const params = getParams();
        if (!hasPagination())
            return;
        const paginationParams = swiper.params.pagination;
        swiper.pagination.bullets.forEach((bulletEl) => {
            if (paginationParams.clickable) {
                makeElFocusable(bulletEl);
                if (!paginationParams.renderBullet) {
                    addElRole(bulletEl, 'button');
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, String(((0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.b)(bulletEl) ?? 0) + 1)));
                }
            }
            if (bulletEl.matches((0,_shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(paginationParams.bulletActiveClass))) {
                bulletEl.setAttribute('aria-current', 'true');
            }
            else {
                bulletEl.removeAttribute('aria-current');
            }
        });
    }
    const initNavEl = (el, _wrapperId, message) => {
        makeElFocusable(el);
        if (el.tagName !== 'BUTTON') {
            addElRole(el, 'button');
            el.addEventListener('keydown', onEnterOrSpaceKey);
        }
        addElLabel(el, message);
    };
    const handlePointerDown = (e) => {
        if (focusTargetSlideEl &&
            focusTargetSlideEl !== e.target &&
            !focusTargetSlideEl.contains(e.target)) {
            preventFocusHandler = true;
        }
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = () => {
        preventFocusHandler = false;
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                if (!swiper.destroyed) {
                    swiper.a11y.clicked = false;
                }
            });
        });
    };
    const onVisibilityChange = (_e) => {
        visibilityChangedTimestamp = new Date().getTime();
    };
    const handleFocus = (e) => {
        const params = getParams();
        if (swiper.a11y.clicked || !params.scrollOnFocus)
            return;
        if (new Date().getTime() - visibilityChangedTimestamp < 100)
            return;
        const target = e.target;
        const slideEl = target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl))
            return;
        focusTargetSlideEl = slideEl;
        const isVirtual = isVirtualEnabled(swiper);
        const isActive = (isVirtual
            ? parseInt(slideEl.getAttribute('data-swiper-slide-index') || '0', 10)
            : swiper.slides.indexOf(slideEl)) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress &&
            swiper.visibleSlides &&
            swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible)
            return;
        const sourceCapabilities = e.sourceCapabilities;
        if (sourceCapabilities && sourceCapabilities.firesTouchEvents)
            return;
        if (swiper.isHorizontal()) {
            swiper.el.scrollLeft = 0;
        }
        else {
            swiper.el.scrollTop = 0;
        }
        requestAnimationFrame(() => {
            if (preventFocusHandler)
                return;
            if (swiper.params.loop) {
                swiper.slideToLoop(swiper.getSlideIndexWhenGrid(parseInt(slideEl.getAttribute('data-swiper-slide-index') || '0', 10)), 0);
            }
            else if (isVirtual) {
                swiper.slideTo(swiper.getSlideIndexWhenGrid(parseInt(slideEl.getAttribute('data-swiper-slide-index') || '0', 10)), 0);
            }
            else {
                swiper.slideTo(swiper.getSlideIndexWhenGrid(swiper.slides.indexOf(slideEl)), 0);
            }
            preventFocusHandler = false;
        });
    };
    const initSlides = () => {
        const params = getParams();
        if (params.itemRoleDescriptionMessage) {
            addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        }
        if (params.slideRole) {
            addElRole(swiper.slides, params.slideRole);
        }
        const slidesLength = swiper.slides.length;
        const slideLabelMessage = params.slideLabelMessage;
        if (slideLabelMessage) {
            swiper.slides.forEach((slideEl, index) => {
                const slideIndex = swiper.params.loop
                    ? parseInt(slideEl.getAttribute('data-swiper-slide-index') || '0', 10)
                    : index;
                const ariaLabelMessage = slideLabelMessage
                    .replace(/\{\{index\}\}/, String(slideIndex + 1))
                    .replace(/\{\{slidesLength\}\}/, String(slidesLength));
                addElLabel(slideEl, ariaLabelMessage);
            });
        }
    };
    const init = () => {
        const params = getParams();
        if (liveRegion)
            swiper.el.append(liveRegion);
        // Container
        const containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) {
            addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        }
        if (params.containerMessage) {
            addElLabel(containerEl, params.containerMessage);
        }
        if (params.containerRole) {
            addElRole(containerEl, params.containerRole);
        }
        // Wrapper
        const wrapperEl = swiper.wrapperEl;
        const wrapperId = String(params.id || wrapperEl.getAttribute('id') || `swiper-wrapper-${getRandomNumber(16)}`);
        addElId(wrapperEl, wrapperId);
        if (params.wrapperLiveRegion) {
            const autoplayParams = swiper.params.autoplay;
            const live = swiper.params.autoplay && autoplayParams?.enabled ? 'off' : 'polite';
            addElLive(wrapperEl, live);
        }
        // Slide
        initSlides();
        // Navigation
        const nav = swiper.navigation
            ? swiper.navigation
            : { nextEl: undefined, prevEl: undefined };
        const nextEls = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(nav.nextEl);
        const prevEls = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(nav.prevEl);
        if (nextEls) {
            nextEls.forEach((el) => initNavEl(el, wrapperId, params.nextSlideMessage));
        }
        if (prevEls) {
            prevEls.forEach((el) => initNavEl(el, wrapperId, params.prevSlideMessage));
        }
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(swiper.pagination.el);
            paginationEl.forEach((el) => {
                el.addEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        // Tab focus
        document.addEventListener('visibilitychange', onVisibilityChange);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('pointerdown', handlePointerDown, true);
        swiper.el.addEventListener('pointerup', handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion)
            liveRegion.remove();
        const nav = swiper.navigation
            ? swiper.navigation
            : { nextEl: undefined, prevEl: undefined };
        const nextEls = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(nav.nextEl);
        const prevEls = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(nav.prevEl);
        if (nextEls) {
            nextEls.forEach((el) => el.removeEventListener('keydown', onEnterOrSpaceKey));
        }
        if (prevEls) {
            prevEls.forEach((el) => el.removeEventListener('keydown', onEnterOrSpaceKey));
        }
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(swiper.pagination.el);
            paginationEl.forEach((el) => {
                el.removeEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        document.removeEventListener('visibilitychange', onVisibilityChange);
        // Tab focus
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('focus', handleFocus, true);
            swiper.el.removeEventListener('pointerdown', handlePointerDown, true);
            swiper.el.removeEventListener('pointerup', handlePointerUp, true);
        }
    }
    on('beforeInit', () => {
        liveRegion = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.a)('span', getParams().notificationClass);
        liveRegion.setAttribute('aria-live', 'assertive');
        liveRegion.setAttribute('aria-atomic', 'true');
    });
    on('afterInit', () => {
        if (!getParams().enabled)
            return;
        init();
    });
    on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', () => {
        if (!getParams().enabled)
            return;
        initSlides();
    });
    on('fromEdge toEdge afterInit lock unlock', () => {
        if (!getParams().enabled)
            return;
        updateNavigation();
    });
    on('paginationUpdate', () => {
        if (!getParams().enabled)
            return;
        updatePagination();
    });
    on('destroy', () => {
        if (!getParams().enabled)
            return;
        destroy();
    });
};




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/autoplay.mjs":
/*!***********************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/autoplay.mjs ***!
  \***********************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Autoplay; }
/* harmony export */ });
const Autoplay = ({ swiper, extendParams, on, emit, params }) => {
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0,
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false,
        },
    });
    function getParams() {
        return swiper.params.autoplay;
    }
    // params here is the user-supplied passedParams; extendParams hasn't yet
    // merged the defaults into swiper.params.autoplay at this point.
    const initialAutoplayDelay = typeof params.autoplay === 'object' &&
        params.autoplay &&
        typeof params.autoplay.delay === 'number'
        ? params.autoplay.delay
        : 3000;
    let timeout;
    let raf;
    let autoplayDelayTotal = initialAutoplayDelay;
    let autoplayDelayCurrent = initialAutoplayDelay;
    let autoplayTimeLeft = 0;
    let autoplayStartTime = new Date().getTime();
    let wasPaused = false;
    let isTouched = false;
    let pausedByTouch = false;
    let touchStartTimeout;
    let pausedByInteraction = false;
    let pausedByPointerEnter = false;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl)
            return;
        if (e.target !== swiper.wrapperEl)
            return;
        swiper.wrapperEl.removeEventListener('transitionend', onTransitionEnd);
        const detail = e.detail;
        if (pausedByPointerEnter || (detail && detail.bySwiperTouchMove)) {
            return;
        }
        resume();
    }
    const calcTimeLeft = () => {
        if (swiper.destroyed || !swiper.autoplay.running)
            return;
        if (swiper.autoplay.paused) {
            wasPaused = true;
        }
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused
            ? autoplayTimeLeft
            : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit('autoplayTimeLeft', timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(() => {
            calcTimeLeft();
        });
    };
    const getSlideDelay = () => {
        let activeSlideEl;
        const virtualEnabled = !!swiper.params.virtual?.enabled;
        if (swiper.virtual && virtualEnabled) {
            activeSlideEl = swiper.slides.find((slideEl) => slideEl.classList.contains('swiper-slide-active'));
        }
        else {
            activeSlideEl = swiper.slides[swiper.activeIndex];
        }
        if (!activeSlideEl)
            return undefined;
        const attr = activeSlideEl.getAttribute('data-swiper-autoplay');
        if (attr == null)
            return undefined;
        return parseInt(attr, 10);
    };
    const getTotalDelay = () => {
        let totalDelay = getParams().delay;
        const currentSlideDelay = getSlideDelay();
        if (typeof currentSlideDelay === 'number' &&
            !Number.isNaN(currentSlideDelay) &&
            currentSlideDelay > 0) {
            totalDelay = currentSlideDelay;
        }
        return totalDelay;
    };
    const run = (delayForce) => {
        if (swiper.destroyed || !swiper.autoplay.running)
            return 0;
        if (raf !== undefined)
            cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = delayForce;
        if (typeof delay === 'undefined') {
            delay = getTotalDelay();
            autoplayDelayTotal = delay;
            autoplayDelayCurrent = delay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = () => {
            if (!swiper || swiper.destroyed)
                return;
            const autoplayParams = getParams();
            if (autoplayParams.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit('autoplay');
                }
                else if (!autoplayParams.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit('autoplay');
                }
            }
            else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit('autoplay');
                }
                else if (!autoplayParams.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit('autoplay');
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(() => {
                    run();
                });
            }
        };
        if (delay > 0) {
            if (timeout !== undefined)
                clearTimeout(timeout);
            timeout = setTimeout(() => {
                proceed();
            }, delay);
        }
        else {
            requestAnimationFrame(() => {
                proceed();
            });
        }
        return delay;
    };
    const start = () => {
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit('autoplayStart');
        return true;
    };
    const stop = () => {
        swiper.autoplay.running = false;
        if (timeout !== undefined)
            clearTimeout(timeout);
        if (raf !== undefined)
            cancelAnimationFrame(raf);
        emit('autoplayStop');
        return true;
    };
    const pause = (internal, reset) => {
        if (swiper.destroyed || !swiper.autoplay.running)
            return;
        if (timeout !== undefined)
            clearTimeout(timeout);
        if (!internal) {
            pausedByInteraction = true;
        }
        const proceed = () => {
            emit('autoplayPause');
            if (getParams().waitForTransition) {
                swiper.wrapperEl.addEventListener('transitionend', onTransitionEnd);
            }
            else {
                resume();
            }
        };
        swiper.autoplay.paused = true;
        if (reset) {
            proceed();
            return;
        }
        const delay = autoplayTimeLeft || getParams().delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop)
            return;
        if (autoplayTimeLeft < 0)
            autoplayTimeLeft = 0;
        proceed();
    };
    const resume = () => {
        if ((swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) ||
            swiper.destroyed ||
            !swiper.autoplay.running)
            return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        }
        else {
            run();
        }
        swiper.autoplay.paused = false;
        emit('autoplayResume');
    };
    const onVisibilityChange = () => {
        if (swiper.destroyed || !swiper.autoplay.running)
            return;
        if (document.visibilityState === 'hidden') {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === 'visible') {
            resume();
        }
    };
    const onPointerEnter = (e) => {
        if (e.pointerType !== 'mouse')
            return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused)
            return;
        pause(true);
    };
    const onPointerLeave = (e) => {
        if (e.pointerType !== 'mouse')
            return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) {
            resume();
        }
    };
    const attachMouseEvents = () => {
        if (getParams().pauseOnMouseEnter) {
            swiper.el.addEventListener('pointerenter', onPointerEnter);
            swiper.el.addEventListener('pointerleave', onPointerLeave);
        }
    };
    const detachMouseEvents = () => {
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('pointerenter', onPointerEnter);
            swiper.el.removeEventListener('pointerleave', onPointerLeave);
        }
    };
    const attachDocumentEvents = () => {
        document.addEventListener('visibilitychange', onVisibilityChange);
    };
    const detachDocumentEvents = () => {
        document.removeEventListener('visibilitychange', onVisibilityChange);
    };
    on('init', () => {
        if (getParams().enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on('destroy', () => {
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) {
            stop();
        }
    });
    on('_freeModeStaticRelease', () => {
        if (pausedByTouch || pausedByInteraction) {
            resume();
        }
    });
    on('_freeModeNoMomentumRelease', () => {
        if (!getParams().disableOnInteraction) {
            pause(true, true);
        }
        else {
            stop();
        }
    });
    on('beforeTransitionStart', (_s, _speed, internal) => {
        if (swiper.destroyed || !swiper.autoplay.running)
            return;
        if (internal || !getParams().disableOnInteraction) {
            pause(true, true);
        }
        else {
            stop();
        }
    });
    on('sliderFirstMove', () => {
        if (swiper.destroyed || !swiper.autoplay.running)
            return;
        if (getParams().disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(() => {
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on('touchEnd', () => {
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched)
            return;
        if (touchStartTimeout !== undefined)
            clearTimeout(touchStartTimeout);
        if (timeout !== undefined)
            clearTimeout(timeout);
        if (getParams().disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode)
            resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on('slideChange', () => {
        if (swiper.destroyed || !swiper.autoplay.running)
            return;
        if (swiper.autoplay.paused) {
            autoplayTimeLeft = getTotalDelay();
            autoplayDelayTotal = getTotalDelay();
        }
    });
    Object.assign(swiper.autoplay, {
        start,
        stop,
        pause,
        resume,
    });
};




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/controller.mjs":
/*!*************************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/controller.mjs ***!
  \*************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Controller; }
/* harmony export */ });
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs");


class LinearSpline {
    x;
    y;
    lastIndex;
    binarySearch;
    constructor(x, y) {
        let maxIndex;
        let minIndex;
        let guess;
        this.binarySearch = (array, val) => {
            minIndex = -1;
            maxIndex = array.length;
            while (maxIndex - minIndex > 1) {
                guess = (maxIndex + minIndex) >> 1;
                if (array[guess] <= val) {
                    minIndex = guess;
                }
                else {
                    maxIndex = guess;
                }
            }
            return maxIndex;
        };
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
    }
    interpolate(x2) {
        if (!x2)
            return 0;
        const i3 = this.binarySearch(this.x, x2);
        const i1 = i3 - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
        return (((x2 - this.x[i1]) * (this.y[i3] - this.y[i1])) / (this.x[i3] - this.x[i1]) + this.y[i1]);
    }
}
const Controller = ({ swiper, extendParams, on }) => {
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide', // or 'container'
        },
    });
    swiper.controller = {
        control: undefined,
    };
    function getParams() {
        return swiper.params.controller;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop
            ? new LinearSpline(swiper.slidesGrid, c.slidesGrid)
            : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const SwiperCtor = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed)
                return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            const controllerParams = getParams();
            if (controllerParams.by === 'slide') {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            else {
                controlledTranslate = 0;
            }
            if (!controlledTranslate || controllerParams.by === 'container') {
                multiplier =
                    (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) {
                    multiplier = 1;
                }
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (controllerParams.inverse) {
                controlledTranslate = c.maxTranslate() - controlledTranslate;
            }
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for (let i = 0; i < controlled.length; i += 1) {
                const target = controlled[i];
                if (target && target !== byController && target instanceof SwiperCtor) {
                    setControlledTranslate(target);
                }
            }
        }
        else if (controlled instanceof SwiperCtor && byController !== controlled) {
            setControlledTranslate(controlled);
        }
    }
    function setTransition(duration, byController) {
        const SwiperCtor = swiper.constructor;
        const controlled = swiper.controller.control;
        function setControlledTransition(c) {
            if (c.destroyed)
                return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) {
                    (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.t)(() => {
                        c.updateAutoHeight();
                    });
                }
                (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.m)(c.wrapperEl, () => {
                    if (!controlled)
                        return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for (let i = 0; i < controlled.length; i += 1) {
                const target = controlled[i];
                if (target && target !== byController && target instanceof SwiperCtor) {
                    setControlledTransition(target);
                }
            }
        }
        else if (controlled instanceof SwiperCtor && byController !== controlled) {
            setControlledTransition(controlled);
        }
    }
    function removeSpline() {
        if (!swiper.controller.control)
            return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', () => {
        const controllerParam = getParams().control;
        if (typeof window !== 'undefined' &&
            (typeof controllerParam === 'string' || controllerParam instanceof HTMLElement)) {
            const controlElements = typeof controllerParam === 'string'
                ? [...document.querySelectorAll(controllerParam)]
                : [controllerParam];
            controlElements.forEach((controlElement) => {
                if (!swiper.controller.control)
                    swiper.controller.control = [];
                const list = swiper.controller.control;
                if (controlElement && controlElement.swiper) {
                    list.push(controlElement.swiper);
                }
                else if (controlElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onControllerSwiper = (e) => {
                        const detail = e.detail;
                        if (detail && detail[0])
                            list.push(detail[0]);
                        swiper.update();
                        controlElement.removeEventListener(eventName, onControllerSwiper);
                    };
                    controlElement.addEventListener(eventName, onControllerSwiper);
                }
            });
            return;
        }
        // After this point control is either Swiper or Swiper[] (or null/undefined),
        // never the string/HTMLElement forms that the public option accepts.
        swiper.controller.control = controllerParam;
    });
    on('update', () => {
        removeSpline();
    });
    on('resize', () => {
        removeSpline();
    });
    on('observerUpdate', () => {
        removeSpline();
    });
    // Event payloads come typed against the legacy public Swiper class
    // (src/types/swiper-class.d.ts) until Phase 5 deletes src/types/; cast the
    // forwarded byController back to the core Swiper so it lines up with the
    // controller-internal signatures.
    on('setTranslate', (_s, translate, byController) => {
        if (!swiper.controller.control)
            return;
        if (!Array.isArray(swiper.controller.control) && swiper.controller.control.destroyed)
            return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', (_s, duration, byController) => {
        if (!swiper.controller.control)
            return;
        if (!Array.isArray(swiper.controller.control) && swiper.controller.control.destroyed)
            return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate,
        setTransition,
    });
};




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/effect-cards.mjs":
/*!***************************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/effect-cards.mjs ***!
  \***************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ EffectCards; }
/* harmony export */ });
/* harmony import */ var _shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/create-shadow.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/create-shadow.mjs");
/* harmony import */ var _shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/effect-init.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/effect-init.mjs");
/* harmony import */ var _shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../shared/effect-target.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/effect-target.mjs");
/* harmony import */ var _shared_effect_virtual_transition_end_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../shared/effect-virtual-transition-end.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/effect-virtual-transition-end.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs");






const EffectCards = ({ swiper, extendParams, on }) => {
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8,
        },
    });
    function getParams() {
        return swiper.params.cardsEffect;
    }
    const setTranslate = () => {
        const { slides, activeIndex, rtlTranslate: rtl } = swiper;
        const params = getParams();
        const { startTranslate, isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for (let i = 0; i < slides.length; i += 1) {
            const slideEl = slides[i];
            const slideProgress = slideEl.progress ?? 0;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset ?? 0;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) {
                swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            }
            if (swiper.params.centeredSlides && swiper.params.cssMode) {
                offset -= slides[0].swiperSlideOffset ?? 0;
            }
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual?.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) &&
                progress > 0 &&
                progress < 1 &&
                (isTouched || swiper.params.cssMode) &&
                (currentTranslate ?? 0) < (startTranslate ?? 0);
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) &&
                progress < 0 &&
                progress > -1 &&
                (isTouched || swiper.params.cssMode) &&
                (currentTranslate ?? 0) > (startTranslate ?? 0);
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${(params.rotate || swiper.isHorizontal() ? -25 : 0) * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) {
                // next
                tX = `calc(${tX}px ${rtl ? '-' : '+'} (${tXAdd * Math.abs(progress)}%))`;
            }
            else if (progress > 0) {
                // prev
                tX = `calc(${tX}px ${rtl ? '-' : '+'} (-${tXAdd * Math.abs(progress)}%))`;
            }
            else {
                tX = `${tX}px`;
            }
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? (rtl ? -rotate : rotate) : 0}deg)
        scale(${scaleString})
      `;
            if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl) {
                    shadowEl = (0,_shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__.c)('cards', slideEl);
                }
                if (shadowEl)
                    shadowEl.style.opacity = String(Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1));
            }
            slideEl.style.zIndex = String(-Math.abs(Math.round(slideProgress)) + slides.length);
            const targetEl = (0,_shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_2__.e)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration) => {
        const transformElements = swiper.slides.map((slideEl) => (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_4__.p)(slideEl));
        transformElements.forEach((el) => {
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl) => {
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0,_shared_effect_virtual_transition_end_mjs__WEBPACK_IMPORTED_MODULE_3__.e)({ swiper, duration, transformElements });
    };
    (0,_shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_1__.e)({
        effect: 'cards',
        swiper,
        on,
        setTranslate,
        setTransition,
        perspective: () => true,
        overwriteParams: () => ({
            _loopSwapReset: false,
            watchSlidesProgress: true,
            loopAdditionalSlides: getParams().rotate ? 3 : 2,
            centeredSlides: true,
            virtualTranslate: !swiper.params.cssMode,
        }),
    });
};




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/effect-coverflow.mjs":
/*!*******************************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/effect-coverflow.mjs ***!
  \*******************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ EffectCoverflow; }
/* harmony export */ });
/* harmony import */ var _shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/create-shadow.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/create-shadow.mjs");
/* harmony import */ var _shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/effect-init.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/effect-init.mjs");
/* harmony import */ var _shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../shared/effect-target.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/effect-target.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs");





const EffectCoverflow = ({ swiper, extendParams, on }) => {
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true,
        },
    });
    function getParams() {
        return swiper.params.coverflowEffect;
    }
    const setTranslate = () => {
        const { width: swiperWidth, height: swiperHeight, slides, slidesSizesGrid } = swiper;
        const params = getParams();
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        const r = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_3__.o)(swiper);
        // Each slide offset from center
        for (let i = 0, length = slides.length; i < length; i += 1) {
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset ?? 0;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === 'function'
                ? params.modifier(centerOffset)
                : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = typeof params.stretch === 'string' && params.stretch.indexOf('%') !== -1
                ? (parseFloat(params.stretch) / 100) * slideSize
                : params.stretch;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001)
                translateX = 0;
            if (Math.abs(translateY) < 0.001)
                translateY = 0;
            if (Math.abs(translateZ) < 0.001)
                translateZ = 0;
            if (Math.abs(rotateY) < 0.001)
                rotateY = 0;
            if (Math.abs(rotateX) < 0.001)
                rotateX = 0;
            if (Math.abs(scale) < 0.001)
                scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${r(rotateX)}deg) rotateY(${r(rotateY)}deg) scale(${scale})`;
            const targetEl = (0,_shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_2__.e)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = String(-Math.abs(Math.round(offsetMultiplier)) + 1);
            if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal
                    ? slideEl.querySelector('.swiper-slide-shadow-left')
                    : slideEl.querySelector('.swiper-slide-shadow-top');
                let shadowAfterEl = isHorizontal
                    ? slideEl.querySelector('.swiper-slide-shadow-right')
                    : slideEl.querySelector('.swiper-slide-shadow-bottom');
                if (!shadowBeforeEl) {
                    shadowBeforeEl = (0,_shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__.c)('coverflow', slideEl, isHorizontal ? 'left' : 'top');
                }
                if (!shadowAfterEl) {
                    shadowAfterEl = (0,_shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__.c)('coverflow', slideEl, isHorizontal ? 'right' : 'bottom');
                }
                if (shadowBeforeEl)
                    shadowBeforeEl.style.opacity = String(offsetMultiplier > 0 ? offsetMultiplier : 0);
                if (shadowAfterEl)
                    shadowAfterEl.style.opacity = String(-offsetMultiplier > 0 ? -offsetMultiplier : 0);
            }
        }
    };
    const setTransition = (duration) => {
        const transformElements = swiper.slides.map((slideEl) => (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_3__.p)(slideEl));
        transformElements.forEach((el) => {
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl) => {
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0,_shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_1__.e)({
        effect: 'coverflow',
        swiper,
        on,
        setTranslate,
        setTransition,
        perspective: () => true,
        overwriteParams: () => ({
            watchSlidesProgress: true,
        }),
    });
};




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/effect-creative.mjs":
/*!******************************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/effect-creative.mjs ***!
  \******************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ EffectCreative; }
/* harmony export */ });
/* harmony import */ var _shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/create-shadow.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/create-shadow.mjs");
/* harmony import */ var _shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/effect-init.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/effect-init.mjs");
/* harmony import */ var _shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../shared/effect-target.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/effect-target.mjs");
/* harmony import */ var _shared_effect_virtual_transition_end_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../shared/effect-virtual-transition-end.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/effect-virtual-transition-end.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs");






const EffectCreative = ({ swiper, extendParams, on }) => {
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [0, 0, 0],
                rotate: [0, 0, 0],
                opacity: 1,
                scale: 1,
            },
            next: {
                translate: [0, 0, 0],
                rotate: [0, 0, 0],
                opacity: 1,
                scale: 1,
            },
        },
    });
    function getParams() {
        return swiper.params.creativeEffect;
    }
    const getTranslateValue = (value) => {
        if (typeof value === 'string')
            return value;
        return `${value}px`;
    };
    const setTranslate = () => {
        const { slides, wrapperEl, slidesSizesGrid } = swiper;
        const params = getParams();
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        const rotateFix = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_4__.o)(swiper);
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - (swiper.params.slidesOffsetBefore ?? 0);
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for (let i = 0; i < slides.length; i += 1) {
            const slideEl = slides[i];
            const slideProgress = slideEl.progress ?? 0;
            const progress = Math.min(Math.max(slideProgress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) {
                originalProgress = Math.min(Math.max(slideEl.originalProgress ?? 0, -params.limitProgress), params.limitProgress);
            }
            const offset = slideEl.swiperSlideOffset ?? 0;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0,
            ];
            const r = [0, 0, 0];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [0, 0, 0],
                rotate: [0, 0, 0],
                scale: 1,
                opacity: 1,
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            }
            else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach((value, index) => {
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach((_value, index) => {
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            slideEl.style.zIndex = String(-Math.abs(Math.round(slideProgress)) + slides.length);
            const translateString = t.join(', ');
            const rotateString = `rotateX(${rotateFix(r[0])}deg) rotateY(${rotateFix(r[1])}deg) rotateZ(${rotateFix(r[2])}deg)`;
            const scaleString = originalProgress < 0
                ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})`
                : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0
                ? 1 + (1 - data.opacity) * originalProgress * multiplier
                : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if ((custom && data.shadow) || !custom) {
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl && data.shadow) {
                    shadowEl = (0,_shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__.c)('creative', slideEl);
                }
                if (shadowEl) {
                    const shadowOpacity = params.shadowPerProgress
                        ? progress * (1 / params.limitProgress)
                        : progress;
                    shadowEl.style.opacity = String(Math.min(Math.max(Math.abs(shadowOpacity), 0), 1));
                }
            }
            const targetEl = (0,_shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_2__.e)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = String(opacityString);
            if (data.origin) {
                targetEl.style.transformOrigin = data.origin;
            }
        }
    };
    const setTransition = (duration) => {
        const transformElements = swiper.slides.map((slideEl) => (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_4__.p)(slideEl));
        transformElements.forEach((el) => {
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl) => {
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0,_shared_effect_virtual_transition_end_mjs__WEBPACK_IMPORTED_MODULE_3__.e)({ swiper, duration, transformElements, allSlides: true });
    };
    (0,_shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_1__.e)({
        effect: 'creative',
        swiper,
        on,
        setTranslate,
        setTransition,
        perspective: () => getParams().perspective,
        overwriteParams: () => ({
            watchSlidesProgress: true,
            virtualTranslate: !swiper.params.cssMode,
        }),
    });
};




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/effect-cube.mjs":
/*!**************************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/effect-cube.mjs ***!
  \**************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ EffectCube; }
/* harmony export */ });
/* harmony import */ var _shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/effect-init.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/effect-init.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs");



const EffectCube = ({ swiper, extendParams, on }) => {
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94,
        },
    });
    function getParams() {
        return swiper.params.cubeEffect;
    }
    const createSlideShadows = (slideEl, progress, isHorizontal) => {
        let shadowBefore = isHorizontal
            ? slideEl.querySelector('.swiper-slide-shadow-left')
            : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = isHorizontal
            ? slideEl.querySelector('.swiper-slide-shadow-right')
            : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) {
            shadowBefore = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.a)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}`.split(' '));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.a)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}`.split(' '));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore)
            shadowBefore.style.opacity = String(Math.max(-progress, 0));
        if (shadowAfter)
            shadowAfter.style.opacity = String(Math.max(progress, 0));
    };
    const recreateShadows = () => {
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach((slideEl) => {
            const progress = Math.max(Math.min(slideEl.progress ?? 0, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    const setTranslate = () => {
        const { el, wrapperEl, slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, } = swiper;
        const r = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.o)(swiper);
        const params = getParams();
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = !!(swiper.virtual && swiper.params.virtual?.enabled);
        let wrapperRotate = 0;
        let cubeShadowEl = null;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.a)('div', 'swiper-cube-shadow');
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            }
            else {
                cubeShadowEl = el.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.a)('div', 'swiper-cube-shadow');
                    el.append(cubeShadowEl);
                }
            }
        }
        for (let i = 0; i < slides.length; i += 1) {
            const slideEl = slides[i];
            let slideIndex = i;
            if (isVirtual) {
                slideIndex = parseInt(slideEl.getAttribute('data-swiper-slide-index') ?? '0', 10);
            }
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min(slideEl.progress ?? 0, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            }
            else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            }
            else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            }
            else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) {
                tx = -tx;
            }
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${r(isHorizontal ? 0 : -slideAngle)}deg) rotateY(${r(isHorizontal ? slideAngle : 0)}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl)
                    wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) {
                createSlideShadows(slideEl, progress, isHorizontal);
            }
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style.setProperty('-webkit-transform-origin', `50% 50% -${swiperSize / 2}px`);
        if (params.shadow && cubeShadowEl) {
            if (isHorizontal) {
                cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
            }
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 -
                    (Math.sin((shadowAngle * 2 * Math.PI) / 360) / 2 +
                        Math.cos((shadowAngle * 2 * Math.PI) / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
            }
        }
        wrapperEl.style.transform = `translate3d(0px,0,0px) rotateX(${r(swiper.isHorizontal() ? 0 : wrapperRotate)}deg) rotateY(${r(swiper.isHorizontal() ? -wrapperRotate : 0)}deg)`;
        wrapperEl.style.setProperty('--swiper-cube-translate-z', '0px');
    };
    const setTransition = (duration) => {
        const { el, slides } = swiper;
        slides.forEach((slideEl) => {
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl
                .querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
                .forEach((subEl) => {
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect?.shadow && !swiper.isHorizontal()) {
            const shadowEl = el.querySelector('.swiper-cube-shadow');
            if (shadowEl)
                shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0,_shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_0__.e)({
        effect: 'cube',
        swiper,
        on,
        setTranslate,
        setTransition,
        recreateShadows,
        getEffectParams: () => swiper.params.cubeEffect,
        perspective: () => true,
        overwriteParams: () => ({
            slidesPerView: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            resistanceRatio: 0,
            spaceBetween: 0,
            centeredSlides: false,
            virtualTranslate: true,
        }),
    });
};




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/effect-fade.mjs":
/*!**************************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/effect-fade.mjs ***!
  \**************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ EffectFade; }
/* harmony export */ });
/* harmony import */ var _shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/effect-init.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/effect-init.mjs");
/* harmony import */ var _shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/effect-target.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/effect-target.mjs");
/* harmony import */ var _shared_effect_virtual_transition_end_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../shared/effect-virtual-transition-end.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/effect-virtual-transition-end.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs");





const EffectFade = ({ swiper, extendParams, on }) => {
    extendParams({
        fadeEffect: {
            crossFade: false,
        },
    });
    function getParams() {
        return swiper.params.fadeEffect;
    }
    const setTranslate = () => {
        const { slides } = swiper;
        const params = getParams();
        for (let i = 0; i < slides.length; i += 1) {
            const slideEl = slides[i];
            const offset = slideEl.swiperSlideOffset ?? 0;
            let tx = -offset;
            if (!swiper.params.virtualTranslate)
                tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideProgress = slideEl.progress ?? 0;
            const slideOpacity = params.crossFade
                ? Math.max(1 - Math.abs(slideProgress), 0)
                : 1 + Math.min(Math.max(slideProgress, -1), 0);
            const targetEl = (0,_shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(params, slideEl);
            targetEl.style.opacity = String(slideOpacity);
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
    };
    const setTransition = (duration) => {
        const transformElements = swiper.slides.map((slideEl) => (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_3__.p)(slideEl));
        transformElements.forEach((el) => {
            el.style.transitionDuration = `${duration}ms`;
        });
        (0,_shared_effect_virtual_transition_end_mjs__WEBPACK_IMPORTED_MODULE_2__.e)({ swiper, duration, transformElements, allSlides: true });
    };
    (0,_shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_0__.e)({
        effect: 'fade',
        swiper,
        on,
        setTranslate,
        setTransition,
        overwriteParams: () => ({
            slidesPerView: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            spaceBetween: 0,
            virtualTranslate: !swiper.params.cssMode,
        }),
    });
};




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/effect-flip.mjs":
/*!**************************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/effect-flip.mjs ***!
  \**************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ EffectFlip; }
/* harmony export */ });
/* harmony import */ var _shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/create-shadow.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/create-shadow.mjs");
/* harmony import */ var _shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/effect-init.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/effect-init.mjs");
/* harmony import */ var _shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../shared/effect-target.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/effect-target.mjs");
/* harmony import */ var _shared_effect_virtual_transition_end_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../shared/effect-virtual-transition-end.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/effect-virtual-transition-end.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs");






const EffectFlip = ({ swiper, extendParams, on }) => {
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true,
        },
    });
    function getParams() {
        return swiper.params.flipEffect;
    }
    const createSlideShadows = (slideEl, progress) => {
        let shadowBefore = swiper.isHorizontal()
            ? slideEl.querySelector('.swiper-slide-shadow-left')
            : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = swiper.isHorizontal()
            ? slideEl.querySelector('.swiper-slide-shadow-right')
            : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) {
            shadowBefore = (0,_shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__.c)('flip', slideEl, swiper.isHorizontal() ? 'left' : 'top');
        }
        if (!shadowAfter) {
            shadowAfter = (0,_shared_create_shadow_mjs__WEBPACK_IMPORTED_MODULE_0__.c)('flip', slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        }
        if (shadowBefore)
            shadowBefore.style.opacity = String(Math.max(-progress, 0));
        if (shadowAfter)
            shadowAfter.style.opacity = String(Math.max(progress, 0));
    };
    const recreateShadows = () => {
        // Set shadows
        const params = getParams();
        swiper.slides.forEach((slideEl) => {
            let progress = slideEl.progress ?? 0;
            if (params.limitRotation) {
                progress = Math.max(Math.min(progress, 1), -1);
            }
            createSlideShadows(slideEl, progress);
        });
    };
    const setTranslate = () => {
        const { slides, rtlTranslate: rtl } = swiper;
        const params = getParams();
        const rotateFix = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_4__.o)(swiper);
        for (let i = 0; i < slides.length; i += 1) {
            const slideEl = slides[i];
            let progress = slideEl.progress ?? 0;
            if (params.limitRotation) {
                progress = Math.max(Math.min(progress, 1), -1);
            }
            const offset = slideEl.swiperSlideOffset ?? 0;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            }
            else if (rtl) {
                rotateY = -rotateY;
            }
            slideEl.style.zIndex = String(-Math.abs(Math.round(progress)) + slides.length);
            if (params.slideShadows) {
                createSlideShadows(slideEl, progress);
            }
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateFix(rotateX)}deg) rotateY(${rotateFix(rotateY)}deg)`;
            const targetEl = (0,_shared_effect_target_mjs__WEBPACK_IMPORTED_MODULE_2__.e)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration) => {
        const transformElements = swiper.slides.map((slideEl) => (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_4__.p)(slideEl));
        transformElements.forEach((el) => {
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl) => {
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0,_shared_effect_virtual_transition_end_mjs__WEBPACK_IMPORTED_MODULE_3__.e)({ swiper, duration, transformElements });
    };
    (0,_shared_effect_init_mjs__WEBPACK_IMPORTED_MODULE_1__.e)({
        effect: 'flip',
        swiper,
        on,
        setTranslate,
        setTransition,
        recreateShadows,
        getEffectParams: () => swiper.params.flipEffect,
        perspective: () => true,
        overwriteParams: () => ({
            slidesPerView: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            spaceBetween: 0,
            virtualTranslate: !swiper.params.cssMode,
        }),
    });
};




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/free-mode.mjs":
/*!************************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/free-mode.mjs ***!
  \************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ FreeMode; }
/* harmony export */ });
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs");


const FreeMode = ({ swiper, extendParams, emit, once }) => {
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02,
        },
    });
    function getParams() {
        return swiper.params.freeMode;
    }
    function onTouchStart() {
        if (swiper.params.cssMode)
            return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({ currentPos: swiper.rtl ? swiper.translate : -swiper.translate });
    }
    function onTouchMove() {
        if (swiper.params.cssMode)
            return;
        const { touchEventsData: data, touches } = swiper;
        // Velocity
        if (data.velocities.length === 0) {
            data.velocities.push({
                position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
                time: data.touchStartTime ?? (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.u)(),
            });
        }
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.u)(),
        });
    }
    function onTouchEnd({ currentPos }) {
        if (swiper.params.cssMode)
            return;
        const { wrapperEl, rtlTranslate: rtl, snapGrid, touchEventsData: data } = swiper;
        const params = swiper.params;
        const freeModeParams = getParams();
        // Time diff
        const touchEndTime = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.u)();
        const timeDiff = touchEndTime - (data.touchStartTime ?? touchEndTime);
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) {
                swiper.slideTo(snapGrid.length - 1);
            }
            else {
                swiper.slideTo(swiper.slides.length - 1);
            }
            return;
        }
        if (freeModeParams.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < freeModeParams.minimumVelocity) {
                    swiper.velocity = 0;
                }
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.u)() - lastMoveEvent.time > 300) {
                    swiper.velocity = 0;
                }
            }
            else {
                swiper.velocity = 0;
            }
            swiper.velocity *= freeModeParams.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * freeModeParams.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl)
                newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * freeModeParams.momentumBounceRatio;
            let needsLoopFix = false;
            if (newPosition < swiper.maxTranslate()) {
                if (freeModeParams.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) {
                        newPosition = swiper.maxTranslate() - bounceAmount;
                    }
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                }
                else {
                    newPosition = swiper.maxTranslate();
                }
                if (params.loop && params.centeredSlides)
                    needsLoopFix = true;
            }
            else if (newPosition > swiper.minTranslate()) {
                if (freeModeParams.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) {
                        newPosition = swiper.minTranslate() + bounceAmount;
                    }
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                }
                else {
                    newPosition = swiper.minTranslate();
                }
                if (params.loop && params.centeredSlides)
                    needsLoopFix = true;
            }
            else if (freeModeParams.sticky) {
                let nextSlide = 0;
                for (let j = 0; j < snapGrid.length; j += 1) {
                    if (snapGrid[j] > -newPosition) {
                        nextSlide = j;
                        break;
                    }
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) <
                    Math.abs((snapGrid[nextSlide - 1] ?? snapGrid[nextSlide]) - newPosition) ||
                    swiper.swipeDirection === 'next') {
                    newPosition = snapGrid[nextSlide];
                }
                else {
                    newPosition = snapGrid[nextSlide - 1];
                }
                newPosition = -newPosition;
            }
            if (needsLoopFix) {
                once('transitionEnd', () => {
                    swiper.loopFix();
                });
            }
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) {
                    momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                }
                else {
                    momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                }
                if (freeModeParams.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    const speed = params.speed;
                    if (moveDistance < currentSlideSize) {
                        momentumDuration = speed;
                    }
                    else if (moveDistance < 2 * currentSlideSize) {
                        momentumDuration = speed * 1.5;
                    }
                    else {
                        momentumDuration = speed * 2.5;
                    }
                }
            }
            else if (freeModeParams.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (freeModeParams.momentumBounce && doBounce && afterBouncePosition !== undefined) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.m)(wrapperEl, () => {
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce)
                        return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(() => {
                        swiper.setTranslate(afterBouncePosition);
                        (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.m)(wrapperEl, () => {
                            if (!swiper || swiper.destroyed)
                                return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            }
            else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.m)(wrapperEl, () => {
                        if (!swiper || swiper.destroyed)
                            return;
                        swiper.transitionEnd();
                    });
                }
            }
            else {
                swiper.updateProgress(newPosition);
            }
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        else if (freeModeParams.sticky) {
            swiper.slideToClosest();
            return;
        }
        else {
            emit('_freeModeNoMomentumRelease');
        }
        if (!freeModeParams.momentum || timeDiff >= params.longSwipesMs) {
            emit('_freeModeStaticRelease');
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    swiper.freeMode = {
        onTouchStart,
        onTouchMove,
        onTouchEnd,
    };
};




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/grid.mjs":
/*!*******************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/grid.mjs ***!
  \*******************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Grid; }
/* harmony export */ });
const Grid = ({ swiper, extendParams, on }) => {
    extendParams({
        grid: {
            rows: 1,
            fill: 'column',
        },
    });
    function getParams() {
        return swiper.params.grid;
    }
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    let wasMultiRow;
    const getSpaceBetween = () => {
        let spaceBetween = swiper.params.spaceBetween ?? 0;
        if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
            spaceBetween = (parseFloat(spaceBetween.replace('%', '')) / 100) * swiper.size;
        }
        else if (typeof spaceBetween === 'string') {
            spaceBetween = parseFloat(spaceBetween);
        }
        return spaceBetween;
    };
    const isVirtualEnabled = () => {
        const virtualParams = swiper.params.virtual;
        return (!!swiper.virtual &&
            typeof virtualParams === 'object' &&
            virtualParams !== null &&
            !!virtualParams.enabled);
    };
    const initSlides = (slides) => {
        const { slidesPerView } = swiper.params;
        const { rows, fill } = getParams();
        const slidesLength = isVirtualEnabled() ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) {
            slidesNumberEvenToRows = slidesLength;
        }
        else {
            slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        }
        if (slidesPerView !== 'auto' && fill === 'row') {
            slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, Math.floor(slidesPerView ?? 1) * rows);
        }
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    const unsetSlides = () => {
        if (swiper.slides) {
            swiper.slides.forEach((slide) => {
                const gridSlide = slide;
                if (gridSlide.swiperSlideGridSet) {
                    slide.style.height = '';
                    slide.style.setProperty(swiper.getDirectionLabel('margin-top'), '');
                }
            });
        }
    };
    const updateSlide = (i, slide, slides) => {
        const { slidesPerGroup } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows, fill } = getParams();
        const slidesLength = isVirtualEnabled() ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === 'row' && (slidesPerGroup ?? 1) > 1) {
            const groupsPer = slidesPerGroup ?? 1;
            const groupIndex = Math.floor(i / (groupsPer * rows));
            const slideIndexInGroup = i - rows * groupsPer * groupIndex;
            const columnsInGroup = groupIndex === 0
                ? groupsPer
                : Math.min(Math.ceil((slidesLength - groupIndex * rows * groupsPer) / rows), groupsPer);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * groupsPer;
            newSlideOrderIndex = column + (row * slidesNumberEvenToRows) / rows;
            slide.style.order = String(newSlideOrderIndex);
        }
        else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || (column === numFullColumns && row === rows - 1)) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        }
        else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        const gridSlide = slide;
        gridSlide.row = row;
        gridSlide.column = column;
        slide.style.height = `calc((100% - ${(rows - 1) * spaceBetween}px) / ${rows})`;
        slide.style.setProperty(swiper.getDirectionLabel('margin-top'), row !== 0 && spaceBetween ? `${spaceBetween}px` : '');
        gridSlide.swiperSlideGridSet = true;
    };
    const updateWrapperSize = (slideSize, snapGrid) => {
        const { centeredSlides, roundLengths } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows } = getParams();
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) {
            swiper.wrapperEl.style.setProperty(swiper.getDirectionLabel('width'), `${swiper.virtualSize + spaceBetween}px`);
        }
        if (centeredSlides) {
            const newSlidesGrid = [];
            for (let i = 0; i < snapGrid.length; i += 1) {
                let slidesGridItem = snapGrid[i];
                if (roundLengths)
                    slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0])
                    newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            snapGrid.push(...newSlidesGrid);
        }
    };
    const onInit = () => {
        const gridParams = swiper.params.grid;
        wasMultiRow = !!(gridParams && (gridParams.rows ?? 1) > 1);
    };
    const onUpdate = () => {
        const { params, el } = swiper;
        const gridParams = params.grid;
        const isMultiRow = !!(gridParams && (gridParams.rows ?? 1) > 1);
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
            numFullColumns = 1;
            swiper.emitContainerClasses();
        }
        else if (!wasMultiRow && isMultiRow) {
            el.classList.add(`${params.containerModifierClass}grid`);
            if (gridParams.fill === 'column') {
                el.classList.add(`${params.containerModifierClass}grid-column`);
            }
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on('init', onInit);
    on('update', onUpdate);
    swiper.grid = {
        initSlides,
        unsetSlides,
        updateSlide,
        updateWrapperSize,
    };
};




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/hash-navigation.mjs":
/*!******************************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/hash-navigation.mjs ***!
  \******************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ HashNavigation; }
/* harmony export */ });
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs");


const isVirtualEnabled = (swiper) => !!swiper.virtual && !!swiper.params.virtual?.enabled;
const HashNavigation = ({ swiper, extendParams, emit, on }) => {
    let initialized = false;
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex(_s, hash) {
                if (isVirtualEnabled(swiper)) {
                    const slideWithHash = swiper.slides.find((slideEl) => slideEl.getAttribute('data-hash') === hash);
                    if (!slideWithHash)
                        return 0;
                    const index = parseInt(slideWithHash.getAttribute('data-swiper-slide-index') || '0', 10);
                    return index;
                }
                const matched = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.e)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0];
                return matched ? swiper.getSlideIndex(matched) : 0;
            },
        },
    });
    function getParams() {
        return swiper.params.hashNavigation;
    }
    const onHashChange = () => {
        emit('hashChange');
        const newHash = document.location.hash.replace('#', '');
        const activeSlideEl = isVirtualEnabled(swiper)
            ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`)
            : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') : '';
        if (newHash !== activeSlideHash) {
            const newIndex = getParams().getSlideIndex(swiper, newHash);
            if (typeof newIndex === 'undefined' || Number.isNaN(newIndex))
                return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = () => {
        const params = getParams();
        if (!initialized || !params.enabled)
            return;
        const activeSlideEl = isVirtualEnabled(swiper)
            ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`)
            : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl
            ? activeSlideEl.getAttribute('data-hash') || activeSlideEl.getAttribute('data-history')
            : '';
        if (params.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, '', `#${activeSlideHash}` || '');
            emit('hashSet');
        }
        else {
            document.location.hash = activeSlideHash || '';
            emit('hashSet');
        }
    };
    const init = () => {
        const params = getParams();
        const historyParams = swiper.params.history;
        if (!params.enabled || (historyParams && historyParams.enabled))
            return;
        initialized = true;
        const hash = document.location.hash.replace('#', '');
        if (hash) {
            const speed = 0;
            const index = params.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (params.watchState) {
            window.addEventListener('hashchange', onHashChange);
        }
    };
    const destroy = () => {
        if (getParams().watchState) {
            window.removeEventListener('hashchange', onHashChange);
        }
    };
    on('init', () => {
        if (getParams().enabled) {
            init();
        }
    });
    on('destroy', () => {
        if (getParams().enabled) {
            destroy();
        }
    });
    on('transitionEnd _freeModeNoMomentumRelease', () => {
        if (initialized) {
            setHash();
        }
    });
    on('slideChange', () => {
        if (initialized && swiper.params.cssMode) {
            setHash();
        }
    });
};




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/history.mjs":
/*!**********************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/history.mjs ***!
  \**********************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ History; }
/* harmony export */ });
const History = ({ swiper, extendParams, on }) => {
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides',
            keepQuery: false,
        },
    });
    let initialized = false;
    let paths = { key: undefined, value: undefined };
    function getParams() {
        return swiper.params.history;
    }
    const slugify = (text) => {
        return text
            .toString()
            .replace(/\s+/g, '-')
            .replace(/[^\w-]+/g, '')
            .replace(/--+/g, '-')
            .replace(/^-+/, '')
            .replace(/-+$/, '');
    };
    const getPathValues = (urlOverride) => {
        let location;
        if (urlOverride) {
            location = new URL(urlOverride);
        }
        else {
            location = window.location;
        }
        const pathArray = location.pathname
            .slice(1)
            .split('/')
            .filter((part) => part !== '');
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return { key, value };
    };
    const setHistory = (key, index) => {
        const params = getParams();
        if (!initialized || !params.enabled)
            return;
        let location;
        if (swiper.params.url) {
            location = new URL(swiper.params.url);
        }
        else {
            location = window.location;
        }
        const isVirtualEnabled = !!swiper.params.virtual
            ?.enabled;
        const slide = swiper.virtual && isVirtualEnabled
            ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${index}"]`)
            : swiper.slides[index];
        if (!slide)
            return;
        let value = slugify(slide.getAttribute('data-history') || '');
        const root = params.root;
        if (root.length > 0) {
            const trimmedRoot = root[root.length - 1] === '/' ? root.slice(0, root.length - 1) : root;
            value = `${trimmedRoot}/${key ? `${key}/` : ''}${value}`;
        }
        else if (!location.pathname.includes(key || '')) {
            value = `${key ? `${key}/` : ''}${value}`;
        }
        if (params.keepQuery) {
            value += location.search;
        }
        const currentState = window.history.state;
        if (currentState && currentState.value === value) {
            return;
        }
        if (params.replaceState) {
            window.history.replaceState({ value }, '', value);
        }
        else {
            window.history.pushState({ value }, '', value);
        }
    };
    const scrollToSlide = (speed, value, runCallbacks) => {
        if (value) {
            for (let i = 0, length = swiper.slides.length; i < length; i += 1) {
                const slide = swiper.slides[i];
                const slideHistory = slugify(slide.getAttribute('data-history') || '');
                if (slideHistory === value) {
                    const index = swiper.getSlideIndex(slide);
                    swiper.slideTo(index, speed, runCallbacks);
                }
            }
        }
        else {
            swiper.slideTo(0, speed, runCallbacks);
        }
    };
    const setHistoryPopState = () => {
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = () => {
        const params = swiper.params.history;
        if (!params)
            return;
        if (!window.history || !window.history.pushState) {
            params.enabled = false;
            const hashParams = swiper.params.hashNavigation;
            if (hashParams)
                hashParams.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!params.replaceState) {
                window.addEventListener('popstate', setHistoryPopState);
            }
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!params.replaceState) {
            window.addEventListener('popstate', setHistoryPopState);
        }
    };
    const destroy = () => {
        if (!getParams().replaceState) {
            window.removeEventListener('popstate', setHistoryPopState);
        }
    };
    on('init', () => {
        if (getParams().enabled) {
            init();
        }
    });
    on('destroy', () => {
        if (getParams().enabled) {
            destroy();
        }
    });
    on('transitionEnd _freeModeNoMomentumRelease', () => {
        if (initialized) {
            setHistory(getParams().key, swiper.activeIndex);
        }
    });
    on('slideChange', () => {
        if (initialized && swiper.params.cssMode) {
            setHistory(getParams().key, swiper.activeIndex);
        }
    });
};




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/index.mjs":
/*!********************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/index.mjs ***!
  \********************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A11y: function() { return /* reexport safe */ _a11y_mjs__WEBPACK_IMPORTED_MODULE_9__["default"]; },
/* harmony export */   Autoplay: function() { return /* reexport safe */ _autoplay_mjs__WEBPACK_IMPORTED_MODULE_12__["default"]; },
/* harmony export */   Controller: function() { return /* reexport safe */ _controller_mjs__WEBPACK_IMPORTED_MODULE_8__["default"]; },
/* harmony export */   EffectCards: function() { return /* reexport safe */ _effect_cards_mjs__WEBPACK_IMPORTED_MODULE_22__["default"]; },
/* harmony export */   EffectCoverflow: function() { return /* reexport safe */ _effect_coverflow_mjs__WEBPACK_IMPORTED_MODULE_20__["default"]; },
/* harmony export */   EffectCreative: function() { return /* reexport safe */ _effect_creative_mjs__WEBPACK_IMPORTED_MODULE_21__["default"]; },
/* harmony export */   EffectCube: function() { return /* reexport safe */ _effect_cube_mjs__WEBPACK_IMPORTED_MODULE_18__["default"]; },
/* harmony export */   EffectFade: function() { return /* reexport safe */ _effect_fade_mjs__WEBPACK_IMPORTED_MODULE_17__["default"]; },
/* harmony export */   EffectFlip: function() { return /* reexport safe */ _effect_flip_mjs__WEBPACK_IMPORTED_MODULE_19__["default"]; },
/* harmony export */   FreeMode: function() { return /* reexport safe */ _free_mode_mjs__WEBPACK_IMPORTED_MODULE_14__["default"]; },
/* harmony export */   Grid: function() { return /* reexport safe */ _grid_mjs__WEBPACK_IMPORTED_MODULE_15__["default"]; },
/* harmony export */   HashNavigation: function() { return /* reexport safe */ _hash_navigation_mjs__WEBPACK_IMPORTED_MODULE_11__["default"]; },
/* harmony export */   History: function() { return /* reexport safe */ _history_mjs__WEBPACK_IMPORTED_MODULE_10__["default"]; },
/* harmony export */   Keyboard: function() { return /* reexport safe */ _keyboard_mjs__WEBPACK_IMPORTED_MODULE_1__["default"]; },
/* harmony export */   Manipulation: function() { return /* reexport safe */ _manipulation_mjs__WEBPACK_IMPORTED_MODULE_16__["default"]; },
/* harmony export */   Mousewheel: function() { return /* reexport safe */ _mousewheel_mjs__WEBPACK_IMPORTED_MODULE_2__["default"]; },
/* harmony export */   Navigation: function() { return /* reexport safe */ _navigation_mjs__WEBPACK_IMPORTED_MODULE_3__["default"]; },
/* harmony export */   Pagination: function() { return /* reexport safe */ _pagination_mjs__WEBPACK_IMPORTED_MODULE_4__["default"]; },
/* harmony export */   Parallax: function() { return /* reexport safe */ _parallax_mjs__WEBPACK_IMPORTED_MODULE_6__["default"]; },
/* harmony export */   Scrollbar: function() { return /* reexport safe */ _scrollbar_mjs__WEBPACK_IMPORTED_MODULE_5__["default"]; },
/* harmony export */   Thumbs: function() { return /* reexport safe */ _thumbs_mjs__WEBPACK_IMPORTED_MODULE_13__["default"]; },
/* harmony export */   Virtual: function() { return /* reexport safe */ _virtual_mjs__WEBPACK_IMPORTED_MODULE_0__["default"]; },
/* harmony export */   Zoom: function() { return /* reexport safe */ _zoom_mjs__WEBPACK_IMPORTED_MODULE_7__["default"]; }
/* harmony export */ });
/* harmony import */ var _virtual_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./virtual.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/virtual.mjs");
/* harmony import */ var _keyboard_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./keyboard.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/keyboard.mjs");
/* harmony import */ var _mousewheel_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mousewheel.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/mousewheel.mjs");
/* harmony import */ var _navigation_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./navigation.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/navigation.mjs");
/* harmony import */ var _pagination_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./pagination.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/pagination.mjs");
/* harmony import */ var _scrollbar_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./scrollbar.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/scrollbar.mjs");
/* harmony import */ var _parallax_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./parallax.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/parallax.mjs");
/* harmony import */ var _zoom_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./zoom.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/zoom.mjs");
/* harmony import */ var _controller_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./controller.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/controller.mjs");
/* harmony import */ var _a11y_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./a11y.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/a11y.mjs");
/* harmony import */ var _history_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./history.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/history.mjs");
/* harmony import */ var _hash_navigation_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./hash-navigation.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/hash-navigation.mjs");
/* harmony import */ var _autoplay_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./autoplay.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/autoplay.mjs");
/* harmony import */ var _thumbs_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./thumbs.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/thumbs.mjs");
/* harmony import */ var _free_mode_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./free-mode.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/free-mode.mjs");
/* harmony import */ var _grid_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./grid.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/grid.mjs");
/* harmony import */ var _manipulation_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./manipulation.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/manipulation.mjs");
/* harmony import */ var _effect_fade_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./effect-fade.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/effect-fade.mjs");
/* harmony import */ var _effect_cube_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./effect-cube.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/effect-cube.mjs");
/* harmony import */ var _effect_flip_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./effect-flip.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/effect-flip.mjs");
/* harmony import */ var _effect_coverflow_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./effect-coverflow.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/effect-coverflow.mjs");
/* harmony import */ var _effect_creative_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./effect-creative.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/effect-creative.mjs");
/* harmony import */ var _effect_cards_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./effect-cards.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/effect-cards.mjs");
























/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/keyboard.mjs":
/*!***********************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/keyboard.mjs ***!
  \***********************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Keyboard; }
/* harmony export */ });
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs");


const Keyboard = ({ swiper, extendParams, on, emit }) => {
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true,
            speed: undefined,
        },
    });
    function getParams() {
        return swiper.params.keyboard;
    }
    function handle(event) {
        if (!swiper.enabled)
            return;
        const { rtlTranslate: rtl } = swiper;
        const e = 'originalEvent' in event && event.originalEvent ? event.originalEvent : event;
        const kc = e.keyCode || e.charCode;
        const params = getParams();
        const pageUpDown = !!params.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext &&
            ((swiper.isHorizontal() && isArrowRight) ||
                (swiper.isVertical() && isArrowDown) ||
                isPageDown)) {
            return false;
        }
        if (!swiper.allowSlidePrev &&
            ((swiper.isHorizontal() && isArrowLeft) || (swiper.isVertical() && isArrowUp) || isPageUp)) {
            return false;
        }
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
            return undefined;
        }
        const activeElement = document.activeElement;
        if (activeElement &&
            (activeElement.isContentEditable ||
                (activeElement.nodeName &&
                    (activeElement.nodeName.toLowerCase() === 'input' ||
                        activeElement.nodeName.toLowerCase() === 'textarea')))) {
            return undefined;
        }
        if (params.onlyInViewport &&
            (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.j)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 &&
                (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.j)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) {
                return undefined;
            }
            const el = swiper.el;
            const swiperWidth = el.clientWidth;
            const swiperHeight = el.clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.h)(el);
            if (rtl)
                swiperOffset.left -= el.scrollLeft;
            const swiperCoord = [
                [swiperOffset.left, swiperOffset.top],
                [swiperOffset.left + swiperWidth, swiperOffset.top],
                [swiperOffset.left, swiperOffset.top + swiperHeight],
                [swiperOffset.left + swiperWidth, swiperOffset.top + swiperHeight],
            ];
            for (let i = 0; i < swiperCoord.length; i += 1) {
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0)
                        continue;
                    inView = true;
                }
            }
            if (!inView)
                return undefined;
        }
        const speed = params.speed;
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.cancelable)
                    e.preventDefault();
            }
            if (((isPageDown || isArrowRight) && !rtl) || ((isPageUp || isArrowLeft) && rtl))
                swiper.slideNext(speed);
            if (((isPageUp || isArrowLeft) && !rtl) || ((isPageDown || isArrowRight) && rtl))
                swiper.slidePrev(speed);
        }
        else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.cancelable)
                    e.preventDefault();
            }
            if (isPageDown || isArrowDown)
                swiper.slideNext(speed);
            if (isPageUp || isArrowUp)
                swiper.slidePrev(speed);
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled)
            return;
        document.addEventListener('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled)
            return;
        document.removeEventListener('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    swiper.keyboard = {
        enabled: false,
        enable,
        disable,
    };
    on('init', () => {
        if (getParams().enabled) {
            enable();
        }
    });
    on('destroy', () => {
        if (swiper.keyboard.enabled) {
            disable();
        }
    });
};




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/manipulation.mjs":
/*!***************************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/manipulation.mjs ***!
  \***************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Manipulation; }
/* harmony export */ });
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs");


function addSlide(index, slides) {
    const swiper = this;
    const { params, activeIndex, slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides ?? 0;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for (let i = baseLength - 1; i >= index; i -= 1) {
        const currentSlide = swiper.slides[i];
        if (!currentSlide)
            continue;
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (Array.isArray(slides)) {
        for (let i = 0; i < slides.length; i += 1) {
            const slide = slides[i];
            if (slide)
                slidesEl.append(slide);
        }
        newActiveIndex =
            activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    }
    else {
        slidesEl.append(slides);
    }
    for (let i = 0; i < slidesBuffer.length; i += 1) {
        slidesEl.append(slidesBuffer[i]);
    }
    swiper.recalcSlides();
    if (params.loop) {
        swiper.loopCreate();
    }
    if (!params.observer || swiper.isElement) {
        swiper.update();
    }
    if (params.loop) {
        swiper.slideTo(newActiveIndex + (swiper.loopedSlides ?? 0), 0, false);
    }
    else {
        swiper.slideTo(newActiveIndex, 0, false);
    }
}

function appendSlide(slides) {
    const swiper = this;
    const { params, slidesEl } = swiper;
    if (params.loop) {
        swiper.loopDestroy();
    }
    const appendElement = (slideEl) => {
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.w)(tempDOM, slideEl);
            const child = tempDOM.children[0];
            if (child)
                slidesEl.append(child);
            (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.w)(tempDOM, '');
        }
        else {
            slidesEl.append(slideEl);
        }
    };
    if (Array.isArray(slides)) {
        for (let i = 0; i < slides.length; i += 1) {
            const slide = slides[i];
            if (slide)
                appendElement(slide);
        }
    }
    else {
        appendElement(slides);
    }
    swiper.recalcSlides();
    if (params.loop) {
        swiper.loopCreate();
    }
    if (!params.observer || swiper.isElement) {
        swiper.update();
    }
}

function prependSlide(slides) {
    const swiper = this;
    const { params, activeIndex, slidesEl } = swiper;
    if (params.loop) {
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl) => {
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.w)(tempDOM, slideEl);
            const child = tempDOM.children[0];
            if (child)
                slidesEl.prepend(child);
            (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.w)(tempDOM, '');
        }
        else {
            slidesEl.prepend(slideEl);
        }
    };
    if (Array.isArray(slides)) {
        for (let i = 0; i < slides.length; i += 1) {
            const slide = slides[i];
            if (slide)
                prependElement(slide);
        }
        newActiveIndex = activeIndex + slides.length;
    }
    else {
        prependElement(slides);
    }
    swiper.recalcSlides();
    if (params.loop) {
        swiper.loopCreate();
    }
    if (!params.observer || swiper.isElement) {
        swiper.update();
    }
    swiper.slideTo(newActiveIndex, 0, false);
}

function removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for (let i = 0; i < swiper.slides.length; i += 1) {
        slidesIndexes.push(i);
    }
    swiper.removeSlide(slidesIndexes);
}

function removeSlide(slidesIndexes) {
    const swiper = this;
    const { params, activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides ?? 0;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    if (Array.isArray(slidesIndexes)) {
        for (let i = 0; i < slidesIndexes.length; i += 1) {
            const indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove])
                swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex)
                newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    else {
        const indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove])
            swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex)
            newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) {
        swiper.loopCreate();
    }
    if (!params.observer || swiper.isElement) {
        swiper.update();
    }
    if (params.loop) {
        swiper.slideTo(newActiveIndex + (swiper.loopedSlides ?? 0), 0, false);
    }
    else {
        swiper.slideTo(newActiveIndex, 0, false);
    }
}

const Manipulation = ({ swiper }) => {
    Object.assign(swiper, {
        appendSlide: appendSlide.bind(swiper),
        prependSlide: prependSlide.bind(swiper),
        addSlide: addSlide.bind(swiper),
        removeSlide: removeSlide.bind(swiper),
        removeAllSlides: removeAllSlides.bind(swiper),
    });
};




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/mousewheel.mjs":
/*!*************************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/mousewheel.mjs ***!
  \*************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Mousewheel; }
/* harmony export */ });
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs");


const Mousewheel = ({ swiper, extendParams, on, emit }) => {
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: 'swiper-no-mousewheel',
        },
    });
    let timeout;
    let lastScrollTime = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.u)();
    let lastEventBeforeSnap;
    let mouseEntered = false;
    const recentWheelEvents = [];
    function getParams() {
        return swiper.params.mousewheel;
    }
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        const ev = e;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if (ev.detail !== undefined) {
            sY = ev.detail;
        }
        if (ev.wheelDelta !== undefined) {
            sY = -ev.wheelDelta / 120;
        }
        if (ev.wheelDeltaY !== undefined) {
            sY = -ev.wheelDeltaY / 120;
        }
        if (ev.wheelDeltaX !== undefined) {
            sX = -ev.wheelDeltaX / 120;
        }
        // side scrolling on FF with DOMMouseScroll
        if (ev.axis !== undefined &&
            ev.HORIZONTAL_AXIS !== undefined &&
            ev.axis === ev.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if (ev.deltaY !== undefined) {
            pY = ev.deltaY;
        }
        if (ev.deltaX !== undefined) {
            pX = ev.deltaX;
        }
        if (ev.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && ev.deltaMode) {
            if (ev.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            }
            else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) {
            sX = pX < 1 ? -1 : 1;
        }
        if (pY && !sY) {
            sY = pY < 1 ? -1 : 1;
        }
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY,
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled)
            return;
        mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled)
            return;
        mouseEntered = false;
    }
    function animateSlider(newEvent) {
        const params = getParams();
        if (params.thresholdDelta && newEvent.delta < params.thresholdDelta) {
            // Prevent if delta of wheel scroll delta is below configured threshold
            return false;
        }
        if (params.thresholdTime && (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.u)() - lastScrollTime < params.thresholdTime) {
            // Prevent if time between scrolls is below configured threshold
            return false;
        }
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.u)() - lastScrollTime < 60) {
            // Return false as a default
            return true;
        }
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        }
        else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = getParams();
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
                // Return true to animate scroll on edges
                return true;
            }
        }
        else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
            // Return true to animate scroll on edges
            return true;
        }
        return false;
    }
    function handle(event) {
        let e = 'originalEvent' in event && event.originalEvent ? event.originalEvent : event;
        let disableParentSwiper = true;
        if (!swiper.enabled)
            return false;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        const params = getParams();
        if (event.target.closest(`.${params.noMousewheelClass}`))
            return false;
        if (swiper.params.cssMode) {
            e.preventDefault();
        }
        let targetEl = swiper.el;
        if (params.eventsTarget !== 'container') {
            targetEl = document.querySelector(params.eventsTarget);
        }
        const targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!mouseEntered && !targetElContainsTarget && !params.releaseOnEdges)
            return true;
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY))
                    delta = -data.pixelX * rtlFactor;
                else
                    return true;
            }
            else if (Math.abs(data.pixelY) > Math.abs(data.pixelX))
                delta = -data.pixelY;
            else
                return true;
        }
        else {
            delta =
                Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        }
        if (delta === 0)
            return true;
        if (params.invert)
            delta = -delta;
        // Get the scroll positions
        let positions = swiper.getTranslate() + delta * (params.sensitivity ?? 1);
        if (positions >= swiper.minTranslate())
            positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate())
            positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop
            ? true
            : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested)
            e.stopPropagation();
        const freeModeParams = swiper.params.freeMode;
        if (!swiper.params.freeMode || !freeModeParams?.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.u)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event,
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) {
                recentWheelEvents.shift(); // only store the last N events
            }
            const prevEvent = recentWheelEvents.length
                ? recentWheelEvents[recentWheelEvents.length - 1]
                : undefined;
            recentWheelEvents.push(newEvent);
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction ||
                    newEvent.delta > prevEvent.delta ||
                    newEvent.time > prevEvent.time + 150) {
                    animateSlider(newEvent);
                }
            }
            else {
                animateSlider(newEvent);
            }
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) {
                return true;
            }
        }
        else {
            // Freemode or scrollContainer:
            const newEvent = {
                time: (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.u)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
            };
            const ignoreWheelEvents = lastEventBeforeSnap &&
                newEvent.time < lastEventBeforeSnap.time + 500 &&
                newEvent.delta <= lastEventBeforeSnap.delta &&
                newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position = swiper.getTranslate() + delta * (params.sensitivity ?? 1);
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate())
                    position = swiper.minTranslate();
                if (position <= swiper.maxTranslate())
                    position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if ((!wasBeginning && swiper.isBeginning) || (!wasEnd && swiper.isEnd)) {
                    swiper.updateSlidesClasses();
                }
                if (swiper.params.loop) {
                    swiper.loopFix({
                        direction: newEvent.direction < 0 ? 'next' : 'prev',
                        byMousewheel: true,
                    });
                }
                if (freeModeParams?.sticky) {
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) {
                        recentWheelEvents.shift(); // only store the last N events
                    }
                    const prevEvent = recentWheelEvents.length
                        ? recentWheelEvents[recentWheelEvents.length - 1]
                        : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent &&
                        (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) {
                        // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                        recentWheelEvents.splice(0);
                    }
                    else if (recentWheelEvents.length >= 15 &&
                        firstEvent &&
                        newEvent.time - firstEvent.time < 500 &&
                        firstEvent.delta - newEvent.delta >= 1 &&
                        newEvent.delta <= 6) {
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.t)(() => {
                            if (swiper.destroyed || !swiper.params)
                                return;
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) {
                        timeout = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.t)(() => {
                            if (swiper.destroyed || !swiper.params)
                                return;
                            const snapToThreshold = 0.5;
                            lastEventBeforeSnap = newEvent;
                            recentWheelEvents.splice(0);
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 500);
                    }
                }
                // Emit event
                if (!ignoreWheelEvents)
                    emit('scroll', e);
                // Stop autoplay
                const autoplayParams = swiper.params.autoplay;
                if (swiper.params.autoplay && autoplayParams?.disableOnInteraction) {
                    swiper.autoplay.stop();
                }
                // Return page scroll on edge positions
                if (params.releaseOnEdges &&
                    (position === swiper.minTranslate() || position === swiper.maxTranslate())) {
                    return true;
                }
            }
        }
        if (e.cancelable)
            e.preventDefault();
        return false;
    }
    function events(method) {
        const params = getParams();
        let targetEl = swiper.el;
        if (params.eventsTarget !== 'container') {
            targetEl = document.querySelector(params.eventsTarget);
        }
        targetEl[method]('mouseenter', handleMouseEnter);
        targetEl[method]('mouseleave', handleMouseLeave);
        targetEl[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled)
            return false;
        events('addEventListener');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener('wheel', handle);
            return true;
        }
        if (!swiper.mousewheel.enabled)
            return false;
        events('removeEventListener');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', () => {
        const params = getParams();
        if (!params.enabled && swiper.params.cssMode) {
            disable();
        }
        if (params.enabled)
            enable();
    });
    swiper.mousewheel = {
        enabled: false,
        enable,
        disable,
    };
    on('destroy', () => {
        if (swiper.params.cssMode) {
            enable();
        }
        if (swiper.mousewheel.enabled)
            disable();
    });
};




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/navigation.mjs":
/*!*************************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/navigation.mjs ***!
  \*************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Navigation; }
/* harmony export */ });
/* harmony import */ var _shared_create_element_if_not_defined_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/create-element-if-not-defined.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/create-element-if-not-defined.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs");



const arrowSvg = `<svg class="swiper-navigation-icon" width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>`;
const Navigation = ({ swiper, extendParams, on, emit }) => {
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            addIcons: true,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled',
        },
    });
    // Initialized as a partial; remaining methods (update, init, destroy,
    // enable, disable) attach after their definitions below.
    swiper.navigation = {
        nextEl: null,
        prevEl: null,
        arrowSvg,
    };
    function getParams() {
        return swiper.params.navigation;
    }
    function getEl(el) {
        let res;
        if (el && typeof el === 'string' && swiper.isElement) {
            res = (swiper.el.querySelector(el) || swiper.hostEl.querySelector(el));
            if (res)
                return res;
        }
        if (el) {
            if (typeof el === 'string')
                res = [...document.querySelectorAll(el)];
            if (swiper.params.uniqueNavElements &&
                typeof el === 'string' &&
                res &&
                res.length > 1 &&
                swiper.el.querySelectorAll(el).length === 1) {
                res = swiper.el.querySelector(el);
            }
            else if (res && res.length === 1) {
                res = res[0];
            }
        }
        if (el && !res)
            return el;
        return res;
    }
    function toggleEl(el, disabled) {
        const params = getParams();
        const els = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(el);
        els.forEach((subEl) => {
            if (subEl) {
                subEl.classList[disabled ? 'add' : 'remove'](...params.disabledClass.split(' '));
                if (subEl.tagName === 'BUTTON')
                    subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) {
                    subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
                }
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        const { nextEl, prevEl } = swiper.navigation;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind)
            return;
        swiper.slidePrev();
        emit('navigationPrev');
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind)
            return;
        swiper.slideNext();
        emit('navigationNext');
    }
    function init() {
        swiper.params.navigation = (0,_shared_create_element_if_not_defined_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev',
        });
        const params = getParams();
        if (!(params.nextEl || params.prevEl))
            return;
        const nextEl = getEl(params.nextEl);
        const prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl,
            prevEl,
        });
        const nextEls = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(nextEl);
        const prevEls = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(prevEl);
        const initButton = (el, dir) => {
            if (el) {
                if (params.addIcons &&
                    el.matches('.swiper-button-next,.swiper-button-prev') &&
                    !el.querySelector('svg')) {
                    const tempEl = document.createElement('div');
                    (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.w)(tempEl, arrowSvg);
                    const svgEl = tempEl.querySelector('svg');
                    if (svgEl)
                        el.appendChild(svgEl);
                    tempEl.remove();
                }
                el.addEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            }
            if (!swiper.enabled && el) {
                el.classList.add(...params.lockClass.split(' '));
            }
        };
        nextEls.forEach((el) => initButton(el, 'next'));
        prevEls.forEach((el) => initButton(el, 'prev'));
    }
    function destroy() {
        const params = getParams();
        const { nextEl, prevEl } = swiper.navigation;
        const nextEls = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(nextEl);
        const prevEls = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(prevEl);
        const destroyButton = (el, dir) => {
            el.removeEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            el.classList.remove(...params.disabledClass.split(' '));
        };
        nextEls.forEach((el) => destroyButton(el, 'next'));
        prevEls.forEach((el) => destroyButton(el, 'prev'));
    }
    on('init', () => {
        if (getParams().enabled === false) {
            disable();
        }
        else {
            init();
            update();
        }
    });
    on('toEdge fromEdge lock unlock', () => {
        update();
    });
    on('destroy', () => {
        destroy();
    });
    on('enable disable', () => {
        const params = getParams();
        const { nextEl, prevEl } = swiper.navigation;
        const nextEls = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(nextEl);
        const prevEls = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        [...nextEls, ...prevEls]
            .filter((el) => !!el)
            .forEach((el) => el.classList.add(params.lockClass));
    });
    on('click', (_s, e) => {
        const params = getParams();
        const { nextEl, prevEl } = swiper.navigation;
        const nextEls = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(nextEl);
        const prevEls = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(prevEl);
        const targetEl = e.target;
        let targetIsButton = prevEls.includes(targetEl) || nextEls.includes(targetEl);
        if (swiper.isElement && !targetIsButton) {
            const path = e.composedPath ? e.composedPath() : [];
            if (path.length) {
                targetIsButton = path.find((pathEl) => nextEls.includes(pathEl) || prevEls.includes(pathEl));
            }
        }
        if (params.hideOnClick && !targetIsButton) {
            if (swiper.pagination &&
                swiper.params.pagination &&
                swiper.params.pagination.clickable &&
                (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl)))
                return;
            let isHidden;
            if (nextEls.length) {
                isHidden = nextEls[0].classList.contains(params.hiddenClass);
            }
            else if (prevEls.length) {
                isHidden = prevEls[0].classList.contains(params.hiddenClass);
            }
            if (isHidden === true) {
                emit('navigationShow');
            }
            else {
                emit('navigationHide');
            }
            [...nextEls, ...prevEls]
                .filter((el) => !!el)
                .forEach((el) => el.classList.toggle(params.hiddenClass));
        }
    });
    const enable = () => {
        const params = getParams();
        swiper.el.classList.remove(...params.navigationDisabledClass.split(' '));
        init();
        update();
    };
    const disable = () => {
        const params = getParams();
        swiper.el.classList.add(...params.navigationDisabledClass.split(' '));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable,
        disable,
        update,
        init,
        destroy,
    });
};




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/pagination.mjs":
/*!*************************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/pagination.mjs ***!
  \*************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Pagination; }
/* harmony export */ });
/* harmony import */ var _shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/classes-to-selector.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/classes-to-selector.mjs");
/* harmony import */ var _shared_create_element_if_not_defined_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/create-element-if-not-defined.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/create-element-if-not-defined.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs");




const isVirtualEnabled = (swiper) => !!swiper.virtual && !!swiper.params.virtual?.enabled;
const isFreeModeEnabled = (swiper) => !!swiper.params.freeMode?.enabled;
// Slides count for bullets/fraction/progressbar totals: with grid rows the
// slides that share a column collapse into one snap position.
const getSlidesLength = (swiper) => {
    if (isVirtualEnabled(swiper))
        return swiper.virtual.slides.length;
    const gridRows = swiper.params.grid?.rows;
    if (swiper.grid && gridRows && gridRows > 1) {
        return swiper.slides.length / Math.ceil(gridRows);
    }
    return swiper.slides.length;
};
const Pagination = ({ swiper, extendParams, on, emit }) => {
    const pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets', // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number) => number,
            formatFractionTotal: (number) => number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`,
        },
    });
    // Initialized as a partial; remaining methods (render, update, init,
    // destroy, enable, disable) attach after their definitions below.
    swiper.pagination = {
        el: null,
        bullets: [],
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function getParams() {
        return swiper.params.pagination;
    }
    function isPaginationDisabled() {
        const elParam = getParams().el;
        return (!elParam ||
            !swiper.pagination.el ||
            (Array.isArray(swiper.pagination.el) &&
                swiper.pagination.el.length === 0));
    }
    function setSideBullets(bulletEl, position) {
        const { bulletActiveClass } = getParams();
        if (!bulletEl)
            return;
        let current = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
        if (current) {
            current.classList.add(`${bulletActiveClass}-${position}`);
            current = current[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
            if (current) {
                current.classList.add(`${bulletActiveClass}-${position}-${position}`);
            }
        }
    }
    function getMoveDirection(prevIndex, nextIndex, length) {
        prevIndex = prevIndex % length;
        nextIndex = nextIndex % length;
        if (nextIndex === prevIndex + 1) {
            return 'next';
        }
        else if (nextIndex === prevIndex - 1) {
            return 'previous';
        }
        return undefined;
    }
    function onBulletClick(e) {
        const targetEl = e.target;
        const bulletEl = targetEl.closest((0,_shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(getParams().bulletClass));
        if (!bulletEl) {
            return;
        }
        e.preventDefault();
        const index = ((0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.b)(bulletEl) ?? 0) * (swiper.params.slidesPerGroup ?? 1);
        if (swiper.params.loop) {
            if (swiper.realIndex === index)
                return;
            const moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
            if (moveDirection === 'next') {
                swiper.slideNext();
            }
            else if (moveDirection === 'previous') {
                swiper.slidePrev();
            }
            else {
                swiper.slideToLoop(index);
            }
        }
        else {
            swiper.slideTo(index);
        }
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = getParams();
        if (isPaginationDisabled())
            return;
        const els = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.s)(swiper.pagination.el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = getSlidesLength(swiper);
        const total = swiper.params.loop
            ? Math.ceil(slidesLength / (swiper.params.slidesPerGroup ?? 1))
            : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current =
                (swiper.params.slidesPerGroup ?? 1) > 1
                    ? Math.floor(swiper.realIndex / (swiper.params.slidesPerGroup ?? 1))
                    : swiper.realIndex;
        }
        else if (typeof swiper.snapIndex !== 'undefined') {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        }
        else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === 'bullets' &&
            swiper.pagination.bullets &&
            swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex = 0;
            let lastIndex = 0;
            let midIndex = 0;
            if (params.dynamicBullets) {
                bulletSize = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.i)(bullets[0], swiper.isHorizontal() ? 'width' : 'height');
                const dim = swiper.isHorizontal() ? 'width' : 'height';
                els.forEach((subEl) => {
                    subEl.style[dim] = `${(bulletSize ?? 0) * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
                        dynamicBulletIndex = params.dynamicMainBullets - 1;
                    }
                    else if (dynamicBulletIndex < 0) {
                        dynamicBulletIndex = 0;
                    }
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach((bulletEl) => {
                const classesToRemove = [
                    '',
                    '-next',
                    '-next-next',
                    '-prev',
                    '-prev-prev',
                    '-main',
                ]
                    .map((suffix) => `${params.bulletActiveClass}${suffix}`)
                    .flatMap((s) => (typeof s === 'string' && s.includes(' ') ? s.split(' ') : [s]));
                bulletEl.classList.remove(...classesToRemove);
            });
            if (els.length > 1) {
                bullets.forEach((bullet) => {
                    const bulletIndex = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.b)(bullet);
                    if (bulletIndex === current) {
                        bullet.classList.add(...params.bulletActiveClass.split(' '));
                    }
                    else if (swiper.isElement) {
                        bullet.setAttribute('part', 'bullet');
                    }
                    if (params.dynamicBullets && bulletIndex !== undefined) {
                        if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                            bullet.classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                        }
                        if (bulletIndex === firstIndex) {
                            setSideBullets(bullet, 'prev');
                        }
                        if (bulletIndex === lastIndex) {
                            setSideBullets(bullet, 'next');
                        }
                    }
                });
            }
            else {
                const bullet = bullets[current];
                if (bullet) {
                    bullet.classList.add(...params.bulletActiveClass.split(' '));
                }
                if (swiper.isElement) {
                    bullets.forEach((bulletEl, bulletIndex) => {
                        bulletEl.setAttribute('part', bulletIndex === current ? 'bullet-active' : 'bullet');
                    });
                }
                if (params.dynamicBullets) {
                    const firstDisplayedBullet = bullets[firstIndex];
                    const lastDisplayedBullet = bullets[lastIndex];
                    for (let i = firstIndex; i <= lastIndex; i += 1) {
                        if (bullets[i]) {
                            bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                        }
                    }
                    setSideBullets(firstDisplayedBullet, 'prev');
                    setSideBullets(lastDisplayedBullet, 'next');
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = ((bulletSize ?? 0) * dynamicBulletsLength - (bulletSize ?? 0)) / 2 -
                    midIndex * (bulletSize ?? 0);
                const offsetProp = rtl ? 'right' : 'left';
                const positionDim = swiper.isHorizontal() ? offsetProp : 'top';
                bullets.forEach((bullet) => {
                    bullet.style[positionDim] = `${bulletsOffset}px`;
                });
            }
        }
        els.forEach((subEl, subElIndex) => {
            if (params.type === 'fraction') {
                subEl.querySelectorAll((0,_shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(params.currentClass)).forEach((fractionEl) => {
                    fractionEl.textContent = String(params.formatFractionCurrent(current + 1));
                });
                subEl.querySelectorAll((0,_shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(params.totalClass)).forEach((totalEl) => {
                    totalEl.textContent = String(params.formatFractionTotal(total));
                });
            }
            if (params.type === 'progressbar') {
                let progressbarDirection;
                if (params.progressbarOpposite) {
                    progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
                }
                else {
                    progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
                }
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === 'horizontal') {
                    scaleX = scale;
                }
                else {
                    scaleY = scale;
                }
                subEl
                    .querySelectorAll((0,_shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(params.progressbarFillClass))
                    .forEach((progressEl) => {
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === 'custom' && params.renderCustom) {
                (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.w)(subEl, params.renderCustom(swiper, current + 1, total));
                if (subElIndex === 0)
                    emit('paginationRender', subEl);
            }
            else {
                if (subElIndex === 0)
                    emit('paginationRender', subEl);
                emit('paginationUpdate', subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) {
                subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
            }
        });
    }
    function render() {
        // Render Container
        const params = getParams();
        if (isPaginationDisabled())
            return;
        const slidesLength = getSlidesLength(swiper);
        const els = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.s)(swiper.pagination.el);
        let paginationHTML = '';
        if (params.type === 'bullets') {
            let numberOfBullets = swiper.params.loop
                ? Math.ceil(slidesLength / (swiper.params.slidesPerGroup ?? 1))
                : swiper.snapGrid.length;
            if (swiper.params.freeMode && isFreeModeEnabled(swiper) && numberOfBullets > slidesLength) {
                numberOfBullets = slidesLength;
            }
            for (let i = 0; i < numberOfBullets; i += 1) {
                if (params.renderBullet) {
                    paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
                }
                else {
                    // oxfmt-ignore
                    paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ''} class="${params.bulletClass}"></${params.bulletElement}>`;
                }
            }
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) {
                paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            }
            else {
                paginationHTML =
                    `<span class="${params.currentClass}"></span>` +
                        ' / ' +
                        `<span class="${params.totalClass}"></span>`;
            }
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) {
                paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            }
            else {
                paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
            }
        }
        swiper.pagination.bullets = [];
        els.forEach((subEl) => {
            if (params.type !== 'custom') {
                (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.w)(subEl, paginationHTML || '');
            }
            if (params.type === 'bullets') {
                swiper.pagination.bullets.push(...Array.from(subEl.querySelectorAll((0,_shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(params.bulletClass))));
            }
        });
        if (params.type !== 'custom') {
            emit('paginationRender', els[0]);
        }
    }
    function init() {
        swiper.params.pagination = (0,_shared_create_element_if_not_defined_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(swiper, swiper.originalParams.pagination, swiper.params.pagination, { el: 'swiper-pagination' });
        const params = getParams();
        if (!params.el)
            return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) {
            el = swiper.el.querySelector(params.el);
        }
        if (!el && typeof params.el === 'string') {
            el = [...document.querySelectorAll(params.el)];
        }
        if (!el) {
            el = params.el;
        }
        if (!el || (Array.isArray(el) && el.length === 0))
            return;
        if (swiper.params.uniqueNavElements &&
            typeof params.el === 'string' &&
            Array.isArray(el) &&
            el.length > 1) {
            el = [...swiper.el.querySelectorAll(params.el)];
            // check if it belongs to another nested Swiper
            if (el.length > 1) {
                const found = el.find((subEl) => {
                    if ((0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.j)(subEl, '.swiper')[0] !== swiper.el)
                        return false;
                    return true;
                });
                if (found)
                    el = found;
            }
        }
        if (Array.isArray(el) && el.length === 1)
            el = el[0];
        Object.assign(swiper.pagination, {
            el,
        });
        const els = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.s)(el);
        els.forEach((subEl) => {
            if (params.type === 'bullets' && params.clickable) {
                subEl.classList.add(...(params.clickableClass || '').split(' '));
            }
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === 'bullets' && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) {
                    params.dynamicMainBullets = 1;
                }
            }
            if (params.type === 'progressbar' && params.progressbarOpposite) {
                subEl.classList.add(params.progressbarOppositeClass);
            }
            if (params.clickable) {
                subEl.addEventListener('click', onBulletClick);
            }
            if (!swiper.enabled) {
                subEl.classList.add(params.lockClass);
            }
        });
    }
    function destroy() {
        const params = getParams();
        if (isPaginationDisabled())
            return;
        const el = swiper.pagination.el;
        if (el) {
            const els = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.s)(el);
            els.forEach((subEl) => {
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    subEl.classList.remove(...(params.clickableClass || '').split(' '));
                    subEl.removeEventListener('click', onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets)
            swiper.pagination.bullets.forEach((subEl) => subEl.classList.remove(...params.bulletActiveClass.split(' ')));
    }
    on('changeDirection', () => {
        if (!swiper.pagination || !swiper.pagination.el)
            return;
        const params = getParams();
        const els = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.s)(swiper.pagination.el);
        els.forEach((subEl) => {
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', () => {
        if (getParams().enabled === false) {
            disable();
        }
        else {
            init();
            render();
            update();
        }
    });
    on('activeIndexChange', () => {
        if (typeof swiper.snapIndex === 'undefined') {
            update();
        }
    });
    on('snapIndexChange', () => {
        update();
    });
    on('snapGridLengthChange', () => {
        render();
        update();
    });
    on('destroy', () => {
        destroy();
    });
    on('enable disable', () => {
        const { el } = swiper.pagination;
        if (el) {
            const params = getParams();
            const els = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.s)(el);
            els.forEach((subEl) => subEl.classList[swiper.enabled ? 'remove' : 'add'](params.lockClass));
        }
    });
    on('lock unlock', () => {
        update();
    });
    on('click', (_s, e) => {
        const targetEl = e.target;
        const els = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.s)(swiper.pagination.el);
        const params = getParams();
        if (params.el &&
            params.hideOnClick &&
            els &&
            els.length > 0 &&
            !targetEl.classList.contains(params.bulletClass)) {
            if (swiper.navigation &&
                ((swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl) ||
                    (swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)))
                return;
            const isHidden = els[0].classList.contains(params.hiddenClass);
            if (isHidden === true) {
                emit('paginationShow');
            }
            else {
                emit('paginationHide');
            }
            els.forEach((subEl) => subEl.classList.toggle(params.hiddenClass));
        }
    });
    const enable = () => {
        const params = getParams();
        swiper.el.classList.remove(params.paginationDisabledClass);
        const { el } = swiper.pagination;
        if (el) {
            const els = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.s)(el);
            els.forEach((subEl) => subEl.classList.remove(params.paginationDisabledClass));
        }
        init();
        render();
        update();
    };
    const disable = () => {
        const params = getParams();
        swiper.el.classList.add(params.paginationDisabledClass);
        const { el } = swiper.pagination;
        if (el) {
            const els = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_2__.s)(el);
            els.forEach((subEl) => subEl.classList.add(params.paginationDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable,
        disable,
        render,
        update,
        init,
        destroy,
    });
};




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/parallax.mjs":
/*!***********************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/parallax.mjs ***!
  \***********************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Parallax; }
/* harmony export */ });
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs");


const Parallax = ({ swiper, extendParams, on }) => {
    extendParams({
        parallax: {
            enabled: false,
        },
    });
    function getParams() {
        return swiper.params.parallax;
    }
    const elementsSelector = '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]';
    const setTransform = (el, progress) => {
        const { rtl } = swiper;
        const rtlFactor = rtl ? -1 : 1;
        const p = el.getAttribute('data-swiper-parallax') || '0';
        let x = el.getAttribute('data-swiper-parallax-x');
        let y = el.getAttribute('data-swiper-parallax-y');
        const scale = el.getAttribute('data-swiper-parallax-scale');
        const opacity = el.getAttribute('data-swiper-parallax-opacity');
        const rotate = el.getAttribute('data-swiper-parallax-rotate');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        }
        else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        }
        else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) {
            x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        }
        else {
            x = `${Number(x) * progress * rtlFactor}px`;
        }
        if (y.indexOf('%') >= 0) {
            y = `${parseInt(y, 10) * progress}%`;
        }
        else {
            y = `${Number(y) * progress}px`;
        }
        if (typeof opacity !== 'undefined' && opacity !== null) {
            const opacityNum = Number(opacity);
            const currentOpacity = opacityNum - (opacityNum - 1) * (1 - Math.abs(progress));
            el.style.opacity = String(currentOpacity);
        }
        let transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== 'undefined' && scale !== null) {
            const scaleNum = Number(scale);
            const currentScale = scaleNum - (scaleNum - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== 'undefined' && rotate !== null) {
            const currentRotate = Number(rotate) * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    const setTranslate = () => {
        const { el, slides, progress, snapGrid } = swiper;
        const elements = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.e)(el, elementsSelector);
        if (swiper.isElement) {
            elements.push(...(0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.e)(swiper.hostEl, elementsSelector));
        }
        elements.forEach((subEl) => {
            setTransform(subEl, progress);
        });
        slides.forEach((slideEl, slideIndex) => {
            let slideProgress = slideEl.progress ?? 0;
            const slidesPerGroup = swiper.params.slidesPerGroup ?? 1;
            if (slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
                slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            }
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl
                .querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`)
                .forEach((subEl) => {
                setTransform(subEl, slideProgress);
            });
        });
    };
    const setTransition = (duration = swiper.params.speed ?? 300) => {
        const { el, hostEl } = swiper;
        const elements = [...el.querySelectorAll(elementsSelector)];
        if (swiper.isElement) {
            elements.push(...hostEl.querySelectorAll(elementsSelector));
        }
        elements.forEach((parallaxEl) => {
            const attr = parallaxEl.getAttribute('data-swiper-parallax-duration');
            let parallaxDuration = (attr ? parseInt(attr, 10) : 0) || duration;
            if (duration === 0)
                parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on('beforeInit', () => {
        if (!getParams().enabled)
            return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', () => {
        if (!getParams().enabled)
            return;
        setTranslate();
    });
    on('setTranslate', () => {
        if (!getParams().enabled)
            return;
        setTranslate();
    });
    on('setTransition', (_swiper, duration) => {
        if (!getParams().enabled)
            return;
        setTransition(duration);
    });
};




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/scrollbar.mjs":
/*!************************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/scrollbar.mjs ***!
  \************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Scrollbar; }
/* harmony export */ });
/* harmony import */ var _shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/classes-to-selector.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/classes-to-selector.mjs");
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs");
/* harmony import */ var _shared_create_element_if_not_defined_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../shared/create-element-if-not-defined.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/create-element-if-not-defined.mjs");




const Scrollbar = ({ swiper, extendParams, on, emit }) => {
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos = 0;
    let dragSize = 0;
    let trackSize = 0;
    let divider = 0;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`,
        },
    });
    // Initialized as a partial; remaining methods (updateSize, setTranslate,
    // init, destroy, enable, disable) attach after their definitions below.
    swiper.scrollbar = {
        el: null,
        dragEl: null,
    };
    function getParams() {
        return swiper.params.scrollbar;
    }
    function setTranslate() {
        const params = getParams();
        if (!params.el || !swiper.scrollbar.el)
            return;
        const { scrollbar, rtlTranslate: rtl } = swiper;
        const { dragEl, el } = scrollbar;
        const progress = swiper.params.loop ? (swiper.progressLoop ?? 0) : swiper.progress;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            }
            else if (-newPos + dragSize > trackSize) {
                newSize = trackSize + newPos;
            }
        }
        else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        }
        else if (newPos + dragSize > trackSize) {
            newSize = trackSize - newPos;
        }
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        }
        else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
        if (params.hide) {
            if (timeout)
                clearTimeout(timeout);
            el.style.opacity = '1';
            timeout = setTimeout(() => {
                el.style.opacity = '0';
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!getParams().el || !swiper.scrollbar.el)
            return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        const params = getParams();
        if (!params.el || !swiper.scrollbar.el)
            return;
        const { scrollbar } = swiper;
        const { dragEl, el } = scrollbar;
        dragEl.style.width = '';
        dragEl.style.height = '';
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider =
            swiper.size /
                (swiper.virtualSize +
                    (swiper.params.slidesOffsetBefore ?? 0) -
                    (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (params.dragSize === 'auto') {
            dragSize = trackSize * divider;
        }
        else {
            dragSize = parseInt(String(params.dragSize), 10);
        }
        if (swiper.isHorizontal()) {
            dragEl.style.width = `${dragSize}px`;
        }
        else {
            dragEl.style.height = `${dragSize}px`;
        }
        if (divider >= 1) {
            el.style.display = 'none';
        }
        else {
            el.style.display = '';
        }
        if (params.hide) {
            el.style.opacity = '0';
        }
        if (swiper.params.watchOverflow && swiper.enabled) {
            scrollbar.el.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
        }
    }
    function getPointerPosition(e) {
        if (swiper.isHorizontal()) {
            return e.clientX ?? e.touches?.[0]?.clientX ?? 0;
        }
        return e.clientY ?? e.touches?.[0]?.clientY ?? 0;
    }
    function setDragPosition(e) {
        const { scrollbar, rtlTranslate: rtl } = swiper;
        const { el } = scrollbar;
        let positionRatio;
        positionRatio =
            (getPointerPosition(e) -
                (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.h)(el)[swiper.isHorizontal() ? 'left' : 'top'] -
                (dragStartPos !== null ? dragStartPos : dragSize / 2)) /
                (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) {
            positionRatio = 1 - positionRatio;
        }
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = getParams();
        const { scrollbar, wrapperEl } = swiper;
        const { el, dragEl } = scrollbar;
        isTouched = true;
        dragStartPos =
            e.target === dragEl
                ? getPointerPosition(e) -
                    e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top']
                : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = '100ms';
        dragEl.style.transitionDuration = '100ms';
        setDragPosition(e);
        if (dragTimeout)
            clearTimeout(dragTimeout);
        el.style.transitionDuration = '0ms';
        if (params.hide) {
            el.style.opacity = '1';
        }
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.scrollSnapType = 'none';
        }
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        const { scrollbar, wrapperEl } = swiper;
        const { el, dragEl } = scrollbar;
        if (!isTouched)
            return;
        if (e.cancelable)
            e.preventDefault();
        setDragPosition(e);
        wrapperEl.style.transitionDuration = '0ms';
        el.style.transitionDuration = '0ms';
        dragEl.style.transitionDuration = '0ms';
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        const params = getParams();
        const { scrollbar, wrapperEl } = swiper;
        const { el } = scrollbar;
        if (!isTouched)
            return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.scrollSnapType = '';
            wrapperEl.style.transitionDuration = '';
        }
        if (params.hide) {
            if (dragTimeout)
                clearTimeout(dragTimeout);
            dragTimeout = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.t)(() => {
                el.style.opacity = '0';
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) {
            swiper.slideToClosest();
        }
    }
    function events(method) {
        const { scrollbar, params } = swiper;
        const el = scrollbar.el;
        if (!el)
            return;
        const activeListener = params.passiveListeners ? { passive: false, capture: false } : false;
        const passiveListener = params.passiveListeners ? { passive: true, capture: false } : false;
        const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        el[eventMethod]('pointerdown', onDragStart, activeListener);
        document[eventMethod]('pointermove', onDragMove, activeListener);
        document[eventMethod]('pointerup', onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!getParams().el || !swiper.scrollbar.el)
            return;
        events('on');
    }
    function disableDraggable() {
        if (!getParams().el || !swiper.scrollbar.el)
            return;
        events('off');
    }
    function init() {
        const { scrollbar, el: swiperEl } = swiper;
        swiper.params.scrollbar = (0,_shared_create_element_if_not_defined_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, { el: 'swiper-scrollbar' });
        const params = getParams();
        if (!params.el)
            return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) {
            el = swiper.el.querySelector(params.el);
        }
        else {
            el = params.el;
        }
        if (!el && typeof params.el === 'string') {
            el = document.querySelectorAll(params.el);
            if (!el.length)
                return;
        }
        else if (!el) {
            el = params.el;
        }
        if (swiper.params.uniqueNavElements &&
            typeof params.el === 'string' &&
            el.length > 1 &&
            swiperEl.querySelectorAll(params.el).length === 1) {
            el = swiperEl.querySelector(params.el);
        }
        if (el.length > 0) {
            el = el[0];
        }
        const elTyped = el;
        elTyped.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let dragEl = null;
        if (elTyped) {
            dragEl = elTyped.querySelector((0,_shared_classes_to_selector_mjs__WEBPACK_IMPORTED_MODULE_0__.c)(params.dragClass));
            if (!dragEl) {
                dragEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.a)('div', params.dragClass);
                elTyped.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: elTyped,
            dragEl,
        });
        if (params.draggable) {
            enableDraggable();
        }
        if (elTyped) {
            elTyped.classList[swiper.enabled ? 'remove' : 'add'](...(0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(params.lockClass));
        }
    }
    function destroy() {
        const params = getParams();
        const el = swiper.scrollbar.el;
        if (el) {
            el.classList.remove(...(0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass));
        }
        disableDraggable();
    }
    on('changeDirection', () => {
        if (!swiper.scrollbar || !swiper.scrollbar.el)
            return;
        const params = getParams();
        const els = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.s)(swiper.scrollbar.el);
        els.forEach((subEl) => {
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', () => {
        if (getParams().enabled === false) {
            disable();
        }
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on('update resize observerUpdate lock unlock changeDirection', () => {
        updateSize();
    });
    on('setTranslate', () => {
        setTranslate();
    });
    on('setTransition', (_s, duration) => {
        setTransition(duration);
    });
    on('enable disable', () => {
        const { el } = swiper.scrollbar;
        if (el) {
            el.classList[swiper.enabled ? 'remove' : 'add'](...(0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(getParams().lockClass));
        }
    });
    on('destroy', () => {
        destroy();
    });
    const enable = () => {
        const params = getParams();
        swiper.el.classList.remove(...(0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(params.scrollbarDisabledClass));
        if (swiper.scrollbar.el) {
            swiper.scrollbar.el.classList.remove(...(0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(params.scrollbarDisabledClass));
        }
        init();
        updateSize();
        setTranslate();
    };
    const disable = () => {
        const params = getParams();
        swiper.el.classList.add(...(0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(params.scrollbarDisabledClass));
        if (swiper.scrollbar.el) {
            swiper.scrollbar.el.classList.add(...(0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(params.scrollbarDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable,
        disable,
        updateSize,
        setTranslate,
        init,
        destroy,
    });
};




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/thumbs.mjs":
/*!*********************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/thumbs.mjs ***!
  \*********************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Thumb; }
/* harmony export */ });
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs");


const Thumb = ({ swiper, extendParams, on }) => {
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs',
        },
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null,
    };
    function getParams() {
        return swiper.params.thumbs;
    }
    function isVirtualEnabled() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed)
            return false;
        const virtual = thumbsSwiper.params.virtual;
        return !!virtual && !!virtual.enabled;
    }
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed)
            return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        const thumbsParams = getParams();
        if (clickedSlide && clickedSlide.classList.contains(thumbsParams.slideThumbActiveClass))
            return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null)
            return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) {
            const attr = thumbsSwiper.clickedSlide?.getAttribute('data-swiper-slide-index');
            slideToIndex = attr == null ? clickedIndex : parseInt(attr, 10);
        }
        else {
            slideToIndex = clickedIndex;
        }
        if (swiper.params.loop) {
            swiper.slideToLoop(slideToIndex);
        }
        else {
            swiper.slideTo(slideToIndex);
        }
    }
    function init() {
        const thumbsParams = getParams();
        if (initialized)
            return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            if (thumbsParams.swiper.destroyed) {
                initialized = false;
                return false;
            }
            const thumbsSwiper = thumbsParams.swiper;
            swiper.thumbs.swiper = thumbsSwiper;
            Object.assign(thumbsSwiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false,
            });
            Object.assign(thumbsSwiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false,
            });
            thumbsSwiper.update();
        }
        else if ((0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.r)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false,
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper)
            return false;
        thumbsSwiper.el.classList.add(thumbsParams.thumbsContainerClass);
        thumbsSwiper.on('tap', onThumbClick);
        if (isVirtualEnabled()) {
            thumbsSwiper.on('virtualUpdate', () => {
                update(false, { autoScroll: false });
            });
        }
        return true;
    }
    function update(initial, p) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed)
            return;
        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbsParams = getParams();
        const thumbActiveClass = thumbsParams.slideThumbActiveClass;
        const slidesPerView = swiper.params.slidesPerView;
        if (typeof slidesPerView === 'number' && slidesPerView > 1 && !swiper.params.centeredSlides) {
            thumbsToActivate = slidesPerView;
        }
        if (!thumbsParams.multipleActiveThumbs) {
            thumbsToActivate = 1;
        }
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach((slideEl) => slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || isVirtualEnabled()) {
            for (let i = 0; i < thumbsToActivate; i += 1) {
                (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.e)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl) => {
                    slideEl.classList.add(thumbActiveClass);
                });
            }
        }
        else {
            for (let i = 0; i < thumbsToActivate; i += 1) {
                const slide = thumbsSwiper.slides[swiper.realIndex + i];
                if (slide) {
                    slide.classList.add(thumbActiveClass);
                }
            }
        }
        if (p?.autoScroll ?? true) {
            autoScroll(initial ? 0 : undefined);
        }
    }
    function autoScroll(slideSpeed) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed)
            return;
        const thumbsSlidesPerView = thumbsSwiper.params.slidesPerView;
        const slidesPerView = thumbsSlidesPerView === 'auto'
            ? thumbsSwiper.slidesPerViewDynamic()
            : (thumbsSlidesPerView ?? 1);
        const autoScrollOffset = getParams().autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            const currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.find((slideEl) => slideEl.getAttribute('data-swiper-slide-index') === `${swiper.realIndex}`);
                newThumbsIndex = newThumbsSlide ? thumbsSwiper.slides.indexOf(newThumbsSlide) : -1;
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) {
                newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            }
            if (thumbsSwiper.visibleSlidesIndexes &&
                thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) {
                        newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    }
                    else {
                        newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                    }
                }
                else if (newThumbsIndex > currentThumbsIndex &&
                    thumbsSwiper.params.slidesPerGroup === 1) ;
                thumbsSwiper.slideTo(newThumbsIndex, slideSpeed);
            }
        }
    }
    on('beforeInit', () => {
        const thumbs = swiper.params.thumbs;
        if (!thumbs || !thumbs.swiper)
            return;
        if (typeof thumbs.swiper === 'string' || thumbs.swiper instanceof HTMLElement) {
            const getThumbsElementAndInit = () => {
                const thumbsElement = typeof thumbs.swiper === 'string'
                    ? document.querySelector(thumbs.swiper)
                    : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                }
                else if (thumbsElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onThumbsSwiper = (e) => {
                        const detail = e.detail;
                        thumbs.swiper = detail[0];
                        thumbsElement.removeEventListener(eventName, onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener(eventName, onThumbsSwiper);
                }
                return thumbsElement;
            };
            const watchForThumbsToAppear = () => {
                if (swiper.destroyed)
                    return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) {
                    requestAnimationFrame(watchForThumbsToAppear);
                }
            };
            requestAnimationFrame(watchForThumbsToAppear);
        }
        else {
            init();
            update(true);
        }
    });
    on('slideChange update resize observerUpdate', () => {
        update();
    });
    on('setTransition', (_s, duration) => {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed)
            return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', () => {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed)
            return;
        if (swiperCreated) {
            thumbsSwiper.destroy();
        }
    });
    Object.assign(swiper.thumbs, {
        init,
        update,
    });
};




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/virtual.mjs":
/*!**********************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/virtual.mjs ***!
  \**********************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Virtual; }
/* harmony export */ });
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs");


const Virtual = ({ swiper, extendParams, on, emit }) => {
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            slidesPerViewAutoSlideSize: 320,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0,
        },
    });
    let cssModeTimeout;
    // Methods (appendSlide/prependSlide/removeSlide/removeAllSlides/update) are
    // attached via Object.assign below once they're defined. Cast through
    // Partial<> so the initial state-only literal can be assigned without
    // pretending the methods exist yet.
    swiper.virtual = {
        cache: {},
        from: 0,
        to: 0,
        slides: [],
        offset: 0,
        slidesGrid: [],
    };
    function getParams() {
        return swiper.params.virtual;
    }
    // Created lazily so module init does not touch the DOM (SSR / Node safe).
    let tempDOM;
    const getTempDOM = () => (tempDOM ??= document.createElement('div'));
    function renderSlide(slide, index) {
        const params = getParams();
        if (params.cache && swiper.virtual.cache[index]) {
            return swiper.virtual.cache[index];
        }
        let slideEl;
        if (params.renderSlide) {
            const rendered = params.renderSlide.call(swiper, slide, index);
            if (typeof rendered === 'string') {
                const el = getTempDOM();
                (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.w)(el, rendered);
                slideEl = el.children[0];
            }
            else {
                slideEl = rendered;
            }
        }
        else if (swiper.isElement) {
            slideEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.a)('swiper-slide');
        }
        else {
            slideEl = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.a)('div', swiper.params.slideClass);
        }
        slideEl.setAttribute('data-swiper-slide-index', String(index));
        if (!params.renderSlide) {
            (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.w)(slideEl, slide);
        }
        if (params.cache) {
            swiper.virtual.cache[index] = slideEl;
        }
        return slideEl;
    }
    function update(force, beforeInit, forceActiveIndex) {
        const { slidesPerGroup, centeredSlides, slidesPerView, loop: isLoop, initialSlide, } = swiper.params;
        if (beforeInit && !isLoop && (initialSlide ?? 0) > 0) {
            return;
        }
        const { addSlidesBefore, addSlidesAfter, slidesPerViewAutoSlideSize } = getParams();
        const { from: previousFrom, to: previousTo, slides, slidesGrid: previousSlidesGrid, offset: previousOffset, } = swiper.virtual;
        if (!swiper.params.cssMode) {
            swiper.updateActiveIndex();
        }
        const activeIndex = typeof forceActiveIndex === 'undefined' ? swiper.activeIndex || 0 : forceActiveIndex;
        let offsetProp;
        if (swiper.rtlTranslate)
            offsetProp = 'right';
        else
            offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        let slidesPerViewNumeric;
        if (slidesPerView === 'auto') {
            if (slidesPerViewAutoSlideSize) {
                let swiperSize = swiper.size;
                if (!swiperSize) {
                    swiperSize = swiper.isHorizontal()
                        ? swiper.el.getBoundingClientRect().width
                        : swiper.el.getBoundingClientRect().height;
                }
                slidesPerViewNumeric = Math.max(1, Math.ceil(swiperSize / slidesPerViewAutoSlideSize));
            }
            else {
                slidesPerViewNumeric = 1;
            }
        }
        else {
            slidesPerViewNumeric = slidesPerView ?? 1;
        }
        const groupSize = slidesPerGroup ?? 1;
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerViewNumeric / 2) + groupSize + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerViewNumeric / 2) + groupSize + addSlidesBefore;
        }
        else {
            slidesAfter = slidesPerViewNumeric + (groupSize - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerViewNumeric : groupSize) + addSlidesBefore;
        }
        let from = activeIndex - slidesBefore;
        let to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides)
                offset += swiper.slidesGrid[0];
        }
        else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides)
                offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from,
            to,
            offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore,
            slidesAfter,
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit('virtualUpdate');
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
                swiper.slides.forEach((slideEl) => {
                    slideEl.style.setProperty(offsetProp, `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`);
                });
            }
            swiper.updateProgress();
            emit('virtualUpdate');
            return;
        }
        const virtualParams = getParams();
        if (virtualParams.renderExternal) {
            const slidesToRender = [];
            for (let i = from; i <= to; i += 1) {
                slidesToRender.push(slides[i]);
            }
            virtualParams.renderExternal.call(swiper, {
                offset,
                from,
                to,
                slides: slidesToRender,
            });
            if (virtualParams.renderExternalUpdate) {
                onRendered();
            }
            else {
                emit('virtualUpdate');
            }
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        const getSlideIndex = (index) => {
            let slideIndex = index;
            if (index < 0) {
                slideIndex = slides.length + index;
            }
            else if (slideIndex >= slides.length) {
                slideIndex = slideIndex - slides.length;
            }
            return slideIndex;
        };
        if (force) {
            swiper.slides
                .filter((el) => el.matches(`.${swiper.params.slideClass}, swiper-slide`))
                .forEach((slideEl) => {
                slideEl.remove();
            });
        }
        else {
            for (let i = previousFrom; i <= previousTo; i += 1) {
                if (i < from || i > to) {
                    const slideIndex = getSlideIndex(i);
                    swiper.slides
                        .filter((el) => el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`))
                        .forEach((slideEl) => {
                        slideEl.remove();
                    });
                }
            }
        }
        const loopFrom = isLoop ? -slides.length : 0;
        const loopTo = isLoop ? slides.length * 2 : slides.length;
        for (let i = loopFrom; i < loopTo; i += 1) {
            if (i >= from && i <= to) {
                const slideIndex = getSlideIndex(i);
                if (typeof previousTo === 'undefined' || force) {
                    appendIndexes.push(slideIndex);
                }
                else {
                    if (i > previousTo)
                        appendIndexes.push(slideIndex);
                    if (i < previousFrom)
                        prependIndexes.push(slideIndex);
                }
            }
        }
        appendIndexes.forEach((index) => {
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) {
            for (let i = prependIndexes.length - 1; i >= 0; i -= 1) {
                const index = prependIndexes[i];
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            }
        }
        else {
            prependIndexes.sort((a, b) => b - a);
            prependIndexes.forEach((index) => {
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.e)(swiper.slidesEl, '.swiper-slide, swiper-slide').forEach((slideEl) => {
            slideEl.style.setProperty(offsetProp, `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`);
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (slides !== null &&
            typeof slides === 'object' &&
            'length' in slides) {
            const arr = slides;
            for (let i = 0; i < arr.length; i += 1) {
                if (arr[i])
                    swiper.virtual.slides.push(arr[i]);
            }
        }
        else {
            swiper.virtual.slides.push(slides);
        }
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for (let i = 0; i < slides.length; i += 1) {
                if (slides[i])
                    swiper.virtual.slides.unshift(slides[i]);
            }
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        }
        else {
            swiper.virtual.slides.unshift(slides);
        }
        if (getParams().cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex) => {
                const cachedEl = cache[Number(cachedIndex)];
                const cachedElIndex = cachedEl.getAttribute('data-swiper-slide-index');
                if (cachedElIndex) {
                    cachedEl.setAttribute('data-swiper-slide-index', String(parseInt(cachedElIndex, 10) + numberOfNewSlides));
                }
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null)
            return;
        let activeIndex = swiper.activeIndex;
        const shiftCacheDownFrom = (removedIndex) => {
            Object.keys(swiper.virtual.cache).forEach((key) => {
                const numericKey = Number(key);
                if (numericKey > removedIndex) {
                    const shifted = swiper.virtual.cache[numericKey];
                    swiper.virtual.cache[numericKey - 1] = shifted;
                    shifted.setAttribute('data-swiper-slide-index', String(numericKey - 1));
                    delete swiper.virtual.cache[numericKey];
                }
            });
        };
        if (Array.isArray(slidesIndexes)) {
            for (let i = slidesIndexes.length - 1; i >= 0; i -= 1) {
                if (getParams().cache) {
                    delete swiper.virtual.cache[slidesIndexes[i]];
                    shiftCacheDownFrom(slidesIndexes[i]);
                }
                swiper.virtual.slides.splice(slidesIndexes[i], 1);
                if (slidesIndexes[i] < activeIndex)
                    activeIndex -= 1;
                activeIndex = Math.max(activeIndex, 0);
            }
        }
        else {
            if (getParams().cache) {
                delete swiper.virtual.cache[slidesIndexes];
                shiftCacheDownFrom(slidesIndexes);
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex)
                activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (getParams().cache) {
            swiper.virtual.cache = {};
        }
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', () => {
        if (!getParams().enabled)
            return;
        let domSlidesAssigned = false;
        const passedVirtual = swiper.passedParams.virtual;
        const passedSlidesUndefined = !passedVirtual || typeof passedVirtual !== 'object' || passedVirtual.slides === undefined;
        if (passedSlidesUndefined) {
            const slides = [...swiper.slidesEl.children].filter((el) => el.matches(`.${swiper.params.slideClass}, swiper-slide`));
            if (slides && slides.length) {
                swiper.virtual.slides = [...slides];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex) => {
                    slideEl.setAttribute('data-swiper-slide-index', String(slideIndex));
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) {
            swiper.virtual.slides = getParams().slides;
        }
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update(false, true);
    });
    on('setTranslate', () => {
        if (!getParams().enabled)
            return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(() => {
                update();
            }, 100);
        }
        else {
            update();
        }
    });
    on('init update resize', () => {
        if (!getParams().enabled)
            return;
        if (swiper.params.cssMode) {
            (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.v)(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
        }
    });
    Object.assign(swiper.virtual, {
        appendSlide,
        prependSlide,
        removeSlide,
        removeAllSlides,
        update,
    });
};




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/zoom.mjs":
/*!*******************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/modules/zoom.mjs ***!
  \*******************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Zoom; }
/* harmony export */ });
/* harmony import */ var _shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../shared/utils.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs");


const Zoom = ({ swiper, extendParams, on, emit }) => {
    extendParams({
        zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            panOnMouseMove: false,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed',
        },
    });
    swiper.zoom = {
        enabled: false,
    };
    function getParams() {
        return swiper.params.zoom;
    }
    let currentScale = 1;
    let isScaling = false;
    let isPanningWithMouse = false;
    let mousePanStart = { x: 0, y: 0 };
    const mousePanSensitivity = -3; // Negative to invert pan direction
    let fakeGestureTouched = false;
    let fakeGestureMoved = false;
    const evCache = [];
    const gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3,
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {},
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined,
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get() {
            return scale;
        },
        set(value) {
            if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        },
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2)
            return 1;
        const x1 = evCache[0].pageX;
        const y1 = evCache[0].pageY;
        const x2 = evCache[1].pageX;
        const y2 = evCache[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    }
    function getMaxRatio() {
        const params = getParams();
        const attr = gesture.imageWrapEl?.getAttribute('data-swiper-zoom');
        const maxRatio = attr != null ? Number(attr) : params.maxRatio;
        const imageEl = gesture.imageEl;
        if (params.limitToOriginalSize && imageEl && imageEl.naturalWidth) {
            const imageMaxRatio = imageEl.naturalWidth / imageEl.offsetWidth;
            return Math.min(imageMaxRatio, maxRatio);
        }
        return maxRatio;
    }
    function getScaleOrigin() {
        if (evCache.length < 2 || !gesture.imageEl)
            return [null, null];
        const box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) /
                currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) /
                currentScale,
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        const slideSelector = getSlideSelector();
        const target = e.target;
        if (!target)
            return false;
        if (target.matches(slideSelector))
            return true;
        if (swiper.slides.filter((slideEl) => slideEl.contains(target)).length > 0)
            return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        const selector = `.${getParams().containerClass}`;
        const target = e.target;
        if (!target)
            return false;
        if (target.matches(selector))
            return true;
        if ([...swiper.hostEl.querySelectorAll(selector)].filter((containerEl) => containerEl.contains(target)).length > 0)
            return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === 'mouse') {
            evCache.splice(0, evCache.length);
        }
        if (!eventWithinSlide(e))
            return;
        const params = getParams();
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) {
            return;
        }
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            const target = e.target;
            gesture.slideEl =
                target?.closest(`.${swiper.params.slideClass}, swiper-slide`) ??
                    undefined;
            if (!gesture.slideEl)
                gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl?.querySelector(`.${params.containerClass}`) ?? null;
            if (imageEl) {
                imageEl =
                    imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0] ?? null;
            }
            gesture.imageEl = imageEl ?? undefined;
            if (imageEl) {
                gesture.imageWrapEl =
                    (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.j)(imageEl, `.${params.containerClass}`)[0] ??
                        undefined;
            }
            else {
                gesture.imageWrapEl = undefined;
            }
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = getMaxRatio();
        }
        if (gesture.imageEl) {
            const [originX, originY] = getScaleOrigin();
            gesture.originX = originX ?? 0;
            gesture.originY = originY ?? 0;
            gesture.imageEl.style.transitionDuration = '0ms';
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e))
            return;
        const params = getParams();
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv) => cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0)
            evCache[pointerIndex] = e;
        if (evCache.length < 2) {
            return;
        }
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) {
            return;
        }
        zoom.scale = (gesture.scaleMove / (gesture.scaleStart ?? 1)) * currentScale;
        if (zoom.scale > gesture.maxRatio) {
            zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        }
        if (zoom.scale < params.minRatio) {
            zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        }
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e))
            return;
        if (e.pointerType === 'mouse' && e.type === 'pointerout')
            return;
        const params = getParams();
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv) => cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0)
            evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) {
            return;
        }
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl)
            return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) {
            gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        }
        else if (zoom.scale <= 1 && gesture.slideEl) {
            gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        }
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    let allowTouchMoveTimeout;
    function allowTouchMove() {
        swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function preventTouchMove() {
        if (allowTouchMoveTimeout !== undefined)
            clearTimeout(allowTouchMoveTimeout);
        swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
        allowTouchMoveTimeout = setTimeout(() => {
            if (swiper.destroyed)
                return;
            allowTouchMove();
        });
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.imageEl)
            return;
        if (image.isTouched)
            return;
        if (device.android && e.cancelable)
            e.preventDefault();
        image.isTouched = true;
        const event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        const isMouseEvent = e.pointerType === 'mouse';
        const isMousePan = isMouseEvent && getParams().panOnMouseMove;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) {
            return;
        }
        const zoom = swiper.zoom;
        if (!gesture.imageEl) {
            return;
        }
        if (!image.isTouched || !gesture.slideEl) {
            if (isMousePan)
                onMouseMove(e);
            return;
        }
        if (isMousePan) {
            onMouseMove(e);
            return;
        }
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            image.startX = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.q)(gesture.imageWrapEl, 'x') || 0;
            image.startY = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.q)(gesture.imageWrapEl, 'y') || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = '0ms';
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - (image.touchesStart.x ?? 0)), Math.abs(image.touchesCurrent.y - (image.touchesStart.y ?? 0)));
        if (touchesDiff > 5) {
            swiper.allowClick = false;
        }
        const startX = image.startX ?? 0;
        const startY = image.startY ?? 0;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() &&
                ((Math.floor(image.minX) === Math.floor(startX) &&
                    image.touchesCurrent.x < (image.touchesStart.x ?? 0)) ||
                    (Math.floor(image.maxX) === Math.floor(startX) &&
                        image.touchesCurrent.x > (image.touchesStart.x ?? 0)))) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
            if (!swiper.isHorizontal() &&
                ((Math.floor(image.minY) === Math.floor(startY) &&
                    image.touchesCurrent.y < (image.touchesStart.y ?? 0)) ||
                    (Math.floor(image.maxY) === Math.floor(startY) &&
                        image.touchesCurrent.y > (image.touchesStart.y ?? 0)))) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
        }
        if (e.cancelable) {
            e.preventDefault();
        }
        e.stopPropagation();
        preventTouchMove();
        image.isMoved = true;
        const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - getParams().minRatio);
        const { originX, originY } = gesture;
        image.currentX =
            image.touchesCurrent.x -
                (image.touchesStart.x ?? 0) +
                startX +
                scaleRatio * (image.width - originX * 2);
        image.currentY =
            image.touchesCurrent.y -
                (image.touchesStart.y ?? 0) +
                startY +
                scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) {
            image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        }
        if (image.currentX > image.maxX) {
            image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        }
        if (image.currentY < image.minY) {
            image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        }
        if (image.currentY > image.maxY) {
            image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        }
        // Velocity
        if (!velocity.prevPositionX)
            velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY)
            velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime)
            velocity.prevTime = Date.now();
        velocity.x =
            (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y =
            (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2)
            velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2)
            velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        evCache.length = 0;
        if (!gesture.imageEl)
            return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const velocityX = velocity.x ?? 0;
        const velocityY = velocity.y ?? 0;
        const momentumDistanceX = velocityX * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocityY * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocityX !== 0)
            momentumDurationX = Math.abs((newPositionX - image.currentX) / velocityX);
        if (velocityY !== 0)
            momentumDurationY = Math.abs((newPositionY - image.currentY) / velocityY);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) {
                gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
            }
            if (gesture.imageWrapEl) {
                gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
            }
            gesture.slideEl.classList.remove(`${getParams().zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function onMouseMove(e) {
        // Only pan if zoomed in and mouse panning is enabled
        if (currentScale <= 1 || !gesture.imageWrapEl)
            return;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e))
            return;
        const currentTransform = window.getComputedStyle(gesture.imageWrapEl).transform;
        const matrix = new window.DOMMatrix(currentTransform);
        if (!isPanningWithMouse) {
            isPanningWithMouse = true;
            mousePanStart.x = e.clientX;
            mousePanStart.y = e.clientY;
            image.startX = matrix.e;
            image.startY = matrix.f;
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            return;
        }
        const deltaX = (e.clientX - mousePanStart.x) * mousePanSensitivity;
        const deltaY = (e.clientY - mousePanStart.y) * mousePanSensitivity;
        const scaledWidth = image.width * currentScale;
        const scaledHeight = image.height * currentScale;
        const slideWidth = gesture.slideWidth;
        const slideHeight = gesture.slideHeight;
        const minX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
        const maxX = -minX;
        const minY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
        const maxY = -minY;
        const newX = Math.max(Math.min(image.startX + deltaX, maxX), minX);
        const newY = Math.max(Math.min(image.startY + deltaY, maxY), minY);
        gesture.imageWrapEl.style.transitionDuration = '0ms';
        gesture.imageWrapEl.style.transform = `translate3d(${newX}px, ${newY}px, 0)`;
        mousePanStart.x = e.clientX;
        mousePanStart.y = e.clientY;
        image.startX = newX;
        image.startY = newY;
        image.currentX = newX;
        image.currentY = newY;
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = getParams();
        if (!gesture.slideEl) {
            if (e && typeof e !== 'number' && 'target' in e && e.target) {
                gesture.slideEl =
                    e.target.closest(`.${swiper.params.slideClass}, swiper-slide`) ?? undefined;
            }
            if (!gesture.slideEl) {
                const virtual = swiper.params.virtual;
                if (virtual && virtual.enabled && swiper.virtual) {
                    gesture.slideEl =
                        (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.e)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0] ?? undefined;
                }
                else {
                    gesture.slideEl = swiper.slides[swiper.activeIndex];
                }
            }
            let imageEl = gesture.slideEl?.querySelector(`.${params.containerClass}`) ?? null;
            if (imageEl) {
                imageEl =
                    imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0] ?? null;
            }
            gesture.imageEl = imageEl ?? undefined;
            if (imageEl) {
                gesture.imageWrapEl =
                    (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.j)(imageEl, `.${params.containerClass}`)[0] ??
                        undefined;
            }
            else {
                gesture.imageWrapEl = undefined;
            }
        }
        if (!gesture.imageEl || !gesture.imageWrapEl || !gesture.slideEl)
            return;
        gesture.maxRatio = getMaxRatio();
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        const eventIsPointer = e && typeof e !== 'number';
        if (typeof image.touchesStart.x === 'undefined' && eventIsPointer) {
            touchX = e.pageX;
            touchY = e.pageY;
        }
        else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        const prevScale = currentScale;
        const forceZoomRatio = typeof e === 'number' ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
            image.touchesStart.x = undefined;
            image.touchesStart.y = undefined;
        }
        const maxRatio = getMaxRatio();
        zoom.scale = forceZoomRatio || maxRatio;
        currentScale = forceZoomRatio || maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.h)(gesture.slideEl).left + window.scrollX;
            offsetY = (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.h)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - (touchX ?? 0);
            diffY = offsetY + slideHeight / 2 - (touchY ?? 0);
            imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            if (prevScale > 0 &&
                forceZoomRatio &&
                typeof image.currentX === 'number' &&
                typeof image.currentY === 'number') {
                translateX = (image.currentX * zoom.scale) / prevScale;
                translateY = (image.currentY * zoom.scale) / prevScale;
            }
            else {
                translateX = diffX * zoom.scale;
                translateY = diffY * zoom.scale;
            }
            if (translateX < translateMinX) {
                translateX = translateMinX;
            }
            if (translateX > translateMaxX) {
                translateX = translateMaxX;
            }
            if (translateY < translateMinY) {
                translateY = translateMinY;
            }
            if (translateY > translateMaxY) {
                translateY = translateMaxY;
            }
        }
        else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        image.currentX = translateX;
        image.currentY = translateY;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = getParams();
        if (!gesture.slideEl) {
            const virtual = swiper.params.virtual;
            if (virtual && virtual.enabled && swiper.virtual) {
                gesture.slideEl =
                    (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.e)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0] ?? undefined;
            }
            else {
                gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            let imageEl = gesture.slideEl?.querySelector(`.${params.containerClass}`) ?? null;
            if (imageEl) {
                imageEl =
                    imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0] ?? null;
            }
            gesture.imageEl = imageEl ?? undefined;
            if (imageEl) {
                gesture.imageWrapEl =
                    (0,_shared_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.j)(imageEl, `.${params.containerClass}`)[0] ??
                        undefined;
            }
            else {
                gesture.imageWrapEl = undefined;
            }
        }
        if (!gesture.imageEl || !gesture.imageWrapEl || !gesture.slideEl)
            return;
        gesture.maxRatio = getMaxRatio();
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        image.currentX = undefined;
        image.currentY = undefined;
        image.touchesStart.x = undefined;
        image.touchesStart.y = undefined;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
        if (params.panOnMouseMove) {
            mousePanStart = { x: 0, y: 0 };
            if (isPanningWithMouse) {
                isPanningWithMouse = false;
                image.startX = 0;
                image.startY = 0;
            }
        }
    }
    // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) {
            // Zoom Out
            zoomOut();
        }
        else {
            // Zoom In
            zoomIn(e);
        }
    }
    function getListeners() {
        const passiveListener = swiper.params.passiveListeners
            ? { passive: true, capture: false }
            : false;
        const activeListenerWithCapture = swiper.params.passiveListeners
            ? { passive: false, capture: true }
            : true;
        return { passiveListener, activeListenerWithCapture };
    }
    // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled)
            return;
        zoom.enabled = true;
        const { passiveListener, activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.addEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        ['pointerup', 'pointercancel', 'pointerout'].forEach((eventName) => {
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled)
            return;
        zoom.enabled = false;
        const { passiveListener, activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.removeEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        ['pointerup', 'pointercancel', 'pointerout'].forEach((eventName) => {
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    on('init', () => {
        if (getParams().enabled) {
            enable();
        }
    });
    on('destroy', () => {
        disable();
    });
    on('touchStart', (_s, e) => {
        if (!swiper.zoom.enabled)
            return;
        onTouchStart(e);
    });
    on('touchEnd', () => {
        if (!swiper.zoom.enabled)
            return;
        onTouchEnd();
    });
    on('doubleTap', (_s, e) => {
        if (!swiper.animating && getParams().enabled && swiper.zoom.enabled && getParams().toggle) {
            zoomToggle(e);
        }
    });
    on('transitionEnd', () => {
        if (swiper.zoom.enabled && getParams().enabled) {
            onTransitionEnd();
        }
    });
    on('slideChange', () => {
        if (swiper.zoom.enabled && getParams().enabled && swiper.params.cssMode) {
            onTransitionEnd();
        }
    });
    Object.assign(swiper.zoom, {
        enable,
        disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle,
    });
};




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/classes-to-selector.mjs":
/*!*********************************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/classes-to-selector.mjs ***!
  \*********************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   c: function() { return /* binding */ classesToSelector; }
/* harmony export */ });
function classesToSelector(classes = '') {
    return `.${classes
        .trim()
        .replace(/([.:!+/()[\]#>~*^$|=,'"@{}\\])/g, '\\$1')
        .replace(/ /g, '.')}`;
}




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/create-element-if-not-defined.mjs":
/*!*******************************************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/create-element-if-not-defined.mjs ***!
  \*******************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   c: function() { return /* binding */ createElementIfNotDefined; }
/* harmony export */ });
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utils.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs");


function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
    const target = (params ?? {});
    const original = (originalParams ?? {});
    if (swiper.params.createElements) {
        Object.keys(checkProps).forEach((key) => {
            if (!target[key] && target.auto === true) {
                let element = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.e)(swiper.el, `.${checkProps[key]}`)[0];
                if (!element) {
                    element = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.a)('div', checkProps[key]);
                    element.className = checkProps[key];
                    swiper.el.append(element);
                }
                target[key] = element;
                original[key] = element;
            }
        });
    }
    return target;
}




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/create-shadow.mjs":
/*!***************************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/create-shadow.mjs ***!
  \***************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   c: function() { return /* binding */ createShadow; }
/* harmony export */ });
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utils.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs");


function createShadow(suffix, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}${suffix ? ` swiper-slide-shadow-${suffix}` : ''}`;
    const shadowContainer = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.p)(slideEl);
    const selector = `.${shadowClass.split(' ').join('.')}`;
    const existing = shadowContainer.querySelector(selector);
    if (existing)
        return existing;
    const created = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.a)('div', shadowClass.split(' '));
    shadowContainer.append(created);
    return created;
}




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/effect-init.mjs":
/*!*************************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/effect-init.mjs ***!
  \*************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   e: function() { return /* binding */ effectInit; }
/* harmony export */ });
function effectInit(params) {
    const { effect, swiper, on, setTranslate, setTransition, overwriteParams, perspective, recreateShadows, getEffectParams, } = params;
    on('beforeInit', () => {
        if (swiper.params.effect !== effect)
            return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) {
            swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        }
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate _virtualUpdated', () => {
        if (swiper.params.effect !== effect)
            return;
        setTranslate();
    });
    on('setTransition', (_s, duration) => {
        if (swiper.params.effect !== effect)
            return;
        setTransition(duration);
    });
    on('transitionEnd', () => {
        if (swiper.params.effect !== effect)
            return;
        if (recreateShadows) {
            const effectParams = getEffectParams ? getEffectParams() : undefined;
            if (!effectParams || !effectParams.slideShadows)
                return;
            swiper.slides.forEach((slideEl) => {
                slideEl
                    .querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left')
                    .forEach((shadowEl) => shadowEl.remove());
            });
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual = false;
    on('virtualUpdate', () => {
        if (swiper.params.effect !== effect)
            return;
        if (!swiper.slides.length) {
            requireUpdateOnVirtual = true;
        }
        requestAnimationFrame(() => {
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/effect-target.mjs":
/*!***************************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/effect-target.mjs ***!
  \***************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   e: function() { return /* binding */ effectTarget; }
/* harmony export */ });
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utils.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs");


function effectTarget(_effectParams, slideEl) {
    const transformEl = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.p)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = 'hidden';
        transformEl.style.setProperty('-webkit-backface-visibility', 'hidden');
    }
    return transformEl;
}




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/effect-virtual-transition-end.mjs":
/*!*******************************************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/effect-virtual-transition-end.mjs ***!
  \*******************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   e: function() { return /* binding */ effectVirtualTransitionEnd; }
/* harmony export */ });
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utils.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs");


function effectVirtualTransitionEnd({ swiper, duration, transformElements, allSlides, }) {
    const { activeIndex } = swiper;
    const getSlide = (el) => {
        if (!el.parentElement) {
            // assume shadow root
            return swiper.slides.find((slideEl) => slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode);
        }
        if (el.parentElement instanceof HTMLElement)
            return el.parentElement;
        return undefined;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) {
            transitionEndTarget = transformElements;
        }
        else {
            transitionEndTarget = transformElements.filter((transformEl) => {
                const el = transformEl.classList.contains('swiper-slide-transform')
                    ? getSlide(transformEl)
                    : transformEl;
                return !!el && swiper.getSlideIndex(el) === activeIndex;
            });
        }
        transitionEndTarget.forEach((el) => {
            (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.m)(el, () => {
                if (eventTriggered)
                    return;
                if (!swiper || swiper.destroyed)
                    return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new CustomEvent('transitionend', { bubbles: true, cancelable: true });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/swiper-core.mjs":
/*!*************************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/swiper-core.mjs ***!
  \*************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   S: function() { return /* binding */ Swiper; },
/* harmony export */   d: function() { return /* binding */ defaults; }
/* harmony export */ });
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utils.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs");


let supportCached;
function calcSupport() {
    if (typeof window === 'undefined')
        return { touch: false };
    return {
        touch: 'ontouchstart' in window || navigator.maxTouchPoints > 0,
    };
}
function getSupport() {
    if (!supportCached)
        supportCached = calcSupport();
    return supportCached;
}

let deviceCached;
function calcDevice({ userAgent } = {}) {
    if (typeof window === 'undefined')
        return { ios: false, android: false };
    const support = getSupport();
    const platform = navigator.platform;
    const ua = userAgent || navigator.userAgent;
    const device = { ios: false, android: false };
    const isAndroid = /(Android);?[\s/]+([\d.]+)?/.test(ua);
    const isIPhoneOrIPod = /(iPhone\sOS|iOS|iPod)/.test(ua);
    const isIPadDirect = /iPad/.test(ua);
    // iPad on iPadOS 13+ reports as MacIntel; distinguish from a real Mac by touch capability.
    const isIPadMasquerade = platform === 'MacIntel' && support.touch && navigator.maxTouchPoints > 1;
    const isIPad = isIPadDirect || isIPadMasquerade;
    const isWindows = platform === 'Win32';
    if (isAndroid && !isWindows) {
        device.os = 'android';
        device.android = true;
    }
    if (isIPad || isIPhoneOrIPod) {
        device.os = 'ios';
        device.ios = true;
    }
    return device;
}
function getDevice(overrides = {}) {
    if (!deviceCached)
        deviceCached = calcDevice(overrides);
    return deviceCached;
}

let browserCached;
function calcBrowser() {
    if (typeof window === 'undefined') {
        return { isSafari: false, isWebView: false, need3dFix: false };
    }
    const device = getDevice();
    const ua = navigator.userAgent;
    const uaLower = ua.toLowerCase();
    const isSafari = uaLower.includes('safari') && !uaLower.includes('chrome') && !uaLower.includes('android');
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua);
    // 3D transform glitches still affect iOS WebView and Safari at the baseline (16.4+).
    const need3dFix = isSafari || (isWebView && device.ios);
    return { isSafari, isWebView, need3dFix };
}
function getBrowser() {
    if (!browserCached)
        browserCached = calcBrowser();
    return browserCached;
}

const processLazyPreloader = (swiper, imageEl) => {
    if (!swiper || swiper.destroyed || !swiper.params)
        return;
    const slideSelector = () => (swiper.isElement ? 'swiper-slide' : `.${swiper.params.slideClass}`);
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) {
                lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            }
            else {
                requestAnimationFrame(() => {
                    if (slideEl.shadowRoot) {
                        const innerLazy = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                        if (innerLazy && !innerLazy.lazyPreloaderManaged)
                            innerLazy.remove();
                    }
                });
            }
        }
        if (lazyEl && !lazyEl.lazyPreloaderManaged)
            lazyEl.remove();
    }
};
const unlazy = (swiper, index) => {
    if (!swiper.slides[index])
        return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl)
        imageEl.removeAttribute('loading');
};
const preload = (swiper) => {
    if (!swiper || swiper.destroyed || !swiper.params)
        return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0)
        return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === 'auto'
        ? swiper.slidesPerViewDynamic()
        : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && (swiper.params.grid.rows ?? 1) > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [activeColumn - amount];
        preloadColumns.push(...Array.from({ length: amount }).map((_, i) => activeColumn + slidesPerView + i));
        swiper.slides.forEach((slideEl, i) => {
            if (slideEl.column !== undefined && preloadColumns.includes(slideEl.column))
                unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) {
        for (let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1) {
            const realIndex = ((i % len) + len) % len;
            if (realIndex < activeIndex || realIndex > slideIndexLastInView)
                unlazy(swiper, realIndex);
        }
    }
    else {
        for (let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1) {
            if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) {
                unlazy(swiper, i);
            }
        }
    }
};

function getBreakpoint(breakpoints, base = 'window', containerEl) {
    if (!breakpoints || (base === 'container' && !containerEl))
        return undefined;
    let breakpoint = false;
    const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point) => {
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return { value, point };
        }
        return { value: point, point };
    });
    points.sort((a, b) => parseInt(String(a.value), 10) - parseInt(String(b.value), 10));
    for (let i = 0; i < points.length; i += 1) {
        const { point, value } = points[i];
        if (base === 'window') {
            if (window.matchMedia(`(min-width: ${value}px)`).matches) {
                breakpoint = point;
            }
        }
        else if (value <= containerEl.clientWidth) {
            breakpoint = point;
        }
    }
    return breakpoint || 'max';
}

const isGridEnabled = (swiper, params) => {
    return !!(swiper.grid && params.grid && params.grid.rows > 1);
};
function setBreakpoint() {
    const swiper = this;
    const { realIndex, initialized, params, el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || (breakpoints && Object.keys(breakpoints).length === 0))
        return;
    // Get breakpoint for window/container width and update parameters
    const breakpointsBase = params.breakpointsBase === 'window' || !params.breakpointsBase
        ? params.breakpointsBase
        : 'container';
    const breakpointContainer = ['window', 'container'].includes(params.breakpointsBase) || !params.breakpointsBase
        ? swiper.el
        : document.querySelector(params.breakpointsBase);
    const breakpoint = swiper.getBreakpoint(breakpoints, breakpointsBase, breakpointContainer);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint)
        return;
    const breakpointsRecord = breakpoints;
    const breakpointOnlyParams = breakpoint in breakpointsRecord ? breakpointsRecord[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = isGridEnabled(swiper, params);
    const isMultiRow = isGridEnabled(swiper, breakpointParams);
    const wasGrabCursor = swiper.params.grabCursor;
    const isGrabCursor = breakpointParams.grabCursor;
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if ((breakpointParams.grid.fill && breakpointParams.grid.fill === 'column') ||
            (!breakpointParams.grid.fill && params.grid.fill === 'column')) {
            el.classList.add(`${params.containerModifierClass}grid-column`);
        }
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) {
        swiper.unsetGrabCursor();
    }
    else if (!wasGrabCursor && isGrabCursor) {
        swiper.setGrabCursor();
    }
    const moduleOpt = (opts, prop) => opts[prop];
    ['navigation', 'pagination', 'scrollbar'].forEach((prop) => {
        const bpOpts = moduleOpt(breakpointParams, prop);
        if (typeof bpOpts === 'undefined')
            return;
        const paramsOpts = moduleOpt(params, prop);
        const wasModuleEnabled = typeof paramsOpts === 'object' && paramsOpts !== null && paramsOpts.enabled;
        const isModuleEnabled = typeof bpOpts === 'object' && bpOpts !== null && bpOpts.enabled;
        const moduleApi = swiper[prop];
        if (wasModuleEnabled && !isModuleEnabled)
            moduleApi?.disable?.();
        if (!wasModuleEnabled && isModuleEnabled)
            moduleApi?.enable?.();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) {
        swiper.changeDirection();
    }
    (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.n)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev,
    });
    if (wasEnabled && !isEnabled) {
        swiper.disable();
    }
    else if (!wasEnabled && isEnabled) {
        swiper.enable();
    }
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        }
        else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        }
        else if (wasLoop && !hasLoop) {
            swiper.loopDestroy();
        }
    }
    swiper.emit('breakpoint', breakpointParams);
}

var breakpoints = { setBreakpoint, getBreakpoint };

function checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params } = swiper;
    const { slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] +
            swiper.slidesSizesGrid[lastSlideIndex] +
            slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    }
    else {
        swiper.isLocked = swiper.snapGrid.length === 1;
    }
    if (params.allowSlideNext === true) {
        swiper.allowSlideNext = !swiper.isLocked;
    }
    if (params.allowSlidePrev === true) {
        swiper.allowSlidePrev = !swiper.isLocked;
    }
    if (wasLocked && wasLocked !== swiper.isLocked) {
        swiper.isEnd = false;
    }
    if (wasLocked !== swiper.isLocked) {
        swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
    }
}
var checkOverflow$1 = { checkOverflow };

function prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item) => {
        if (typeof item === 'object') {
            Object.keys(item).forEach((classNames) => {
                if (item[classNames]) {
                    resultClasses.push(prefix + classNames);
                }
            });
        }
        else if (typeof item === 'string') {
            resultClasses.push(prefix + item);
        }
    });
    return resultClasses;
}
function addClasses() {
    const swiper = this;
    const { classNames, params, rtl, el, device } = swiper;
    // oxfmt-ignore
    const suffixes = prepareClasses([
        'initialized',
        params.direction,
        { 'free-mode': swiper.params.freeMode && params.freeMode.enabled },
        { 'autoheight': params.autoHeight },
        { 'rtl': rtl },
        { 'grid': params.grid && params.grid.rows > 1 },
        { 'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column' },
        { 'android': device.android },
        { 'ios': device.ios },
        { 'css-mode': params.cssMode },
        { 'centered': params.cssMode && params.centeredSlides },
        { 'watch-progress': params.watchSlidesProgress },
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}

function removeClasses() {
    const swiper = this;
    const { el, classNames } = swiper;
    if (!el || typeof el === 'string')
        return;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}

var classes = { addClasses, removeClasses };

const defaults = {
    init: true,
    direction: 'horizontal',
    oneWayMovement: false,
    swiperElementNodeName: 'SWIPER-CONTAINER',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: 'swiper',
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    snapToSlideEdge: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-blank',
    slideActiveClass: 'swiper-slide-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideFullyVisibleClass: 'swiper-slide-fully-visible',
    slideNextClass: 'swiper-slide-next',
    slidePrevClass: 'swiper-slide-prev',
    wrapperClass: 'swiper-wrapper',
    lazyPreloaderClass: 'swiper-lazy-preloader',
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false,
};

var eventsEmitter = {
    on(events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed)
            return self;
        if (typeof handler !== 'function')
            return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach((event) => {
            if (!self.eventsListeners[event])
                self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once(events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed)
            return self;
        if (typeof handler !== 'function')
            return self;
        const onceHandler = function onceHandlerFn(...args) {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) {
                delete onceHandler.__emitterProxy;
            }
            handler.apply(self, args);
        };
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny(handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed)
            return self;
        if (typeof handler !== 'function')
            return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) {
            self.eventsAnyListeners[method](handler);
        }
        return self;
    },
    offAny(handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed)
            return self;
        if (!self.eventsAnyListeners)
            return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) {
            self.eventsAnyListeners.splice(index, 1);
        }
        return self;
    },
    off(events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed)
            return self;
        if (!self.eventsListeners)
            return self;
        events.split(' ').forEach((event) => {
            if (typeof handler === 'undefined') {
                self.eventsListeners[event] = [];
            }
            else if (self.eventsListeners[event]) {
                self.eventsListeners[event].forEach((eventHandler, index) => {
                    if (eventHandler === handler ||
                        (eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler)) {
                        self.eventsListeners[event].splice(index, 1);
                    }
                });
            }
        });
        return self;
    },
    emit(...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed)
            return self;
        if (!self.eventsListeners)
            return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        }
        else {
            const opts = args[0];
            events = opts.events;
            data = opts.data ?? [];
            context = opts.context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach((event) => {
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
                self.eventsAnyListeners.forEach((eventHandler) => {
                    eventHandler.apply(context, [event, ...data]);
                });
            }
            if (self.eventsListeners && self.eventsListeners[event]) {
                self.eventsListeners[event].forEach((eventHandler) => {
                    eventHandler.apply(context, data);
                });
            }
        });
        return self;
    },
};

function onClick(e) {
    const swiper = this;
    if (swiper.destroyed)
        return;
    if (!swiper.enabled)
        return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks)
            e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}

function onDocumentTouchStart() {
    const swiper = this;
    if (swiper.destroyed)
        return;
    if (swiper.documentTouchHandlerProceeded)
        return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) {
        swiper.el.style.touchAction = 'auto';
    }
}

function onLoad(e) {
    const swiper = this;
    if (swiper.destroyed)
        return;
    processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode ||
        (swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight)) {
        return;
    }
    swiper.update();
}

function onResize() {
    const swiper = this;
    const { params, el } = swiper;
    if (el && el.offsetWidth === 0)
        return;
    // Breakpoints
    if (params.breakpoints) {
        swiper.setBreakpoint();
    }
    // Save locks
    const { allowSlideNext, allowSlidePrev, snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual?.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) &&
        swiper.isEnd &&
        !swiper.isBeginning &&
        !swiper.params.centeredSlides &&
        !isVirtualLoop) {
        const slidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
        swiper.slideTo(slidesLength - 1, 0, false, true);
    }
    else {
        if (swiper.params.loop && !isVirtual) {
            swiper.slideToLoop(swiper.realIndex, 0, false, true);
        }
        else {
            swiper.slideTo(swiper.activeIndex, 0, false, true);
        }
    }
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        const autoplay = swiper.autoplay;
        clearTimeout(autoplay.resizeTimeout);
        autoplay.resizeTimeout = setTimeout(() => {
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
                swiper.autoplay.resume();
            }
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
    }
}

function onScroll() {
    const swiper = this;
    if (swiper.destroyed)
        return;
    const { wrapperEl, rtlTranslate, enabled } = swiper;
    if (!enabled)
        return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) {
        swiper.translate = -wrapperEl.scrollLeft;
    }
    else {
        swiper.translate = -wrapperEl.scrollTop;
    }
    if (swiper.translate === 0)
        swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) {
        newProgress = 0;
    }
    else {
        newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    }
    if (newProgress !== swiper.progress) {
        swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    }
    swiper.emit('setTranslate', swiper.translate, false);
}

function onTouchEnd(event) {
    const swiper = this;
    if (swiper.destroyed)
        return;
    const data = swiper.touchEventsData;
    let e = event.originalEvent ?? event;
    const isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
    if (!isTouchEvent) {
        if (data.touchId !== null)
            return; // return from pointer if we use touch
        const pe = e;
        if (pe.pointerId !== data.pointerId)
            return;
    }
    else {
        const te = e;
        const found = [...te.changedTouches].find((t) => t.identifier === data.touchId);
        if (!found || found.identifier !== data.touchId)
            return;
    }
    if (['pointercancel', 'pointerout', 'pointerleave', 'contextmenu'].includes(e.type)) {
        const proceed = ['pointercancel', 'contextmenu'].includes(e.type) &&
            (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) {
            return;
        }
    }
    data.pointerId = null;
    data.touchId = null;
    const { params, touches, rtlTranslate: rtl, slidesGrid, enabled } = swiper;
    if (!enabled)
        return;
    if (!params.simulateTouch && e.pointerType === 'mouse')
        return;
    if (data.allowTouchCallbacks) {
        swiper.emit('touchEnd', e);
    }
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) {
            swiper.setGrabCursor(false);
        }
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor &&
        data.isMoved &&
        data.isTouched &&
        (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
        swiper.setGrabCursor(false);
    }
    // Time diff
    const touchEndTime = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.u)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        // Legacy `e.path` was a non-standard Chrome extension; `composedPath()` is the modern API.
        const pathTree = e.path ?? (e.composedPath && e.composedPath());
        swiper.updateClickedSlide((pathTree && pathTree[0]), pathTree);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
            swiper.emit('doubleTap doubleClick', e);
        }
    }
    data.lastClickTime = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.u)();
    (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.t)(() => {
        if (!swiper.destroyed)
            swiper.allowClick = true;
    });
    if (!data.isTouched ||
        !data.isMoved ||
        !swiper.swipeDirection ||
        (touches.diff === 0 && !data.loopSwapReset) ||
        (data.currentTranslate === data.startTranslate && !data.loopSwapReset)) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) {
        currentPos = rtl ? swiper.translate : -swiper.translate;
    }
    else {
        currentPos = -(data.currentTranslate ?? 0);
    }
    if (params.cssMode) {
        return;
    }
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({ currentPos });
        return;
    }
    // Find current slide
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for (let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (swipeToLast ||
                (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment])) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        }
        else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) {
            rewindLastIndex =
                params.virtual?.enabled && swiper.virtual
                    ? swiper.virtual.slides.length - 1
                    : swiper.slides.length - 1;
        }
        else if (swiper.isEnd) {
            rewindFirstIndex = 0;
        }
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio)
                swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else
                swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) {
                swiper.slideTo(stopIndex + increment);
            }
            else if (rewindLastIndex !== null &&
                ratio < 0 &&
                Math.abs(ratio) > params.longSwipesRatio) {
                swiper.slideTo(rewindLastIndex);
            }
            else {
                swiper.slideTo(stopIndex);
            }
        }
    }
    else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation &&
            (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') {
                swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            }
            if (swiper.swipeDirection === 'prev') {
                swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
            }
        }
        else if (e.target === swiper.navigation.nextEl) {
            swiper.slideTo(stopIndex + increment);
        }
        else {
            swiper.slideTo(stopIndex);
        }
    }
}

function onTouchMove(event) {
    const swiper = this;
    if (swiper.destroyed)
        return;
    const data = swiper.touchEventsData;
    const { params, touches, rtlTranslate: rtl, enabled } = swiper;
    if (!enabled)
        return;
    if (!params.simulateTouch && event.pointerType === 'mouse')
        return;
    // Legacy event wrappers nest the native event under .originalEvent.
    const wrapped = event;
    const e = wrapped.originalEvent ?? wrapped;
    if (e.type === 'pointermove') {
        if (data.touchId !== null)
            return; // return from pointer if we use touch
        const pe = e;
        if (pe.pointerId !== data.pointerId)
            return;
    }
    let targetTouch;
    if (e.type === 'touchmove') {
        const te = e;
        const found = [...te.changedTouches].find((t) => t.identifier === data.touchId);
        if (!found || found.identifier !== data.touchId)
            return;
        targetTouch = found;
    }
    else {
        targetTouch = e;
    }
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) {
            swiper.emit('touchMoveOpposite', e);
        }
        return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) {
            swiper.allowClick = false;
        }
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY,
            });
            data.touchStartTime = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.u)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) {
            // Vertical
            if ((pageY < touches.startY && swiper.translate <= swiper.maxTranslate()) ||
                (pageY > touches.startY && swiper.translate >= swiper.minTranslate())) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        }
        else if (rtl &&
            ((pageX > touches.startX && -swiper.translate <= swiper.maxTranslate()) ||
                (pageX < touches.startX && -swiper.translate >= swiper.minTranslate()))) {
            return;
        }
        else if (!rtl &&
            ((pageX < touches.startX && swiper.translate <= swiper.maxTranslate()) ||
                (pageX > touches.startX && swiper.translate >= swiper.minTranslate()))) {
            return;
        }
    }
    if (document.activeElement &&
        document.activeElement.matches(data.focusableElements) &&
        document.activeElement !== e.target &&
        e.pointerType !== 'mouse') {
        document.activeElement.blur();
    }
    if (document.activeElement) {
        if (e.target === document.activeElement &&
            e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) {
        swiper.emit('touchMove', e);
    }
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold)
        return;
    if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if ((swiper.isHorizontal() && touches.currentY === touches.startY) ||
            (swiper.isVertical() && touches.currentX === touches.startX)) {
            data.isScrolling = false;
        }
        else {
            if (diffX * diffX + diffY * diffY >= 25) {
                touchAngle = (Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180) / Math.PI;
                data.isScrolling = swiper.isHorizontal()
                    ? touchAngle > params.touchAngle
                    : 90 - touchAngle > params.touchAngle;
            }
        }
    }
    if (data.isScrolling) {
        swiper.emit('touchMoveOpposite', e);
    }
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
            data.startMoving = true;
        }
    }
    if (data.isScrolling || (e.type === 'touchmove' && data.preventTouchMoveFromPointerMove)) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) {
        return;
    }
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) {
        e.preventDefault();
    }
    if (params.touchMoveStopPropagation && !params.nested) {
        e.stopPropagation();
    }
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal()
        ? touches.currentX - touches.previousX
        : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = (swiper.touchesDirection === 'next' && swiper.allowSlideNext) ||
        (swiper.touchesDirection === 'prev' && swiper.allowSlidePrev);
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) {
            swiper.loopFix({ direction: swiper.swipeDirection });
        }
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent('transitionend', {
                bubbles: true,
                cancelable: true,
                detail: {
                    bySwiperTouchMove: true,
                },
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
            swiper.setGrabCursor(true);
        }
        swiper.emit('sliderFirstMove', e);
    }
    new Date().getTime();
    if (params._loopSwapReset !== false &&
        data.isMoved &&
        data.allowThresholdMove &&
        prevTouchesDirection !== swiper.touchesDirection &&
        isLoop &&
        allowLoopFix &&
        Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate,
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    // startTranslate is guaranteed to be set by this point (set in onTouchStart-side init).
    const startTranslate = data.startTranslate ?? 0;
    data.currentTranslate = diff + startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) {
        resistanceRatio = 0;
    }
    if (diff > 0) {
        if (isLoop &&
            allowLoopFix &&
            true &&
            data.allowThresholdMove &&
            data.currentTranslate >
                (params.centeredSlides
                    ? swiper.minTranslate() -
                        swiper.slidesSizesGrid[swiper.activeIndex + 1] -
                        (params.slidesPerView !== 'auto' &&
                            swiper.slides.length - params.slidesPerView >= 2
                            ? swiper.slidesSizesGrid[swiper.activeIndex + 1] +
                                swiper.params.spaceBetween
                            : 0) -
                        swiper.params.spaceBetween
                    : swiper.minTranslate())) {
            swiper.loopFix({ direction: 'prev', setTranslate: true, activeSlideIndex: 0 });
        }
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) {
                data.currentTranslate =
                    swiper.minTranslate() -
                        1 +
                        (-swiper.minTranslate() + startTranslate + diff) ** resistanceRatio;
            }
        }
    }
    else if (diff < 0) {
        if (isLoop &&
            allowLoopFix &&
            true &&
            data.allowThresholdMove &&
            data.currentTranslate <
                (params.centeredSlides
                    ? swiper.maxTranslate() +
                        swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] +
                        swiper.params.spaceBetween +
                        (params.slidesPerView !== 'auto' &&
                            swiper.slides.length - params.slidesPerView >= 2
                            ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] +
                                swiper.params.spaceBetween
                            : 0)
                    : swiper.maxTranslate())) {
            swiper.loopFix({
                direction: 'next',
                setTranslate: true,
                activeSlideIndex: swiper.slides.length -
                    (params.slidesPerView === 'auto'
                        ? swiper.slidesPerViewDynamic()
                        : Math.ceil(parseFloat(String(params.slidesPerView)))),
            });
        }
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) {
                data.currentTranslate =
                    swiper.maxTranslate() +
                        1 -
                        (swiper.maxTranslate() - startTranslate - diff) ** resistanceRatio;
            }
        }
    }
    if (disableParentSwiper) {
        e.preventedByNestedSwiper = true;
    }
    // Directions locks
    if (!swiper.allowSlideNext &&
        swiper.swipeDirection === 'next' &&
        (data.currentTranslate ?? 0) < startTranslate) {
        data.currentTranslate = startTranslate;
    }
    if (!swiper.allowSlidePrev &&
        swiper.swipeDirection === 'prev' &&
        (data.currentTranslate ?? 0) > startTranslate) {
        data.currentTranslate = startTranslate;
    }
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
        data.currentTranslate = startTranslate;
    }
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal()
                    ? touches.currentX - touches.startX
                    : touches.currentY - touches.startY;
                return;
            }
        }
        else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode)
        return;
    // Update active index in free mode
    if ((params.freeMode && params.freeMode.enabled && swiper.freeMode) ||
        params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) {
        swiper.freeMode.onTouchMove();
    }
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate ?? 0);
}

// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function closestElement(selector, base) {
    function __closestFrom(el) {
        if (!el || el === document || el === window)
            return null;
        let cur = el;
        if (cur.assignedSlot)
            cur = cur.assignedSlot;
        const found = cur.closest(selector);
        if (!found && !cur.getRootNode) {
            return null;
        }
        const root = cur.getRootNode();
        return found || __closestFrom(root.host);
    }
    return __closestFrom(base);
}
function preventEdgeSwipe(swiper, event, startX) {
    const { params } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection &&
        (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function onTouchStart(event) {
    const swiper = this;
    if (swiper.destroyed)
        return;
    const e = event.originalEvent ?? event;
    const data = swiper.touchEventsData;
    if (e.type === 'pointerdown') {
        const pe = e;
        if (data.pointerId !== null && data.pointerId !== pe.pointerId) {
            return;
        }
        data.pointerId = pe.pointerId;
    }
    else if (e.type === 'touchstart' && e.targetTouches.length === 1) {
        data.touchId = e.targetTouches[0].identifier;
    }
    if (e.type === 'touchstart') {
        // don't proceed touch event
        preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    const { params, touches, enabled } = swiper;
    if (!enabled)
        return;
    if (!params.simulateTouch && e.pointerType === 'mouse')
        return;
    if (swiper.animating && params.preventInteractionOnTransition) {
        return;
    }
    if (!swiper.animating && params.cssMode && params.loop) {
        swiper.loopFix();
    }
    let targetEl = e.target;
    if (params.touchEventsTarget === 'wrapper') {
        if (!(0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.f)(targetEl, swiper.wrapperEl))
            return;
    }
    // Secondary mouse buttons (right-click / middle-click) shouldn't start a swipe.
    const mouseLike = e;
    if (typeof mouseLike.which === 'number' && mouseLike.which === 3)
        return;
    if (typeof mouseLike.button === 'number' && mouseLike.button > 0)
        return;
    if (data.isTouched && data.isMoved)
        return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
    // `path` is a non-standard Chrome extension; `composedPath()` is the modern API.
    const eventPath = e.composedPath
        ? e.composedPath()
        : e.path;
    if (swipingClassHasValue &&
        e.target &&
        e.target.shadowRoot &&
        eventPath) {
        targetEl = eventPath[0];
    }
    const noSwipingSelector = params.noSwipingSelector
        ? params.noSwipingSelector
        : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping &&
        (isTargetShadow
            ? closestElement(noSwipingSelector, targetEl)
            : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (typeof params.swipeHandler === 'string' && !targetEl.closest(params.swipeHandler))
            return;
    }
    // At this point `e` is a PointerEvent or MouseEvent (touchstart returned earlier).
    const pe = e;
    touches.currentX = pe.pageX;
    touches.currentY = pe.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!preventEdgeSwipe(swiper, e, startX)) {
        return;
    }
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined,
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.u)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0)
        data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === 'SELECT') {
            data.isTouched = false;
        }
    }
    if (document.activeElement &&
        document.activeElement.matches(data.focusableElements) &&
        document.activeElement !== targetEl &&
        (pe.pointerType === 'mouse' ||
            (pe.pointerType !== 'mouse' && !targetEl.matches(data.focusableElements)))) {
        document.activeElement.blur();
    }
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) &&
        !targetEl.isContentEditable) {
        e.preventDefault();
    }
    if (params.freeMode &&
        params.freeMode.enabled &&
        swiper.freeMode &&
        swiper.animating &&
        !params.cssMode) {
        swiper.freeMode.onTouchStart();
    }
    swiper.emit('touchStart', e);
}

const events = (swiper, method) => {
    const { params, el, wrapperEl, device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    const swiperMethod = method;
    if (!el || typeof el === 'string')
        return;
    // Touch Events
    document[domMethod]('touchstart', swiper.onDocumentTouchStart, {
        passive: false,
        capture,
    });
    el[domMethod]('touchstart', swiper.onTouchStart, { passive: false });
    el[domMethod]('pointerdown', swiper.onTouchStart, { passive: false });
    document[domMethod]('touchmove', swiper.onTouchMove, {
        passive: false,
        capture,
    });
    document[domMethod]('pointermove', swiper.onTouchMove, {
        passive: false,
        capture,
    });
    document[domMethod]('touchend', swiper.onTouchEnd, { passive: true });
    document[domMethod]('pointerup', swiper.onTouchEnd, { passive: true });
    document[domMethod]('pointercancel', swiper.onTouchEnd, { passive: true });
    document[domMethod]('touchcancel', swiper.onTouchEnd, { passive: true });
    document[domMethod]('pointerout', swiper.onTouchEnd, { passive: true });
    document[domMethod]('pointerleave', swiper.onTouchEnd, { passive: true });
    document[domMethod]('contextmenu', swiper.onTouchEnd, { passive: true });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) {
        el[domMethod]('click', swiper.onClick, true);
    }
    if (params.cssMode) {
        wrapperEl[domMethod]('scroll', swiper.onScroll);
    }
    // Resize handler
    const subscribe = (events) => {
        swiper[swiperMethod](events, onResize, true);
    };
    if (params.updateOnWindowResize) {
        subscribe(device.ios || device.android
            ? 'resize orientationchange observerUpdate'
            : 'resize observerUpdate');
    }
    else {
        subscribe('observerUpdate');
    }
    // Images loader
    el[domMethod]('load', swiper.onLoad, { capture: true });
};
function attachEvents() {
    const swiper = this;
    const { params } = swiper;
    swiper.onTouchStart = onTouchStart.bind(swiper);
    swiper.onTouchMove = onTouchMove.bind(swiper);
    swiper.onTouchEnd = onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = onDocumentTouchStart.bind(swiper);
    if (params.cssMode) {
        swiper.onScroll = onScroll.bind(swiper);
    }
    swiper.onClick = onClick.bind(swiper);
    swiper.onLoad = onLoad.bind(swiper);
    events(swiper, 'on');
}
function detachEvents() {
    const swiper = this;
    events(swiper, 'off');
}
var events$1 = {
    attachEvents,
    detachEvents,
};

function setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch ||
        (swiper.params.watchOverflow && swiper.isLocked) ||
        swiper.params.cssMode)
        return;
    const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) {
        swiper.__preventObserver__ = true;
    }
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
    if (swiper.isElement) {
        requestAnimationFrame(() => {
            swiper.__preventObserver__ = false;
        });
    }
}

function unsetGrabCursor() {
    const swiper = this;
    if ((swiper.params.watchOverflow && swiper.isLocked) || swiper.params.cssMode) {
        return;
    }
    if (swiper.isElement) {
        swiper.__preventObserver__ = true;
    }
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
    if (swiper.isElement) {
        requestAnimationFrame(() => {
            swiper.__preventObserver__ = false;
        });
    }
}

var grabCursor = {
    setGrabCursor,
    unsetGrabCursor,
};

function loopCreate(slideRealIndex, initial) {
    const swiper = this;
    const { params, slidesEl } = swiper;
    if (!params.loop || (swiper.virtual && swiper.params.virtual?.enabled))
        return;
    const initSlides = () => {
        const slides = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach((el, index) => {
            el.setAttribute('data-swiper-slide-index', String(index));
        });
    };
    const clearBlankSlides = () => {
        const slides = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.e)(slidesEl, `.${params.slideBlankClass}`);
        slides.forEach((el) => {
            el.remove();
        });
        if (slides.length > 0) {
            swiper.recalcSlides();
            swiper.updateSlides();
        }
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (params.loopAddBlankSlides && (params.slidesPerGroup > 1 || gridEnabled)) {
        clearBlankSlides();
    }
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides) => {
        for (let i = 0; i < amountOfSlides; i += 1) {
            const slideEl = swiper.isElement
                ? (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.a)('swiper-slide', [params.slideBlankClass])
                : (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.a)('div', [params.slideClass, params.slideBlankClass]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = slidesPerGroup - (swiper.slides.length % slidesPerGroup);
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        }
        else {
            (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.x)('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        }
        initSlides();
    }
    else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = params.grid.rows - (swiper.slides.length % params.grid.rows);
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        }
        else {
            (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.x)('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        }
        initSlides();
    }
    else {
        initSlides();
    }
    const bothDirections = params.centeredSlides || !!params.slidesOffsetBefore || !!params.slidesOffsetAfter;
    swiper.loopFix({
        slideRealIndex,
        direction: bothDirections ? undefined : 'next',
        initial,
    });
}

function loopDestroy() {
    const swiper = this;
    const { params, slidesEl } = swiper;
    if (!params.loop || !slidesEl || (swiper.virtual && swiper.params.virtual?.enabled))
        return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl) => {
        const loopSlideEl = slideEl;
        const index = typeof loopSlideEl.swiperSlideIndex === 'undefined'
            ? Number(slideEl.getAttribute('data-swiper-slide-index'))
            : loopSlideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl) => {
        slideEl.removeAttribute('data-swiper-slide-index');
    });
    newSlidesOrder.forEach((slideEl) => {
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}

function loopFix(options = {}) {
    const { slideRealIndex, slideTo = true, direction, setTranslate, activeSlideIndex: activeSlideIndexParam, initial, byController, byMousewheel, } = options;
    let activeSlideIndex = activeSlideIndexParam;
    const swiper = this;
    if (!swiper.params.loop)
        return;
    swiper.emit('beforeLoopFix');
    const { slides, allowSlidePrev, allowSlideNext, slidesEl, params } = swiper;
    const { centeredSlides, slidesOffsetBefore, slidesOffsetAfter, initialSlide } = params;
    const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual?.enabled) {
        if (slideTo) {
            const virtualSlidesLength = swiper.virtual.slides.length;
            const virtualSlidesBefore = swiper.virtual.slidesBefore ?? 0;
            if (!bothDirections && swiper.snapIndex === 0) {
                swiper.slideTo(virtualSlidesLength, 0, false, true);
            }
            else if (bothDirections && swiper.snapIndex < params.slidesPerView) {
                swiper.slideTo(virtualSlidesLength + swiper.snapIndex, 0, false, true);
            }
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) {
                swiper.slideTo(virtualSlidesBefore, 0, false, true);
            }
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit('loopFix');
        return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === 'auto') {
        slidesPerView = swiper.slidesPerViewDynamic();
    }
    else {
        slidesPerView = Math.ceil(parseFloat(String(params.slidesPerView)));
        if (bothDirections && slidesPerView % 2 === 0) {
            slidesPerView = slidesPerView + 1;
        }
    }
    const slidesPerGroup = params.slidesPerGroupAuto
        ? slidesPerView
        : params.slidesPerGroup;
    let loopedSlides = bothDirections
        ? Math.max(slidesPerGroup, Math.ceil(slidesPerView / 2))
        : slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) {
        loopedSlides += slidesPerGroup - (loopedSlides % slidesPerGroup);
    }
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides ||
        (swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2)) {
        (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.x)('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
    }
    else if (gridEnabled && params.grid.fill === 'row') {
        (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.x)('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
    }
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !bothDirections;
    let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
    if (typeof activeSlideIndex === 'undefined') {
        activeSlideIndex = swiper.getSlideIndex(slides.find((el) => el.classList.contains(params.slideActiveClass)));
    }
    else {
        activeIndex = activeSlideIndex;
    }
    const isNext = direction === 'next' || !direction;
    const isPrev = direction === 'prev' || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const activeColIndex = gridEnabled
        ? (slides[activeSlideIndex].column ?? 0)
        : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex +
        (bothDirections && typeof setTranslate === 'undefined' ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for (let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1) {
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                const colIndexToPrepend = cols - index - 1;
                for (let j = slides.length - 1; j >= 0; j -= 1) {
                    if (slides[j].column === colIndexToPrepend)
                        prependSlidesIndexes.push(j);
                }
            }
            else {
                prependSlidesIndexes.push(cols - index - 1);
            }
        }
    }
    else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        if (isInitialOverflow) {
            slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
        }
        for (let i = 0; i < slidesAppended; i += 1) {
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                slides.forEach((slide, slideIndex) => {
                    if (slide.column === index)
                        appendSlidesIndexes.push(slideIndex);
                });
            }
            else {
                appendSlidesIndexes.push(index);
            }
        }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(() => {
        swiper.__preventObserver__ = false;
    });
    if (swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
        if (appendSlidesIndexes.includes(activeSlideIndex)) {
            appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
        }
        if (prependSlidesIndexes.includes(activeSlideIndex)) {
            prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
        }
    }
    if (isPrev) {
        prependSlidesIndexes.forEach((index) => {
            const slideEl = slides[index];
            slideEl.swiperLoopMoveDOM = true;
            slidesEl.prepend(slideEl);
            slideEl.swiperLoopMoveDOM = false;
        });
    }
    if (isNext) {
        appendSlidesIndexes.forEach((index) => {
            const slideEl = slides[index];
            slideEl.swiperLoopMoveDOM = true;
            slidesEl.append(slideEl);
            slideEl.swiperLoopMoveDOM = false;
        });
    }
    swiper.recalcSlides();
    if (params.slidesPerView === 'auto') {
        swiper.updateSlides();
    }
    else if (gridEnabled &&
        ((prependSlidesIndexes.length > 0 && isPrev) || (appendSlidesIndexes.length > 0 && isNext))) {
        swiper.slides.forEach((slide, slideIndex) => {
            swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
        });
    }
    if (params.watchSlidesProgress) {
        swiper.updateSlidesOffset();
    }
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) {
                    swiper.setTranslate(swiper.translate - diff);
                }
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate =
                            swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate =
                            swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            }
            else {
                if (setTranslate) {
                    const shift = gridEnabled
                        ? prependSlidesIndexes.length / params.grid.rows
                        : prependSlidesIndexes.length;
                    swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                    swiper.touchEventsData.currentTranslate = swiper.translate;
                }
            }
        }
        else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) {
                    swiper.setTranslate(swiper.translate - diff);
                }
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate =
                            swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate =
                            swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            }
            else {
                const shift = gridEnabled
                    ? appendSlidesIndexes.length / params.grid.rows
                    : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    const controlled = swiper.controller?.control;
    if (controlled && !byController) {
        const loopParams = {
            slideRealIndex,
            direction,
            setTranslate,
            activeSlideIndex,
            byController: true,
        };
        if (Array.isArray(controlled)) {
            controlled.forEach((c) => {
                if (!c.destroyed && c.params.loop)
                    c.loopFix({
                        ...loopParams,
                        slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false,
                    });
            });
        }
        else if (controlled instanceof swiper.constructor &&
            controlled.params.loop) {
            controlled.loopFix({
                ...loopParams,
                slideTo: controlled.params.slidesPerView === params.slidesPerView ? slideTo : false,
            });
        }
    }
    swiper.emit('loopFix');
}

var loop = {
    loopCreate,
    loopFix,
    loopDestroy,
};

function moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
            (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.n)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) {
            params[moduleParamName] = { enabled: true };
        }
        if (moduleParamName === 'navigation' &&
            params[moduleParamName] &&
            params[moduleParamName].enabled &&
            !params[moduleParamName].prevEl &&
            !params[moduleParamName].nextEl) {
            params[moduleParamName].auto = true;
        }
        if (['pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 &&
            params[moduleParamName] &&
            params[moduleParamName].enabled &&
            !params[moduleParamName].el) {
            params[moduleParamName].auto = true;
        }
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.n)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
            params[moduleParamName].enabled = true;
        }
        if (!params[moduleParamName])
            params[moduleParamName] = { enabled: false };
        (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.n)(allModulesParams, obj);
    };
}

const Observer = ({ swiper, extendParams, on }) => {
    const observers = [];
    const attach = (target, options = {}) => {
        const ObserverFunc = window.MutationObserver ||
            window
                .WebkitMutationObserver;
        if (!ObserverFunc)
            return;
        const observer = new ObserverFunc((mutations) => {
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__)
                return;
            if (mutations.length === 1) {
                swiper.emit('observerUpdate', mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                swiper.emit('observerUpdate', mutations[0]);
            };
            if (window.requestAnimationFrame) {
                window.requestAnimationFrame(observerUpdate);
            }
            else {
                window.setTimeout(observerUpdate, 0);
            }
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: swiper.isElement || (typeof options.childList === 'undefined' ? true : options.childList),
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData,
        });
        observers.push(observer);
    };
    const init = () => {
        if (!swiper.params.observer)
            return;
        if (swiper.params.observeParents) {
            const containerParents = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.j)(swiper.hostEl);
            for (let i = 0; i < containerParents.length; i += 1) {
                attach(containerParents[i]);
            }
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren,
        });
        // Observe wrapper
        attach(swiper.wrapperEl, { attributes: false });
    };
    const destroy = () => {
        observers.forEach((observer) => {
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false,
    });
    on('init', init);
    on('destroy', destroy);
};

const Resize = ({ swiper, on, emit }) => {
    let observer = null;
    let animationFrame = null;
    const resizeHandler = () => {
        if (!swiper || swiper.destroyed || !swiper.initialized)
            return;
        emit('beforeResize');
        emit('resize');
    };
    const createObserver = () => {
        if (!swiper || swiper.destroyed || !swiper.initialized)
            return;
        observer = new ResizeObserver((entries) => {
            animationFrame = window.requestAnimationFrame(() => {
                const { width, height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach(({ contentBoxSize, contentRect, target }) => {
                    if (target && target !== swiper.el)
                        return;
                    // Older Safari (≤15) exposed `contentBoxSize` as a single object instead of an array.
                    const box = Array.isArray(contentBoxSize)
                        ? contentBoxSize[0]
                        : contentBoxSize;
                    newWidth = contentRect ? contentRect.width : box.inlineSize;
                    newHeight = contentRect ? contentRect.height : box.blockSize;
                });
                if (newWidth !== width || newHeight !== height) {
                    resizeHandler();
                }
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = () => {
        if (animationFrame) {
            window.cancelAnimationFrame(animationFrame);
        }
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = () => {
        if (!swiper || swiper.destroyed || !swiper.initialized)
            return;
        emit('orientationchange');
    };
    on('init', () => {
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window.addEventListener('resize', resizeHandler);
        window.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', () => {
        removeObserver();
        window.removeEventListener('resize', resizeHandler);
        window.removeEventListener('orientationchange', orientationChangeHandler);
    });
};

function slideNext(speed, runCallbacks = true, internal) {
    const swiper = this;
    const { enabled, params, animating } = swiper;
    if (!enabled || swiper.destroyed)
        return swiper;
    if (typeof speed === 'undefined') {
        speed = swiper.params.speed;
    }
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
        perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    }
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual?.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding)
            return false;
        swiper.loopFix({ direction: 'next' });
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(() => {
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) {
        return swiper.slideTo(0, speed, runCallbacks, internal);
    }
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

function slidePrev(speed, runCallbacks = true, internal) {
    const swiper = this;
    const { params, snapGrid, slidesGrid, rtlTranslate, enabled, animating } = swiper;
    if (!enabled || swiper.destroyed)
        return swiper;
    if (typeof speed === 'undefined') {
        speed = swiper.params.speed;
    }
    const isVirtual = swiper.virtual && params.virtual?.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding)
            return false;
        swiper.loopFix({ direction: 'prev' });
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0)
            return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val) => normalize(val));
    const isFreeMode = params.freeMode && params.freeMode.enabled;
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && (params.cssMode || isFreeMode)) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex) => {
            if (normalizedTranslate >= snap) {
                prevSnapIndex = snapIndex;
            }
        });
        if (typeof prevSnapIndex !== 'undefined') {
            prevSnap = isFreeMode
                ? snapGrid[prevSnapIndex]
                : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
        }
    }
    let prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0)
            prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' &&
            params.slidesPerGroup === 1 &&
            params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual?.enabled && swiper.virtual
            ? swiper.virtual.slides.length - 1
            : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    }
    else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(() => {
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

function slideReset(speed, runCallbacks = true, internal) {
    const swiper = this;
    if (swiper.destroyed)
        return;
    if (typeof speed === 'undefined') {
        speed = swiper.params.speed;
    }
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

function slideTo(index = 0, speed, runCallbacks = true, internal, initial) {
    if (typeof index === 'string') {
        index = parseInt(index, 10);
    }
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0)
        slideIndex = 0;
    const { params, snapGrid, slidesGrid, previousIndex, activeIndex, rtlTranslate: rtl, wrapperEl, enabled, } = swiper;
    if ((!enabled && !internal && !initial) ||
        swiper.destroyed ||
        (swiper.animating && params.preventInteractionOnTransition)) {
        return false;
    }
    if (typeof speed === 'undefined') {
        speed = swiper.params.speed;
    }
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length)
        snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        for (let i = 0; i < slidesGrid.length; i += 1) {
            const normalizedTranslate = -Math.floor(translate * 100);
            const normalizedGrid = Math.floor(slidesGrid[i] * 100);
            const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
            if (typeof slidesGrid[i + 1] !== 'undefined') {
                if (normalizedTranslate >= normalizedGrid &&
                    normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
                    slideIndex = i;
                }
                else if (normalizedTranslate >= normalizedGrid &&
                    normalizedTranslate < normalizedGridNext) {
                    slideIndex = i + 1;
                }
            }
            else if (normalizedTranslate >= normalizedGrid) {
                slideIndex = i;
            }
        }
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext &&
            (rtl
                ? translate > swiper.translate && translate > swiper.minTranslate()
                : translate < swiper.translate && translate < swiper.minTranslate())) {
            return false;
        }
        if (!swiper.allowSlidePrev &&
            translate > swiper.translate &&
            translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) {
                return false;
            }
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) {
        swiper.emit('beforeSlideChangeStart');
    }
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex)
        direction = 'next';
    else if (slideIndex < activeIndex)
        direction = 'prev';
    else
        direction = 'reset';
    // initial virtual
    const isVirtual = swiper.virtual && swiper.params.virtual?.enabled;
    const isInitialVirtual = isVirtual && initial;
    // Update Index
    if (!isInitialVirtual &&
        ((rtl && -translate === swiper.translate) || (!rtl && translate === swiper.translate))) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) {
            swiper.updateAutoHeight();
        }
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') {
            swiper.setTranslate(translate);
        }
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && (swiper.params.initialSlide ?? 0) > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(() => {
                    wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
                });
            }
            else {
                wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            }
            if (isVirtual) {
                requestAnimationFrame(() => {
                    swiper.wrapperEl.style.scrollSnapType = '';
                    swiper._immediateVirtual = false;
                });
            }
        }
        else {
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: t,
                behavior: 'smooth',
            });
        }
        return true;
    }
    const browser = getBrowser();
    const isSafari = browser.isSafari;
    if (isVirtual && !initial && isSafari && swiper.isElement) {
        swiper.virtual.update(false, false, slideIndex);
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) {
        swiper.transitionEnd(runCallbacks, direction);
    }
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) {
            swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed)
                    return;
                if (e.target !== this)
                    return;
                swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
                swiper.onSlideToWrapperTransitionEnd = null;
                delete swiper.onSlideToWrapperTransitionEnd;
                swiper.transitionEnd(runCallbacks, direction);
            };
        }
        swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}

function slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed)
        return;
    const { params, slidesEl, clickedSlide, clickedIndex } = swiper;
    if (clickedSlide === undefined || clickedIndex === undefined)
        return;
    const slidesPerView = params.slidesPerView === 'auto'
        ? swiper.slidesPerViewDynamic()
        : params.slidesPerView;
    let slideToIndex = swiper.getSlideIndexWhenGrid(clickedIndex);
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    const isGrid = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    if (params.loop) {
        if (swiper.animating)
            return;
        realIndex = parseInt(clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        if (params.centeredSlides) {
            swiper.slideToLoop(realIndex);
        }
        else if (slideToIndex >
            (isGrid
                ? (swiper.slides.length - slidesPerView) / 2 - (swiper.params.grid.rows - 1)
                : swiper.slides.length - slidesPerView)) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.e)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.t)(() => {
                swiper.slideTo(slideToIndex);
            });
        }
        else {
            swiper.slideTo(slideToIndex);
        }
    }
    else {
        swiper.slideTo(slideToIndex);
    }
}

function slideToClosest(speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    if (swiper.destroyed)
        return;
    if (typeof speed === 'undefined') {
        speed = swiper.params.speed;
    }
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
            index += swiper.params.slidesPerGroup;
        }
    }
    else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) {
            index -= swiper.params.slidesPerGroup;
        }
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}

function slideToLoop(index = 0, speed, runCallbacks = true, internal) {
    if (typeof index === 'string') {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed)
        return;
    if (typeof speed === 'undefined') {
        speed = swiper.params.speed;
    }
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual?.enabled) {
            newIndex = newIndex + (swiper.virtual.slidesBefore ?? 0);
        }
        else {
            let targetSlideIndex;
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                const targetSlideEl = swiper.slides.find((slideEl) => Number(slideEl.getAttribute('data-swiper-slide-index')) === slideIndex);
                targetSlideIndex = targetSlideEl?.column ?? 0;
            }
            else {
                targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            }
            const cols = gridEnabled
                ? Math.ceil(swiper.slides.length / swiper.params.grid.rows)
                : swiper.slides.length;
            const { centeredSlides, slidesOffsetBefore, slidesOffsetAfter } = swiper.params;
            const bothDirections = centeredSlides || !!slidesOffsetBefore || !!slidesOffsetAfter;
            let slidesPerView;
            if (swiper.params.slidesPerView === 'auto') {
                slidesPerView = swiper.slidesPerViewDynamic();
            }
            else {
                slidesPerView = Math.ceil(parseFloat(String(swiper.params.slidesPerView)));
                if (bothDirections && slidesPerView % 2 === 0) {
                    slidesPerView = slidesPerView + 1;
                }
            }
            let needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (bothDirections) {
                needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            }
            if (internal && bothDirections && swiper.params.slidesPerView !== 'auto' && !gridEnabled) {
                needLoopFix = false;
            }
            if (needLoopFix) {
                const direction = bothDirections
                    ? targetSlideIndex < swiper.activeIndex
                        ? 'prev'
                        : 'next'
                    : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView
                        ? 'next'
                        : 'prev';
                swiper.loopFix({
                    direction,
                    slideTo: true,
                    activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === 'next' ? swiper.realIndex : undefined,
                });
            }
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                const targetSlideEl = swiper.slides.find((slideEl) => Number(slideEl.getAttribute('data-swiper-slide-index')) === slideIndex);
                newIndex = targetSlideEl?.column ?? 0;
            }
            else {
                newIndex = swiper.getSlideIndexByData(newIndex);
            }
        }
    }
    requestAnimationFrame(() => {
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}

var slide = {
    slideTo,
    slideToLoop,
    slideNext,
    slidePrev,
    slideReset,
    slideToClosest,
    slideToClickedSlide,
};

function setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : '';
    }
    swiper.emit('setTransition', duration, byController);
}

function transitionEmit({ swiper, runCallbacks, direction, step, }) {
    const { activeIndex, previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex)
            dir = 'next';
        else if (activeIndex < previousIndex)
            dir = 'prev';
        else
            dir = 'reset';
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && dir === 'reset') {
        swiper.emit(`slideResetTransition${step}`);
    }
    else if (runCallbacks && activeIndex !== previousIndex) {
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') {
            swiper.emit(`slideNextTransition${step}`);
        }
        else {
            swiper.emit(`slidePrevTransition${step}`);
        }
    }
}

function transitionEnd(runCallbacks = true, direction) {
    const swiper = this;
    const { params } = swiper;
    swiper.animating = false;
    if (params.cssMode)
        return;
    swiper.setTransition(0);
    transitionEmit({ swiper, runCallbacks, direction, step: 'End' });
}

function transitionStart(runCallbacks = true, direction) {
    const swiper = this;
    const { params } = swiper;
    if (params.cssMode)
        return;
    if (params.autoHeight) {
        swiper.updateAutoHeight();
    }
    transitionEmit({ swiper, runCallbacks, direction, step: 'Start' });
}

var transition = {
    setTransition,
    transitionStart,
    transitionEnd,
};

function getSwiperTranslate(axis = this.isHorizontal() ? 'x' : 'y') {
    const swiper = this;
    const { params, rtlTranslate: rtl, translate, wrapperEl } = swiper;
    if (params.virtualTranslate) {
        return rtl ? -translate : translate;
    }
    if (params.cssMode) {
        return translate;
    }
    let currentTranslate = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.q)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl)
        currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}

function maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}

function minTranslate() {
    return -this.snapGrid[0];
}

function setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params, wrapperEl, progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) {
        x = rtl ? -translate : translate;
    }
    else {
        y = translate;
    }
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) {
        wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    }
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) {
            x -= swiper.cssOverflowAdjustment();
        }
        else {
            y -= swiper.cssOverflowAdjustment();
        }
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) {
        newProgress = 0;
    }
    else {
        newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    }
    if (newProgress !== progress) {
        swiper.updateProgress(translate);
    }
    swiper.emit('setTranslate', swiper.translate, byController);
}

function translateTo(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const { params, wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) {
        return false;
    }
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate)
        newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate)
        newTranslate = maxTranslate;
    else
        newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) {
            wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        }
        else {
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: -newTranslate,
                behavior: 'smooth',
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    }
    else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) {
                swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                    if (!swiper || swiper.destroyed)
                        return;
                    if (e.target !== this)
                        return;
                    swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                    swiper.onTranslateToWrapperTransitionEnd = null;
                    delete swiper.onTranslateToWrapperTransitionEnd;
                    swiper.animating = false;
                    if (runCallbacks) {
                        swiper.emit('transitionEnd');
                    }
                };
            }
            swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}

var translate = {
    getTranslate: getSwiperTranslate,
    setTranslate,
    minTranslate,
    maxTranslate,
    translateTo,
};

function getActiveIndexByTranslate(swiper) {
    const { slidesGrid, params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for (let i = 0; i < slidesGrid.length; i += 1) {
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (translate >= slidesGrid[i] &&
                translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
                activeIndex = i;
            }
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
                activeIndex = i + 1;
            }
        }
        else if (translate >= slidesGrid[i]) {
            activeIndex = i;
        }
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined')
            activeIndex = 0;
    }
    return activeIndex;
}
function updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid, params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex, } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex) => {
        const virtualSlides = swiper.virtual.slides;
        let realIndex = aIndex - (swiper.virtual.slidesBefore ?? 0);
        if (realIndex < 0) {
            realIndex = virtualSlides.length + realIndex;
        }
        if (realIndex >= virtualSlides.length) {
            realIndex -= virtualSlides.length;
        }
        return realIndex;
    };
    if (typeof activeIndex === 'undefined') {
        activeIndex = getActiveIndexByTranslate(swiper);
    }
    if (snapGrid.indexOf(translate) >= 0) {
        snapIndex = snapGrid.indexOf(translate);
    }
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length)
        snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    }
    if (activeIndex === previousIndex &&
        swiper.params.loop &&
        swiper.virtual &&
        swiper.params.virtual?.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual?.enabled) {
        if (params.loop) {
            realIndex = getVirtualRealIndex(activeIndex);
        }
        else {
            realIndex = activeIndex;
        }
    }
    else if (gridEnabled) {
        const firstSlideInColumn = swiper.slides.find((slideEl) => slideEl.column === activeIndex);
        let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
        if (Number.isNaN(activeSlideIndex)) {
            activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        }
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    }
    else if (swiper.slides[activeIndex]) {
        const slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
        if (slideIndex) {
            realIndex = parseInt(slideIndex, 10);
        }
        else {
            realIndex = activeIndex;
        }
    }
    else {
        realIndex = activeIndex;
    }
    Object.assign(swiper, {
        previousSnapIndex,
        snapIndex,
        previousRealIndex,
        realIndex,
        previousIndex,
        activeIndex,
    });
    if (swiper.initialized) {
        preload(swiper);
    }
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) {
            swiper.emit('realIndexChange');
        }
        swiper.emit('slideChange');
    }
}

function updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual?.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === 'number') {
        swiper.setTransition(speed);
    }
    else if (speed === true) {
        swiper.setTransition(swiper.params.speed);
    }
    const getSlideByIndex = (index) => {
        if (isVirtual) {
            return swiper.slides[swiper.getSlideIndexByData(index)];
        }
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) {
            (swiper.visibleSlides || []).forEach((slide) => {
                activeSlides.push(slide);
            });
        }
        else {
            for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
                const index = swiper.activeIndex + i;
                if (index > swiper.slides.length && !isVirtual)
                    break;
                const slide = getSlideByIndex(index);
                if (slide)
                    activeSlides.push(slide);
            }
        }
    }
    else {
        const slide = getSlideByIndex(swiper.activeIndex);
        if (slide)
            activeSlides.push(slide);
    }
    // Find new height from highest slide in view
    for (i = 0; i < activeSlides.length; i += 1) {
        if (typeof activeSlides[i] !== 'undefined') {
            const height = activeSlides[i].offsetHeight;
            newHeight = height > newHeight ? height : newHeight;
        }
    }
    // Update Height
    if (newHeight || newHeight === 0)
        swiper.wrapperEl.style.height = `${newHeight}px`;
}

function updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) {
        [...path.slice(path.indexOf(el) + 1, path.length)].forEach((pathEl) => {
            if (!slide &&
                pathEl.matches &&
                pathEl.matches(`.${params.slideClass}, swiper-slide`)) {
                slide = pathEl;
            }
        });
    }
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for (let i = 0; i < swiper.slides.length; i += 1) {
            if (swiper.slides[i] === slide) {
                slideFound = true;
                slideIndex = i;
                break;
            }
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual?.enabled) {
            swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
        }
        else {
            swiper.clickedIndex = slideIndex;
        }
    }
    else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide &&
        swiper.clickedIndex !== undefined &&
        swiper.clickedIndex !== swiper.activeIndex) {
        swiper.slideToClickedSlide();
    }
}

function updateProgress(translate) {
    const swiper = this;
    if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        translate = (swiper && swiper.translate && swiper.translate * multiplier) || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress, isBeginning, isEnd } = swiper;
    let progressLoop = swiper.progressLoop;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    }
    else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded)
            progress = 0;
        if (isEndRounded)
            progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) {
            progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        }
        else {
            progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        }
        if (progressLoop > 1)
            progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress,
        progressLoop,
        isBeginning,
        isEnd,
    });
    if (params.watchSlidesProgress || (params.centeredSlides && params.autoHeight))
        swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) {
        swiper.emit('reachBeginning toEdge');
    }
    if (isEnd && !wasEnd) {
        swiper.emit('reachEnd toEdge');
    }
    if ((wasBeginning && !isBeginning) || (wasEnd && !isEnd)) {
        swiper.emit('fromEdge');
    }
    swiper.emit('progress', progress);
}

function updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
        width = swiper.params.width;
    }
    else {
        width = el.clientWidth;
    }
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
        height = swiper.params.height;
    }
    else {
        height = el.clientHeight;
    }
    if ((width === 0 && swiper.isHorizontal()) || (height === 0 && swiper.isVertical())) {
        return;
    }
    // Subtract paddings
    width =
        width -
            parseInt((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.l)(el, 'padding-left') || '0', 10) -
            parseInt((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.l)(el, 'padding-right') || '0', 10);
    height =
        height -
            parseInt((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.l)(el, 'padding-top') || '0', 10) -
            parseInt((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.l)(el, 'padding-bottom') || '0', 10);
    if (Number.isNaN(width))
        width = 0;
    if (Number.isNaN(height))
        height = 0;
    Object.assign(swiper, {
        width,
        height,
        size: swiper.isHorizontal() ? width : height,
    });
}

function updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || '0');
    }
    const params = swiper.params;
    const { wrapperEl, slidesEl, rtlTranslate: rtl, wrongRTL } = swiper;
    const isVirtual = !!(swiper.virtual && params.virtual?.enabled);
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.e)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    const resolveOffset = (value) => typeof value === 'function' ? value.call(swiper) : value;
    const offsetBefore = resolveOffset(params.slidesOffsetBefore);
    const offsetAfter = resolveOffset(params.slidesOffsetAfter);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    const swiperSize = swiper.size - offsetBefore - offsetAfter;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === 'undefined') {
        return;
    }
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
        spaceBetween = (parseFloat(spaceBetween.replace('%', '')) / 100) * swiperSize;
    }
    else if (typeof spaceBetween === 'string') {
        spaceBetween = parseFloat(spaceBetween);
    }
    swiper.virtualSize =
        -spaceBetween - offsetBefore - offsetAfter;
    // reset margins
    slides.forEach((slideEl) => {
        if (rtl) {
            slideEl.style.marginLeft = '';
        }
        else {
            slideEl.style.marginRight = '';
        }
        slideEl.style.marginBottom = '';
        slideEl.style.marginTop = '';
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.v)(wrapperEl, '--swiper-centered-offset-before', '');
        (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.v)(wrapperEl, '--swiper-centered-offset-after', '');
    }
    // set cssMode offsets
    if (params.cssMode) {
        (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.v)(wrapperEl, '--swiper-slides-offset-before', `${offsetBefore}px`);
        (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.v)(wrapperEl, '--swiper-slides-offset-after', `${offsetAfter}px`);
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) {
        swiper.grid.initSlides(slides);
    }
    else if (swiper.grid) {
        swiper.grid.unsetSlides();
    }
    // Calc slides
    let slideSize = 0;
    const shouldResetSlideSize = params.slidesPerView === 'auto' &&
        params.breakpoints &&
        Object.keys(params.breakpoints).filter((key) => {
            const bp = params.breakpoints[key];
            return typeof bp?.slidesPerView !== 'undefined';
        }).length > 0;
    for (let i = 0; i < slidesLength; i += 1) {
        slideSize = 0;
        const slide = slides[i];
        if (slide) {
            if (gridEnabled) {
                swiper.grid.updateSlide(i, slide, slides);
            }
            if ((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.l)(slide, 'display') === 'none')
                continue;
        }
        if (isVirtual && params.slidesPerView === 'auto') {
            if (params.virtual?.slidesPerViewAutoSlideSize) {
                slideSize = params.virtual.slidesPerViewAutoSlideSize;
            }
            if (slideSize && slide) {
                if (params.roundLengths)
                    slideSize = Math.floor(slideSize);
                slide.style[swiper.getDirectionLabel('width')] =
                    `${slideSize}px`;
            }
        }
        else if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) {
                slide.style[swiper.getDirectionLabel('width')] = ``;
            }
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) {
                slide.style.transform = 'none';
            }
            if (currentWebKitTransform) {
                slide.style.webkitTransform =
                    'none';
            }
            if (params.roundLengths) {
                slideSize = swiper.isHorizontal()
                    ? (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.i)(slide, 'width')
                    : (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.i)(slide, 'height');
            }
            else {
                const width = getDirectionPropertyValue(slideStyles, 'width');
                const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                const boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') {
                    slideSize = width + marginLeft + marginRight;
                }
                else {
                    const { clientWidth, offsetWidth } = slide;
                    slideSize =
                        width +
                            paddingLeft +
                            paddingRight +
                            marginLeft +
                            marginRight +
                            (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) {
                slide.style.transform = currentTransform;
            }
            if (currentWebKitTransform) {
                slide.style.webkitTransform =
                    currentWebKitTransform;
            }
            if (params.roundLengths)
                slideSize = Math.floor(slideSize);
        }
        else {
            slideSize =
                (swiperSize - (params.slidesPerView - 1) * spaceBetween) /
                    params.slidesPerView;
            if (params.roundLengths)
                slideSize = Math.floor(slideSize);
            if (slide) {
                slide.style[swiper.getDirectionLabel('width')] =
                    `${slideSize}px`;
            }
        }
        if (slide) {
            slide.swiperSlideSize = slideSize;
        }
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0)
                slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0)
                slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 1 / 1000)
                slidePosition = 0;
            if (params.roundLengths)
                slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0)
                snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        }
        else {
            if (params.roundLengths)
                slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) %
                swiper.params.slidesPerGroup ===
                0)
                snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
        wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    }
    if (params.setWrapperSize) {
        wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
    }
    if (gridEnabled) {
        swiper.grid.updateWrapperSize(slideSize, snapGrid);
    }
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        // Check if snapToSlideEdge should be applied
        const isFractionalSlidesPerView = params.slidesPerView !== 'auto' && params.slidesPerView % 1 !== 0;
        const shouldSnapToSlideEdge = params.snapToSlideEdge &&
            !params.loop &&
            (params.slidesPerView === 'auto' || isFractionalSlidesPerView);
        // Calculate the last allowed snap index when snapToSlideEdge is enabled
        // This ensures minimum slides are visible at the end
        let lastAllowedSnapIndex = snapGrid.length;
        if (shouldSnapToSlideEdge) {
            let minVisibleSlides;
            if (params.slidesPerView === 'auto') {
                // For 'auto' mode, calculate how many slides fit based on actual sizes
                minVisibleSlides = 1;
                let accumulatedSize = 0;
                for (let i = slidesSizesGrid.length - 1; i >= 0; i -= 1) {
                    accumulatedSize +=
                        slidesSizesGrid[i] + (i < slidesSizesGrid.length - 1 ? spaceBetween : 0);
                    if (accumulatedSize <= swiperSize) {
                        minVisibleSlides = slidesSizesGrid.length - i;
                    }
                    else {
                        break;
                    }
                }
            }
            else {
                minVisibleSlides = Math.floor(params.slidesPerView);
            }
            lastAllowedSnapIndex = Math.max(slidesLength - minVisibleSlides, 0);
        }
        const newSlidesGrid = [];
        for (let i = 0; i < snapGrid.length; i += 1) {
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths)
                slidesGridItem = Math.floor(slidesGridItem);
            if (shouldSnapToSlideEdge) {
                // When snapToSlideEdge is enabled, only keep snaps up to lastAllowedSnapIndex
                if (i <= lastAllowedSnapIndex) {
                    newSlidesGrid.push(slidesGridItem);
                }
            }
            else if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
                // When snapToSlideEdge is disabled, keep snaps that fit within scrollable area
                newSlidesGrid.push(slidesGridItem);
            }
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) >
            1) {
            // Only add edge-aligned snap if snapToSlideEdge is not enabled
            if (!shouldSnapToSlideEdge) {
                snapGrid.push(swiper.virtualSize - swiperSize);
            }
        }
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        const slidesBefore = swiper.virtual.slidesBefore ?? 0;
        const slidesAfter = swiper.virtual.slidesAfter ?? 0;
        const virtualLoopCount = slidesBefore + slidesAfter;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil(virtualLoopCount / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for (let i = 0; i < groups; i += 1) {
                snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
            }
        }
        for (let i = 0; i < virtualLoopCount; i += 1) {
            if (params.slidesPerGroup === 1) {
                snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            }
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0)
        snapGrid = [0];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
        slides
            .filter((_, slideIndex) => {
            if (!params.cssMode || params.loop)
                return true;
            if (slideIndex === slides.length - 1) {
                return false;
            }
            return true;
        })
            .forEach((slideEl) => {
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue) => {
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
        snapGrid = snapGrid.map((snap) => {
            if (snap <= 0)
                return -offsetBefore;
            if (snap > maxSnap)
                return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue) => {
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex) => {
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex) => {
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides,
        snapGrid,
        slidesGrid,
        slidesSizesGrid,
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.v)(wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.v)(wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v) => v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v) => v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) {
        swiper.emit('slidesLengthChange');
    }
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow)
            swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) {
        swiper.emit('slidesGridLengthChange');
    }
    if (params.watchSlidesProgress) {
        swiper.updateSlidesOffset();
    }
    swiper.emit('slidesUpdated');
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded)
                swiper.el.classList.add(backFaceHiddenClass);
        }
        else if (hasClassBackfaceClassAdded) {
            swiper.el.classList.remove(backFaceHiddenClass);
        }
    }
}

const toggleSlideClasses$1 = (slideEl, condition, className) => {
    if (condition && !slideEl.classList.contains(className)) {
        slideEl.classList.add(className);
    }
    else if (!condition && slideEl.classList.contains(className)) {
        slideEl.classList.remove(className);
    }
};
function updateSlidesClasses() {
    const swiper = this;
    const { slides, params, slidesEl, activeIndex } = swiper;
    const isVirtual = !!(swiper.virtual && params.virtual?.enabled);
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector) => {
        return (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.e)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
        if (params.loop) {
            const virtualSlides = swiper.virtual.slides;
            let slideIndex = activeIndex - (swiper.virtual.slidesBefore ?? 0);
            if (slideIndex < 0)
                slideIndex = virtualSlides.length + slideIndex;
            if (slideIndex >= virtualSlides.length)
                slideIndex -= virtualSlides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        }
        else {
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
        }
    }
    else if (gridEnabled) {
        activeSlide = slides.find((slideEl) => slideEl.column === activeIndex);
        nextSlide = slides.find((slideEl) => slideEl.column === activeIndex + 1);
        prevSlide = slides.find((slideEl) => slideEl.column === activeIndex - 1);
    }
    else {
        activeSlide = slides[activeIndex];
    }
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.g)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            if (params.loop && !nextSlide) {
                nextSlide = slides[0];
            }
            // Prev Slide
            prevSlide = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.k)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            // NOTE: legacy guard from v9; `(!prevSlide) === 0` is always false, but we preserve
            // the original behaviour (no-op) to avoid runtime changes in v14. Audit candidate.
            if (params.loop && !prevSlide === 0) {
                prevSlide = slides[slides.length - 1];
            }
        }
    }
    slides.forEach((slideEl) => {
        toggleSlideClasses$1(slideEl, slideEl === activeSlide, params.slideActiveClass);
        toggleSlideClasses$1(slideEl, slideEl === nextSlide, params.slideNextClass);
        toggleSlideClasses$1(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}

function updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    const minusOffset = swiper.isElement
        ? swiper.isHorizontal()
            ? swiper.wrapperEl.offsetLeft
            : swiper.wrapperEl.offsetTop
        : 0;
    for (let i = 0; i < slides.length; i += 1) {
        slides[i].swiperSlideOffset =
            (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) -
                minusOffset -
                swiper.cssOverflowAdjustment();
    }
}

const toggleSlideClasses = (slideEl, condition, className) => {
    if (condition && !slideEl.classList.contains(className)) {
        slideEl.classList.add(className);
    }
    else if (!condition && slideEl.classList.contains(className)) {
        slideEl.classList.remove(className);
    }
};
function updateSlidesProgress(translate = (this && this.translate) || 0) {
    const swiper = this;
    const params = swiper.params;
    const { slides, rtlTranslate: rtl, snapGrid } = swiper;
    if (slides.length === 0)
        return;
    if (typeof slides[0].swiperSlideOffset === 'undefined')
        swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl)
        offsetCenter = translate;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
        spaceBetween = (parseFloat(spaceBetween.replace('%', '')) / 100) * swiper.size;
    }
    else if (typeof spaceBetween === 'string') {
        spaceBetween = parseFloat(spaceBetween);
    }
    for (let i = 0; i < slides.length; i += 1) {
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset ?? 0;
        if (params.cssMode && params.centeredSlides) {
            slideOffset -= slides[0].swiperSlideOffset ?? 0;
        }
        const slideSize = slide.swiperSlideSize ?? 0;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) /
            (slideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter -
            snapGrid[0] +
            (params.centeredSlides ? swiper.minTranslate() : 0) -
            slideOffset) /
            (slideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        const isVisible = (slideBefore >= 0 && slideBefore < swiper.size - 1) ||
            (slideAfter > 1 && slideAfter <= swiper.size) ||
            (slideBefore <= 0 && slideAfter >= swiper.size);
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
        }
        toggleSlideClasses(slide, isVisible, params.slideVisibleClass);
        toggleSlideClasses(slide, isFullyVisible, params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}

var update = {
    updateSize,
    updateSlides,
    updateAutoHeight,
    updateSlidesOffset,
    updateSlidesProgress,
    updateProgress,
    updateSlidesClasses,
    updateActiveIndex,
    updateClickedSlide,
};

const prototypes = {
    eventsEmitter,
    update,
    translate,
    transition,
    slide,
    loop,
    grabCursor,
    events: events$1,
    breakpoints,
    checkOverflow: checkOverflow$1,
    classes,
};
const extendedDefaults = {};
class Swiper {
    static extendedDefaults;
    static defaults;
    constructor(...args) {
        let el;
        let params;
        if (args.length === 1 &&
            args[0] !== null &&
            typeof args[0] === 'object' &&
            Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
            params = args[0];
        }
        else {
            [el, params] = args;
        }
        if (!params)
            params = {};
        params = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.n)({}, params);
        if (el && !params.el)
            params.el = el;
        if (params.el &&
            typeof params.el === 'string' &&
            typeof document !== 'undefined' &&
            document.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document.querySelectorAll(params.el).forEach((containerEl) => {
                const newParams = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.n)({}, params, { el: containerEl });
                swipers.push(new Swiper(newParams));
            });
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = getSupport();
        swiper.device = getDevice({ userAgent: params.userAgent ?? undefined });
        swiper.browser = getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [...(swiper.__modules__ || [])];
        if (params.modules && Array.isArray(params.modules)) {
            params.modules.forEach((mod) => {
                const fn = mod;
                if (typeof fn === 'function' && swiper.modules.indexOf(fn) < 0) {
                    swiper.modules.push(fn);
                }
            });
        }
        const allModulesParams = {};
        swiper.modules.forEach((mod) => {
            mod({
                params: params,
                swiper,
                extendParams: moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper),
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.n)({}, defaults, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.n)({}, swiperParams, extendedDefaults, params);
        swiper.originalParams = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.n)({}, swiper.params);
        swiper.passedParams = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.n)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) {
            const onHandlers = swiper.params.on;
            Object.keys(onHandlers).forEach((eventName) => {
                const handler = onHandlers[eventName];
                if (handler)
                    swiper.on(eventName, handler);
            });
        }
        if (swiper.params && swiper.params.onAny) {
            swiper.onAny(swiper.params.onAny);
        }
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal() {
                return swiper.params.direction === 'horizontal';
            },
            isVertical() {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment() {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null,
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0,
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0,
        });
        swiper.emit('_swiper');
        // Init
        if (swiper.params.init) {
            swiper.init();
        }
        // Return app instance
        return swiper;
    }
    getDirectionLabel(property) {
        if (this.isHorizontal()) {
            return property;
        }
        // oxfmt-ignore
        return {
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom',
        }[property];
    }
    /**
     * !INTERNAL
     */
    isHorizontal() {
        return this.params.direction === 'horizontal';
    }
    isVertical() {
        return this.params.direction === 'vertical';
    }
    cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
    }
    getSlideIndex(slideEl) {
        const { slidesEl, params } = this;
        const slides = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.b)(slides[0]);
        return (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.b)(slideEl) - (firstSlideIndex ?? 0);
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.find((slideEl) => Number(slideEl.getAttribute('data-swiper-slide-index')) === index));
    }
    getSlideIndexWhenGrid(index) {
        if (this.grid && this.params.grid && this.params.grid.rows > 1) {
            if (this.params.grid.fill === 'column') {
                index = Math.floor(index / this.params.grid.rows);
            }
            else if (this.params.grid.fill === 'row') {
                index = index % Math.ceil(this.slides.length / this.params.grid.rows);
            }
        }
        return index;
    }
    recalcSlides() {
        const { slidesEl, params } = this;
        this.slides = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    /**
     * Enable Swiper (if it was disabled)
     */
    enable() {
        if (this.enabled)
            return;
        this.enabled = true;
        if (this.params.grabCursor) {
            this.setGrabCursor();
        }
        this.emit('enable');
    }
    /**
     * Disable Swiper (if it was enabled). When Swiper is disabled, it will hide all navigation elements and won't respond to any events and interactions
     */
    disable() {
        if (!this.enabled)
            return;
        this.enabled = false;
        if (this.params.grabCursor) {
            this.unsetGrabCursor();
        }
        this.emit('disable');
    }
    /**
     * Set Swiper translate progress (from 0 to 1). Where 0 - its initial position (offset) on first slide, and 1 - its maximum position (offset) on last slide
     *
     * @param progress Swiper translate progress (from 0 to 1).
     * @param speed Transition duration (in ms).
     */
    setProgress(progress, speed) {
        progress = Math.min(Math.max(progress, 0), 1);
        const min = this.minTranslate();
        const max = this.maxTranslate();
        const current = (max - min) * progress + min;
        this.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        this.updateActiveIndex();
        this.updateSlidesClasses();
    }
    emitContainerClasses() {
        if (!this.params._emitClasses || !this.el)
            return;
        const cls = this.el.className.split(' ').filter((className) => {
            return (className.indexOf('swiper') === 0 ||
                className.indexOf(this.params.containerModifierClass) === 0);
        });
        this.emit('_containerClasses', cls.join(' '));
    }
    getSlideClasses(slideEl) {
        if (this.destroyed)
            return '';
        return slideEl.className
            .split(' ')
            .filter((className) => {
            return (className.indexOf('swiper-slide') === 0 ||
                className.indexOf(this.params.slideClass) === 0);
        })
            .join(' ');
    }
    emitSlidesClasses() {
        if (!this.params._emitClasses || !this.el)
            return;
        const updates = [];
        this.slides.forEach((slideEl) => {
            const classNames = this.getSlideClasses(slideEl);
            updates.push({ slideEl, classNames });
            this.emit('_slideClass', slideEl, classNames);
        });
        this.emit('_slideClasses', updates);
    }
    /**
     * Get dynamically calculated amount of slides per view, useful only when slidesPerView set to `auto`
     */
    slidesPerViewDynamic(view = 'current', exact = false) {
        const { params, slides, slidesGrid, slidesSizesGrid, size: swiperSize, activeIndex } = this;
        let spv = 1;
        if (typeof params.slidesPerView === 'number')
            return params.slidesPerView;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize ?? 0) : 0;
            let breakLoop = false;
            for (let i = activeIndex + 1; i < slides.length; i += 1) {
                if (slides[i] && !breakLoop) {
                    slideSize += Math.ceil(slides[i].swiperSlideSize ?? 0);
                    spv += 1;
                    if (slideSize > swiperSize)
                        breakLoop = true;
                }
            }
            for (let i = activeIndex - 1; i >= 0; i -= 1) {
                if (slides[i] && !breakLoop) {
                    slideSize += slides[i].swiperSlideSize ?? 0;
                    spv += 1;
                    if (slideSize > swiperSize)
                        breakLoop = true;
                }
            }
        }
        else if (view === 'current') {
            for (let i = activeIndex + 1; i < slides.length; i += 1) {
                const slideInView = exact
                    ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize
                    : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) {
                    spv += 1;
                }
            }
        }
        else {
            // previous
            for (let i = activeIndex - 1; i >= 0; i -= 1) {
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) {
                    spv += 1;
                }
            }
        }
        return spv;
    }
    /**
     * You should call it after you add/remove slides
     * manually, or after you hide/show it, or do any
     * custom DOM modifications with Swiper
     * This method also includes subcall of the following
     * methods which you can use separately:
     */
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed)
            return;
        const { snapGrid, params } = swiper;
        // Breakpoints
        if (params.breakpoints) {
            swiper.setBreakpoint();
        }
        [...swiper.el.querySelectorAll('[loading="lazy"]')].forEach((imageEl) => {
            if (imageEl.complete) {
                processLazyPreloader(swiper, imageEl);
            }
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode?.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) {
                swiper.updateAutoHeight();
            }
        }
        else {
            if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) &&
                swiper.isEnd &&
                !params.centeredSlides) {
                const slidesLength = swiper.virtual && params.virtual?.enabled
                    ? swiper.virtual.slides.length
                    : swiper.slides.length;
                translated = swiper.slideTo(slidesLength - 1, 0, false, true);
            }
            else {
                translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            }
            if (!translated) {
                setTranslate();
            }
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
            swiper.checkOverflow();
        }
        swiper.emit('update');
    }
    /**
     * Changes slider direction from horizontal to vertical and back.
     *
     * @param direction New direction. If not specified, then will automatically changed to opposite direction
     * @param needUpdate Will call swiper.update(). Default true
     */
    changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) {
            newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        }
        if (newDirection === currentDirection ||
            (newDirection !== 'horizontal' && newDirection !== 'vertical')) {
            return swiper;
        }
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl) => {
            if (newDirection === 'vertical') {
                slideEl.style.width = '';
            }
            else {
                slideEl.style.height = '';
            }
        });
        swiper.emit('changeDirection');
        if (needUpdate)
            swiper.update();
        return swiper;
    }
    /**
     * Changes slider language
     *
     * @param direction New direction. Should be `rtl` or `ltr`
     */
    changeLanguageDirection(direction) {
        const swiper = this;
        if ((swiper.rtl && direction === 'rtl') || (!swiper.rtl && direction === 'ltr'))
            return;
        swiper.rtl = direction === 'rtl';
        swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'rtl';
        }
        else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'ltr';
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted)
            return true;
        // No DOM (SSR / Node) — nothing to mount to.
        if (typeof document === 'undefined')
            return false;
        // Find el (params.el can be a CSSSelector, HTMLElement, or undefined)
        const initialEl = element ?? swiper.params.el;
        let el = null;
        if (typeof initialEl === 'string') {
            el = document.querySelector(initialEl);
        }
        else if (initialEl instanceof HTMLElement) {
            el = initialEl;
        }
        if (!el) {
            return false;
        }
        el.swiper = swiper;
        const parent = el.parentNode;
        if (parent &&
            parent.host &&
            parent.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) {
            swiper.isElement = true;
        }
        const getWrapperSelector = () => {
            return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = () => {
            if (el && el.shadowRoot) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.e)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.a)('div', swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.e)(el, `.${swiper.params.slideClass}`).forEach((slideEl) => {
                wrapperEl.append(slideEl);
            });
        }
        const host = swiper.isElement ? el.parentNode.host : null;
        Object.assign(swiper, {
            el,
            wrapperEl,
            slidesEl: swiper.isElement && !host.slideSlots ? host : wrapperEl,
            hostEl: swiper.isElement ? host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.l)(el, 'direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' &&
                (el.dir.toLowerCase() === 'rtl' || (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.l)(el, 'direction') === 'rtl'),
            wrongRTL: (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.l)(wrapperEl, 'display') === '-webkit-box',
        });
        return true;
    }
    /**
     * Initialize slider
     */
    init(el) {
        const swiper = this;
        if (swiper.initialized)
            return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false)
            return swiper;
        swiper.emit('beforeInit');
        // Set breakpoint
        if (swiper.params.breakpoints) {
            swiper.setBreakpoint();
        }
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) {
            swiper.checkOverflow();
        }
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) {
            swiper.setGrabCursor();
        }
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual?.enabled) {
            swiper.slideTo((swiper.params.initialSlide ?? 0) + (swiper.virtual.slidesBefore ?? 0), 0, swiper.params.runCallbacksOnInit, false, true);
        }
        else {
            swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        }
        // Create loop
        if (swiper.params.loop) {
            swiper.loopCreate(undefined, true);
        }
        // Attach events
        swiper.attachEvents();
        const lazyElements = [...swiper.el.querySelectorAll('[loading="lazy"]')];
        if (swiper.isElement) {
            lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        }
        lazyElements.forEach((imageEl) => {
            if (imageEl.complete) {
                processLazyPreloader(swiper, imageEl);
            }
            else {
                imageEl.addEventListener('load', (e) => {
                    processLazyPreloader(swiper, e.target);
                });
            }
        });
        preload(swiper);
        // Init Flag
        swiper.initialized = true;
        preload(swiper);
        // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    }
    /**
     * Destroy slider instance and detach all events listeners
     *
     * @param deleteInstance Set it to false (by default it is true) to not to delete Swiper instance
     * @param cleanStyles Set it to true (by default it is true) and all custom styles will be removed from slides, wrapper and container.
     * Useful if you need to destroy Swiper and to init again with new options or in different direction
     */
    destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params, el, wrapperEl, slides } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) {
            return null;
        }
        swiper.emit('beforeDestroy');
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) {
            swiper.loopDestroy();
        }
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            if (el && typeof el !== 'string') {
                el.removeAttribute('style');
            }
            if (wrapperEl) {
                wrapperEl.removeAttribute('style');
            }
            if (slides && slides.length) {
                slides.forEach((slideEl) => {
                    slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                    slideEl.removeAttribute('style');
                    slideEl.removeAttribute('data-swiper-slide-index');
                });
            }
        }
        swiper.emit('destroy');
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName) => {
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            if (swiper.el && typeof swiper.el !== 'string') {
                swiper.el.swiper = null;
            }
            (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.d)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__.n)(extendedDefaults, newDefaults);
    }
    static installModule(mod) {
        if (!Swiper.prototype.__modules__)
            Swiper.prototype.__modules__ = [];
        const modules = Swiper.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) {
            modules.push(mod);
        }
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m) => Swiper.installModule(m));
            return Swiper;
        }
        Swiper.installModule(module);
        return Swiper;
    }
}
Object.defineProperty(Swiper, 'extendedDefaults', {
    get() {
        return extendedDefaults;
    },
});
Object.defineProperty(Swiper, 'defaults', {
    get() {
        return defaults;
    },
});
// Attach prototype-mixin method groups onto Swiper.prototype. Each group is a
// plain record of method-name → function; we copy them across as-is.
const prototypeRecord = prototypes;
const swiperProto = Swiper.prototype;
Object.keys(prototypeRecord).forEach((prototypeGroup) => {
    const group = prototypeRecord[prototypeGroup];
    Object.keys(group).forEach((protoMethod) => {
        swiperProto[protoMethod] = group[protoMethod];
    });
});
Swiper.use([Resize, Observer]);




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs":
/*!*******************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/utils.mjs ***!
  \*******************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   a: function() { return /* binding */ createElement; },
/* harmony export */   b: function() { return /* binding */ elementIndex; },
/* harmony export */   c: function() { return /* binding */ classesToTokens; },
/* harmony export */   d: function() { return /* binding */ deleteProps; },
/* harmony export */   e: function() { return /* binding */ elementChildren; },
/* harmony export */   f: function() { return /* binding */ elementIsChildOf; },
/* harmony export */   g: function() { return /* binding */ elementNextAll; },
/* harmony export */   h: function() { return /* binding */ elementOffset; },
/* harmony export */   i: function() { return /* binding */ elementOuterSize; },
/* harmony export */   j: function() { return /* binding */ elementParents; },
/* harmony export */   k: function() { return /* binding */ elementPrevAll; },
/* harmony export */   l: function() { return /* binding */ elementStyle; },
/* harmony export */   m: function() { return /* binding */ elementTransitionEnd; },
/* harmony export */   n: function() { return /* binding */ extend; },
/* harmony export */   o: function() { return /* binding */ getRotateFix; },
/* harmony export */   p: function() { return /* binding */ getSlideTransformEl; },
/* harmony export */   q: function() { return /* binding */ getTranslate; },
/* harmony export */   r: function() { return /* binding */ isObject; },
/* harmony export */   s: function() { return /* binding */ makeElementsArray; },
/* harmony export */   t: function() { return /* binding */ nextTick; },
/* harmony export */   u: function() { return /* binding */ now; },
/* harmony export */   v: function() { return /* binding */ setCSSProperty; },
/* harmony export */   w: function() { return /* binding */ setInnerHTML; },
/* harmony export */   x: function() { return /* binding */ showWarning; }
/* harmony export */ });
function classesToTokens(classes = '') {
    return classes
        .trim()
        .split(' ')
        .filter((c) => !!c.trim());
}

function deleteProps(obj) {
    Object.keys(obj).forEach((key) => {
        try {
            obj[key] = null;
        }
        catch {
            // no getter for object
        }
        try {
            delete obj[key];
        }
        catch {
            // something got wrong
        }
    });
}
function nextTick(callback, delay = 0) {
    return setTimeout(callback, delay);
}
function now() {
    return Date.now();
}
function getComputedStyle(el) {
    return window.getComputedStyle(el, null);
}
function getTranslate(el, axis = 'x') {
    const style = getComputedStyle(el);
    const transform = style.transform || style.webkitTransform;
    if (!transform || transform === 'none')
        return 0;
    const matrix = new DOMMatrixReadOnly(transform);
    return axis === 'x' ? matrix.m41 : matrix.m42;
}
function isObject(o) {
    return (typeof o === 'object' &&
        o !== null &&
        o.constructor === Object &&
        Object.prototype.toString.call(o).slice(8, -1) === 'Object');
}
function isNode(node) {
    if (typeof HTMLElement !== 'undefined' && node instanceof HTMLElement)
        return true;
    return (!!node &&
        typeof node === 'object' &&
        (node.nodeType === 1 || node.nodeType === 11));
}
function extend(target, ...sources) {
    const to = Object(target);
    for (let i = 0; i < sources.length; i += 1) {
        const nextSource = sources[i];
        if (nextSource === undefined || nextSource === null || isNode(nextSource))
            continue;
        const sourceObj = nextSource;
        const keysArray = Object.keys(Object(sourceObj)).filter((key) => key !== '__proto__' && key !== 'constructor' && key !== 'prototype');
        for (const nextKey of keysArray) {
            const desc = Object.getOwnPropertyDescriptor(sourceObj, nextKey);
            if (!desc || !desc.enumerable)
                continue;
            const sourceVal = sourceObj[nextKey];
            if (isObject(to[nextKey]) && isObject(sourceVal)) {
                if (sourceVal.__swiper__) {
                    to[nextKey] = sourceVal;
                }
                else {
                    extend(to[nextKey], sourceVal);
                }
            }
            else if (!isObject(to[nextKey]) && isObject(sourceVal)) {
                to[nextKey] = {};
                if (sourceVal.__swiper__) {
                    to[nextKey] = sourceVal;
                }
                else {
                    extend(to[nextKey], sourceVal);
                }
            }
            else {
                to[nextKey] = sourceVal;
            }
        }
    }
    return to;
}
function setCSSProperty(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function getSlideTransformEl(slideEl) {
    const direct = slideEl.querySelector('.swiper-slide-transform');
    if (direct)
        return direct;
    if (slideEl.shadowRoot) {
        const shadowed = slideEl.shadowRoot.querySelector('.swiper-slide-transform');
        if (shadowed)
            return shadowed;
    }
    return slideEl;
}
function elementChildren(element, selector = '') {
    const children = [...element.children];
    if (element instanceof HTMLSlotElement) {
        children.push(...element.assignedElements());
    }
    return selector ? children.filter((el) => el.matches(selector)) : children;
}
function elementIsChildOfSlot(el, slot) {
    const queue = [slot];
    while (queue.length > 0) {
        const cur = queue.shift();
        if (el === cur)
            return true;
        queue.push(...cur.children, ...(cur.shadowRoot ? cur.shadowRoot.children : []), ...(cur.assignedElements
            ? cur.assignedElements()
            : []));
    }
    return false;
}
function elementIsChildOf(el, parent) {
    let isChild = parent.contains(el);
    if (!isChild && parent instanceof HTMLSlotElement) {
        const children = [...parent.assignedElements()];
        isChild = children.includes(el);
        if (!isChild)
            isChild = elementIsChildOfSlot(el, parent);
    }
    return isChild;
}
function showWarning(text) {
    try {
        console.warn(text);
    }
    catch {
        // err
    }
}
function createElement(tag, classes = []) {
    const el = document.createElement(tag);
    el.classList.add(...(Array.isArray(classes) ? classes : classesToTokens(classes)));
    return el;
}
function elementOffset(el) {
    const box = el.getBoundingClientRect();
    return {
        top: box.top + window.scrollY - (el.clientTop || 0),
        left: box.left + window.scrollX - (el.clientLeft || 0),
    };
}
function elementPrevAll(el, selector) {
    const prevEls = [];
    let prev = el.previousElementSibling;
    while (prev) {
        if (!selector || prev.matches(selector))
            prevEls.push(prev);
        prev = prev.previousElementSibling;
    }
    return prevEls;
}
function elementNextAll(el, selector) {
    const nextEls = [];
    let next = el.nextElementSibling;
    while (next) {
        if (!selector || next.matches(selector))
            nextEls.push(next);
        next = next.nextElementSibling;
    }
    return nextEls;
}
function elementStyle(el, prop) {
    return window.getComputedStyle(el, null).getPropertyValue(prop);
}
function elementIndex(el) {
    if (!el || !el.parentNode)
        return undefined;
    return [...el.parentNode.children].indexOf(el);
}
function elementParents(el, selector) {
    const parents = [];
    let parent = el.parentElement;
    while (parent) {
        if (!selector || parent.matches(selector))
            parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function elementTransitionEnd(el, callback) {
    if (!callback)
        return;
    el.addEventListener('transitionend', function fireCallBack(e) {
        if (e.target !== el)
            return;
        callback.call(el, e);
    }, { once: true });
}
function elementOuterSize(el, size, includeMargins) {
    {
        const style = window.getComputedStyle(el, null);
        return (el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] +
            parseFloat(style.getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) +
            parseFloat(style.getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom')));
    }
}
function makeElementsArray(el) {
    return (Array.isArray(el) ? el : [el]).filter((e) => !!e);
}
function getRotateFix(swiper) {
    return (v) => {
        if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) {
            return v + 0.001;
        }
        return v;
    };
}
function setInnerHTML(el, html = '') {
    const tt = globalThis.trustedTypes;
    if (typeof tt !== 'undefined') {
        el.innerHTML = tt.createPolicy('html', { createHTML: (s) => s }).createHTML(html);
    }
    else {
        el.innerHTML = html;
    }
}




/***/ }),

/***/ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/swiper.mjs":
/*!*************************************************************************!*\
  !*** ./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/swiper.mjs ***!
  \*************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Swiper: function() { return /* reexport safe */ _shared_swiper_core_mjs__WEBPACK_IMPORTED_MODULE_0__.S; },
/* harmony export */   "default": function() { return /* reexport safe */ _shared_swiper_core_mjs__WEBPACK_IMPORTED_MODULE_0__.S; }
/* harmony export */ });
/* harmony import */ var _shared_swiper_core_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./shared/swiper-core.mjs */ "./node_modules/.pnpm/swiper@14.0.2/node_modules/swiper/shared/swiper-core.mjs");
/**
 * Swiper 14.0.2
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2026 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: July 7, 2026
 */




/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		if (!(moduleId in __webpack_modules__)) {
/******/ 			delete __webpack_module_cache__[moduleId];
/******/ 			var e = new Error("Cannot find module '" + moduleId + "'");
/******/ 			e.code = 'MODULE_NOT_FOUND';
/******/ 			throw e;
/******/ 		}
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter/value functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			if(Array.isArray(definition)) {
/******/ 				var i = 0;
/******/ 				while(i < definition.length) {
/******/ 					var key = definition[i++];
/******/ 					var binding = definition[i++];
/******/ 					if(!__webpack_require__.o(exports, key)) {
/******/ 						if(binding === 0) {
/******/ 							Object.defineProperty(exports, key, { enumerable: true, value: definition[i++] });
/******/ 						} else {
/******/ 							Object.defineProperty(exports, key, { enumerable: true, get: binding });
/******/ 						}
/******/ 					} else if(binding === 0) { i++; }
/******/ 				}
/******/ 			} else {
/******/ 				for(var key in definition) {
/******/ 					if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 						Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 					}
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
!function() {
"use strict";
/*!**************************!*\
  !*** ./scripts/index.js ***!
  \**************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _styles_index_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../styles/index.css */ "./styles/index.css");
/* harmony import */ var _app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @/app */ "./scripts/app.js");


_app__WEBPACK_IMPORTED_MODULE_1__["default"].mount();
if (window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function () {
    _app__WEBPACK_IMPORTED_MODULE_1__["default"].unmount();
    _app__WEBPACK_IMPORTED_MODULE_1__["default"].mount();
  });
  document.addEventListener('shopify:section:unload', function () {
    _app__WEBPACK_IMPORTED_MODULE_1__["default"].unmount();
    _app__WEBPACK_IMPORTED_MODULE_1__["default"].mount();
  });
}
_app__WEBPACK_IMPORTED_MODULE_1__["default"].on('app:update', function () {
  _app__WEBPACK_IMPORTED_MODULE_1__["default"].unmount();
  _app__WEBPACK_IMPORTED_MODULE_1__["default"].mount();
});
_app__WEBPACK_IMPORTED_MODULE_1__["default"].on('app:mount', function () {
  _app__WEBPACK_IMPORTED_MODULE_1__["default"].mount();
});
document.addEventListener('product-recommendations:loaded', function () {
  _app__WEBPACK_IMPORTED_MODULE_1__["default"].emit('app:update');
});
}();
/******/ })()
;